webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/Feskt3/%3F1696870395421&title=1-2%20Samuel%2C%201-2%20Kings%2C%201-2%20Chronicles%2C%20Reformation%20Commentary%20on%20Scripture%20Series&summary=%22Then%20David%20said%20to%20the%20Philistine%2C%20%27You%20come%20to%20me%20with%20a%20sword%20and%20with%20a%20spear%20and%20with%20a%20javelin%2C%20but%20I%20come%20to%20you%20in%20the%20name%20of%20the%20LORD%20of%20hosts.%27%22%20%281%20Samuel%2017%3A45%29%20%0D%0A%0D%0AReflecting%20upon%20David%27s%20victory%20over%20Goliath%2C%20Reformation%20translator%2C%20theologi&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/Feskt3/%3F1696870395421",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=%22Then%20David%20said%20to%20the%20Philistine%2C%20%27You%20come%20to%20me%20with%20a%20sword%20and%20with%20a%20spear%20and%20with%20a%20javelin%2C%20but%20I%20come%20to%20you%20in%20the%20name%20of%20the%20LORD%20%0Dhttps://textcafe.co/books/Feskt3/%3F1696870395421&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/Feskt3/%3F1696870395421&posttype=link&caption=%22Then%20David%20said%20to%20the%20Philistine%2C%20%27You%20come%20to%20me%20with%20a%20sword%20and%20with%20a%20spear%20and%20with%20a%20javelin%2C%20but%20I%20come%20to%20you%20in%20the%20name%20of%20the%20LORD%20of%20hosts.%27%22%20%281%20Samuel%2017%3A45%29%20%0D%0A%0D%0AReflecting%20upon%20David%27s%20victory%20over%20Goliath%2C%20Reformation%20translator%2C%20theologi",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/Feskt3/%3F1696870395421&description=%22Then%20David%20said%20to%20the%20Philistine%2C%20%27You%20come%20to%20me%20with%20a%20sword%20and%20with%20a%20spear%20and%20with%20a%20javelin%2C%20but%20I%20come%20to%20you%20in%20the%20name%20of%20the%20LORD%20of%20hosts.%27%22%20%281%20Samuel%2017%3A45%29%20%0D%0A%0D%0AReflecting%20upon%20David%27s%20victory%20over%20Goliath%2C%20Reformation%20translator%2C%20theologi&media=https://textcafe.co/books/Feskt3/tc-custom/9780830899784.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/Samuel-Chronicles-Reformation-Commentary-Scripture-ebook/dp/B01D8W6II4?SubscriptionId=AKIAISHVWNTZ4L3IXTPQ&tag=mobilebookcom-20&linkCode=xm2&camp=2025&creative=165953&creativeASIN=B01D8W6II4',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=eK4PDAAAQBAJ&amp;rdid=book-eK4PDAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }, {
        title: 'Kobo',
        img: 'https://textcafe.co/global-css/img/kobo_appicon.svg',
        url: 'https://www.kobo.com/us/en/search?Query=9780830899784',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780830899784').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/Feskt3/tc-custom/9780830899784.jpg?1696870395421',
        alt: '1-2 Samuel, 1-2 Kings, 1-2 Chronicles, Reformation Commentary on Scripture Series'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "Text/cover", "Text/titlepage", "Text/dedication", "Text/credits", "Text/IVP", "Text/contents", "Text/acknowledgments", "Text/abbreviations", "Text/bibletransl", "Text/commentaryguide", "Text/genintro", "Text/introduction", "Text/1samuel", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/Feskt3/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Text_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Text_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Text_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Text_titlepage__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Text_titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Text_titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Text_dedication__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Text_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Text_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Text_credits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Text_credits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Text_credits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Text_IVP__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Text_IVP___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Text_IVP__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Text_contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Text_contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Text_contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Text_acknowledgments__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Text_acknowledgments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Text_acknowledgments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Text_abbreviations__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Text_abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Text_abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Text_bibletransl__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Text_bibletransl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Text_bibletransl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Text_commentaryguide__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Text_commentaryguide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Text_commentaryguide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Text_genintro__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Text_genintro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Text_genintro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Text_introduction__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Text_introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Text_introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Text_1samuel__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Text_1samuel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Text_1samuel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Text_2samuel__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Text_2samuel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Text_2samuel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Text_1kings__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Text_1kings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Text_1kings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Text_2kings__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Text_2kings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Text_2kings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Text_1chronicles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Text_1chronicles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Text_1chronicles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Text_2chronicles__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Text_2chronicles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Text_2chronicles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Text_mapandtimeline__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Text_mapandtimeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Text_mapandtimeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Text_figuresandworks__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Text_figuresandworks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Text_figuresandworks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Text_sourcesbiosketch__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Text_sourcesbiosketch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Text_sourcesbiosketch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Text_bibliography__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Text_bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Text_bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Text_authorwritingsindex__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Text_authorwritingsindex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Text_authorwritingsindex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Text_subjectindex__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Text_subjectindex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Text_subjectindex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Text_scriptureindex__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Text_scriptureindex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Text_scriptureindex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Text_notes__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Text_notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Text_notes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Text_praise__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Text_praise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Text_praise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Text_advisers__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Text_advisers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Text_advisers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Text_serieseditors__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Text_serieseditors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Text_serieseditors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Text_volumeeditor__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Text_volumeeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Text_volumeeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Text_RConS__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Text_RConS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Text_RConS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Text_textbookselector__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Text_textbookselector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Text_textbookselector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Text_copyright__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Text_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Text_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_last__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_last__);
/*jshint esversion: 6 */








































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/Text/cover",
    "name": "Text/cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_Text_cover___default.a
  }, {
    "path": "/Text/titlepage",
    "name": "Text/titlepage",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_Text_titlepage___default.a
  }, {
    "path": "/Text/dedication",
    "name": "Text/dedication",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_Text_dedication___default.a
  }, {
    "path": "/Text/credits",
    "name": "Text/credits",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_Text_credits___default.a
  }, {
    "path": "/Text/IVP",
    "name": "Text/IVP",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_Text_IVP___default.a
  }, {
    "path": "/Text/contents",
    "name": "Text/contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_Text_contents___default.a
  }, {
    "path": "/Text/acknowledgments",
    "name": "Text/acknowledgments",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_Text_acknowledgments___default.a
  }, {
    "path": "/Text/abbreviations",
    "name": "Text/abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_Text_abbreviations___default.a
  }, {
    "path": "/Text/bibletransl",
    "name": "Text/bibletransl",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_Text_bibletransl___default.a
  }, {
    "path": "/Text/commentaryguide",
    "name": "Text/commentaryguide",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_Text_commentaryguide___default.a
  }, {
    "path": "/Text/genintro",
    "name": "Text/genintro",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_Text_genintro___default.a
  }, {
    "path": "/Text/introduction",
    "name": "Text/introduction",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_Text_introduction___default.a
  }, {
    "path": "/Text/1samuel",
    "name": "Text/1samuel",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_Text_1samuel___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_37__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Feskt3/tc-custom/9780830899784.jpg?1696870395421",
      "alt": "This image is the cover for the book 1-2 Samuel, 1-2 Kings, 1-2 Chronicles, Reformation Commentary on Scripture Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("1-2 Samuel, 1-2 Kings, 1-2 Chronicles, Reformation Commentary on Scripture Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"Then David said to the Philistine, 'You come to me with a sword and with a spear and with a javelin, but I come to you in the name of the LORD of hosts.'\" (1 Samuel 17:45) Reflecting upon David's victory over Goliath, Reformation translator, theologian and commentator William Tyndale compared it to Christ's victory over sin and death: \"When David had killed Goliath the giant, glad tidings came to the Israelites that their fearful and cruel enemy was dead and that they were delivered out of all danger. For this gladness, they sang, danced and were joyful. In like manner, the good news or 'gospel' of God is joyful tidings.\" The books of 1-2 Samuel, 1-2 Kings and 1-2 Chronicles, which record the history of Israel from the prophetic ministry of Samuel to the fall of Jerusalem, provided the reformers with some of the best-known narratives of the Old Testament upon which to comment, including Hannah's prayer, the anointing of Saul as Israel's first king, David's triumph over Goliath and his later adultery with Bathsheba, Solomon's building of the Temple, Elijah's challenge to the prophets of Baal, and the healing of Naaman. For the reformers, these stories were not merely ancient Israelite history, but they also foreshadowed the coming of Jesus Christ, and they had immediate relevance for their lives and the church of their day. Thus, Anglican exegete John Mayer perceived within King Josiah's reform of Israelite worship after the discovery of the Book of the Law a prefiguration of \"what should be done in the latter days of the gospel, in which a greater reformation of the religion is now being made.\" In this Reformation Commentary on Scripture volume, Derek Cooper and Martin Lohrmann guide readers through a diversity of Reformation commentary on these historical books. Here, readers will find reflections from both well-known voices and lesser-known figures from a variety of confessional traditions—Lutherans, Reformed, Radicals, Anglicans and Roman Catholics—many of which appear in English for the first time. By drawing upon a variety of resources—including commentaries, sermons, treatises and confessions—this volume will enable scholars and students to understand better the depth and breadth of Reformation-era insights on Scripture. It will also provide resources for contemporary preachers, and encourage all those who continually seek to share the \"joyful tidings\" of Jesus Christ.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Derek Cooper, Martin J. Lohrmann\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Derek Cooper (PhD, The Lutheran Theological Seminary at Philadelphia) is associate professor of world Christian history at Biblical Theological Seminary. He is the author of several books, including "), _c('em', [_vm._v("Exploring Church History")]), _vm._v(" and "), _c('em', [_vm._v("Christianity and World Religions: An Introduction to the World's Major Faiths")]), _vm._v(", and he is the coeditor of the Reformation Commentary on Scripture volume on 1-2 Samuel, 1-2 Kings, 1-2 Chronicles.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "9780830899784.jpg",
      "src": "Images/9780830899784.jpg"
    }
  })])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "endorsements"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagei",
      "title": "i"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageii",
      "title": "ii"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageiii",
      "title": "iii"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageiv",
      "title": "iv"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("Reformation Commentary on Scripture")]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("Old Testament V")]), _vm._v(" "), _c('p', {
    staticClass: "tp2"
  }, [_vm._v("1–2 Samuel, 1–2 Kings, 1–2 Chronicles")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("Edited by"), _c('br'), _vm._v("\n    Derek Cooper and Martin J. Lohrmann")]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("General Editor"), _c('br'), _vm._v("\n    Timothy George")]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("Associate General Editor"), _c('br'), _vm._v("\n    Scott M. Manetsch")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "http://www.IVPress.com/academic",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "IVP Academic Imprint",
      "src": "Images/IVPAcademic.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagevi",
      "title": "vi"
    }
  })])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("To Timothy J. Wengert, our teacher")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageviii",
      "title": "viii"
    }
  })])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('h6', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageix",
      "title": "ix"
    }
  }), _vm._v("Reformation Commentary on Scripture")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("Project Staff"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Project Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("David W. McNutt")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Managing Editor and Production Manager")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Benjamin M. McCoy")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Copyeditor")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jeffrey A. Reimer")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Assistant Project Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Todd R. Hains")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Editorial and Research Assistants")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("David J. Hooper")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Ethan McCarthy")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Assistants to the General Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Le-Ann Little")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jason Odom")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Design")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Cindy Kiple")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Design Assistant")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Beth McGill")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Content Production")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Richard M. Chung")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Maureen G. Tobey")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Daniel van Loon")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jeanna L. Wiggins")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Proofreader")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Travis Ables")]), _vm._v(" "), _c('hr', {
    staticClass: "half"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Print Coordinator")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jim Erhart")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagex",
      "title": "x"
    }
  }), _vm._v("InterVarsity Press"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Robert A. Fryling")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Associate Publisher, Editorial")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Cindy Bunch")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Editorial Director, Academic")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Daniel G. Reid")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Production Director")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Anne Gerth")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexi",
      "title": "xi"
    }
  })])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgments#_idTextAnchor001"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/abbreviations#_idTextAnchor002"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/bibletransl#_idTextAnchor003"
    }
  }, [_vm._v("Bible Translations")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/commentaryguide#_idTextAnchor004"
    }
  }, [_vm._v("A Guide to Using This Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/genintro#_idTextAnchor005"
    }
  }, [_vm._v("General Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#_idTextAnchor006"
    }
  }, [_vm._v("Introduction to 1–2 Samuel, 1–2 Kings, 1–2 Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/1samuel#_idTextAnchor072"
    }
  }, [_vm._v("Commentary on 1 Samuel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/2samuel#_idTextAnchor3462",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 2 Samuel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/1kings#_idTextAnchor4184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 1 Kings")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/2kings#_idTextAnchor4964",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 2 Kings")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/1chronicles#_idTextAnchor5755",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 1 Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/2chronicles#_idTextAnchor6152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 2 Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/mapandtimeline#page674",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Europe at the Time of the Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/mapandtimeline#page675",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timeline of the Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/figuresandworks#_idTextAnchor6678",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biographical Sketches of Reformation-Era Figures and Works")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/sourcesbiosketch#_idTextAnchor6680",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources for Biographical Sketches")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography#_idTextAnchor6681",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/authorwritingsindex#_idTextAnchor6682",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author and Writings Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/subjectindex#_idTextAnchor6684",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scriptureindex#_idTextAnchor6686",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor6687",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for the Reformation Commentary on Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/advisers#_idTextAnchor6688",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformation Commentary on Scripture Board of Advisers")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/serieseditors#_idTextAnchor6689",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Series Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/volumeeditor#_idTextAnchor6690",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Volume Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RConS#_idTextAnchor6691",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformation Commentary on Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/textbookselector#_idTextAnchor6692",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Academic Textbook Selector")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexii",
      "title": "xii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexiii",
      "title": "xiii"
    }
  })])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_vm._v("As the saying goes, “The teacher is always the primary learner.” This has been especially true as we have made our way through these books of the Bible and through these many writers of the Reformation. Our learning from this project will undoubtedly continue to bear personal and professional fruit in us for years to come. We hope that readers’ engagement with this volume will likewise lead to new insights and a renewed love of and appreciation for God’s Word.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We are grateful to InterVarsity Press for the opportunity to contribute to this great series, the Reformation Commentary on Scripture. We would especially like to express our gratitude to Timothy George, Scott Manetsch, Joel Scandrett, Michael Gibson, Brannon Ellis, David McNutt, Frank James, David Lamb, Todd Hains and David Hooper.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We are also immensely thankful to our families for their love and support over the several years, busy weeks, early mornings and long nights a project like this requires. To Barb, Gabriela, Eli and Mia Cooper; Carrie, Hilde, Jonah and Theodore Lohrmann: we thank God for you as companions in faith and in life.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Finally, we wish to dedicate this volume to the Rev. Dr. Timothy J. Wengert, who served as "), _c('i', [_vm._v("Doktorvater")]), _vm._v(" for both of us in our studies at The Lutheran Theological Seminary at Philadelphia. Through his outstanding teaching and guidance, Dr. Wengert has shown us how good scholarship and firm faith can go hand in hand with service to the church and the wider society. We dedicate this book to him with deep admiration, appreciation and thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("With all the faithful, we give thanks to God in the words of David: “The Lord is my rock and my fortress and my deliverer, my God, my rock, in whom I take refuge” (2 Sam 22:2-3).")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', [_vm._v("Derek Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("Martin J. Lohrmann")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexiv",
      "title": "xiv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexv",
      "title": "xv"
    }
  })])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Abbreviations"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('table', {
    staticClass: "no-lines"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("ACCS")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Ancient Christian Commentary on Scripture. 29 vols. Edited by Thomas C. Oden. Downers Grove, IL: InterVarsity Press, 1998–2009.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("ANF")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("The Ante-Nicene Fathers. 10 vols. Edited by Alexander Roberts and James Donaldson. Buffalo, NY: Christian Literature, 1885–1896. Accessible online at ccel.org.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("BoC")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("The Book of Concord: The Confessions of the Evangelical Lutheran Church")]), _vm._v(". Edited by Robert Kolb and Timothy J. Wengert. Translated by Charles Arand et al. Minneapolis: Fortress, 2000.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("BNP")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Brill’s New Pauly: Encyclopedia of the Ancient World")]), _vm._v(". Edited by Hubert Cancik and Helmuth Schneider. 20 vols. Leiden: Brill, 2002–2011.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("BSLK")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Die Bekenntnisschriften der evangelisch-lutherischen Kirche")]), _vm._v(". 12th ed. Göttingen: Vandenhoeck & Ruprecht, 1998.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("CHB")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Cambridge History of the Bible.")]), _vm._v(" 3 vols. Cambridge: Cambridge University Press, 1963–1970.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("CNTC")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Calvin’s New Testament Commentaries.")]), _vm._v(" 12 vols. Edited by D. W. Torrance and T. F. Torrance. Grand Rapids: Eerdmans, 1959–1972.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("CO")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Ioannis Calvini Opera quae supersunt omnia")]), _vm._v(". 59 vols. Corpus Reformatorum 29–88. Edited by G. Baum, E. Cunitz and E. Reuss. Brunswick and Berlin: C. A. Schwetschke, 1863–1900. Digital copy online at archive-ouverte.unige.ch/unige:650.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Creeds")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Philip Schaff. "), _c('i', [_vm._v("The Creeds of Christendom: With a Critical History and Notes.")]), _vm._v(" 3 vols. New York: Harper & Row, 1877. Reprint, Grand Rapids: Baker, 1977. Digital copy online at ccel.org.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("CRR")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Classics of the Radical Reformation. 12 vols. Waterloo, ON, and Scottdale, PA: Herald Press, 1973–2010.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("CTS")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Calvin Translation Society edition of Calvin’s commentaries. 46 vols. Edinburgh, 1843–1855. Several reprints, but variously bound; volume numbers (when cited) are relative to specific commentaries and not to the entire set. Available online at ccel.org.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("DMBI")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Dictionary of Major Biblical Interpreters.")]), _vm._v(" Edited by Donald K. McKim. Downers Grove, IL: IVP Academic, 2007.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("DNB")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Dictionary of National Biography")]), _vm._v(". Edited by Leslie Stephen and Sidney Lee. 63 vols. London: Smith, Elder, 1885–1900.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexvi",
      "title": "xvi"
    }
  }), _vm._v("EEBO")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Early English Books Online. Subscription database, eebo.chadwyck.com.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Library of Christian Classics. 26 vols. Edited by John Baillie et al. Philadelphia: Westminster, 1953–1966.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("LW")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Luther’s Works")]), _vm._v(" ["), _c('i', [_vm._v("American edition")]), _vm._v("]. 82 vols. planned. St. Louis: Concordia; Philadelphia: Fortress, 1955–1986; 2009–.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("MO")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Philippi Melanthonis Opera quae supersunt omnia")]), _vm._v(". 28 vols. Corpus Reformatorum 1–28. Edited by C. G. Bretschneider. Halle: C. A. Schwetschke, 1834–1860. Digital copies online at "), _c('a', {
    attrs: {
      "href": "http://archive.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("archive.org")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://books.google.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("books.google.com")])]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("NDB")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Neue Deutsche Biographie")]), _vm._v(". 28 vols. projected. Berlin: Duncker & Humblot, 1953–. Accessible online at "), _c('a', {
    attrs: {
      "href": "http://www.deutsche-biographie.de",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("www.deutsche-biographie.de")])]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("NPNF")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church")]), _vm._v(". 28 vols. in two series, denoted as NPNF and NPNF2. Edited by Philip Schaff et al. Buffalo, NY: Christian Literature, 1887–1894. Several reprints; also accessible online at "), _c('a', {
    attrs: {
      "href": "http://ccel.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("ccel.org")])]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("OER")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Oxford Encyclopedia of the Reformation.")]), _vm._v(" 4 vols. Edited by Hans J. Hillerbrand. New York: Oxford University Press, 1996.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("PL")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Patrologia cursus completus. Series Latina. 221 vols. Edited by J.-P. Migne. Paris: Migne, 1844–1864. Digital copy online at "), _c('a', {
    attrs: {
      "href": "http://books.google.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("books.google.com")])]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("QGT")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Quellen zur Geschichte der Täufer")]), _vm._v(". 18 vols. Leipzig: M. Heinsius; Gütersloh: Gerd Mohn, 1930–. The first two volumes are under the series title Quellen zur Geschichte der Wiedertäufer.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("r, v")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Some early books are numbered not by page but by folio (leaf). Front and back sides (pages) of a numbered folio are indicated by "), _c('i', [_vm._v("recto")]), _vm._v(" (r) and "), _c('i', [_vm._v("verso")]), _vm._v(" (v), respectively.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("RCS")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Reformation Commentary on Scripture. 28 vols. projected. Edited by Timothy George and Scott M. Manetsch. Downers Grove, IL: IVP Academic, 2011–.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("TO")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Alphonsi Tostati Opera Omnia.")]), _vm._v(" 27 vols. Venice: Balleoniana, 1728. Digital copy online at "), _c('a', {
    attrs: {
      "href": "http://books.google.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("books.google.com")])]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("WA")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke, Kritische Gesamtausgabe: [Schriften]")]), _vm._v(". 73 vols. Weimar: Hermann Böhlaus Nachfolger, 1883–2009. Digital copy online at "), _c('a', {
    attrs: {
      "href": "http://archive.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("archive.org")])]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("WADB")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke, Kritische Gesamtausgabe: Deutsche Bibel.")]), _vm._v(" 12 vols. Weimar: Böhlaus Nachfolger, 1906–1961. Partial digital copy online at "), _c('a', {
    attrs: {
      "href": "http://archive.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("archive.org")])]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("WATR")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke, Kritische Gesamtausgabe: Tischreden")]), _vm._v(". 6 vols. Weimar: Hermann Böhlaus Nachfolger, 1912–1921. Digital copy online at "), _c('a', {
    attrs: {
      "href": "http://archive.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("archive.org")])]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("ZSW")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('i', [_vm._v("Huldreich Zwinglis Sämtliche Werke")]), _vm._v(". 14 vols. Corpus Reformatorum 88–101. Edited by E. Egli et al. Berlin: C. A. Schwetschke, 1905–1959. Reprint Zurich: Theologischer Verlag Zurich, 1983. Digital copy online at "), _c('a', {
    attrs: {
      "href": "http://www.irg.uzh.ch",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("irg.uzh.ch")])]), _vm._v(".")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexvii",
      "title": "xvii"
    }
  })])])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Bible Translations"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexviii",
      "title": "xviii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexix",
      "title": "xix"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "no-lines"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ESV")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("English Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("KJV")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("King James Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Septuagint")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("New Reivsed Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Vg")]), _vm._v(" "), _c('td', {
    staticClass: "no-lines"
  }, [_vm._v("Vulgate")])])])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("A Guide to Using This Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_vm._v("Several features have been incorporated into the design of this commentary. The following comments are intended to assist readers in making full use of this volume.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_3"
    }
  }, [_vm._v("Pericopes of Scripture")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The scriptural text has been divided into pericopes, or passages, usually several verses in length. Each of these pericopes is given a heading, which appears at the beginning of the pericope. For example, the first pericope in this commentary is 1 Samuel 1:1-28 “The Birth and Dedication of Samuel.” This heading is followed by the Scripture passage quoted in the English Standard Version ("), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ESV")]), _vm._v("). The Scripture passage is provided for the convenience of readers, but it is also in keeping with Reformation-­era commentaries, which often followed the patristic and medieval commentary tradition, in which the citations of the reformers were arranged according to the text of Scripture.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_vm._v("Overviews")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Following each pericope of text is an overview of the Reformation authors’ comments on that pericope. The format of this overview varies among the volumes of this series, depending on the requirements of the specific book(s) of Scripture. The function of the overview is to identify succinctly the key exegetical, theological and pastoral concerns of the Reformation writers arising from the pericope, providing the reader with an orientation to Reformation-era approaches and emphases. It tracks a reasonably cohesive thread of argument among reformers’ comments, even though they are derived from diverse sources and generations. Thus, the summaries do not proceed chronologically or by verse sequence. Rather, they seek to rehearse the overall course of the reformers’ comments on that pericope.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We do not assume that the commentators themselves anticipated or expressed a formally received cohesive argument but rather that the various arguments tend to flow in a plausible, recognizable pattern. Modern readers can thus glimpse aspects of continuity in the flow of diverse exegetical traditions representing various generations and geographical locations.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("Topical Headings")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("An abundance of varied Reformation-era comment is available for each pericope. For this reason we have broken the pericopes into two levels. First is the verse with its topical heading. "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexx",
      "title": "xx"
    }
  }), _vm._v("The reformers’ comments are then focused on aspects of each verse, with topical headings summarizing the essence of the individual comment by evoking a key phrase, metaphor or idea. This feature provides a bridge by which modern readers can enter into the heart of the Reformation-era comment.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_6"
    }
  }, [_vm._v("Identifying the Reformation Authors, Texts and Events")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Following the topical heading of each section of comment, the name of the Reformation commentator is given. An English translation (where needed) of the reformer’s comment is then provided. This is immediately followed by the title of the original work rendered in English.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Readers who wish to pursue a deeper investigation of the reformers’ works cited in this commentary will find full bibliographic detail for each Reformation title provided in the bibliography at the back of the volume. Information on English translations (where available) and standard original-language editions and critical editions of the works cited is found in the bibliography. The Biographical Sketches section provides brief overviews of the life and work of each commentator, and each confession or collaborative work, appearing in the present volume (as well as in any previous volumes). Finally, a Timeline of the Reformation offers broader context for people, places and events relevant to the commentators and their works.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_7"
    }
  }, [_vm._v("Footnotes and Back Matter")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("To aid the reader in exploring the background and texts in further detail, this commentary utilizes footnotes. The use and content of footnotes may vary among the volumes in this series. Where footnotes appear, a footnote number directs the reader to a note at the bottom of the page, where one will find annotations (clarifications or biblical cross references), information on English translations (where available) or standard original-language editions of the work cited.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Where original-language texts have remained untranslated into English, we provide new translations. Where there is any serious ambiguity or textual problem in the selection, we have tried to reflect the best available textual tradition. Wherever current English translations are already well rendered, they are utilized, but where necessary they are stylistically updated. A single asterisk (*) indicates that a previous English translation has been updated to modern English or amended for easier reading. We have standardized spellings and made grammatical variables uniform so that our English references will not reflect the linguistic oddities of the older English translations. For ease of reading we have in some cases removed superfluous conjunctions.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxi",
      "title": "xxi"
    }
  })])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("General Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_vm._v("The Reformation Commentary on Scripture (RCS) is a twenty-eight-volume series of exegetical comment covering the entire Bible and gathered from the writings of sixteenth-century preachers, scholars and reformers. The RCS is intended as a sequel to the highly acclaimed Ancient Christian Commentary on Scripture (ACCS), and as such its overall concept, method, format and audience are similar to the earlier series. Both series are committed to the renewal of the church through careful study and meditative reflection on the Old and New Testaments, the charter documents of Christianity, read in the context of the worshiping, believing community of faith across the centuries. However, the patristic and Reformation eras are separated by nearly a millennium, and the challenges of reading Scripture with the reformers require special attention to their context, resources and assumptions. The purpose of this general introduction is to present an overview of the context and process of biblical interpretation in the age of the Reformation.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_8"
    }
  }, [_vm._v("Goals")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The Reformation Commentary on Scripture seeks to introduce its readers to the depth and richness of exegetical ferment that defined the Reformation era. The RCS has four goals: the enrichment of contemporary biblical interpretation through exposure to Reformation-era biblical exegesis; the renewal of contemporary preaching through exposure to the biblical insights of the Reformation writers; a deeper understanding of the Reformation itself and the breadth of perspectives represented within it; and a recovery of the profound integration of the life of faith and the life of the mind that should characterize Christian scholarship. Each of these goals requires a brief comment.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Renewing contemporary biblical interpretation")]), _c('b', [_vm._v(".")]), _vm._v(" During the past half-century, biblical hermeneutics has become a major growth industry in the academic world. One of the consequences of the historical-critical hegemony of biblical studies has been the privileging of contemporary philosophies and ideologies at the expense of a commitment to the Christian church as the primary reading community within which and for which biblical exegesis is done. Reading Scripture with the church fathers and the reformers is a corrective to all such imperialism of the present. One of the greatest skills required for a fruitful interpretation of the Bible is the ability to listen. We rightly emphasize the importance of listening to the voices of contextual theologies today, but in doing so we often marginalize or ignore another crucial context—the community of believing Christians through the centuries. The serious study of Scripture requires more than the latest "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxii",
      "title": "xxii"
    }
  }), _vm._v("Bible translation in one hand and the latest commentary (or niche study Bible) in the other. John L. Thompson has called on Christians today to practice the art of “reading the Bible with the dead.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-052-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The RCS presents carefully selected comments from the extant commentaries of the Reformation as an encouragement to more in-depth study of this important epoch in the history of biblical interpretation.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Strengthening contemporary preaching")]), _c('b', [_vm._v(".")]), _vm._v(" The Protestant reformers identified the public preaching of the Word of God as an indispensible means of grace and a sure sign of the true church. Through the words of the preacher, the living voice of the gospel ("), _c('i', [_vm._v("viva vox evangelii")]), _vm._v(") is heard. Luther famously said that the church is not a “pen house” but a “mouth house.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-051-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" The Reformation in Switzerland began when Huldrych Zwingli entered the pulpit of the Grossmünster in Zurich on January 1, 1519, and began to preach a series of expositional sermons chapter by chapter from the Gospel of Matthew. In the following years he extended this homiletical approach to other books of the Old and New Testaments. Calvin followed a similar pattern in Geneva. Many of the commentaries represented in this series were either originally presented as sermons or were written to support the regular preaching ministry of local church pastors. Luther said that the preacher should be a "), _c('i', [_vm._v("bonus textualis—")]), _vm._v("a good one with a text—well-versed in the Scriptures. Preachers in the Reformation traditions preached not only about the Bible but also from it, and this required more than a passing acquaintance with its contents. Those who have been charged with the office of preaching in the church today can find wisdom and insight—and fresh perspectives—in the sermons of the Reformation and the biblical commentaries read and studied by preachers of the sixteenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Deepening understanding of the Reformation.")]), _vm._v(" Some scholars of the sixteenth century prefer to speak of the period they study in the plural, the European Reformations, to indicate that many diverse impulses for reform were at work in this turbulent age of transition from medieval to modern times."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-050-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" While this point is well taken, the RCS follows the time-honored tradition of using "), _c('i', [_vm._v("Reformation")]), _vm._v(" in the singular form to indicate not only a major moment in the history of Christianity in the West but also, as Hans J. Hillerbrand has put it, “an essential cohesiveness in the heterogeneous pursuits of religious reform in the sixteenth century.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-049-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" At the same time, in developing guidelines to assist the volume editors in making judicious selections from the vast amount of commentary material available in this period, we have stressed the multifaceted character of the Reformation across many confessions, theological orientations and political settings.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Advancing Christian scholarship.")]), _vm._v(" By assembling and disseminating numerous voices from such a signal period as the Reformation, the RCS aims to make a significant contribution to the ever-growing stream of Christian scholarship. The post-Enlightenment split between the study "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxiii",
      "title": "xxiii"
    }
  }), _vm._v("of the Bible as an academic discipline and the reading of the Bible as spiritual nurture was foreign to the reformers. For them the study of the Bible was transformative at the most basic level of the human person: "), _c('i', [_vm._v("coram deo.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The reformers all repudiated the idea that the Bible could be studied and understood with dispassionate objectivity, as a cold artifact from antiquity. Luther’s famous Reformation breakthrough triggered by his laborious study of the Psalms and Paul’s letter to the Romans is well known, but the experience of Cambridge scholar Thomas Bilney was perhaps more typical. When Erasmus’s critical edition of the Greek New Testament was published in 1516, it was accompanied by a new translation in elegant Latin. Attracted by the classical beauty of Erasmus’s Latin, Bilney came across this statement in 1 Timothy 1:15: “Christ Jesus came into the world to save sinners.” In the Greek this sentence is described as "), _c('i', [_vm._v("pistos ho logos,")]), _vm._v(" which the Vulgate had rendered "), _c('i', [_vm._v("fidelis sermo,")]), _vm._v(" “a faithful saying.” Erasmus chose a different word for the Greek "), _c('i', [_vm._v("pistos")]), _vm._v("—"), _c('i', [_vm._v("certus,")]), _vm._v(" “sure, certain.” When Bilney grasped the meaning of this word applied to the announcement of salvation in Christ, he tells us that “Immediately, I felt a marvellous comfort and quietness, insomuch as ‘my bruised bones leaped for joy.’”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-048-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Luther described the way the Bible was meant to function in the minds and hearts of believers when he reproached himself and others for studying the nativity narrative with such cool unconcern:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("I hate myself because when I see Christ laid in the manger or in the lap of his mother and hear the angels sing, my heart does not leap into flame. With what good reason should we all despise ourselves that we remain so cold when this word is spoken to us, over which everyone should dance and leap and burn for joy! We act as though it were a frigid historical fact that does not smite our hearts, as if someone were merely relating that the sultan has a crown of gold."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-047-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("It was a core conviction of the Reformation that the careful study and meditative listening to the Scriptures, what the monks called "), _c('i', [_vm._v("lectio divina,")]), _vm._v(" could yield transformative results for "), _c('i', [_vm._v("all")]), _vm._v(" of life. The value of such a rich commentary, therefore, lies not only in the impressive volume of Reformation-era voices that are presented throughout the course of the series but in the many particular fields for which their respective lives and ministries are relevant. The Reformation is consequential for historical studies, both church as well as secular history. Biblical and theological studies, to say nothing of pastoral and spiritual studies, also stand to benefit and progress immensely from renewed engagement today, as mediated through the RCS, with the reformers of yesteryear.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_9"
    }
  }, [_c('b', [_vm._v("Perspectives")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In setting forth the perspectives and parameters of the RCS, the following considerations have proved helpful.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxiv",
      "title": "xxiv"
    }
  }), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Chronology")]), _c('b', [_vm._v(".")]), _vm._v(" When did the Reformation begin, and how long did it last? In some traditional accounts, the answer was clear: the Reformation began with the posting of Lu-ther’s Ninety-five Theses at Wittenberg in 1517 and ended with the death of Calvin in Geneva in 1564. Apart from reducing the Reformation to a largely German event with a side trip to Switzerland, this perspective fails to do justice to the important events that led up to Luther’s break with Rome and its many reverberations throughout Europe and beyond. In choosing commentary selections for the RCS, we have adopted the concept of the long sixteenth century, say, from the late 1400s to the mid-seventeenth century. Thus we have included commentary selections from early or pre-Reformation writers such as John Colet and Jacques Lefèvre d’Étaples to seventeenth-century figures such as Henry Ainsworth and Johann Gerhard"), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Confession.")]), _vm._v(" The RCS concentrates primarily, though not exclusively, on the exegetical writings of the Protestant reformers. While the ACCS provided a compendium of key consensual exegetes of the early Christian centuries, the Catholic/Protestant confessional divide in the sixteenth century tested the very idea of consensus, especially with reference to ecclesiology and soteriology. While many able and worthy exegetes faithful to the Roman Catholic Church were active during this period, this project has chosen to include primarily those figures that represent perspectives within the Protestant Reformation. For this reason we have not included comments on the apocryphal or deuterocanonical writings.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We recognize that “Protestant” and “Catholic” as contradistinctive labels are anachronistic terms for the early decades of the sixteenth century before the hardening of confessional identities surrounding the Council of Trent (1545–1563). Protestant figures such as Philipp Melanchthon, Johannes Oecolampadius and John Calvin were all products of the revival of sacred letters known as biblical humanism. They shared an approach to biblical interpretation that owed much to Desiderius Erasmus and other scholars who remained loyal to the Church of Rome. Careful comparative studies of Protestant and Catholic exegesis in the sixteenth century have shown surprising areas of agreement when the focus was the study of a particular biblical text rather than the standard confessional debates.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("At the same time, exegetical differences among the various Protestant groups could become strident and church-dividing. The most famous example of this is the interpretive impasse between Luther and Zwingli over the meaning of “This is my body” (Mt 26:26) in the words of institution. Their disagreement at the Colloquy of Marburg in 1529 had important christological and pastoral implications, as well as social and political consequences. Luther refused fellowship with Zwingli and his party at the end of the colloquy; in no small measure this bitter division led to the separate trajectories pursued by Lutheran and Reformed Protestantism to this day. In Elizabethan England, Puritans and Anglicans agreed that “Holy Scripture containeth all things necessary to salvation: so that whatsoever is not read therein, nor may be proved thereby, is not to be required of any man” (article 6 of the Thirty-Nine Articles of Religion), yet on the basis of their differing interpretations of the Bible they fought bitterly over the structures of the church, the clothing of the clergy and the ways of worship. On the matter of infant baptism, Catholics and "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxv",
      "title": "xxv"
    }
  }), _vm._v("Protestants alike agreed on its propriety, though there were various theories as to how a practice not mentioned in the Bible could be justified biblically. The Anabaptists were outliers on this subject. They rejected infant baptism altogether. They appealed to the example of the baptism of Jesus and to his final words as recorded in the Gospel of Matthew (Mt 28:19-20): “Go therefore, and make disciples of all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Spirit, teaching them to observe all that I have commanded you.” New Testament Christians, they argued, are to follow not only the commands of Jesus in the Great Commission, but also the exact order in which they were given: evangelize, baptize, catechize.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("These and many other differences of interpretation among the various Protestant groups are reflected in their many sermons, commentaries and public disputations. In the RCS, the volume editors’ introduction to each volume is intended to help the reader understand the nature and significance of doctrinal conversations and disputes that resulted in particular, and frequently clashing, interpretations. Footnotes throughout the text will be provided to explain obscure references, unusual expressions and other matters that require special comment. Volume editors have chosen comments on the Bible across a wide range of sixteenth-century confessions and schools of interpretation: biblical humanists, Lutheran, Reformed, Anglican, Puritan and Anabaptist. We have not pursued passages from post-Tridentine Catholic authors or from radical spiritualists and antitrinitarian writers, though sufficient material is available from these sources to justify another series.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Format")]), _c('b', [_vm._v(".")]), _vm._v(" The design of the RCS is intended to offer reader-friendly access to these classic texts. The availability of digital resources has given access to a huge residual database of sixteenth-century exegetical comment hitherto available only in major research universities and rare book collections. The RCS has benefited greatly from online databases such as Alexander Street Press’s Digital Library of Classical Protestant Texts (DLCPT) as well as freely accessible databases like the Post-Reformation Digital Library (prdl.org). Through the help of RCS editorial advisor Herman Selderhuis, we have also had access to the special Reformation collections of the Johannes a Lasco Bibliothek in Emden, Germany. In addition, modern critical editions and translations of Reformation sources have been published over the past generation. Original translations of Reformation sources are given unless an acceptable translation already exists.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Each volume in the RCS will include an introduction by the volume editor placing that portion of the canon within the historical context of the Protestant Reformation and presenting a summary of the theological themes, interpretive issues and reception of the particular book(s). The commentary itself consists of particular pericopes identified by a pericope heading; the biblical text in the English Standard Version ("), _c('span', {
    staticClass: "small-caps"
  }, [_c('i', [_vm._v("ESV")])]), _vm._v("), with significant textual variants registered in the footnotes; an overview of the pericope in which principal exegetical and theological concerns of the Reformation writers are succinctly noted; and excerpts from the Reformation writers identified by name according to the conventions of the "), _c('i', [_vm._v("Oxford Encyclopedia of the Reformation")]), _vm._v(". Each volume will also include a bibliography of sources cited, as well as an appendix of authors and source works.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The Reformation era was a time of verbal as well as physical violence, and this fact has presented "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxvi",
      "title": "xxvi"
    }
  }), _vm._v("a challenge for this project. Without unduly sanitizing the texts, where they contain anti-Semitic, sexist or inordinately polemical rhetoric, we have not felt obliged to parade such comments either. We have noted the abridgement of texts with ellipses and an explanatory footnote. While this procedure would not be valid in the critical edition of such a text, we have deemed it appropriate in a series whose primary purpose is pastoral and devotional. When translating "), _c('i', [_vm._v("homo")]), _vm._v(" or similar terms that refer to the human race as a whole or to individual persons without reference to gender, we have used alternative English expressions to the word "), _c('i', [_vm._v("man")]), _vm._v(" (or derivative constructions that formerly were used generically to signify humanity at large), whenever such substitutions can be made without producing an awkward or artificial construction.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As is true in the ACCS, we have made a special effort where possible to include the voices of women, though we acknowledge the difficulty of doing so for the early modern period when for a variety of social and cultural reasons few theological and biblical works were published by women. However, recent scholarship has focused on a number of female leaders whose literary remains show us how they understood and interpreted the Bible. Women who made significant contributions to the Reformation include Marguerite d’Angoulême, sister of King Francis I, who supported French reformist evangelicals including Calvin and who published a religious poem influenced by Luther’s theology, "), _c('i', [_vm._v("The Mirror of the Sinful Soul")]), _vm._v("; Argula von Grumbach, a Bavarian noblewoman who defended the teachings of Luther and Melanchthon before the theologians of the University of Ingolstadt; Katharina Schütz Zell, the wife of a former priest, Matthias Zell, and a remarkable reformer in her own right—she conducted funerals, compiled hymnbooks, defended the downtrodden and published a defense of clerical marriage as well as composing works of consolation on divine comfort and pleas for the toleration of Anabaptists and Catholics alike; and Anne Askew, a Protestant martyr put to death in 1546 after demonstrating remarkable biblical prowess in her examinations by church officials. Other echoes of faithful women in the age of the Reformation are found in their letters, translations, poems, hymns, court depositions and martyr records.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Lay culture, learned culture.")]), _vm._v(" In recent decades, much attention has been given to what is called “reforming from below,” that is, the expressions of religious beliefs and churchly life that characterized the popular culture of the majority of the population in the era of the Reformation. Social historians have taught us to examine the diverse pieties of townspeople and city folk, of rural religion and village life, the emergence of lay theologies and the experiences of women in the religious tumults of Reformation Europe."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-046-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Formal commentaries by their nature are artifacts of learned culture. Almost all of them were written in Latin, the lingua franca of learned discourse well past the age of the Reformation. Biblical commentaries were certainly not the primary means by which the Protestant Reformation spread so rapidly across wide sectors of sixteenth-century society. Small pamphlets and broadsheets, later called "), _c('i', [_vm._v("Flugschriften")]), _vm._v(" (“flying writings”), with their graphic woodcuts and cartoon-like depictions of Reformation personalities and events, became the means of choice for mass communication in the early age of printing. Sermons and works of "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxvii",
      "title": "xxvii"
    }
  }), _vm._v("devotion were also printed with appealing visual aids. Luther’s early writings were often accompanied by drawings and sketches from Lucas Cranach and other artists. This was done “above all for the sake of children and simple folk,” as Luther put it, “who are more easily moved by pictures and images to recall divine history than through mere words or doctrines.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-045-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We should be cautious, however, in drawing too sharp a distinction between learned and lay culture in this period. The phenomenon of preaching was a kind of verbal bridge between scholars at their desks and the thousands of illiterate or semiliterate listeners whose views were shaped by the results of Reformation exegesis. According to contemporary witness, more than one thousand people were crowding into Geneva to hear Calvin expound the Scriptures every day."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-044-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" An example of how learned theological works by Reformation scholars were received across divisions of class and social status comes from Lazare Drilhon, an apothecary of Toulon. He was accused of heresy in May 1545 when a cache of prohibited books was found hidden in his garden shed. In addition to devotional works, the French New Testament and a copy of Calvin’s Genevan liturgy, there was found a series of biblical commentaries, translated from the Latin into French: Martin Bucer’s on Matthew, François Lambert’s on the Apocalypse and one by Oecolampadius on 1 John."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-043-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Biblical exegesis in the sixteenth century was not limited to the kind of full-length commentaries found in Drilhon’s shed. Citations from the Bible and expositions of its meaning permeate the extant literature of sermons, letters, court depositions, doctrinal treatises, records of public disputations and even last wills and testaments. While most of the selections in the RCS will be drawn from formal commentary literature, other sources of biblical reflection will also be considered.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_10"
    }
  }, [_vm._v("Historical Context")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("The medieval legacy.")]), _vm._v(" On October 18, 1512, the degree "), _c('i', [_vm._v("Doctor in Biblia")]), _vm._v(" was conferred on Martin Luther, and he began his career as a professor in the University of Wittenberg. As is well known, Luther was also a monk who had taken solemn vows in the Augustinian Order of Hermits at Erfurt. These two settings—the university and the monastery—both deeply rooted in the Middle Ages, form the background not only for Luther’s personal vocation as a reformer but also for the history of the biblical commentary in the age of the Reformation. Since the time of the Venerable Bede (d. 735), sometimes called “the last of the Fathers,” serious study of the Bible had taken place primarily in the context of cloistered monasteries. The Rule of St. Benedict brought together "), _c('i', [_vm._v("lectio")]), _vm._v(" and "), _c('i', [_vm._v("meditatio,")]), _vm._v(" the knowledge of letters and the life of prayer. The liturgy was the medium through which the daily reading of the Bible, especially the Psalms, and the sayings of the church fathers came together in the spiritual formation of the monks."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-042-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Essential to this understanding "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxviii",
      "title": "xxviii"
    }
  }), _vm._v("was a belief in the unity of the people of God throughout time as well as space, and an awareness that life in this world was a preparation for the beatific vision in the next.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The source of theology was the study of the sacred page ("), _c('i', [_vm._v("sacra pagina")]), _vm._v("); its object was the accumulation of knowledge not for its own sake but for the obtaining of eternal life. For these monks, the Bible had God for its author, salvation for its end and unadulterated truth for its matter, though they would not have expressed it in such an Aristotelian way. The medieval method of interpreting the Bible owed much to Augustine’s "), _c('i', [_vm._v("On Christian Doctrine")]), _vm._v(". In addition to setting forth a series of rules (drawn from an earlier work by Tyconius), Augustine stressed the importance of distinguishing the literal and spiritual or allegorical senses of Scripture. While the literal sense was not disparaged, the allegorical was valued because it enabled the believer to obtain spiritual benefit from the obscure places in the Bible, especially in the Old Testament. For Augustine, as for the monks who followed him, the goal of scriptural exegesis was freighted with eschatological meaning; its purpose was to induce faith, hope and love and so to advance in one’s pilgrimage toward that city with foundations (see Heb 11:10).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Building on the work of Augustine and other church fathers going back to Origen, medieval exegetes came to understand Scripture as possessed of four possible meanings, the famous "), _c('i', [_vm._v("quadriga")]), _vm._v(". The literal meaning was retained, of course, but the spiritual meaning was now subdivided into three senses: the allegorical, the moral and the anagogical. Medieval exegetes often referred to the four meanings of Scripture in a popular rhyme:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("The letter shows us what God and our fathers did;")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("The allegory shows us where our faith is hid;")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("The moral meaning gives us rules of daily life;")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("The anagogy shows us where we end our strife."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-041-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In this schema, the three spiritual meanings of the text correspond to the three theological virtues: faith (allegory), hope (anagogy) and love (the moral meaning). It should be noted that this way of approaching the Bible assumed a high doctrine of scriptural inspiration: the multiple meanings inherent in the text had been placed there by the Holy Spirit for the benefit of the people of God. The biblical justification for this method went back to the apostle Paul, who had used the words "), _c('i', [_vm._v("allegory")]), _vm._v(" and "), _c('i', [_vm._v("type")]), _vm._v(" when applying Old Testament events to believers in Christ (Gal 4:21-31; 1 Cor 10:1-11). The problem with this approach was knowing how to relate each of the four senses to one another and how to prevent Scripture from becoming a nose of wax turned this way and that by various interpreters. As G. R. Evans explains, “Any interpretation which could be put upon the text and was in keeping with the faith and edifying, had the warrant of God himself, for no human reader had the ingenuity to find more than God had put there.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-040-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("With the rise of the universities in the eleventh century, theology and the study of Scripture moved from the cloister into the classroom. Scripture and the Fathers were still important, but they came to function more as footnotes to the theological questions debated in the schools and "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxix",
      "title": "xxix"
    }
  }), _vm._v("brought together in an impressive systematic way in works such as Peter Lombard’s "), _c('i', [_vm._v("Books of Sentences")]), _vm._v(" (the standard theology textbook of the Middle Ages) and the great scholastic "), _c('i', [_vm._v("summa")]), _vm._v("e of the thirteenth century. Indispensible to the study of the Bible in the later Middle Ages was the "), _c('i', [_vm._v("Glossa ordinaria,")]), _vm._v(" a collection of exegetical opinions by the church fathers and other commentators. Heiko Oberman summarized the transition from devotion to dialectic this way: “When, due to the scientific revolution of the twelfth century, Scripture became the "), _c('i', [_vm._v("object")]), _vm._v(" of study rather than the "), _c('i', [_vm._v("subject")]), _vm._v(" through which God speaks to the student, the difference between the two modes of speaking was investigated in terms of the texts themselves rather than in their relation to the recipients.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-039-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" It was possible, of course, to be both a scholastic theologian and a master of the spiritual life. Meister Eckhart, for example, wrote commentaries on the Old Testament in Latin and works of mystical theology in German, reflecting what had come to be seen as a division of labor between the two.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("An increasing focus on the text of Scripture led to a revival of interest in its literal sense. The two key figures in this development were Thomas Aquinas (d. 1274) and Nicholas of Lyra (d. 1340). Thomas is best remembered for his "), _c('i', [_vm._v("Summa Theologiae,")]), _vm._v(" but he was also a prolific commentator on the Bible. Thomas did not abandon the multiple senses of Scripture but declared that all the senses were founded on one—the literal—and this sense eclipsed allegory as the basis of sacred doctrine. Nicholas of Lyra was a Franciscan scholar who made use of the Hebrew text of the Old Testament and quoted liberally from works of Jewish scholars, especially the learned French rabbi Salomon Rashi (d. 1105). After Aquinas, Lyra was the strongest defender of the literal, historical meaning of Scripture as the primary basis of theological disputation. His "), _c('i', [_vm._v("Postilla,")]), _vm._v(" as his notes were called—the abbreviated form of "), _c('i', [_vm._v("post illa verba textus")]), _vm._v(", meaning “after these words from Scripture”—were widely circulated in the late Middle Ages and became the first biblical commentary to be printed in the fifteenth century. More than any other commentator from the period of high scholasticism, Lyra and his work were greatly valued by the early reformers. According to an old Latin pun, "), _c('i', [_vm._v("Nisi Lyra lyrasset, Lutherus non saltasset,")]), _vm._v(" “If Lyra had not played his lyre, Luther would not have danced.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-038-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" While Luther was never an uncritical disciple of any teacher, he did praise Lyra as a good Hebraist and quoted him more than one hundred times in his lectures on Genesis, where he declared, “I prefer him to almost all other interpreters of Scripture.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-037-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Sacred philology.")]), _vm._v(" The sixteenth century has been called a golden age of biblical interpretation, and it is a fact that the age of the Reformation witnessed an explosion of commentary writing unparalleled in the history of the Christian church. Kenneth Hagen has cataloged forty-five commentaries on Hebrews between 1516 (Erasmus) and 1598 (Beza)."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-036-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" During the sixteenth century, more than seventy new commentaries on Romans were published, five of them by Melanchthon alone, and nearly one hundred commentaries on the Bible’s prayer book, the Psalms."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-035-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" There were "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxx",
      "title": "xxx"
    }
  }), _vm._v("two developments in the fifteenth century that presaged this development and without which it could not have taken place: the invention of printing and the rediscovery of a vast store of ancient learning hitherto unknown or unavailable to scholars in the West.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("It is now commonplace to say that what the computer has become in our generation, the printing press was to the world of Erasmus, Luther and other leaders of the Reformation. Johannes Gutenberg, a goldsmith by trade, developed a metal alloy suitable for type and a machine that would allow printed characters to be cast with relative ease, placed in even lines of composition and then manipulated again and again, making possible the mass production of an unbelievable number of texts. In 1455, the Gutenberg Bible, the masterpiece of the typographical revolution, was published at Mainz in double columns in gothic type. Forty-seven copies of the beautiful Gutenberg Bible are still extant, each consisting of more than one thousand colorfully illuminated and impeccably printed pages. What began at Gutenberg’s print shop in Mainz on the Rhine River soon spread, like McDonald’s or Starbucks in our day, into every nook and cranny of the known world. Printing presses sprang up in Rome (1464), Venice (1469), Paris (1470), the Netherlands (1471), Switzerland (1472), Spain (1474), England (1476), Sweden (1483) and Constantinople (1490). By 1500, these and other presses across Europe had published some twenty-seven thousand titles, most of them in Latin. Erasmus once compared himself with an obscure preacher whose sermons were heard by only a few people in one or two churches while his books were read in every country in the world. Erasmus was not known for his humility, but in this case he was simply telling the truth."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-034-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The Italian humanist Lorenzo Valla (d. 1457) died in the early dawn of the age of printing, but his critical and philological studies would be taken up by others who believed that genuine reform in church and society could come about only by returning to the wellsprings of ancient learning and wisdom—"), _c('i', [_vm._v("ad fontes,")]), _vm._v(" “back to the sources!” Valla is best remembered for undermining a major claim made by defenders of the papacy when he proved by philological research that the so-called Donation of Constantine, which had bolstered papal assertions of temporal sovereignty, was a forgery. But it was Valla’s "), _c('i', [_vm._v("Collatio Novi Testamenti")]), _vm._v(" of 1444 that would have such a great effect on the renewal of biblical studies in the next century. Erasmus discovered the manuscript of this work while rummaging through an old library in Belgium and published it at Paris in 1505. In the preface to his edition of Valla, Erasmus gave the rationale that would guide his own labors in textual criticism. Just as Jerome had translated the Latin Vulgate from older versions and copies of the Scriptures in his day, so now Jerome’s own text must be subjected to careful scrutiny and correction. Erasmus would be "), _c('i', [_vm._v("Hieronymus redivivus,")]), _vm._v(" a new Jerome come back to life to advance the cause of sacred philology. The restoration of the Scriptures and the writings of the church fathers would usher in what Erasmus believed would be a golden age of peace and learning. In 1516, the Basel publisher Froben brought out Erasmus’s "), _c('i', [_vm._v("Novum Instrumentum,")]), _vm._v(" the first published edition of the Greek New Testament. Erasmus’s Greek New Testament would go through five editions in his lifetime, each one with new emendations to the text and a growing section of annotations that expanded to include not only "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxi",
      "title": "xxxi"
    }
  }), _vm._v("technical notes about the text but also theological comment. The influence of Erasmus’s Greek New Testament was enormous. It formed the basis for Robert Estienne’s "), _c('i', [_vm._v("Novum Testamentum Graece")]), _vm._v(" of 1550, which in turn was used to establish the Greek "), _c('i', [_vm._v("Textus Receptus")]), _vm._v(" for a number of late Reformation translations including the King James Version of 1611.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("For all his expertise in Greek, Erasmus was a poor student of Hebrew and only published commentaries on several of the psalms. However, the renaissance of Hebrew letters was part of the wider program of biblical humanism as reflected in the establishment of trilingual colleges devoted to the study of Hebrew, Greek and Latin (the three languages written on the "), _c('i', [_vm._v("titulus")]), _vm._v(" of Jesus’ cross [Jn 19:20]) at Alcalá in Spain, Wittenberg in Germany, Louvain in Belgium and Paris in France. While it is true that some medieval commentators, especially Nicholas of Lyra, had been informed by the study of Hebrew and rabbinics in their biblical work, it was the publication of Johannes Reuchlin’s "), _c('i', [_vm._v("De rudimentis hebraicis")]), _vm._v(" (1506), a combined grammar and dictionary, that led to the recovery of "), _c('i', [_vm._v("veritas Hebraica,")]), _vm._v(" as Jerome had referred to the true voice of the Hebrew Scriptures. The pursuit of Hebrew studies was carried forward in the Reformation by two great scholars, Konrad Pellikan and Sebastian Münster. Pellikan was a former Franciscan friar who embraced the Protestant cause and played a major role in the Zurich reformation. He had published a Hebrew grammar even prior to Reuchlin and produced a commentary on nearly the entire Bible that appeared in seven volumes between 1532 and 1539. Münster was Pellikan’s student and taught Hebrew at the University of Heidelberg before taking up a similar position in Basel. Like his mentor, Münster was a great collector of Hebraica and published a series of excellent grammars, dictionaries and rabbinic texts. Münster did for the Hebrew Old Testament what Erasmus had done for the Greek New Testament. His "), _c('i', [_vm._v("Hebraica Biblia")]), _vm._v(" offered a fresh Latin translation of the Old Testament with annotations from medieval rabbinic exegesis.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Luther first learned Hebrew with Reuchlin’s grammar in hand but took advantage of other published resources, such as the four-volume Hebrew Bible published at Venice by Daniel Bomberg in 1516 to 1517. He also gathered his own circle of Hebrew experts, his "), _c('i', [_vm._v("sanhedrin")]), _vm._v(" he called it, who helped him with his German translation of the Old Testament. We do not know where William Tyndale learned Hebrew, though perhaps it was in Worms, where there was a thriving rabbinical school during his stay there. In any event, he had sufficiently mastered the language to bring out a freshly translated Pentateuch that was published at Antwerp in 1530. By the time the English separatist scholar Henry Ainsworth published his prolix commentaries on the Pentateuch in 1616, the knowledge of Hebrew, as well as Greek, was taken for granted by every serious scholar of the Bible. In the preface to his commentary on Genesis, Ainsworth explained that “the literal sense of Moses’s Hebrew (which is the tongue wherein he wrote the law), is the ground of all interpretation, and that language hath figures and properties of speech, different from ours: These therefore in the first place are to be opened that the natural meaning of the Scripture, being known, the mysteries of godliness therein implied, may be better discerned.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-033-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxii",
      "title": "xxxii"
    }
  }), _vm._v("The restoration of the biblical text in the original languages made possible the revival of scriptural exposition reflected in the floodtide of sermon literature and commentary work. Of even more far-reaching import was the steady stream of vernacular Bibles in the sixteenth century. In the introduction to his 1516 edition of the New Testament, Erasmus had expressed his desire that the Scriptures be translated into all languages so that “the lowliest women” could read the Gospels and the Pauline epistles and “the farmer sing some portion of them at the plow, the weaver hum some parts of them to the movement of his shuttle, the traveler lighten the weariness of the journey with stories of this kind.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-032-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Like Erasmus, Tyndale wanted the Bible to be available in the language of the common people. He once said to a learned divine that if God spared his life he would cause the boy who drives the plow to know more of the Scriptures than he did!"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-031-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" The project of allowing the Bible to speak in the language of the mother in the house, the children in the street and the cheesemonger in the marketplace was met with stiff opposition by certain Catholic polemists such as Johann Eck, Luther’s antagonist at the Leipzig Debate of 1519. In his "), _c('i', [_vm._v("Enchiridion")]), _vm._v(" (1525), Eck derided the “inky theologians” whose translations paraded the Bible before “the untutored crowd” and subjected it to the judgment of “laymen and crazy old women.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-030-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" In fact, some fourteen German Bibles had already been published prior to Luther’s September Testament of 1522, which he translated from Erasmus’s Greek New Testament in less than three months’ time while sequestered in the Wartburg. Luther’s German New Testament became the first bestseller in the world, appearing in forty-three distinct editions between 1522 and 1525 with upward of one hundred thousand copies issued in these three years. It is estimated that 5 percent of the German population may have been literate at this time, but this rate increased as the century wore on due in no small part to the unmitigated success of vernacular Bibles."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-029-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Luther’s German Bible (inclusive of the Old Testament from 1534) was the most successful venture of its kind, but it was not alone in the field. Hans Denck and Ludwig Hätzer, leaders in the early Anabaptist movement, translated the prophetic books of the Old Testament from Hebrew into German in 1527. This work influenced the Swiss-German Bible of 1531 published by Leo Jud and other pastors in Zurich. Tyndale’s influence on the English language rivaled that of Luther on German. At a time when English was regarded as “that obscure and remote dialect of German spoken in an off-shore island,” Tyndale, with his remarkable linguistic ability (he was fluent in eight languages), “made a language for England,” as his modern editor David Daniell has put it."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-028-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Tyndale was imprisoned and executed near Brussels in 1536, but the influence of his biblical work "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxiii",
      "title": "xxxiii"
    }
  }), _vm._v("among the common people of England was already being felt. There is no reason to doubt the authenticity of John Foxe’s recollection of how Tyndale’s New Testament was received in England during the 1520s and 1530s:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The fervent zeal of those Christian days seemed much superior to these our days and times; as manifestly may appear by their sitting up all night in reading and hearing; also by their expenses and charges in buying of books in English, of whom some gave five marks, some more, some less, for a book: some gave a load of hay for a few chapters of St. James, or of St. Paul in English."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-027-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Calvin helped to revise and contributed three prefaces to the French Bible translated by his cousin Pierre Robert Olivétan and originally published at Neuchâtel in 1535. Clément Marot and Beza provided a fresh translation of the Psalms with each psalm rendered in poetic form and accompanied by monophonic musical settings for congregational singing. The Bay Psalter, the first book printed in America, was an English adaptation of this work. Geneva also provided the provenance of the most influential Italian Bible published by Giovanni Diodati in 1607. The flowering of biblical humanism in vernacular Bibles resulted in new translations in all of the major language groups of Europe: Spanish (1569), Portuguese (1681), Dutch (New Testament, 1523; Old Testament, 1527), Danish (1550), Czech (1579–1593/94), Hungarian (New Testament, 1541; complete Bible, 1590), Polish (1563), Swedish (1541) and even Arabic (1591)."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-026-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_11"
    }
  }, [_vm._v("Patterns of Reformation")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Once the text of the Bible had been placed in the hands of the people, in cheap and easily available editions, what further need was there of published expositions such as commentaries? Given the Protestant doctrine of the priesthood of all believers, was there any longer a need for learned clergy and their bookish religion? Some radical reformers thought not. Sebastian Franck searched for the true church of the Spirit “scattered among the heathen and the weeds” but could not find it in any of the institutional structures of his time. "), _c('i', [_vm._v("Veritas non potest scribi, aut exprimi,")]), _vm._v(" he said, “truth can neither be spoken nor written.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-025-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Kaspar von Schwenckfeld so emphasized religious inwardness that he suspended external observance of the Lord’s Supper and downplayed the readable, audible Scriptures in favor of the Word within. This trajectory would lead to the rise of the Quakers in the next century, but it was pursued neither by the mainline reformers nor by most of the Anabaptists. Article 7 of the Augsburg Confession (1530) declared the one holy Christian church to be “the assembly of all believers among whom the Gospel is purely preached and the holy sacraments are administered according to the Gospel.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-024-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Historians of the nineteenth century referred to the material and formal principles of the Reformation. In this construal, the matter at stake was the meaning of the Christian gospel: the "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxiv",
      "title": "xxxiv"
    }
  }), _vm._v("liberating insight that helpless sinners are graciously justified by the gift of faith alone, apart from any works or merits of their own, entirely on the basis of Christ’s atoning work on the cross. For Luther especially, justification by faith alone became the criterion by which all other doctrines and practices of the church were to be judged. The cross proves everything, he said at the Heidelberg disputation in 1518. The distinction between law and gospel thus became the primary hermeneutical key that unlocked the true meaning of Scripture.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The formal principle of the Reformation, "), _c('i', [_vm._v("sola Scriptura")]), _vm._v(", was closely bound up with proper distinctions between Scripture and tradition. “Scripture alone,” said Luther, “is the true lord and master of all writings and doctrine on earth. If that is not granted, what is Scripture good for? The more we reject it, the more we become satisfied with human books and human teachers.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-023-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" On the basis of this principle, the reformers challenged the structures and institutions of the medieval Catholic Church. Even a simple layperson, they asserted, armed with Scripture should be believed above a pope or a council without it. But, however boldly asserted, the doctrine of the primacy of Scripture did not absolve the reformers from dealing with a host of hermeneutical issues that became matters of contention both between Rome and the Reformation and within each of these two communities: the extent of the biblical canon, the validity of critical study of the Bible, the perspicuity of Scripture and its relation to preaching, and the retention of devotional and liturgical practices such as holy days, incense, the burning of candles, the sprinkling of holy water, church art and musical instruments. Zwingli, the Puritans and the radicals dismissed such things as a rubbish heap of ceremonials that amounted to nothing but tomfoolery, while Lutherans and Anglicans retained most of them as consonant with Scripture and valuable aids to worship.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("It is important to note that while the mainline reformers differed among themselves on many matters, overwhelmingly they saw themselves as part of the ongoing Catholic tradition, indeed as the legitimate bearers of it. This was seen in numerous ways including their sense of continuity with the church of the preceding centuries; their embrace of the ecumenical orthodoxy of the early church; and their desire to read the Bible in dialogue with the exegetical tradition of the church.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In their biblical commentaries, the reformers of the sixteenth century revealed a close familiarity with the preceding exegetical tradition, and they used it respectfully as well as critically in their own expositions of the sacred text. For them, "), _c('i', [_vm._v("sola Scriptura")]), _vm._v(" was not "), _c('i', [_vm._v("nuda Scriptura")]), _vm._v(". Rather, the Scriptures were seen as the book given to the church, gathered and guided by the Holy Spirit. In his restatement of the Vincentian canon, Calvin defined the church as “a society of all the saints, a society which, spread over the whole world, and existing in all ages, and bound together by the one doctrine and the one spirit of Christ, cultivates and observes unity of faith and brotherly concord. With this church we deny that we have any disagreement. Nay, rather, as we revere her as our mother, so we desire to remain in her bosom.” Defined thus, the church has a real, albeit relative and circumscribed, authority since, as Calvin admits, “We cannot fly without wings.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-022-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" While the reformers could not agree with the Council of Trent (though some recent Catholic "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxv",
      "title": "xxxv"
    }
  }), _vm._v("theologians have challenged this interpretation) that Scripture and tradition were two separate and equal sources of divine revelation, they did believe in the coinherence of Scripture and tradition. This conviction shaped the way they read and interpreted the Bible."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-021-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_12"
    }
  }, [_vm._v("Schools of Exegesis")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The reformers were passionate about biblical exegesis, but they showed little concern for hermeneutics as a separate field of inquiry. Niels Hemmingsen, a Lutheran theologian in Denmark, did write a treatise, "), _c('i', [_vm._v("De methodis")]), _vm._v(" (1555), in which he offered a philosophical and theological framework for the interpretation of Scripture. This was followed by the "), _c('i', [_vm._v("Clavis Scripturae Sacrae")]), _vm._v(" (1567) of Matthias Flacius Illyricus, which contains some fifty rules for studying the Bible drawn from Scripture itself."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-020-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" However, hermeneutics as we know it came of age only in the Enlightenment and should not be backloaded into the Reformation. It is also true that the word "), _c('i', [_vm._v("commentary")]), _vm._v(" did not mean in the sixteenth century what it means for us today. Erasmus provided both annotations and paraphrases on the New Testament, the former a series of critical notes on the text but also containing points of doctrinal substance, the latter a theological overview and brief exposition. Most of Calvin’s commentaries began as sermons or lectures presented in the course of his pastoral ministry. In the dedication to his 1519 study of Galatians, Luther declared that his work was “not so much a commentary as a testimony of my faith in Christ.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-019-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" The exegetical work of the reformers was embodied in a wide variety of forms and genres, and the RCS has worked with this broader concept in setting the guidelines for this compendium.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The Protestant reformers shared in common a number of key interpretive principles such as the priority of the grammatical-historical sense of Scripture and the christological centeredness of the entire Bible, but they also developed a number of distinct approaches and schools of exegesis."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-018-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" For the purposes of the RCS, we note the following key figures and families of interpretation in this period.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Biblical humanism.")]), _vm._v(" The key figure is Erasmus, whose importance is hard to exaggerate for Catholic and Protestant exegetes alike. His annotated Greek New Testament and fresh Latin translation challenged the hegemony of the Vulgate tradition and was doubtless a factor in the decision of the Council of Trent to establish the Vulgate edition as authentic and normative. Erasmus believed that the wide distribution of the Scriptures would contribute to personal spiritual renewal and the reform of society. In 1547, the English translation of Erasmus’s "), _c('i', [_vm._v("Paraphrases")]), _vm._v(" was ordered to be placed in every parish church in England. John Colet first encouraged Erasmus "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxvi",
      "title": "xxxvi"
    }
  }), _vm._v("to learn Greek, though he never took up the language himself. Colet’s lectures on Paul’s epistles at Oxford are reflected in his commentaries on Romans and 1 Corinthians.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Jacques Lefèvre d’Étaples has been called the “French Erasmus” because of his great learning and support for early reform movements in his native land. He published a major edition of the Psalter, as well as commentaries on the Pauline Epistles (1512), the Gospels (1522) and the General Epistles (1527). Guillaume Farel, the early reformer of Geneva, was a disciple of Lefèvre, and the young Calvin also came within his sphere of influence.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Among pre-Tridentine Catholic reformers, special attention should be given to Thomas de Vio, better known as Cajetan. He is best remembered for confronting Martin Luther on behalf of the pope in 1518, but his biblical commentaries (on nearly every book of the Bible) are virtually free of polemic. Like Erasmus, he dared to criticize the Vulgate on linguistic grounds. His commentary on Romans supported the doctrine of justification by grace applied by faith based on the “alien righteousness” of God in Christ. Jared Wicks sums up Cajetan’s significance in this way: “Cajetan’s combination of passion for pristine biblical meaning with his fully developed theological horizon of understanding indicates, in an intriguing manner, something of the breadth of possibilities open to Roman Catholics before a more restrictive settlement came to exercise its hold on many Catholic interpreters in the wake of the Council of Trent.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-017-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Girolamo Seripando, like Cajetan, was a cardinal in the Catholic Church, though he belonged to the Augustinian rather than the Dominican order. He was an outstanding classical scholar and published commentaries on Romans and Galatians. Also important is Jacopo Sadoleto, another cardinal, best known for his 1539 letter to the people of Geneva beseeching them to return to the church of Rome, to which Calvin replied with a manifesto of his own. Sadoleto published a commentary on Romans in 1535. Bucer once commended Sadoleto’s teaching on justification as approximating that of the reformers, while others saw him tilting away from the Augustinian tradition toward Pelagianism."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-016-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Luther and the Wittenberg School.")]), _vm._v(" It was in the name of the Word of God, and specifically as a doctor of Scripture, that Luther challenged the church of his day and inaugurated the Reformation. Though Luther renounced his monastic vows, he never lost that sense of intimacy with "), _c('i', [_vm._v("sacra pagina")]), _vm._v(" he first acquired as a young monk. Luther provided three rules for reading the Bible: prayer, meditation and struggle ("), _c('i', [_vm._v("tentatio")]), _vm._v("). His exegetical output was enormous. In the American edition of Luther’s works, thirty out of the fifty-five volumes are devoted to his biblical studies, and additional translations are planned. Many of his commentaries originated as sermons or lecture notes presented to his students at the university and to his parishioners at Wittenberg’s parish church of St. Mary. Luther referred to Galatians as his bride: “The Epistle to the Galatians is my dear epistle. I have betrothed myself to it. It is my Käthe von Bora.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-015-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" He considered his 1535 commentary on Galatians his greatest exegetical work, although his massive commentary on "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxvii",
      "title": "xxxvii"
    }
  }), _vm._v("Genesis (eight volumes in LW), which he worked on for ten years (1535–1545), must be considered his crowning work. Luther’s principles of biblical interpretation are found in his "), _c('i', [_vm._v("Open Letter on Translating")]), _vm._v(" and in the prefaces he wrote to all the books of the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Philipp Melanchthon was brought to Wittenberg to teach Greek in 1518 and proved to be an able associate to Luther in the reform of the church. A set of his lecture notes on Romans was published without his knowledge in 1522. This was revised and expanded many times until his large commentary of 1556. Melanchthon also commented on other New Testament books including Matthew, John, Galatians and the Petrine epistles, as well as Proverbs, Daniel and Ecclesiastes. Though he was well trained in the humanist disciplines, Melanchthon devoted little attention to critical and textual matters in his commentaries. Rather, he followed the primary argument of the biblical writer and gathered from this exposition a series of doctrinal topics for special consideration. This method lay behind Melanchthon’s "), _c('i', [_vm._v("Loci communes")]), _vm._v(" (1521), the first Protestant theology textbook to be published. Another Wittenberger was Johannes Bugenhagen of Pomerania, a prolific commentator on both the Old and New Testaments. His commentary on the Psalms (1524), translated into German by Bucer, applied Luther’s teaching on justification to the Psalter. He also wrote a commentary on Job and annotations on many of the books in the Bible. The Lutheran exegetical tradition was shaped by many other scholar-reformers including Andreas Osiander, Johannes Brenz, Caspar Cruciger, Erasmus Sarcerius, Georg Maior, Jacob Andreae, Nikolaus Selnecker and Johann Gerhard.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Strasbourg-Basel tradition")]), _c('b', [_vm._v(".")]), _vm._v(" Bucer, the son of a shoemaker in Alsace, became the leader of the Reformation in Strasbourg. A former Dominican, he was early on influenced by Erasmus and continued to share his passion for Christian unity. Bucer was the most ecumenical of the Protestant reformers seeking rapprochement with Catholics on justification and an armistice between Luther and Zwingli in their strife over the Lord’s Supper. Bucer also had a decisive influence on Calvin, though the latter characterized his biblical commentaries as longwinded and repetitious."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-014-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" In his exegetical work, Bucer made ample use of patristic and medieval sources, though he criticized the abuse and overuse of allegory as “the most blatant insult to the Holy Spirit.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-013-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" He declared that the purpose of his commentaries was “to help inexperienced brethren [perhaps like the apothecary Drilhon, who owned a French translation of Bucer’s "), _c('i', [_vm._v("Commentary on Matthew")]), _vm._v("] to understand each of the words and actions of Christ, and in their proper order as far as possible, and to retain an explanation of them in their natural meaning, so that they will not distort God’s Word through age-old aberrations or by inept interpretation, but rather with a faithful comprehension of everything as written by the Spirit of God, they may expound to all the churches in their firm upbuilding in faith and love.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-012-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" In addition to writing commentaries on all four Gospels, Bucer published commentaries on Judges, the Psalms, Zephaniah, Romans and Ephesians. In the early years of the "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxviii",
      "title": "xxxviii"
    }
  }), _vm._v("Reformation, there was a great deal of back and forth between Strasbourg and Basel, and both were centers of a lively publishing trade. Wolfgang Capito, Bucer’s associate at Strasbourg, was a notable Hebraist and composed commentaries on Hosea (1529) and Habakkuk (1527).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("At Basel, the great Sebastian Münster defended the use of Jewish sources in the Christian study of the Old Testament and published, in addition to his famous Hebrew grammar, an annotated version of the Gospel of Matthew translated from Greek into Hebrew. Oecolampadius, Basel’s chief reformer, had been a proofreader in Froben’s publishing house and worked with Erasmus on his Greek New Testament and his critical edition of Jerome. From 1523 he was both a preacher and professor of Holy Scripture at Basel. He defended Zwingli’s eucharistic theology at the Colloquy of Marburg and published commentaries on 1 John (1524), Romans (1525) and Haggai–Malachi (1525). Oecolampadius was succeeded by Simon Grynaeus, a classical scholar who taught Greek and supported Bucer’s efforts to bring Lutherans and Zwinglians together. More in line with Erasmus was Sebastian Castellio, who came to Basel after his expulsion from Geneva in 1545. He is best remembered for questioning the canonicity of the Song of Songs and for his annotations and French translation of the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Zurich group")]), _c('b', [_vm._v(".")]), _vm._v(" Biblical exegesis in Zurich was centered on the distinctive institution of the "), _c('i', [_vm._v("Prophezei,")]), _vm._v(" which began on June 19, 1525. On five days a week, at seven o’clock in the morning, all of the ministers and theological students in Zurich gathered into the choir of the Grossmünster to engage in a period of intense exegesis and interpretation of Scripture. After Zwingli had opened the meeting with prayer, the text of the day was read in Latin, Greek and Hebrew, followed by appropriate textual or exegetical comments. One of the ministers then delivered a sermon on the passage in German that was heard by many of Zurich’s citizens who stopped by the cathedral on their way to work. This institute for advanced biblical studies had an enormous influence as a model for Reformed academies and seminaries throughout Europe. It was also the seedbed for sermon series in Zurich’s churches and the extensive exegetical publications of Zwingli, Leo Jud, Konrad Pellikan, Heinrich Bullinger, Oswald Myconius and Rudolf Gwalther. Zwingli had memorized in Greek all of the Pauline epistles, and this bore fruit in his powerful expository preaching and biblical exegesis. He took seriously the role of grammar, rhetoric and historical research in explaining the biblical text. For example, he disagreed with Bucer on the value of the Septuagint, regarding it as a trustworthy witness to a proto-Hebrew version earlier than the Masoretic text.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Zwingli’s work was carried forward by his successor Bullinger, one of the most formidable scholars and networkers among the reformers. He composed commentaries on Daniel (1565), the Gospels (1542–1546), the Epistles (1537), Acts (1533) and Revelation (1557). He collaborated with Calvin to produce the "), _c('i', [_vm._v("Consensus Tigurinus")]), _vm._v(" (1549), a Reformed accord on the nature of the Lord’s Supper, and produced a series of fifty sermons on Christian doctrine, known as "), _c('i', [_vm._v("Decades,")]), _vm._v(" which became required reading in Elizabethan England. As the "), _c('i', [_vm._v("Antistes")]), _vm._v(" (“overseer”) of the Zurich church for forty-four years, Bullinger faced opposition from nascent Anabaptism on the one hand and resurgent Catholicism on the other. The need for a well-trained clergy and scholarly resources, including Scripture commentaries, arose from the fact that the Bible was “difficult or "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexxxix",
      "title": "xxxix"
    }
  }), _vm._v("obscure to the unlearned, unskillful, unexercised, and malicious or corrupted wills.” While forswearing papal claims to infallibility, Bullinger and other leaders of the magisterial Reformation saw the need for a kind of Protestant magisterium as a check against the tendency to read the Bible in “such sense as everyone shall be persuaded in himself to be most convenient.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-011-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Two other commentators can be treated in connection with the Zurich group, though each of them had a wide-ranging ministry across the Reformation fronts. A former Benedictine monk, Wolfgang Musculus, embraced the Reformation in the 1520s and served briefly as the secretary to Bucer in Strasbourg. He shared Bucer’s desire for Protestant unity and served for seventeen years (1531–1548) as a pastor and reformer in Augsburg. After a brief time in Zurich, where he came under the influence of Bullinger, Musculus was called to Bern, where he taught the Scriptures and published commentaries on the Psalms, the Decalogue, Genesis, Romans, Isaiah, 1 and 2 Corinthians, Galatians and Ephesians, Philippians, Colossians, 1 and 2 Thessalonians, and 1 Timothy. Drawing on his exegetical writings, Musculus also produced a compendium of Protestant theology that was translated into English in 1563 as "), _c('i', [_vm._v("Commonplaces of Christian Religion")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Peter Martyr Vermigli was a Florentine-born scholar and Augustinian friar who embraced the Reformation and fled to Switzerland in 1542. Over the next twenty years, he would gain an international reputation as a prolific scholar and leading theologian within the Reformed community. He lectured on the Old Testament at Strasbourg, was made regius professor at Oxford, corresponded with the Italian refugee church in Geneva and spent the last years of his life as professor of Hebrew at Zurich. Vermigli published commentaries on 1 Corinthians, Romans and Judges during his lifetime. His biblical lectures on Genesis, Lamentations, 1 and 2 Samuel, and 1 and 2 Kings were published posthumously. The most influential of his writings was the "), _c('i', [_vm._v("Loci communes")]), _vm._v(" ("), _c('i', [_vm._v("Commonplaces")]), _vm._v("), a theological compendium drawn from his exegetical writings.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Genevan reformers.")]), _vm._v(" What Zwingli and Bullinger were to Zurich, Calvin and Beza were to Geneva. Calvin has been called “the father of modern biblical scholarship,” and his exegetical work is without parallel in the Reformation. Because of the success of his "), _c('i', [_vm._v("Institutes of the Christian Religion")]), _vm._v(" Calvin has sometimes been thought of as a man of one book, but he always intended the "), _c('i', [_vm._v("Institutes,")]), _vm._v(" which went through eight editions in Latin and five in French during his lifetime, to serve as a guide to the study of the Bible, to show the reader “what he ought especially to seek in Scripture and to what end he ought to relate its contents.” Jacob Arminius, who modified several principles of Calvin’s theology, recommended his commentaries next to the Bible, for, as he said, Calvin “is incomparable in the interpretation of Scripture.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-010-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Drawing on his superb knowledge of Greek and Hebrew and his thorough training in humanist rhetoric, Calvin produced commentaries on all of the New Testament books except 2 and 3 John and Revelation. Calvin’s Old Testament commentaries originated as sermon and lecture series and include Genesis, Psalms, Hosea, Isaiah, "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexl",
      "title": "xl"
    }
  }), _vm._v("minor prophets, Daniel, Jeremiah and Lamentations, a harmony of the last four books of Moses, Ezekiel 1–20, and Joshua. Calvin sought for brevity and clarity in all of his exegetical work. He emphasized the illumination of the Holy Spirit as essential to a proper understanding of the text. Calvin underscored the continuity between the two Testaments (one covenant in two dispensations) and sought to apply the plain or natural sense of the text to the church of his day. In the preface to his own influential commentary on Romans, Karl Barth described how Calvin worked to recover the mind of Paul and make the apostle’s message relevant to his day:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("How energetically Calvin goes to work, first scientifically establishing the text (“what stands there?”), then following along the footsteps of its thought; that is to say, he conducts a discussion with it until the wall between the first and the sixteenth centuries becomes transparent, and until there in the first century Paul speaks and here the man of the sixteenth century hears, until indeed the conversation between document and reader becomes concentrated upon the substance (which must be the same now as then)."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-009-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Beza was elected moderator of Geneva’s Company of Pastors after Calvin’s death in 1564 and guided the Genevan Reformation over the next four decades. His annotated Latin translation of the Greek New Testament (1556) and his further revisions of the Greek text established his reputation as the leading textual critic of the sixteenth century after Erasmus. Beza completed the translation of Marot’s metrical Psalter, which became a centerpiece of Huguenot piety and Reformed church life. Though known for his polemical writings on grace, free will and predestination, Beza’s work is marked by a strong pastoral orientation and concern for a Scripture-based spirituality.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Robert Estienne (Stephanus) was a printer-scholar who had served the royal household in Paris. After his conversion to Protestantism, in 1550 he moved to Geneva, where he published a series of notable editions and translations of the Bible. He also produced sermons and commentaries on Job, Ecclesiastes, the Song of Songs, Romans and Hebrews, as well as dictionaries, concordances and a thesaurus of biblical terms. He also published the first editions of the Bible with chapters divided into verses, an innovation that quickly became universally accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("The British Reformation.")]), _vm._v(" Commentary writing in England and Scotland lagged behind the continental Reformation for several reasons. In 1500, there were only three publishing houses in England compared with more than two hundred on the Continent. A 1408 statute against publishing or reading the Bible in English, stemming from the days of Lollardy, stifled the free flow of ideas, as was seen in the fate of Tyndale. Moreover, the nature of the English Reformation from Henry through Elizabeth provided little stability for the flourishing of biblical scholarship. In the sixteenth century, many “hot-gospel” Protestants in England were edified by the English translations of commentaries and theological writings by the Continental reformers. The influence of Calvin and Beza was felt especially in the Geneva Bible with its “Protestant glosses” of theological notes and references.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexli",
      "title": "xli"
    }
  }), _vm._v("During the later Elizabethan and Stuart church, however, the indigenous English commentary came into its own. Both Anglicans and Puritans contributed to this outpouring of biblical studies. The sermons of Lancelot Andrewes and John Donne are replete with exegetical insights based on a close study of the Greek and Hebrew texts. Among the Reformed authors in England, none was more influential than William Perkins, the greatest of the early Puritan theologians, who published commentaries on Galatians, Jude, Revelation and the Sermon on the Mount (Mt 5–7). John Cotton, one of his students, wrote commentaries on the Song of Songs, Ecclesiastes and Revelation before departing for New England in 1633. The separatist pastor Henry Ainsworth was an outstanding scholar of Hebrew and wrote major commentaries on the Pentateuch, the Psalms and the Song of Songs. In Scotland, Robert Rollock, the first principal of Edinburgh University (1585), wrote numerous commentaries including those on the Psalms, Ephesians, Daniel, Romans, 1 and 2 Thessalonians, John, Colossians and Hebrews. Joseph Mede and Thomas Brightman were leading authorities on Revelation and contributed to the apocalyptic thought of the seventeenth century. Mention should also be made of Archbishop James Ussher, whose "), _c('i', [_vm._v("Annals of the Old Testament")]), _vm._v(" was published in 1650. Ussher developed a keen interest in biblical chronology and calculated that the creation of the world had taken place on October 26, 4004 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("B.C")]), _vm._v(". As late as 1945, the Scofield Reference Bible still retained this date next to Genesis 1:1, but later editions omitted it because of the lack of evidence on which to fix such dates."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-008-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Anabaptism.")]), _vm._v(" Irena Backus has noted that there was no school of “dissident” exegesis during the Reformation, and the reasons are not hard to find. The radical Reformation was an ill-defined movement that existed on the margins of official church life in the sixteenth century. The denial of infant baptism and the refusal to swear an oath marked radicals as a seditious element in society, and they were persecuted by Protestants and Catholics alike. However, in the RCS we have made an attempt to include some voices of the radical Reformation, especially among the Anabaptists. While the Anabaptists published few commentaries in the sixteenth century, they were avid readers and quoters of the Bible. Numerous exegetical gems can be found in their letters, treatises, martyr acts (especially "), _c('i', [_vm._v("The Martyrs’ Mirror")]), _vm._v("), hymns and histories. They placed a strong emphasis on the memorizing of Scripture and quoted liberally from vernacular translations of the Bible. George H. Williams has noted that “many an Anabaptist theological tract was really a beautiful mosaic of Scripture texts.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-007-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" In general, most Anabaptists accepted the apocryphal books as canonical, contrasted outer word and inner spirit with relative degrees of strictness and saw the New Testament as normative for church life and social ethics (witness their pacifism, nonswearing, emphasis on believers’ baptism and congregational discipline).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We have noted the Old Testament translation of Ludwig Hätzer, who became an anti­trinitarian, and Hans Denck that they published at Worms in 1527. Denck also wrote a notable commentary on Micah. Conrad Grebel belonged to a Greek reading circle in Zurich and came to his Anabaptist convictions while poring over the text of Erasmus’s New Testament. The only Anabaptist "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexlii",
      "title": "xlii"
    }
  }), _vm._v("leader with university credentials was Balthasar Hubmaier, who was made a doctor of theology (Ingolstadt, 1512) in the same year as Luther. His reflections on the Bible are found in his numerous writings, which include the first catechism of the Reformation (1526), a two-part treatise on the freedom of the will and a major work ("), _c('i', [_vm._v("On the Sword")]), _vm._v(") setting forth positive attitudes toward the role of government and the Christian’s place in society. Melchior Hoffman was an apocalyptic seer who wrote commentaries on Romans, Revelation and Daniel 12. He predicted that Christ would return in 1533. More temperate was Pilgram Marpeck, a mining engineer who embraced Anabaptism and traveled widely throughout Switzerland and south Germany, from Strasbourg to Augsburg. His “Admonition of 1542” is the longest published defense of Anabaptist views on baptism and the Lord’s Supper. He also wrote many letters that functioned as theological tracts for the congregations he had founded dealing with topics such as the fruits of repentance, the lowliness of Christ and the unity of the church. Menno Simons, a former Catholic priest, became the most outstanding leader of the Dutch Anabaptist movement. His masterpiece was the "), _c('i', [_vm._v("Foundation of Christian Doctrine")]), _vm._v(" published in 1540. His other writings include "), _c('i', [_vm._v("Meditation on the Twenty-fifth Psalm")]), _vm._v(" (1537); "), _c('i', [_vm._v("A Personal Exegesis of Psalm Twenty-five")]), _vm._v(" modeled on the style of Augustine’s "), _c('i', [_vm._v("Confessions")]), _vm._v("; "), _c('i', [_vm._v("Confession of the Triune God")]), _vm._v(" (1550), directed against Adam Pastor, a former disciple of Menno who came to doubt the divinity of Christ; "), _c('i', [_vm._v("Meditations and Prayers for Mealtime")]), _vm._v(" (1557); and the "), _c('i', [_vm._v("Cross of the Saints")]), _vm._v(" (1554), an exhortation to faithfulness in the face of persecution. Like many other Anabaptists, Menno emphasized the centrality of discipleship ("), _c('i', [_vm._v("Nachfolge")]), _vm._v(") as a deliberate repudiation of the old life and a radical commitment to follow Jesus as Lord.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_13"
    }
  }, [_vm._v("Reading Scripture with the Reformers")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In 1947, Gerhard Ebeling set forth his thesis that the history of the Christian church is the history of the interpretation of Scripture. Since that time, the place of the Bible in the story of the church has been investigated from many angles. A better understanding of the history of exegesis has been aided by new critical editions and scholarly discussions of the primary sources. The "), _c('i', [_vm._v("Cambridge History of the Bible,")]), _vm._v(" published in three volumes (1963–1970), remains a standard reference work in the field. The ACCS built on, and itself contributed to, the recovery of patristic biblical wisdom of both East and West. Beryl Smalley’s "), _c('i', [_vm._v("The Study of the Bible in the Middle Ages")]), _vm._v(" (1940) and Henri de Lubac’s "), _c('i', [_vm._v("Medieval Exegesis: The Four Senses of Scripture")]), _vm._v(" (1959) are essential reading for understanding the monastic and scholastic settings of commentary work between Augustine and Luther. The Reformation took place during what has been called “le grand siècle de la Bible.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-006-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Aided by the tools of Renaissance humanism and the dynamic impetus of Reformation theology (including permutations and reactions against it), the sixteenth century produced an unprecedented number of commentaries on every book in the Bible. Drawing from this vast storehouse of exegetical treasures, the RCS allows us to read Scripture along with the reformers. In doing so, it serves as a practical homiletic and devotional guide to some of the greatest masters of biblical interpretation in the history of the church.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexliii",
      "title": "xliii"
    }
  }), _vm._v("The RCS gladly acknowledges its affinity with and dependence on recent scholarly investigations of Reformation-era exegesis. Between 1976 and 1990, three international colloquia on the history of biblical exegesis in the sixteenth century took place in Geneva and in Durham, North Carolina."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-005-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Among those participating in these three gatherings were a number of scholars who have produced groundbreaking works in the study of biblical interpretation in the Reformation. These include Elsie McKee, Irena Backus, Kenneth Hagen, Scott H. Hendrix, Richard A. Muller, Guy Bedouelle, Gerald Hobbs, John B. Payne, Bernard Roussel, Pierre Fraenkel and David C. Steinmetz. Among other scholars whose works are indispensible for the study of this field are Heinrich Bornkamm, Jaroslav Pelikan, Heiko A. Oberman, James S. Preus, T. H. L. Parker, David F. Wright, Tony Lane, John L. Thompson, Frank A. James and Timothy J. Wengert."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-004-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Among these scholars no one has had a greater influence on the study of Reformation exegesis than David C. Steinmetz. A student of Oberman, he has emphasized the importance of understanding the Reformation in medieval perspective. In addition to important studies on Luther and Staupitz, he has pioneered the method of comparative exegesis showing both continuity and discontinuity between major Reformation figures and the preceding exegetical traditions (see his "), _c('i', [_vm._v("Luther in Context")]), _vm._v(" and "), _c('i', [_vm._v("Calvin in Context")]), _vm._v("). From his base at Duke University, he has spawned what might be called a Steinmetz school, a cadre of students and scholars whose work on the Bible in the Reformation era continues to shape the field. Steinmetz serves on the RCS Board of Editorial Advisors, and a number of our volume editors have pursued doctoral studies under his supervision.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In 1980, Steinmetz published “The Superiority of Pre-critical Exegesis,” a seminal essay that not only placed Reformation exegesis in the context of the preceding fifteen centuries of the church’s study of the Bible but also challenged certain assumptions underlying the hegemony of historical-critical exegesis of the post-Enlightenment academy."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-003-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Steinmetz helps us to approach the reformers and other precritical interpreters of the Bible on their own terms as faithful witnesses to the church’s apostolic tradition. For them, a specific book or pericope had to be understood within the scope of the consensus of the canon. Thus the reformers, no less than the Fathers and the schoolmen, interpreted the hymn of the Johannine prologue about the preexistent Christ in consonance with the creation narrative of Genesis 1. In the same way, Psalm 22, Isaiah 53 and Daniel 7 are seen as part of an overarching storyline that finds ultimate fulfillment in Jesus Christ. Reading the Bible with the resources of the new learning, the reformers challenged the exegetical conclusions of their medieval predecessors at many points. However, unlike Alexander "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexliv",
      "title": "xliv"
    }
  }), _vm._v("Campbell in the nineteenth century, their aim was not to “open the New Testament as if mortal man had never seen it before.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-002-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Rather, they wanted to do their biblical work as part of an interpretive conversation within the family of the people of God. In the reformers’ emphatic turn to the literal sense, which prompted their many blasts against the unrestrained use of allegory, their work was an extension of a similar impulse made by Thomas Aquinas and Nicholas of Lyra.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This is not to discount the radically new insights gained by the reformers in their dynamic engagement with the text of Scripture; nor should we dismiss in a reactionary way the light shed on the meaning of the Bible by the scholarly accomplishments of the past two centuries. However, it is to acknowledge that the church’s exegetical tradition is an indispensible aid for the proper interpretation of Scripture. And this means, as Richard Muller has said, that “while it is often appropriate to recognize that traditionary readings of the text are erroneous on the grounds offered by the historical-critical method, we ought also to recognize that the conclusions offered by historical-critical exegesis may themselves be quite erroneous on the grounds provided by the exegesis of the patristic, medieval, and reformation periods.”"), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" The RCS wishes to commend the exegetical work of the Reformation era as a program of retrieval for the sake of renewal—spiritual réssourcement for believers committed to the life of faith today.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("George Herbert was an English pastor and poet who reaped the benefits of the renewal of biblical studies in the age of the Reformation. He referred to the Scriptures as a book of infinite sweetness, “a mass of strange delights,” a book with secrets to make the life of anyone good. In describing the various means pastors require to be fully furnished in the work of their calling, Herbert provided a rationale for the history of exegesis and for the Reformation Commentary on Scripture:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The fourth means are commenters and Fathers, who have handled the places controverted, which the parson by no means refuseth. As he doth not so study others as to neglect the grace of God in himself and what the Holy Spirit teacheth him, so doth he assure himself that God in all ages hath had his servants to whom he hath revealed his Truth, as well as to him; and that as one country doth not bear all things that there may be a commerce, so neither hath God opened or will open all to one, that there may be a traffic in knowledge between the servants of God for the planting both of love and humility. Wherefore he hath one comment[ary] at least upon every book of Scripture, and ploughing with this, and his own meditations, he enters into the secrets of God treasured in the holy Scripture."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-000-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-000",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', [_vm._v("Timothy George")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("General Editor")]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexlv",
      "title": "xlv"
    }
  })])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Introduction to 1–2 Samuel, 1–2 Kings, 1–2 Chronicles"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_14"
    }
  }, [_vm._v("Samuel, Kings and Chronicles: Enduring Value and Depth")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The six books studied in this volume contain some of the greatest characters and moments of Scripture. Here are prophets like Samuel, Nathan, Elijah and Elisha, inspiring saints like Hannah and Jonathan, and infamous villains like Ahab and Jezebel. These books describe the lives and works of the kings of Israel and Judah, especially the first three: Saul, David and Solomon. Here, too, are the timeless stories of David and Goliath, Solomon’s wisdom and Elijah’s chariots of fire. Beyond such a “greatest hits” list are even more gems, including Abigail and Nabal, the witch of En-dor, the steadfast prophet Micaiah, the prophetess Huldah and righteous kings like Jehoshaphat, Hezekiah and Josiah. The biblical books of 1–2 Samuel, 1–2 Kings and 1–2 Chronicles are indeed spiritual and literary treasures.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Jesus of Nazareth and the writers of the New Testament also knew these books well. Each of the Synoptic Gospels (Mt 12:1-8; Mk 2:23-28; Lk 6:1-5) includes Jesus telling the story of David and his army eating the bread of the Presence in 1 Samuel 21. In the Gospel of Luke (Lk 4:16-30), Jesus scandalously invokes Elijah’s miraculous deeds for the widow of Zarephath in 1 Kings 17 and Elisha’s healing of Naaman in 2 Kings 5 to foreshadow Jesus’ mission to the Gentiles. And both the Gospels of Matthew (Mt 23:33-36) and of Luke (Lk 11:49-51) mention 2 Chronicles 24, where, according to Jesus’ comments in the Gospels, the priest Zechariah was “murdered between the sanctuary and the altar” as a holy and unjustly persecuted martyr. Such references only begin to plumb the depths of the New Testament writers’ frequent discussion of the kingdom of Israel, its naming of Jesus as the “Son of David” and its many other allusions to the kings and prophets of Israel. Further, the importance of these books for the New Testament becomes exceedingly clear when we recall that Jesus identified his crucified and risen body with the holy temple promised to David and first built by Solomon. The histories and theologies of each of the books in this volume deeply informed the theology and witness of the New Testament and the early church.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In terms of literary style and theological content, 1–2 Samuel, 1–2 Kings and 1–2 Chronicles are enduring and endearing because they present complex people, themes and events. While cherished images like David the shepherd boy, Solomon the wise ruler or Elijah the righteous prophet "), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexlvi",
      "title": "xlvi"
    }
  }), _vm._v("capture the popular imagination, there are deeper struggles and questions lingering below the surface. In addition to being a humble shepherd boy, David was also a shrewd and cunning leader from the beginning, with a reign that revealed deep character flaws, including his adultery with Bathsheba, the murder of noble Uriah and a civil war against his cherished son Absalom. In the next generation, Solomon—despite his proverbial wisdom—could not overcome idolatry and the misuse of power, so that the kingdom quickly fell apart under his successors. And though Elijah is one of the great holy men of the Bible, he was also—as the epistle of James says—“a man with a nature like ours” (Jas 5:17), intimately familiar with fear, disappointment and despair. Irony, tragedy, humor and pathos fill the narratives of these six books and invite readers into deep reflection on the many ups and downs of sharing a personal and communal life with God.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_15"
    }
  }, [_vm._v("Reformation Interpretations of Biblical History")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Commentators of the Reformation era were well aware of these complexities. Readers of this volume will be struck by our commentators’ close attention to detail and nuance. From the beginning of the sixteenth century onward, Christian scholars in Europe had access to critical editions of the Hebrew Scriptures and to quality grammatical aids."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-073-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" They also knew the historical-critical reality that Samuel and Kings provide the narrative peak and denouement of what is called the Former Prophets in the Jewish tradition (later referred to by modern critical scholars as the “Deuteronomistic History”), that cycle of books based on Deuteronomy that includes Joshua, Judges, Samuel and Kings."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-072-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The internal continuity of 1–2 Samuel and 1–2 Kings was also clear in the fact that they were named together as the four books of Kings in the Greek Septuagint, a tradition the influential Latin Vulgate continued.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Although 1–2 Chronicles relate many of the same stories as 1–2 Samuel and 1–2 Kings, sixteenth- and seventeenth-century interpreters recognized that the Chronicler’s narratives share a literary heritage with Ezra and Nehemiah rather than with the Former Prophets. Reformation-era scholars, therefore, knew very well that some of the same biblical stories had been told in two intentionally different ways. Additionally, although the sixteenth century became a watershed epoch in the history of biblical interpretation, reforming exegetes did not forget or neglect commentaries and other interpretive aids from earlier times. Readers of this volume will therefore discover that our commentators not only referred to Scripture but also to interpreters from across the centuries, including early church writers and medieval Christian and Jewish scholars, to advance their understanding of the text. Through their own attention to detail and their use of existing resources, scholars of the Reformation era were able to study, interpret and apply the teachings found in Samuel, Kings and Chronicles with a high level of sophistication and self-awareness.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexlvii",
      "title": "xlvii"
    }
  }), _vm._v("Respect for the Bible as holy and Spirit-breathed Scripture did not prevent Reformation interpreters from careful and critical textual study. On the contrary, reverence for the Word of God pushed them to think seriously about biblical texts, especially when it came to more challenging passages. They did this in a number of ways, beginning with close grammatical and historical study. For instance, the second-generation Lutheran theologian Lucas Osiander recognizes inconsistencies between Samuel, Kings and Chronicles about names and places, but he does not view these as a theological problem. Instead, Osiander asserts that the Chronicler served the church by doing the best work possible with the best available, but ultimately inaccurate sources."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-071-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Martin Luther puts it more bluntly:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The author of the books of Kings goes a hundred thousand steps beyond the author of the books of Chronicles. For he has described the most important and special events, passing over rocky and unimportant matters. If at any place Kings varies from Chronicles, I trust the author of Kings more than the author of Chronicles. And so I agree with neither what Jerome nor Nicholas of Lyra says—that Kings provokes many questions, unlike Chronicles. Kings is to be greatly preferred."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-070-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("John Calvin, when confronted with hard passages about God’s actions or emotions, developed a concept of accommodation to emphasize that the cultural complexities inherent to Scripture’s way of speaking must be understood in the broader context of the divine message of grace. Relevant for this volume, Calvin raises this point in his "), _c('i', [_vm._v("Institutes")]), _vm._v(" when considering the issue of God’s repentance, a question especially present in the rise and fall of King Saul."), _c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-069-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" On the question of biblical authority and hard textual questions, the Wittenberg Reformer Johannes Bugenhagen in his 1550 commentary on Jonah quotes Augustine of Hippo.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("For Augustine wrote most blessedly to St. Jerome something that they even have in their papal decrees, distinction 9: He says, “I have learned to yield this respect and honor [of authority] only to the canonical books of Scripture: of these alone do I most firmly believe that the authors were completely free from error. And if in these writings I am perplexed by anything which appears to me opposed to truth, I do not hesitate to suppose that either the manuscript is faulty, or the translator has not caught the meaning of what was said, or I myself have failed to understand it.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-068-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Though they were without many of the historical-critical tools of today’s scholarship, Reformation-era interpreters were by no means naive about the complexities of biblical texts. Instead, for the sake of good preaching and teaching, they used the best sources, grammatical aids, scriptural commentaries and logical skills possible to derive clear interpretations. This task often meant gathering smaller individual points of teaching ("), _c('i', [_vm._v("loci")]), _vm._v(") within a passage in order to discern the broader meaning ("), _c('i', [_vm._v("scopus")]), _vm._v(") of a chapter or book. Philipp Melanchthon employs this “"), _c('i', [_vm._v("loci")]), _vm._v(" method” in his "), _c('i', [_vm._v("Loci "), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexlviii",
      "title": "xlviii"
    }
  }), _vm._v("communes rerum theologicarum")]), _vm._v(" (1521), a work in which he let these smaller touchstones ("), _c('i', [_vm._v("loci communes")]), _vm._v(") lead him through the main points that Paul conveys in the letter to the Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The famous Reformation slogan "), _c('i', [_vm._v("sola Scriptura")]), _vm._v(" expresses that desire to go deep into the truths and wonders of the Christian faith through the careful study of Scripture. Contemporary readers should be aware that in the sixteenth and seventeenth centuries, "), _c('i', [_vm._v("sola Scriptura")]), _vm._v(" was not used as an excuse to put an end to critical thinking; indeed, such an approach would have been dismissed as unbiblical and unpersuasive by theologians of all confessional backgrounds. While some theologians were more confident of human reason’s ability to come to edifying scriptural conclusions than others, nevertheless they all engaged Scripture with the idea that the good use of reason and critical thinking was essential to good biblical interpretation. Therefore, trusting in the triune God of Scripture and following the rule of faith in their various contexts, interpreters sought to gain wisdom and edification even in the Bible’s most mysterious passages by applying their hearts and their minds to spiritual truth."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-067-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_16"
    }
  }, [_vm._v("Diverse Confessional Perspectives")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("While the commentators collected here each sought to be faithful to the “Spirit that gives life” in their work, their diversity of perspectives is immediately apparent. Thus an exciting aspect of this volume is the chance to study why various commentators chose to comment on the themes and "), _c('i', [_vm._v("loci")]), _vm._v(" that they did. Although the goal of all writers was to share good biblical teaching with their audiences, they often did this in different ways. For instance: was David the ideal prophet, priest and king whose model should be the guide and norm for all godly leaders? Or was he a man of blood, war and sin, whose greatest example for later generations are his moments of humble faith, sincere repentance and servant leadership? Interpreters colored David’s successes and failures differently, depending on the theological points they viewed as most important in the biblical text itself. Some upheld David as the godly ruler par excellence, while others viewed him in his best and worst moments as a great example of "), _c('i', [_vm._v("simul iustus et peccator")]), _vm._v(" (“simultaneously righteous and sinner”). In either case, interpreters aimed to be faithful to Scripture and persuasive to their audiences.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("For this reason, readers should be aware that this volume is not a collection of answers. Instead, it is more like an invitation to listen to theological and exegetical conversations from the Reformation era. Sometimes these conversations included the (relatively) confessionally neutral discussion of grammatical points and relevant cross-references to other parts of the Bible. Some of the conversations readers will overhear in this volume, however, took place amid the more heated debates of the period. If such conversations never happened in person, they often found written expression. For instance, the Augsburg Confession invoked David as a good example to follow as a godly king but not as a source of holy mediation or intercession, a position based "), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexlix",
      "title": "xlix"
    }
  }), _vm._v("on Scripture’s descriptions of David as a man who sinned and required forgiveness."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-066-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" In another example, when addressing antinomian reformers who wanted to abrogate the authority of the Hebrew Scriptures, the Anglican Thirty-Nine Articles reaffirmed the Old Testament writings as divinely inspired works whose moral commandments ought to remain binding."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-065-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" Working in this theological context, English commentators therefore often emphasized the lasting moral and spiritual wisdom to be found in these biblical histories. As a third example of how these books influenced public discourse, John Calvin and his followers were involved in written controversies with Lutherans about how best to interpret David and the “messianic psalms.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-064-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" Although Calvin tended to prefer a more historical or moral reading of these psalms and the Lutherans tended to argue for a more christological interpretation, all parties sought to offer interpretations that were faithful to the text itself and to its spiritual meaning that gives life (2 Cor 3:6). This volume, therefore, offers a fascinating look into the relationship between biblical interpretation and the development of church doctrine, practice and polity. While all interpreters aimed for faithfulness to the text, their respective encounters with the text led to different—biblically grounded!—insights, which bore different fruits.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("These general confessional differences quickly become evident in the comments on Samuel, Kings and Chronicles. Reformed and Puritan writers commented much more on matters of discipline and holy living than Lutheran writers, who saw justification by faith and the theology of the cross almost everywhere they looked in these historical books of the Old Testament."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-063-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" For their part, Anabaptist writers brought their interests in knowing and experiencing spiritual truth to their exegesis. Discerning readers, therefore, will certainly find instances of various streams of Protestantism, each of which imports their theological preferences into their exegesis. This fact does not reduce interpreters to mere representatives of their confessional traditions or accuse them of hand-picking their biblical theology; on the contrary, it reveals the large extent to which confessional diversity was itself rooted in a variety of encounters with Scripture and came from many different ways of reading the same holy texts.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_17"
    }
  }, [_vm._v("Using This Resource")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Recognizing that this volume offers a plurality of perspectives rather than a collection of “right answers” is critical to using this resource well. Whether in sermons, commentaries, devotional "), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagel",
      "title": "l"
    }
  }), _vm._v("books or theological tracts, Reformation-era authors wrote in order to clarify their audience’s understanding of Scripture and to help people apply it to their lives as beneficially as possible. Many of these authors, of course, were either implicitly or expressly writing to refute competing interpretations. And yet here we have scandalously set them side by side as equals, without judgment. We especially hope that readers will avoid the temptation of using this volume as an updated type of "), _c('i', [_vm._v("Glossa ordinaria,")]), _vm._v(" that is, as a collection of diverse sources that somehow presents a unified and internally coherent interpretation of 1–2 Samuel, 1–2 Kings and 1–2 Chronicles."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-062-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Beyond this caveat, however, great benefits abound in this volume. First, many of the insights and interpretations presented are incredibly perceptive, instructive and relevant for contemporary study, preaching and teaching. Second, readers will gain a deeper appreciation for the various theological streams of the Reformation era by paying attention to the way they interpreted Scripture. Third, in a manner that resonates with the Reformation slogan "), _c('i', [_vm._v("ad fontes")]), _vm._v(" (“back to the sources”), this project invites readers to enjoy direct study of the Scriptures themselves, the “pure, clear fountain of Israel.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-061-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Far more interesting and edifying than looking for “right answers,” therefore, is this volume’s invitation to read the Bible with a wide range of church reformers. In such an environment, readers will have a chance to learn what these interpreters found inspiring and instructive about the people of Israel and their kings. Readers will also get to compare differing perspectives from biblical history about matters like church and state, with insights coming both from those who knew a magisterial Reformation (as in the Lutheran, Reformed and Anglican experiences) and from those who were on the margins of political authority (as was true of Anabaptists and English Dissenters). Readers will also get a chance to consider for themselves the relative advantages of emphasizing moral purity in these texts (as did the Puritans) or the "), _c('i', [_vm._v("simul iustus et peccator")]), _vm._v(" paradox of the Lutherans.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Most of all, readers will enjoy reflecting with these commentators on the central question of what it means to belong to the people of God. The insights may be different—perhaps even in opposition to each other—but they can certainly enrich contemporary understandings of the Scriptures for the sake of faithful Christian study and witness today. Here readers are surrounded by a cloud of witnesses who each testify to the enduring value of Samuel, Kings and Chronicles for piety, proclamation and practice today.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_18"
    }
  }, [_vm._v("A Structural Overview of This Volume")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Of the six biblical books studied in this volume, 1–2 Samuel received the most attention from Reformation writers. Why? These are the two books that most fully describe the life of King David, a central figure for the entire Bible. Although Reformation-era commentators greatly criticized David for his moral failures, they also lauded him as the greatest of kings. David personally embodies "), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageli",
      "title": "li"
    }
  }), _vm._v("the promises made to Abraham, the teachings given to Moses, the inheritance given to the people of Israel and the promise of a redeemer. His story provides the heart and climax of the Former Prophets. The dramatic narratives about David’s life enjoy additional spiritual depth through their relationship with the Psalms, many of which were “about,” “for” or “by” David, according to the Hebrew headings."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-060-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" Finally, David takes an exalted place for Christian interpreters as both the forefather of Jesus Christ and as a type of Christ himself. That is, through the Holy Spirit at work in David’s faith and leadership, the stories and psalms connected to David become stories and psalms of the eternal Christ at work in the history of God’s chosen people. Because of David’s immense importance for the Christian church, many writers of the Reformation era embraced these books, either in whole or in part, producing an abundance of riches reflected in these pages.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In contrast, those who published works on Kings and Chronicles, particularly Chronicles, were most often commenting on them as part of larger studies on the entire Bible, the Old Testament or the so-called historical books. This has presented the editorial challenge of not having the same range of sources available for 1–2 Kings and 1–2 Chronicles as for 1–2 Samuel. This potential problem brings the corresponding blessing that readers get the chance to know a few interpreters better. For this reason, this volume’s work on 1–2 Kings is also a treasure, as we have been able to highlight writers whose works are not widely known or available in English.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("While they are interesting and valuable in their own right or when paired with Ezra–Nehemiah, the books of 1–2 Chronicles repeat many of the same narratives found in Samuel and Kings. Indeed, the title most commonly used by Reformation-era writers for Chronicles was "), _c('i', [_vm._v("Paralipomenon,")]), _vm._v(" a Greek word from antiquity that means “the things left over” or “of things passed over.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-059-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" With such a long history of being overlooked or overshadowed, it is not surprising that fewer early modern interpreters wrote commentaries on these two books. For those who did venture into writing commentaries on 1–2 Chronicles, their sparse comments often conformed to the nature of the text itself, which at times employs lists and genealogies rather than narrative writing.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Still, we have secured comments for each pericope in 1–2 Chronicles, with some sections containing vigorous and detailed discussions due to the theological richness evoked by the passage at hand. For readers who would like to explore these sections in more depth, we have followed the example of the fifth volume in the Ancient Christian Commentary on Scripture, referring readers of 1–2 Chronicles to parallel passages in 1–2 Samuel and 1–2 Kings.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_19"
    }
  }, [_vm._v("Introduction to the Commentators")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The two theological giants of the sixteenth century, Martin Luther and John Calvin, appear with some regularity in this volume. Though Luther translated the entire Bible and lectured on many of its books, he did not publish commentaries on any of the historical books of the Old Testa"), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v("ment. Nevertheless, because of his voluminous knowledge of Scripture and his exegetical practice of “interpreting Scripture with Scripture,” we have culled many excerpts from other writings. Calvin, however, preached on 1 Samuel (1561–1562) and 2 Samuel 1–13 (1562–1563). Although some of these sermons have been ably translated into English, they may be largely unfamiliar to readers. For this reason, we have proudly featured Calvin’s sermons on 2 Samuel in this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Similarly, Philipp Melanchthon—the great “teacher of Germany” and a prolific exegete—appears here primarily through excerpts from various editions of his "), _c('i', [_vm._v("Loci communes")]), _vm._v(". Instead of leaning on Luther, Calvin and Melanchthon for this volume, we have embraced the goal set by this series of drawing extensively from the writings of reformers whose works have been much less studied or are not as widely available in English.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Among Lutheran reformers, we have included many comments from Luther’s pastor and colleague Johannes Bugenhagen, as well as Lucas Osiander and Viktorin Strigel. In their comments on Samuel, Kings and Chronicles, Lutherans consistently emphasized the primacy of faith as the saving relationship between God and human beings. Through this trusting relationship of faith, God gives the righteousness of Jesus Christ to sinners who contribute nothing but themselves and their trust, a faith planted by the Holy Spirit."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-058-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" Here Christian discipleship is not merely a matter of imitating the saints in righteousness or good works but (like David) of returning to God daily in repentance and faith, confession and thanksgiving. With the theology of the cross as a model, Lutheran interpreters could view the fall of Israel and Jerusalem not only as signs of God’s judgment against sin but also as the way God would bring a more complete victory through the promised Messiah.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Alongside Lutheranism, the Continental Reformed tradition stands as perhaps the most intellectually robust stream of early Protestantism. Indeed, the majority of comments in this volume come from capable and learned Reformed commentators, particularly Konrad Pellikan and Johannes Piscator. Pellikan taught biblical languages in Zurich and wrote the first Hebrew grammar in Europe. While he regularly cribs others’ work—for example, Martin Bucer’s Psalms commentary, Desiderius Erasmus’s New Testament paraphrases and Johannes Oecolampadius’s Hebrews commentary—he does not appear to do so for his coverage of Samuel, Kings and Chronicles. Piscator compiled Latin commentaries on every book in the Bible. These commentaries contain three parts: first a “logical analysis” of each chapter in the spirit of the popular Ramist school of thought (based on the teachings of the Huguenot Peter Ramus); then linguistic annotations on specific words used in each verse; and finally ethical and theological observations that highlighted the moral qualities of the people and actions discussed in each verse. The wide influence of Pellikan and Piscator as Hebraists makes them valuable contributors to this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This volume also includes select excerpts from marginal commentary on the Geneva Bible as well as several different books of annotations: Giovanni Diodati’s "), _c('i', [_vm._v("Annotationes in Biblia,")]), _vm._v(" the "), _c('i', [_vm._v("Dutch Annotations")]), _vm._v(" and the "), _c('i', [_vm._v("English Annotations")]), _vm._v(". Often overlooked in scholarship of the period, they provide a great contrast to individual commentaries, because they reflect joint ventures sanc"), _c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagelii",
      "title": "lii"
    }
  }), _vm._v("tioned by local churches or regions for teaching and instruction."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-057-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" Popular readers of the Bible as well as clergy used these resources as an aid to interpretation, especially “upon all the hard places” of Scripture."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-056-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" These works typically offer brief remarks on linguistic, theological or historical features of the text.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Among the English reformers, we have featured two prominently: Andrew Willet and John Mayer. An Anglican priest, Willet had read widely of the Christian tradition before him and incorporated the comments of many previous interpreters into his own writing. His commentaries on 1–2 Samuel follow the "), _c('i', [_vm._v("loci")]), _vm._v(" method and cover a wide range of theological, linguistic, historical and ethical matters. While serving as a pastor, Mayer wrote a commentary on every book of the Bible. Like Willet, he made ample use of previous historians and interpreters such as Josephus, Augustine, Chrysostom, Calvin and Peter Martyr Vermigli. He intertwined his commentaries on 1–2 Kings and 1–2 Chronicles as a historical harmony.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("With respect to Radical and Anabaptist writers, none of them published commentaries on any of the books included in this volume. Indeed, commentaries by Anabaptists—especially on the Old Testament—are a rarity given their focus on the New Testament, not to mention the persecution and life-threatening situations many of their most learned theologians endured. Despite this lack of a full-length commentary on Samuel, Kings or Chronicles, it is clear that the Anabaptists cared deeply for these books. In this volume well-known Radicals, such as Menno Simons, Hans Denck, Balthasar Hubmaier and Dirk Philips, explore themes related to David and to God’s promise of an everlasting posterity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The overwhelming majority of comments in this volume intentionally come from Protestant theologians and pastors. However, we also included comments from pre-Tridentine Catholics, particularly Alonso Tostado and Cardinal Cajetan. Tostado, the learned bishop of Ávila, sought and enacted reform in the Catholic Church in Spain. His commentaries employed the "), _c('i', [_vm._v("quaestio")]), _vm._v(" method, in which he commented on each chapter by means of dozens of theological and moral questions."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-055-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" Cajetan, an equally scholarly churchman, wrote commentaries on each of the books of the Bible, except Song of Songs and Revelation. He especially focused on linguistic and grammatical matters.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Finally, although official commentaries serve as the foundation of each of the books in this volume, we have incorporated many comments from sixteenth- and seventeenth-century publications that remain outside of the genre of commentary. Some of the authors of these works are generally well known, including writers like the English Reformer William Tyndale, the Swiss reformer Heinrich Bullinger, the Dutch theologian Jacobus Arminius and the Anglican bishop Lancelot Andrewes. But others, such as the French jurist Lambert Daneau and the English clergyman Thomas Adams, remain more obscure. In this regard, intermittent comments from both "), _c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pageliiiliv",
      "title": "liiiliv"
    }
  }), _vm._v("renowned and less recognized reformers appear throughout this volume. Indeed, they complement well the more sustained interpretation from those who wrote biblical commentaries on these historical books.")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("• • •"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In 1532, Luther wrote a glowing preface for a new commentary on 1 Samuel."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-054-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" He commends this resource as a model for answering the thorny question, What does history, particularly this ancient history, have to do with us today? Or, put differently, why should we read this history?")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("[Justus Menius] has referred everything back to the fount and source, teaching that the faith of the saints toward God is the preeminent thing in the histories. . . . You will see that these histories are being reborn and renovated through the use of faith, as if through a baptism of their own, and that they live for us in our own age—or, rather, forever—and, with their magnificent and most glorious examples of faith they serve usefully for instruction, for argument, for teaching, for consolation, indeed, for everything for which, as Paul writes, the word of faith is powerful. For what is the sacred history but a visible word or a work of faith that teaches us by event and deed what the Scriptures elsewhere transmit in word and speech?"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-053-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("We need these stories, so we know that we are not alone in our suffering and doubting, in our rejoicing and believing. By the example and in the company of others we are stirred up and strengthened in our faith in God’s promises. Others have been there before, are there now and will be there in the future. Believers, separated by space and time, are united in Christ by his Spirit. And together they are instructed, corrected and consoled in Scripture.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', [_vm._v("Derek Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("Martin J. Lohrmann")])])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page1",
      "title": "1"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "COM_Title",
    attrs: {
      "id": "sigil_toc_id_20"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _vm._v("COMMENTARY ON 1 SAMUEL")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview")]), _c('b', [_vm._v(":")]), _vm._v(" The reformers regard Samuel not only as a prophet but also as the last of the judges of Israel, thereby serving as a bridge between the era of the judges and that of the kings. According to these interpreters, the first part of 1 Samuel focuses on the desire of the Israelites to secure a king like the surrounding nations. Due to their lack of trust in God, the first king of Israel was a tyrant, while the second king, David, serves as a figure of the Messiah.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_21"
    }
  }, [_c('span', {
    staticClass: "b-i"
  }, [_vm._v("Prolegomena: What This Book Is About")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Four Books of Kings, That Is, Samuel and Kings.")]), _vm._v(" "), _c('i', [_vm._v("Sebastian Münster:")]), _vm._v(" The four books of Kings are only two books in Hebrew, namely the book of Samuel and the book of Kings. Both of these books the Latin translators have divided into two books. We too will follow these translators, except that the first and second books we will call First and Second Samuel; the third and fourth books we will name First and Second Kings. "), _c('i', [_vm._v("The Temple of the Lord: 1 Samuel 1.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-439-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Book of Prophets.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" The first book of Samuel, as it is called, teaches not only that the majority of this book was written by Samuel, as can be observed from 1 Chronicles 29, but also the deeds of this same prophet. For this Samuel was the last judge or governor of the people of Israel. Until that time the judges had ruled; afterward the Israelites asked to receive a king. For this reason, because the kings are described in the later parts of this book, we also call this book the First Book of Kings. . . . In Matthew 12, Jesus cites this book about David and the bread of the Presence. And Paul recounted the history of these books in Acts 13. The second book speaks especially clearly of Christ when it tells the promises to David. Many examples of divine sovereignty over against the impious are displayed, as are converse examples of the goodness of God’s mercy to the pious. From these examples we should learn to fear God, to trust in him with our whole heart and to love him from our soul. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-438-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-438",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Did Not Write the Whole Book.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" The title of both this book and the one that follows is Samuel, from the teachers of the Jews, who is initially discussed in this book. The book is believed to have been written by Samuel in the first part; however, it is clear that Samuel himself did not write about the events after his death. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-437-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Template for God’s People.")]), _vm._v(" "), _c('i', [_vm._v("Geneva Bible:")]), _vm._v(" According to Deuteronomy 17:14, God ordained that when the Israelites should reside in the land of Canaan, he would appoint them a king. Consequently, this first book of Samuel narrates the state of this people under their "), _c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _vm._v("fi"), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  }), _vm._v("rst "), _c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor146"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor200"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor218"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page2",
      "title": "2"
    }
  }), _vm._v("king, King Saul. However, contrary to God’s timing, the people were not content with the current government God had erected, and so demanded a king so that the Israelites might be like the other nations, which the Israelites believed to be safer since they had a king. The Israelites did not ask for a king so that they could better serve God under a godly person who represented Jesus Christ, the true deliverer. Therefore God gave them a tyrant and a hypocrite to rule over them so they might learn that a human king is not sufficient to defend them. Rather, only a ruler who was empowered and helped by God could do so. Therefore, God punished the ingratitude of his people, and he sent them continual wars both at home and abroad. And because Saul, who was not truly worthy of the office of king, did not acknowledge God’s mercy toward him but rather disposed of the Word of God and was not zealous for God’s glory, he was put down by the voice of God. In his place, David, the true figure of the Messiah, was placed on the throne. Indeed, David’s patience, modesty, constancy, persecution by open enemies, false friends and lying flatterers are left to the church, and to every member of the body of Christ, as a template for their vocations as God’s people. "), _c('i', [_vm._v("Argument of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-436-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-436",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor221"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor233"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor246"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor257"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor262"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor263"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor267"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor277"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor286"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor290"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor299"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor305"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor306"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor310"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor313"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor315"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor320"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor344"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor351"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor361"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor368"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor370"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor374"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor375"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor380"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor390"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor391"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor393"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor397"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor400"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor402"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor413"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor414"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor417"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor421"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor422"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor430"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor432"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor433"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor434"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor438"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor440"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor446"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor449"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor453"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor454"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor455"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor461"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor462"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor463"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor464"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor465"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor466"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor467"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor468"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor469"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor470"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor471"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor472"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor473"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor474"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor475"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor476"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor477"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor478"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor479"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor480"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor481"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor482"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor483"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor484"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor485"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor486"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor487"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor488"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor489"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor490"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor491"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor492"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page3",
      "title": "3"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_22"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("1:1-28")]), _vm._v(" THE BIRTH AND DEDICATION OF SAMUEL")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("There was a certain man of Ramathaim-zophim of the hill country of Ephraim whose name was Elkanah the son of Jeroham, son of Elihu, son of Tohu, son of Zuph, an Ephrathite.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("He had two wives. The name of the one was Hannah, and the name of the other, Peninnah. And Peninnah had children, but Hannah had no children.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now this man used to go up year by year from his city to worship and to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts at Shiloh, where the two sons of Eli, Hophni and Phinehas, were priests of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("On the day when Elkanah sacrificed, he would give portions to Peninnah his wife and to all her sons and daughters.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("But to Hannah he gave a double portion, because he loved her, though the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had closed her womb.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And her rival used to provoke her grievously to irritate her, because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had closed her womb.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("So it went on year by year. As often as she went up to the house of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", she used to provoke her. Therefore Hannah wept and would not eat.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And Elkanah, her husband, said to her, “Hannah, why do you weep? And why do you not eat? And why is your heart sad? Am I not more to you than ten sons?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("After they had eaten and drunk in Shiloh, Hannah rose. Now Eli the priest was sitting on the seat beside the doorpost of the temple of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("She was deeply distressed and prayed to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and wept bitterly.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And she vowed a vow and said, “O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts, if you will indeed look on the affliction of your servant and remember me and not forget your servant, but will give to your servant a son, then I will give him to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("all the days of his life, and no razor shall touch his head.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("As she continued praying before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", Eli observed her mouth.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Hannah was speaking in her heart; only her lips moved, and her voice was not heard. Therefore Eli took her to be a drunken woman.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And Eli said to her, “How long will you go on being drunk? Put your wine away from you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("But Hannah answered, “No, my lord, I am a woman troubled in spirit. I have drunk neither wine nor strong drink, but I have been pouring out my soul before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("Do not regard your servant as a worthless woman, for all along I have been speaking out of my great anxiety and vexation.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Then Eli answered, “Go in peace, and the God of Israel grant your petition that you have made to him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And she said, “Let your servant find favor in your eyes.” Then the woman went her way and ate, and her face was no longer sad.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("They rose early in the morning and worshiped before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("; then they went back to their house at Ramah. And Elkanah knew Hannah his wife, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("remembered her.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And in due time Hannah conceived and bore a son, and she called his name Samuel, for she said, “I have asked for him from the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("The man Elkanah and all his house went up to offer to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("the yearly sacrifice and to pay his vow.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("But Hannah did not go up, for she said to her husband, “As soon as the child is weaned, I will bring him, so that he may appear in the presence of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and dwell there forever.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("Elkanah her husband said to her, “Do what seems best to you; wait until you have weaned him; only, may the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("establish his word.” So the woman remained and nursed her son until she weaned him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And when she had weaned him, she took him up with her, along with a three-year-old bull,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("an ephah")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("of flour, and a skin of wine, and she brought him to the house of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("at Shiloh. And the child was young.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Then they slaughtered the bull, and they brought the child to Eli.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And she said, “Oh, my lord! As you live, my lord, I am the woman who was standing here in your presence, praying to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("For this child I prayed, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has granted me my petition that I made to him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Therefore I have lent him to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". As long as he lives, he is lent to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("And he worshiped the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("there.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Syriac; the meaning of the Hebrew is uncertain. Septuagint "), _c('i', [_vm._v("And, although he loved Hannah, he would give Hannah only one portion, because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had closed her womb")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("Samuel")]), _vm._v(" sounds like the Hebrew for "), _c('i', [_vm._v("heard of God")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Dead Sea Scroll, Septuagint, Syriac; Masoretic Text "), _c('i', [_vm._v("three bulls")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" An "), _c('i', [_vm._v("ephah")]), _vm._v(" was about 3/5 bushel or 22 liters"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor493"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor494"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor495"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor496"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor497"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor498"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor499"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor500"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor501"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor502"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor503"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor504"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor505"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor506"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor507"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor508"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor509"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor510"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor511"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor512"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor513"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor514"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor515"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor516"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor517"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor518"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor519"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor520"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor521"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor522"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor523"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor524"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor525"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor526"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor527"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor528"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor529"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor530"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor531"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor532"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor533"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor534"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor535"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor536"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor537"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor538"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor539"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor540"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor541"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor542"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor543"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor544"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor545"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor546"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor547"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor548"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor549"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor550"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor551"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor552"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor553"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor554"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor555"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor556"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor557"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor558"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor559"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor560"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor561"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor562"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor563"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor564"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor565"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor566"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor567"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor568"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor569"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor570"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor571"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor572"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor573"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor574"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor575"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor576"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor577"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor578"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor579"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor580"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor581"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor582"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor583"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor584"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor585"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor586"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor587"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor588"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor589"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor590"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor591"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor592"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor593"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor594"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor595"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor596"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor597"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor598"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor599"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor600"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor601"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor602"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor603"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor604"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page4",
      "title": "4"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" The reformers concentrate on Elkanah’s polygamy, a sensitive topic for some of the commentators on account of their association with rulers who sometimes aspired to having more than one wife. Both Bucer and Melanchthon, for instance, attended the marriage of Philip of Hesse (1504–1567) to a second wife in 1540, and Luther’s role in the bigamous union incited controversy."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-435-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-435",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" Bugenhagen interprets Elkanah’s marriage to two women as a spiritual mystery indicating two responses to faith: hypocrisy and belief. Other interpreters criticize the cultural practice of polygamy among biblical patriarchs. Elkanah, however, is recognized as a just man who worships God faithfully. More importantly, Hannah is regarded as the ideal woman who trusted in God despite hardship. Her sincere prayer for a child is answered by God, but the reformers, opposed to the vows of parents who dedicated their children as oblates in medieval monasteries, argue that Hannah’s entrusting of little Samuel to Eli is not a perpetual vow.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_23"
    }
  }, [_c('b', [_vm._v("1:1-2")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Polygamy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Elkanah’s Two Wives.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The mystery of these two wives is the same as Hagar and Sarah, about whom you read in Genesis and in the epistle to the Galatians. Furthermore, see how thoroughly this point is made in all of Scripture. These two women contrast our native hypocrisy and our faith, hypocrites and believers. Peninnah respected marriage, was not guilty of a bad reputation and ascended to the holy place, as was seen before God and before people. God is viewed as approving of this holy goodness when he gives her the honor of rewards, that is, children. Hannah, whose womb is closed, seems to be cast down. This is certainly a curse, just as the earth is cursed when planted seeds do not bear fruit. And yet a person cannot judge rightly about this case. For not only Peninnah but also the good man Eli was wrong when he mistook sadness and affliction for drunkenness. Hypocritical opinions have their wisdom, piety and righteousness not only when they concern others but also concerning oneself. These ideas abound in everyone and multiply in people: “God has given abundantly,” as if merits had been accepted. These carry the certainty of the Pharisee’s decree when he judged, “I am not like other people. Surely God does not love others! No, God hates all those who fall to the depths!”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Through bad fruits such as these, God’s disciples can see this and know that these are the ones whom Scripture calls “men of blood,” that is, they want evil for others. While they are proud of their works and gifts to God, they cannot help but hate others. They have no compassion for anyone with sin. They scorn not only sin but also the cross where God was placed. And they think further that their scorn is a curse from the same God whom they themselves do not receive, as if God himself works against the faithful. This is the greatest pious temptation for their own pitiful selves.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This is why Hannah was scorned: God had closed her womb. As it says in the psalm: “many are saying of my soul, there is no salvation for him in God.” And again, “God has forsaken him; pursue and seize him, for there is none to deliver him.” But by believing that it is proper to condescend, to impose the cross and daily to scatter the benefits of God while ascending into glory through the cross, then through glory these blind ones descend into death (even as the faith of the righteous blessedly ascends). And so their blasphemy never ends. “But many who are first will be last, and the last first,” and the greater shall serve the lesser: “I have loved "), _c('a', {
    attrs: {
      "id": "_idTextAnchor605"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor606"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor607"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor608"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor609"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor610"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor611"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor612"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor613"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor614"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor615"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor616"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor617"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor618"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor619"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor620"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor621"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor622"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor623"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor624"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor625"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor626"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor627"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor628"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor629"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor630"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor631"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor632"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor633"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor634"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor635"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor636"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor637"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor638"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor639"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor640"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor641"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor642"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor643"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor644"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor645"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor646"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor647"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor648"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor649"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor650"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor651"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor652"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor653"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor654"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor655"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor656"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor657"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor658"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor659"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor660"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor661"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor662"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor663"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor664"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor665"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor666"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor667"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor668"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor669"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor670"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor671"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor672"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor673"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor674"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor675"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor676"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor677"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor678"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor679"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor680"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor681"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor682"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor683"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor684"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor685"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor686"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor687"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor688"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor689"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor690"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor691"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor692"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor693"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor694"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor695"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor696"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor697"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor698"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor699"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor700"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor701"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor702"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor703"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor704"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor705"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor706"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor707"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor708"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor709"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor710"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor711"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor712"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor713"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor714"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor715"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor716"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor717"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor718"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor719"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor720"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor721"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor722"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor723"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor724"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor725"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor726"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page5",
      "title": "5"
    }
  }), _vm._v("Jacob but Esau I have hated. I have laid waste his hill country and left his heritage to jackals of the desert.” Hannah declares all of this in her song of chapter 2. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-434-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-434",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Polygamy Tolerated but Not Approved.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Piscator:")]), _vm._v(" We have an example of polygamy in this holy man Elkanah, the father of Samuel. This raises the question of whether polygamy is allowed. If it is allowed, it appears to be approved here, given that many of the holy men in the Old Testament were polygamous: Abraham, Jacob, David, etc. For their polygamy never seem to be reproved or condemned. But, in fact, polygamy was not allowed. That’s because the whole notion of polygamy fights against the institution of marriage given by God, which was created and established for our first parents between a man and a woman. According to Genesis 2, Adam proclaimed that the man and woman shall unite and “become one flesh.” This is affirmed in Matthew 19:4-6. Let me respond to this question from a different angle. As for whether polygamy is allowed, it is important to note that the life of holy people is not a rule for us exactly, because holy people had their warts just like we do. But ultimately we are to imitate them in the acts they do that we recognize as conforming to the divine law. As for the other matter, although the polygamy carried about by the holy patriarchs before the law was not condemned, it is prohibited after the law was given, in accordance with Leviticus: “And you shall not take a woman as a rival wife to her sister, uncovering her nakedness while her sister is still alive.” Therefore, although God tolerated the polygamy of holy men, God did not approve it. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-433-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Trouble with Polygamy.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" This presence of polygamy under the law in marrying two or more wives was not simply lawful or dispensed with, which is the opinion of many. . . . Such an interpretation cannot be, for our Savior says concerning this matter: “from the beginning it was not so.” So also the Prophet Malachi: “Did he not make them one, with a portion of the Spirit in their union? And what was the one God seeking? Godly offspring.” Therefore, the best interpretation is that polygamy was a human infirmity in the patriarchs in which they took for themselves two or more wives. And such marriages were not without great inconveniencies. There was continual competition between them, as between Sarah and Hagar, Leah and Rachel and here between these two wives of Elkanah.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The first polygamist in the Bible was Lamech, of the cursed seed of Cain. Yet because at this time the temporal promises of the Jewish nation depended upon their carnal generation, it pleased God to wink at this infirmity and to tolerate it in the patriarchs. God did so until the Messiah came, when the church of God should no longer be tied to the people of the Jews, but spiritual children should be begotten unto God from all nations, even among the Gentiles. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-432-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-432",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_24"
    }
  }, [_c('b', [_vm._v("1:3-8")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Elkanah Goes to Worship Year After Year")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Going Up to Shiloh.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" And Elkanah went up according to the law of Deuteronomy 16. The Lord’s tabernacle had been in Shiloh since the time of Joshua, as is said in Joshua. Doubtlessly the ark was there too, for it had been moved under Eli’s authority, as you will see. The Lord speaks of Shiloh in Jeremiah: “Do not trust in the external worship of God even as God has commanded, unless faith is there, because trusting in anything as holy is most assuredly not allowed.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-431-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-431",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor727"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor728"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor729"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor730"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor731"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor732"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor733"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor734"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor735"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor736"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor737"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor738"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor739"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor740"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor741"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor742"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor743"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor744"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor745"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor746"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor747"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor748"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor749"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor750"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor751"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor752"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor753"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor754"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor755"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor756"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor757"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor758"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor759"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor760"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor761"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor762"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor763"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor764"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor765"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor766"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor767"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor768"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor769"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor770"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor771"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor772"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor773"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor774"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor775"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor776"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor777"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor778"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor779"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor780"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor781"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor782"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor783"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor784"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor785"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor786"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor787"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor788"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor789"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor790"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor791"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor792"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor793"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor794"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor795"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor796"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor797"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor798"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor799"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor800"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor801"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor802"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor803"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor804"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor805"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor806"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor807"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor808"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor809"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor810"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor811"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor812"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor813"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor814"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor815"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor816"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor817"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor818"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor819"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor820"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor821"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor822"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor823"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor824"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor825"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor826"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor827"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor828"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor829"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor830"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page6",
      "title": "6"
    }
  })]), _c('b', [_vm._v("Holy Worship.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Elkanah went up to the Lord’s tabernacle in order to worship God and to sacrifice to the Lord of hosts—as he is called, because all creatures serve him as if they were his soldiers. At that time the Lord of hosts had his holy tabernacle in Shiloh. For under the law the fathers strengthened their faith through sacrifices, which foreshadowed Christ’s death. And it is fitting for us to gather frequently and diligently to hear the Word of God and to strengthen our faith through the enjoyment of the Lord’s Supper. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-430-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-430",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Recognizing the Mediator.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Every year Elkanah took his family to Shiloh, where there was then a tabernacle, to hear the teaching concerning the law and the Messiah. And he prayed and gave thanks for all spiritual and material blessings. For it is explicitly said that he worshiped and gave sacrifices, so that it would be indicated that he does not placate God through ceremonies, unless first the foundation has been considered, that is, the Mediator has been recognized. Through the Mediator the remission of sins, reconciliation with God and the beginnings of moral obedience are received. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-429-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-429",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Feast and Eli’s Line.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" Here Elkanah went to the feast of the Passover with all his family [just like Jesus did with his family] in Luke 2:41. It is very likely that Elkanah observed the law so faithfully that he attended the feasts on all three solemn festivals in accordance with Exodus 23:17. There is no mention made of this Eli anywhere else. However, it appears based on 2 Samuel 8:17 and 1 Chronicles 24:3-4 that he was one of Ithamar’s posterity, who was Aaron’s younger brother. It also appears that for some unknown reason there had been an interruption in the succession of the priesthood in Eleazar, the firstborn in his line, who was afterward reestablished in the line of Zadok. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-428-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-428",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah’s Portion and Prayer.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Elkanah gave Hannah “one part” because she was alone, not having children to whom more parts could be given. She had not taken the food; it had not pleased her to eat, so she ate little even though it says below, “after they had all eaten and drunk.” Then it says, “She was deeply distressed.” Here is the cross, even while hypocrites reign secure as if near to God. Also, one does not fight against enemies here, for the heaviest troubles that need to be fought are known to be those on the inside. But prayers are multiplied before God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-427-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah’s Example of Faith and Love.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Hannah is truly a mirror on which all pious and honest women should reflect. She does not harbor hatred or rage against God in the midst of her troubles. She is obedient to God, recognizing and deploring her peculiar sin and weakness, even as she asks God for help, knowing that barrenness and fertility are not accidents but both are the work of God. And what did her husband Elkanah do? He tolerated the foolish Peninnah and most gently consoled Hannah with his words: “Why do you weep? And why do you not eat? Am I not more to you than many sons?” It is as if he said, “Peninnah has the shell but you have the kernel. For as she has the fruit of my body, so you rest in my heart. You sweetly surround this better part and you do not need to desire more than this.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-426-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Pleasure Divided from Pain.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" It is noted that Elkanah loved Hannah more than his other wife, promising no doubt a greater matter of comfort to himself in her than in the other. But what followed? He loved her, says the prophet, and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor831"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor832"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor833"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor834"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor835"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor836"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor837"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor838"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor839"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor840"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor841"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor842"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor843"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor844"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor845"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor846"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor847"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor848"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor849"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor850"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor851"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor852"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor853"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor854"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor855"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor856"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor857"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor858"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor859"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor860"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor861"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor862"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor863"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor864"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor865"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor866"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor867"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor868"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor869"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor870"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor871"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor872"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor873"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor874"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor875"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor876"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor877"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor878"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor879"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor880"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor881"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor882"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor883"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor884"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor885"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor886"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor887"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor888"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor889"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor890"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor891"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor892"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor893"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor894"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor895"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor896"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor897"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor898"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor899"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor900"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor901"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor902"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor903"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor904"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor905"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor906"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor907"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor908"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor909"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor910"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor911"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor912"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor913"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor914"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor915"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor916"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor917"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor918"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor919"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor920"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor921"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor922"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor923"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor924"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor925"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor926"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor927"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page7",
      "title": "7"
    }
  }), _vm._v("the Lord made her barren. Mark the connection of his loving her and God’s making her barren. So shall it be in all such earthly creatures, where we cleave inordinately and falsely promise joy to ourselves in their use. God in his just judgment shall make these barren, so that they shall not yield us a quarter of that comfort or benefit that we expected. The rich fool promised himself a little heaven in his riches: “Soul, you have ample goods laid up for many years; relax, eat, drink, be merry. . . .” But, alas, how soon did God give him unease? “Fool, this night your soul is required of you, and the things you have prepared, whose will they be?” Here is the reason for this deceit: We look only at the apparent and outward good of those things we desire or expect. In other words, we extract the sweet from the sour and the pleasure from the pain. But when we get what we want, we feel more of the sour than of the sweet. And hence it comes to pass that nothing pleases us so well in the expectation itself. Indeed, almost nothing that pleasures us when hoped for gives us more displeasure once acquired. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-425-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_25"
    }
  }, [_c('b', [_vm._v("1:9-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Hannah’s Vow and Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah’s Vow.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Here Hannah has nothing in her power, nothing in her free will, no presumptive claims, rather everything relating to the vow is committed to God; all things here are entirely in the hands of God. “If you give me a son, I will give him to you. If you do not give, I can give nothing to you. If you do not desire to give, you will not give. If you do desire it, you give it. And the one entrusted to me, I will give to you, so that he might minister in the tabernacle and serve the priests. Then if something else should be pleasing in your sight, I will have made sure that he does not remain in his ministry, for I do not presume to determine your calling through this vow. He will be yours. You will do as it has pleased you. A vow against your will is impious. If you give this and he is presented to you, you will make sure that the child whom you give has the mind to obey me in this. You will grant this to pious parents, so that the son does my will according to God. Yes indeed, this one whom God gives me will at the same time recognize the calling of God and honor the commandment about parents. If through later impiety the child comes to condemn God’s calling and parental orders, nevertheless I will be responsible to the vow for the child in my keeping while he is under my care. I truly vow nothing here that brings danger to the child’s conscience. So if he grasps it, it is already done alone as a free person who can change, which is very important. For I am making a vow to you, not against you.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-424-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-424",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Heart Like a Flower.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" A godly heart is . . . like a flower. For flowers shut when the sun sets and the night comes, but open again when the sun returns and shines on them. If God withdraws his favor and sends a night of affliction, they shut up themselves as well as their thoughts in silence. But if he shines again and sheds abroad the light and sense of his love on them, then their heart and mouth are wide open toward heaven, in lifting up praises to God. Hannah prayed silently, so long as she was in bitterness of soul and of a sorrowful spirit. But as soon as God answered her prayers and filled her heart with joy in him, her mouth immediately opened into a song of thanksgiving. "), _c('i', [_vm._v("Seven Sermons on Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-423-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Prayer as a Key.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Prayer may be compared to a key. An example is when Elisha opened the heavens by prayer when they were shut up. . . . Likewise, when God shuts up the wombs of women . . . so that they become barren, prayer is the key that opens them. By this key was the womb of Hannah opened so that she brought forth Samuel. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-422-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-422",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor928"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor929"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor930"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor931"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor932"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor933"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor934"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor935"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor936"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor937"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor938"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor939"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor940"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor941"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor942"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor943"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor944"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor945"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor946"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor947"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor948"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor949"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor950"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor951"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor952"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor953"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor954"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor955"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor956"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor957"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor958"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor959"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor960"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor961"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor962"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor963"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor964"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor965"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor966"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor967"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor968"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor969"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor970"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor971"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor972"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor973"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor974"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor975"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor976"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor977"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor978"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor979"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor980"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor981"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor982"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor983"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor984"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor985"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor986"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor987"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor988"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor989"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor990"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor991"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor992"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor993"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor994"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor995"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor996"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor997"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor998"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor999"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1000"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1001"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1002"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1003"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1005"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1012"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1015"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1017"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1021"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1022"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1024"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1030"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1031"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1032"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1033"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1034"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1035"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1036"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1037"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1038"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1040"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1043"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page8",
      "title": "8"
    }
  })]), _c('b', [_vm._v("Spiritual Children.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Children whom God gives to parents upon a plentiful contrition and repentance usually prove to be excellent in all spiritual graces. The first example of this is Seth, who is not only the foundation of the church but of all humankind. . . . It also appeared in Hannah, who having bewailed her own case in the bitterness of her soul, received from the Lord a blessed seed who came to be called Samuel. He is the one who restored religion and settled the state of the kingdom. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-421-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_26"
    }
  }, [_c('b', [_vm._v("1:12-20")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Eli’s Response to Hannah")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Comfort from Eli.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Hannah received the word of consolation from the mouth of Eli as if from the mouth of God. Doubtless, if you prayed an invocation to God and a holy man responded, would you not be consoled by a sure word through this one as if from the Lord? Thus we believe that in former times God consoled the saints through holy people, and only rarely through special revelation. For this reason, Hannah was not more sorrowful. This is the nature of God’s consolation after the cross and hell. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-420-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli’s Ministry.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The priest Eli might be considered as a primary example of a faithful ministry, because he did not seek pleasure, useless leisure or sloth. Instead, “Sparta is your country, make the most of it.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-419-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" He was offered all the work of his office and he took it. For that reason he sat in the forecourt of the temple, so that he might bring wanderers or erring people back, fortify the inexperienced, strengthen the weak, shed light on dark and intricate questions and loosen the bonds of those hopelessly wrapped up in doubts. Therefore, by this example of Eli, let us learn to avoid thoughtless judgments, which will require repentance. As the old saying says: “He who judges quickly shall soon repent.” "), _c('i', [_vm._v("Commentary on 1 Samuel")]), _vm._v("."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-418-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Drinking Allowed.")]), _vm._v(" "), _c('i', [_vm._v("Johann Arndt:")]), _vm._v(" People were not to drink wine or strong drink when they went into the tabernacle. . . . This signifies that if a man wishes to go into the eternal tabernacle of God, that is, to eternal life, he must give up the pleasure and lusts of the flesh of this world and everything by which the flesh conquers the spirit, so that the flesh will not be stronger than the spirit and conquer it. The love of this world, pleasure and pride is a strong sweet wine by which the soul and the spirit are conquered. "), _c('i', [_vm._v("True Christianity.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-417-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Talk of Fools.")]), _vm._v(" "), _c('i', [_vm._v("John Dod:")]), _vm._v(" Those who are too conceited of themselves and of their own wits are here to be sharply reproved. These are the types who will brag and boast that they are not so simple, but they know well enough how to serve God and how to do the duties that pertain to them in their families. Although they have not lived in the world for long and are just recently married, yet they know sufficiently without teaching what belongs to the duty of a husband, of a father, of a master and of all other things a Christian man should know. By saying such things, these foolish men consider little what they speak against themselves and how far they discover their own nakedness. Hereby they make it apparent that they have in them no Christianity at all. For let’s ask ourselves this: Are they wiser than all the prophets and righteous people who lived in ancient times? They saw and acknowledged their great lack of the understanding of holy things. . . . How foully was Eli overtaken through ignorance in censuring and condemning good Hannah for drunkenness when she was pouring out her soul "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1045"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1046"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1048"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1053"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1069"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1070"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1071"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1090"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1097"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1109"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1121"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1123"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1129"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1130"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1131"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page9",
      "title": "9"
    }
  }), _vm._v("before the Lord because she moved her lips only? Although she uttered no words in his hearing, she spoke in her heart to God. And the like might be said of many indiscreet speeches and actions of the disciples of Christ before the resurrection, and till they had received the Spirit of understanding in a more plentiful measure. "), _c('i', [_vm._v("The Third Sermon of the Lord’s Supper.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-416-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_27"
    }
  }, [_c('b', [_vm._v("1:21-28")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Hannah Prepares and Delivers Samuel to the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Vows Can Be Revoked.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" Samuel, whose mother dedicated him to God, did not always observe the vow, but, as Samuel clearly indicated, become a ruler, traveled around the country, served the people and did not always remain in the temple as had been vowed. On the contrary, Samuel later lived in Ramah, and his example is a powerful argument against eternally binding monastic vows. "), _c('i', [_vm._v("An Answer to Several Questions on Monastic Vows.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-415-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Is Lent to the Lord.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This vow is not a perpetual vow, as it says, “As long as he lives, he is lent to the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(".” For because he was a Levite from Kohath, he has been given not by his mother’s vow but the law of God in Numbers 4 to minister from his thirtieth year to his fiftieth, at which time the law restores his freedom. This background also explains why Samuel will be described later as being in Ramah in possession of his father’s house and a judge in Israel for many years. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-414-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel’s Sacrifice as a Type of Christ’s.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Oblations were of two sorts according to Numbers 28:4, a “morning lamb” and an “evening lamb.” The presentation of Christ in the temple by his parents was the morning lamb; and the offering up of himself as a sacrifice in his passion was the evening lamb. In his oblation he was the author and beginning of our faith; in his passion, he was the finisher and accomplishment of our faith. For the application of this Scripture—that it may not seem strange but lawful and warrantable both by Scripture and by practice of Christ’s church—we are to know that it is lawful and usual to compare things spiritual . . . with things natural. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-413-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Temporal Versus Spiritual Prayers.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some question whether it is lawful to pray for temporal and indifferent things, as here Hannah prays for a child and obtains one. . . . Temporal things are only to be prayed for in general, as we pray for them under the name of bread in the Lord’s Prayer. However, it appears by the examples of holy people in the Scripture that it is lawful to pray for temporal things, as Abraham prayed for Ishmael and Moses prayed for victory against Amalek. But there are two conditions required for temporal prayers: first, that we should pray for them transitorily, that is, not with as great a fervency and desire as for spiritual things; and second, that we must demonstrate how they will be used for God’s glory. But we must not think that we are heard for the merit of our prayer. God hears us in mercy, though prayer is appointed as the way and the means by which we walk. It is not the cause of granting our requests. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-412-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-412",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Perpetual Nazirite.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" If we ask why Hannah . . . gives something to God, the reason is because God has been offended by humankind and therefore must be appeased; and nothing more serves to appease wrath than a gift. . . . But if we will appease by a gift there must be an equality; we may not offer a thing under the value of the thing that was taken away. That is the reason why all the sacrifices of the law could not appease God. . . . The value of our obedience to God is such as cannot appease and satisfy his majesty, having "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1146"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1200"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1221"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page10",
      "title": "10"
    }
  }), _vm._v("been offended. . . . But if we can offer to God a thing of equal price to the obedience that we owe to God, then no doubt God will be appeased, especially if we offer a thing of a higher rate. . . . To offer Samuel as a Nazirite was not enough, for that continues but for certain days. . . . But Hannah gives her son to the Lord all his life, that is, forever. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-411-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor1222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1233"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1246"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1257"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1262"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1263"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1267"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1277"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1286"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1290"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1299"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1305"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1306"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1310"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1313"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page11",
      "title": "11"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_28"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("2:1-10")]), _vm._v(" THE PRAYER OF HANNAH")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Hannah prayed and said,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("“My heart exults in the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(";")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("my horn is exalted in the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("My mouth derides my enemies,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("because I rejoice in your salvation.")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")])]), _c('i', [_vm._v("“There is none holy like the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("for there is none besides you;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("there is no rock like our God.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")])]), _c('i', [_vm._v("Talk no more so very proudly,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("let not arrogance come from your mouth;")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is a God of knowledge,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and by him actions are weighed.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")])]), _c('i', [_vm._v("The bows of the mighty are broken,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("but the feeble bind on strength.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")])]), _c('i', [_vm._v("Those who were full have hired themselves out for bread,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("but those who were hungry have ceased to hunger.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("The barren has borne seven,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("but she who has many children is forlorn.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")])]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("kills and brings to life;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he brings down to Sheol and raises up.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")])]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("makes poor and makes rich;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he brings low and he exalts.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")])]), _c('i', [_vm._v("He raises up the poor from the dust;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he lifts the needy from the ash heap")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("to make them sit with princes")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and inherit a seat of honor.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("For the pillars of the earth are the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and on them he has set the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "versefirst"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")])]), _c('i', [_vm._v("“He will guard the feet of his faithful ones,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("but the wicked shall be cut off in darkness,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("for not by might shall a man prevail.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")])]), _c('i', [_vm._v("The adversaries of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("shall be broken to pieces;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("against them he will thunder in heaven.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will judge the ends of the earth;")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he will give strength to his king")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and exalt the horn of his anointed.”")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" Hannah’s prayer, according to the reformers, signifies much more than mere praise of God for the gift of a child. It foretells the reign of Christ, and also provides the basis for Mary’s prayer in Luke 1:46-55."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-410-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" The commentators regard this as one of chief passages where the messianic king, Jesus Christ, is predicted in the Old Testament. The reformers, intent on safeguarding the sovereignty of God, dwell on Hannah’s words that the Lord both takes and restores life, which Strigel interprets as true conversion to God. The story of a barren yet faithful woman who ends up with a baby boy is a common one in the Bible, but the commentators see more spiritual significance in the story than first meets the eye.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_29"
    }
  }, [_c('b', [_vm._v("2:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Overview of Hannah’s Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah Sings of God’s Glory.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" From her experience, Hannah, full of the Spirit, sings against the glory of human hypocrisy and sings about God’s glory, through which God graciously makes the barren fruitful. This means that Gentiles and sinners acquire grace. This divine grace and glory has been declared and entered the world through the reign of Christ, whose strength God exalts against all of the world’s powers, knowledge, righteousness and especially all human hypocrisy. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-409-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hannah’s Faithful and Prophetic Prayer.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Hannah conforms to the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1315"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1320"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1344"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1351"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1361"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1368"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1370"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1374"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1375"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1380"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1390"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1391"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1393"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1397"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1400"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1402"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1413"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1414"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1417"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page12",
      "title": "12"
    }
  }), _vm._v("pattern given in James: “Is anyone among you suffering? Let him pray. Is anyone cheerful? Let him sing praise.” Just as she brought prayers and vows to God earlier, she then celebrated the goodness and mercy of God with the sweetest song. But Hannah’s song is so admirably worthy not only because it praises the source of the gift but also because it foretells the reign of Christ, which lasts even to the end of the earth. Further, she teaches faith in God alone to be such that one can be killed and made alive, taken down to hell and brought back. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-408-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Giving All.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" God gave Samuel to Hannah, Hannah gave Samuel back again to God. In a similar way, return part of your riches to God, who gave all to you in the first place. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-407-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Prayer of All Creatures.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" The want of so great a blessing as is the bearing of a child moved Hannah to break forth into this desire of prayer. Yet it is most certain that the Virgin Mary needed a Savior—for which she also confessed that her spirit rejoiced—more so than Hannah needed a son. And as Mary’s need was greater, so her prayer was stronger than Hannah’s prayer. For Hannah prayed alone; but as for Mary’s prayer, it was accompanied with the desire and prayer of all creatures. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-406-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_30"
    }
  }, [_c('b', [_vm._v("2:6-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Killing and Bringing to Life")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Taking and Giving Life.")]), _vm._v(" "), _c('i', [_vm._v("Hans Denck:")]), _vm._v(" The righteousness of God is God himself. Sin is what raises itself up against God; it is in truth nothing. The righteousness works through the Word that was from the beginning and is subsequently divided in two, law and gospel, on account of the twofold office that Christ as king of righteousness exercises, namely, to destroy the unbelievers and to bring to life the believers. Now, all believers were once unbelievers. Consequently, in becoming believers, they thus first had to die in order that they might thereafter no longer live for themselves, as unbelievers do, but for God through Christ that their walk might indeed no longer be on earth but in heaven, as Paul says. David also verifies this where he says: The Lord leads down into hell and up again. All this I believe (Lord, crush my unbelief) in truth, awaiting now whoever wishes to deny and overthrow it. "), _c('i', [_vm._v("Nuremberg Confession.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-405-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Law Versus Gospel.")]), _vm._v(" "), _c('i', [_vm._v("Johann Gerhard:")]), _vm._v(" God kills and makes alive, and he leads down to hell and brings back again. Specifically, God kills by contrition that he may make alive by consolation. And God leads down to hell by the hammer of the law that he may bring back from hell by the comfort of the gospel. "), _c('i', [_vm._v("The Conquest of Temptations.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-404-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("True Repentance Involves Dying and Rising.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Hannah’s song describes true repentance, or conversion to God, in which there are two moves: dying and being made alive. Dying points to the heart’s recognizing God’s wrath against sin with true fear and suffering. Scripture describes this suffering: “Like a lion he breaks all my bones.” In these sufferings, which come from awareness of God’s wrath, there is mortification of the flesh, or of the old and corrupt nature. This suffering may be greater or smaller in various people, but contrition is necessary in all conversions, as it says in 2 Corinthians: “You were grieved into repenting . . . for godly grief produces a repentance that leads to salvation.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-403-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Studying at God’s School.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" I have often seen excellent men horribly vexed by terrors, afflictions and the severest persecutions, so "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1421"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1422"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1430"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1432"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1433"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1434"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1438"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1440"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1446"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1449"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1453"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1454"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1455"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1461"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1462"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1463"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1464"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1465"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1466"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1467"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1468"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1469"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1470"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1471"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1472"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1473"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1474"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1475"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1476"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1477"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1478"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1479"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1480"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1481"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1482"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1483"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1484"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1485"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1486"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1487"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1488"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1489"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1490"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1491"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1492"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1493"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1494"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1495"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1496"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1497"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1498"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1499"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1500"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1501"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1502"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1503"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1504"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1505"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1506"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1507"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1508"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page13",
      "title": "13"
    }
  }), _vm._v("much so that they nearly experienced despair of heart. But these things must be learned so that we may be able to comfort such men and interpret the temptations as the special manner by which God is accustomed to wrestle with us in the form of a destroyer and that we may exhort them firmly to retain the promise, or lamp and spark, of the Word in the hope that the rescue will certainly follow. For God leads down to hell and brings back. Now you see his back parts, and God seems to be shunning you, but sometime later you will see his front parts and his face. This is what it means for him to love those whom he chastises. This love must be learned from experience, nor should chastisement be avoided and shunned. The story is told of a peasant who, when he heard this consolation from his pastor, that the afflictions and troubles by which God afflicts us are signs of his love, replied: “Ah, how I would like him to love others and not me!” "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-402-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("All Is God’s Own.")]), _vm._v(" "), _c('i', [_vm._v("David Clarkson:")]), _vm._v(" God has the right to dispose of all as he wills, and does actually dispose of any things and persons as he thinks is good. He has "), _c('i', [_vm._v("jus praesenter disponendi")]), _vm._v(", “the right of present disposal,” which is properly dominion or property. He gives possession and ejects, puts in and throws out, lifts up and casts down, whom and when he will. . . . Why does God thus dispose of all? Because all is his own. "), _c('i', [_vm._v("Sermon on 1 Chronicles 29:11.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-401-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_31"
    }
  }, [_c('b', [_vm._v("2:10")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God Blessed His Church")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Another Prediction About the Messiah.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" According to the Hebrew, the passage states: “He will give strength to his king; he will raise the horn of his Messiah.” Before this time, however, no king had been instituted in Israel. Therefore, this passage speaks about the messianic king, for God gave him strength and elevated his power. In fact, in Hebrew the word "), _c('i', [_vm._v("Messiah")]), _vm._v(" means “anointed,” while in Greek the word is translated as "), _c('i', [_vm._v("Christ")]), _vm._v(". Now, it is evident that Christ will come at the time of judgment in strength and in great stature. And for this reason it is manifest that he will be a person who judges the ends of the earth according to the prophecy from the book of Job. And this is the fourth passage in which the Messiah is clearly predicted: first, during the time of Abraham; second, during the time of Jacob; third, during the time of Moses; and fourth, during the time of Samuel. Later the Messiah is predicted in the book of Job. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-400-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David, the Chosen One.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Before a king had been established over the people, Hannah, the mother of Samuel, describing the happiness of the godly, already says in her song: “God will give strength to his king and exalt the horn of his Messiah.” By these words she means that God will bless his church. To this corresponds the prophecy that is added a little later: “The priest whom I shall raise up . . . will walk in the presence of my Christ.” And there is no doubt that our heavenly Father willed that we perceive in David and his descendants the living image of Christ. Accordingly David, wishing to urge the pious fear of God, commands them to “kiss the Son.” To this corresponds the saying of the Gospel: “He who does not honor the Son does not honor the Father.” Therefore, although the kingdom collapsed because of the revolt of the ten tribes, yet the covenant God made with David and his successors had to stand, just as he spoke through the prophets: “I will not tear away all the kingdom . . . for the sake of David my servant and for the sake of Jerusalem, which I have chosen . . . but to your son one tribe will remain.” This same promise is repeated a second and a third time. It is expressly stated: “I will . . . afflict David’s descendants, but not eternally.” Sometime later it is said: “For the sake of David his servant, God gave him a lamp in Jerusalem, to "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1509"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1510"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1511"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1512"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1513"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1514"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1515"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1516"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1517"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1518"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1519"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1520"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1521"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1522"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1523"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1524"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1525"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1526"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1527"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1528"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1529"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1530"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1531"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1532"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1533"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1534"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1535"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1536"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1537"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1538"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1539"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1540"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1541"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1542"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1543"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1544"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1545"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1546"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1547"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1548"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1549"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1550"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1551"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1552"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1553"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1554"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1555"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1556"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1557"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1558"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1559"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1560"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1561"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1562"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1563"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1564"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1565"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1566"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1567"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1568"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1569"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1570"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1571"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1572"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1573"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1574"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1575"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1576"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1577"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1578"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1579"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1580"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1581"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page14",
      "title": "14"
    }
  }), _vm._v("raise himself up a son and to protect Jerusalem.” Then, although affairs verged on ruin, it was again said: “The Lord was unwilling to destroy Judah, for the sake of David his servant, since he promised to give a lamp to him and to his sons forever.” To sum up: While all others were passed over, David alone was chosen as the one in whom God’s pleasure should rest. "), _c('i', [_vm._v("Institutes 2.6.2.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-399-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor1582"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1583"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1584"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1585"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1586"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1587"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1588"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1589"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1590"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1591"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1592"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1593"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1594"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1595"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1596"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1597"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1598"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1599"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1600"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1601"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1602"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1603"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1604"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1605"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1606"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1607"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1608"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1609"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1610"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1611"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1612"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1613"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1614"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1615"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1616"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1617"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1618"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1619"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1620"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1621"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1622"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1623"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1624"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1625"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1626"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1627"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1628"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1629"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1630"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1631"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1632"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1633"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1634"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1635"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1636"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1637"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1638"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1639"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1640"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1641"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1642"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1643"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1644"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1645"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1646"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1647"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1648"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page15",
      "title": "15"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_32"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("2:11-36")]), _vm._v(" REJECTION OF ELI’S WICKED SONS AND HIS HOUSEHOLD")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then Elkanah went home to Ramah. And the boy")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("was ministering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in the presence of Eli the priest.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Now the sons of Eli were worthless men. They did not know the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("The custom of the priests with the people was that when any man offered sacrifice, the priest’s servant would come, while the meat was boiling, with a three-pronged fork in his hand,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("and he would thrust it into the pan or kettle or cauldron or pot. All that the fork brought up the priest would take for himself. This is what they did at Shiloh to all the Israelites who came there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Moreover, before the fat was burned, the priest’s servant would come and say to the man who was sacrificing, “Give meat for the priest to roast, for he will not accept boiled meat from you but only raw.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And if the man said to him, “Let them burn the fat first, and then take as much as you wish,” he would say, “No, you must give it now, and if not, I will take it by force.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Thus the sin of the young men was very great in the sight of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for the men treated the offering of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("with contempt.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Samuel was ministering before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", a boy clothed with a linen ephod.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And his mother used to make for him a little robe and take it to him each year when she went up with her husband to offer the yearly sacrifice.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Eli would bless Elkanah and his wife, and say, “May the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("give you children by this woman for the petition she asked of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".” So then they would return to their home.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Indeed the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("visited Hannah, and she conceived and bore three sons and two daughters. And the boy Samuel grew in the presence of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Now Eli was very old, and he kept hearing all that his sons were doing to all Israel, and how they lay with the women who were serving at the entrance to the tent of meeting.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And he said to them, “Why do you do such things? For I hear of your evil dealings from all these people.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("No, my sons; it is no good report that I hear the people of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("spreading abroad.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("If someone sins against a man, God will mediate for him, but if someone sins against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", who can intercede for him?” But they would not listen to the voice of their father, for it was the will of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("to put them to death.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Now the boy Samuel continued to grow both in stature and in favor with the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and also with man.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("And there came a man of God to Eli and said to him, “Thus says the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", ‘Did I indeed reveal myself to the house of your father when they were in Egypt subject to the house of Pharaoh?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Did I choose him out of all the tribes of Israel to be my priest, to go up to my altar, to burn incense, to wear an ephod before me? I gave to the house of your father all my offerings by fire from the people of Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("Why then do you scorn")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("my sacrifices and my offerings that I commanded for my dwelling, and honor your sons above me by fattening yourselves on the choicest parts of every offering of my people Israel?’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("Therefore the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, declares: ‘I promised that your house and the house of your father should go in and out before me forever,’ but now the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("declares: ‘Far be it from me, for those who honor me I will honor, and those who despise me shall be lightly esteemed.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("Behold, the days are coming when I will cut off your strength and the strength of your father’s house, so that there will not be an old man in your house.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("Then in distress you will look with envious eye on all the prosperity that shall be bestowed on Israel, and there shall not be an old man in your house forever.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("The only one of you whom I shall not cut off from my altar shall be spared to weep his")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("eyes out to grieve his heart, and all the descendants")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("of your house shall die by the sword of men.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("And this that shall come upon your two sons, Hophni and Phinehas, shall be the sign to you: both of them shall die on the same day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("And I will raise up for myself a faithful priest, who shall do according to what is in my heart and in my mind. And I will build him a sure house, and he shall go in and out before my "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1649"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1650"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1651"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1652"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1653"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1654"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1655"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1656"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1657"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1658"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1659"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1660"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1661"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1662"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1663"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1664"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1665"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1666"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1667"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1668"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1669"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1670"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1671"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1672"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1673"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1674"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1675"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1676"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1677"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1678"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1679"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1680"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1681"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1682"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1683"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1684"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1685"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1686"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1687"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1688"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1689"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1690"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1691"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1692"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1693"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1694"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1695"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1696"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1697"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1698"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1699"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1700"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1701"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1702"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1703"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1704"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1705"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1706"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1707"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1708"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1709"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page16",
      "title": "16"
    }
  }), _c('i', [_vm._v("anoi"), _c('a', {
    attrs: {
      "id": "_idTextAnchor1710"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1711"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1712"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1713"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1714"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1715"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1716"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1717"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1718"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1719"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1720"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1721"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1722"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1723"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1724"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1725"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1726"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1727"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1728"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1729"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1730"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1731"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1732"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1733"
    }
  }), _vm._v("nted forever.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("And everyone who is left in your house shall come to implore him for a piece of silver or a loaf of bread and shall say, “Please put me in one of the priests’ places, that I may eat a morsel of bread.”’”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew "), _c('i', [_vm._v("na’ar")]), _vm._v(" can be rendered "), _c('i', [_vm._v("boy")]), _vm._v(" (2:11, 18, 21, 26; 3:1, 8), "), _c('i', [_vm._v("servant")]), _vm._v(" (2:13, 15), or "), _c('i', [_vm._v("young man")]), _vm._v(" (2:17), depending on the context "), _c('b', [_vm._v("b")]), _vm._v(" Hebrew "), _c('i', [_vm._v("kick at")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("your")]), _vm._v("; twice in this verse "), _c('b', [_vm._v("d")]), _vm._v(" Hebrew "), _c('i', [_vm._v("increase")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("die as men"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" According to the interpreters, leadership of God’s people is a great responsibility, not to be taken lightly. Melanchthon exhorts us not to discredit the gospel by our bad behavior. The reformers believe that leaders, particularly members of the clergy, are to display exemplary lives in accordance with good doctrine. When God’s people see poor behavior in their leaders, they are drawn to imitate their bad example rather than seek the higher road to goodness and righteousness. Eli’s sons are evil leaders juxtaposed with Samuel’s godly leadership. Moreover, the reformers criticize Eli for being too lenient toward his sons, and the commentators use this passage to encourage parents to follow the wisdom of Proverbs by disciplining their children. When Eli tries to admonish his sons’ behavior, however, it is too late. According to the interpreters, Eli is unable to intercede with God on his sons’ behalf, and God rightly condemns his sons for their wicked behavior. Despite the free actions of Eli’s sons, the removal of Eli’s lineage from the priesthood is part of God’s sovereign plan, which prompts an explanation of the difference between conditional and unconditional promises.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_33"
    }
  }, [_c('b', [_vm._v("2:11-17")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Differences Between Godly and Ungodly Leaders")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Integrity Among Ministers.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" We, who confess the gospel, are especially to consider how severely God is angered if we give the gospel an evil name. For such sin God cast aside the high priest Eli and his sons, as the text says, 1 Samuel 2:17, “Thus the sin of the young men was very great in the sight of the Lord; for they treated the offering of the Lord with contempt.” As God was angry with those who gave reason for speaking of the sacrifice, you should not give reason for, or support, blasphemy or contempt of the gospel. We must, therefore, be careful in doctrine and customs, so that we do not incur the anger of God with offensive doctrine or injurious examples. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-398-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel’s Steadfastness Contrasts with Eli’s Sons.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Samuel possessed great and amazing virtue, because he did not imitate the depraved example of Eli’s sons. For he very much shows examples of self-governance in both parts of valor. For they are especially strong who have close friendships at home and who attend closely to God. Therefore, when Samuel did not follow the impious and otherwise wicked sons of Eli, then his incorruptibility can rightly be described as Pyrrhus spoke of Fabricius (as stated in Eutropius’s history). Such is Samuel, who was as hard to separate from honesty as Saul was quick. For he was always true to himself, unchanging in all matters. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-397-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Role of a Church Leader.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Let us consider how pastors are to lead the church of Christ and exemplify a holy life. The Lord said to his disciples in the Gospel: “You are the light of the world. A city on a hill cannot be hidden. Neither do people light a lamp and put it under a bowl. Instead they put it on its stand, and it gives light to everyone in the house. In the same way, let your light shine before men, that they may see your good deeds and praise your Father in "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1734"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1735"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1736"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1737"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1738"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1739"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1740"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1741"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1742"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1743"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1744"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1745"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1746"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1747"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1748"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1749"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1750"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1751"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1752"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1753"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1754"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1755"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1756"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1757"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1758"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1759"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1760"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1761"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1762"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1763"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1764"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1765"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1766"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1767"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1768"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1769"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1770"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1771"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1772"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1773"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1774"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1775"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1776"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1777"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1778"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1779"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1780"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1781"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1782"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1783"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1784"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1785"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page17",
      "title": "17"
    }
  }), _vm._v("hea"), _c('a', {
    attrs: {
      "id": "_idTextAnchor1786"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1787"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1788"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1789"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1790"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1791"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1792"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1793"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1794"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1795"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1796"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1797"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1798"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1799"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1800"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1801"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1802"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1803"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1804"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1805"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1806"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1807"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1808"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1809"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1810"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1811"
    }
  }), _vm._v("ven.” As such, pastors are to give light to their churches by means of a holy life and not just by means of doctrine. After seeing that the pastor’s life agrees with sound doctrine, the people of the church will be moved toward innocence of life. For the most part, an example of a holy and good person may be found in the study of the virtues; on the contrary, Scripture testifies in many ways how the corrupt sons of Eli, the chief leaders of religion, served as an example to corrupt the people. For Scripture says, “This sin of the young men was very great in the Lord’s sight, for they were treating the Lord’s offering with contempt.” For it is apparent that people begin to doubt the whole doctrine when they see the corrupt life of the ministers of the church. The people cry out, “If the pastor truly believed the things he teaches us, he would not lead such an immoral life.” In this way, the teachers are said to have overthrown in their evil life what they had constructed in their unsound doctrine. "), _c('i', [_vm._v("Decades 5.4.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-396-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Many Offenses of Eli’s Sons.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The sin Eli’s sons committed against the offerings of the Lord was not of one sort but many. First, they were guilty of theft and robbery. For whereas only the breast and right shoulder belonged to the priest of the peace offerings, they took more and were not content with the ordinary portion brought up by their utensils. Second, they also committed sacrilege. For whereas the Lord was to be served first and the fat burned first, they exacted their fee and more, even before the Lord had gotten his due. Third, they did this with contemptuous hostility and violence, not staying to receive it at the offerer’s hand, but being their own carvers. Fourth, they were also guilty of the sin of wantonness. They took the flesh while it was yet raw, so that they might dress it to the priest’s liking. In short, the sin of the young men was very great: in respect to themselves . . . who, being priests, should have given a good example to others; in regard to God, against whom they were presumptuous; and in respect to the great hurt and inconvenience that arose from this, they caused the people to abhor the sacrifices of the Lord. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-395-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_34"
    }
  }, [_c('b', [_vm._v("2:18-21")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel and His Ephod")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Ephod Linen.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This was the ephod garment of the Levites, spoken of in Exodus 28, which covered over the priests’ lower body. But when it was put on Samuel, it signified his public ministry and his Levitical priesthood in the tabernacle. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-394-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Different Kinds of Ephods.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" There were two kinds of ephods belonging to the service of the tabernacle, one peculiar to the high priest wrought with gold and blue silk; and another of linen only, which was common to all the Levites and priests. . . . Of this sort was Samuel’s ephod. Yet there was also a third kind of ephod, which was a civil garment of white linen used in the time of celebration and joy. Such is the type of ephod David put on when he danced before the ark and about which the Preacher said, “Let your garments be always white.” "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-393-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_35"
    }
  }, [_c('b', [_vm._v("2:22-26")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Sins of the Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Scattering the Wolves.")]), _vm._v(" "), _c('i', [_vm._v("Martin Bucer:")]), _vm._v(" Let us be admonished by those horrible punishments that were suffered by the priest Eli . . . and the whole people of Israel on account of their wicked indulgence and misguided compassion toward those against whom they should have treated severely—by God’s command, who alone is truly compassionate and merciful. We should not imagine that anyone—contrary to God’s teaching "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1812"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1813"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1814"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1815"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1816"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1817"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1818"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1819"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1820"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1821"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1822"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1823"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1824"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1825"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1826"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1827"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1828"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1829"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1830"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1831"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1832"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1833"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1834"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1835"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1836"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1837"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1838"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1839"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1840"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1841"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1842"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1843"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1844"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1845"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1846"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1847"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1848"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1849"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1850"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1851"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1852"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1853"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1854"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1855"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1856"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1857"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1858"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1859"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1860"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1861"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1862"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1863"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1864"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1865"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1866"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1867"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1868"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1869"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1870"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1871"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1872"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1873"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1874"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1875"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1876"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1877"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1878"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1879"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1880"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1881"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1882"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page18",
      "title": "18"
    }
  }), _vm._v("and to the church of God’s ruin—will be shown leniency or pardoned at all. Christian leniency and mercy must be shown to "), _c('i', [_vm._v("Christ’s")]), _vm._v(" sheep—by which they should be protected from wolves—not to wolves, so that they can scatter and destroy the sheep. "), _c('i', [_vm._v("Reign of Christ.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-392-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Parental Responsibility.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Also we need to teach parents their responsibility to instill in their children the fear of God, to teach and let them learn the Word of God. Thus we read in the Proverbs of Solomon: “For folly is bound up in the heart of a child, but the rod of discipline drives it far from him.” So Paul in Ephesians 6 says: “Fathers, do not provoke your children to anger, but bring them up in the discipline and instruction of the Lord.” Such is the example of Eli who according to 1 Samuel 2 was punished by God and deprived of his priestly office because he had not taken seriously the rearing of this children. Never have youth been more insolent than today—we see how little they obey, how little they respect their parents. On this account, undoubtedly, the world is full of plagues, war, rebellion and other evils. "), _c('i', [_vm._v("Instructions by the Visitors of Parish Pastors: On True Christian Prayer.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-391-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Will Punish Eli’s Corrupt Sons.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" A priest holds the office of mediation between God and people, to teach the people God’s Word and to make sacrifices. These all stumble wherever the Word of God is despised. For what good does it do to add piety to impiety? In the same way, these priests stretched what was written in the Lord’s law about the portions given to priests and the sacrifices of the law concerning the fat burned to the Lord as written in Leviticus. They did not come back to their senses when admonished by the people but rather used violence against those who questioned them. When their father rightly admonished them, they despised his great forbearance and earned God’s judgment, as it is written, “It was the will of the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" to put them to death.” This is an example of how human doctrines gather people against God’s Word while the glory of wealth and worldly opinions of justice are sought instead. Here are erring spirits, which little by little possess what they want by violent means. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-390-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Scandalous Sacrifice.")]), _vm._v(" "), _c('i', [_vm._v("Robert Sanderson:")]), _vm._v(" In judging the cases of scandal, we are not so much to look at the event, what that is or may be, as we are at the cause from where it comes. . . . The first is when a person does something before another person that is in itself evil, unlawful and sinful. In which case, neither the intention of the one who does it nor the event, as to him who sees it done, is of any consideration. It does not matter whether the doer had an intention to draw the other into sin or not. Nor does it matter whether the other was induced to commit sin or not. The fact that the action itself is evil, and done before others, is sufficient to render the doer guilty of having given scandal, though he had neither any intention himself so to do, nor was any person actually scandalized by it. This is because whatsoever is in itself and in its own nature evil is also of itself, and in its own nature, scandalous, and of evil example. Thus did Hophni and Phinehas, the sons of Eli, give scandal by their wretched profaneness and greediness about the sacrifices of the Lord as well as their vile and shameless abusing of the women. "), _c('i', [_vm._v("The Case Determined.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-389-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Multiplying Sin.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" The sin of the clergy is like a sickness, which rising from the stomach into the head, drops down upon the lungs . . . until all the members of the body languish into corruption. Eli’s lewd sons acted intolerably when they sinned in the tabernacle. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor1883"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1884"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1885"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1886"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1887"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1888"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1889"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1890"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1891"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1892"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1893"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1894"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1895"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1896"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1897"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1898"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1899"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1900"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1901"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1902"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1903"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1904"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1905"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1906"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1907"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1908"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1909"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1910"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1911"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1912"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1913"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1914"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1915"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1916"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1917"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1918"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1919"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1920"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1921"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1922"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1923"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1924"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1925"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1926"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1927"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1928"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1929"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1930"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1931"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1932"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1933"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1934"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1935"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1936"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1937"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1938"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1939"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1940"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1941"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1942"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1943"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1944"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1945"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1946"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1947"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1948"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page19",
      "title": "19"
    }
  }), _vm._v("Although their sacrifices could do away the sins of others, no sacrifice could do away their own sin. Although many a soul was the cleaner for the blood of those beasts they shed, their own souls were the fouler by it. By one and the same service, they atoned for the people’s offenses and multiplied their own. "), _c('i', [_vm._v("The Temple.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-388-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why We Must Read the Scriptures.")]), _vm._v(" "), _c('i', [_vm._v("John Jewel:")]), _vm._v(" Are you a father? Do you have children? Read the Scriptures and they will teach you. If you have sons, instruct them. Eli the prophet, by sparing his wanton children, cast away himself and his children: They were killed, the ark of God was taken and old Eli fell down and broke his neck. Of the Holy Scriptures."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-387-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_36"
    }
  }, [_c('b', [_vm._v("2:27-36")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Lord Rejects Eli’s Household")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("There Came a Man of God.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Another prophet was sent by God. As Eli’s own words show, he was not ignorant of his sin of releasing his ungodly sons into the priesthood and letting this matter become a disgrace. Here the law or judgment of God is revealed clearly to him, which confounds his conscience. Love for his sons keeps him from coming to his senses, even though the priesthood should not be a private honor. But he heard the judgment of God again from Samuel when he said, “It is the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(". Let him do what seems good to him.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-386-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli’s Three Errors.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The prophet’s remembrance of the earlier blessings given to the Levites is followed by the most egregious accusations, in which three of Eli the priest’s crimes are brought up. The first is profaning the sacrifice. The second is being fawning and overindulgent to his children. The third is avarice. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-385-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("But It Should Not Be So.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Here arises a great doubt, given we know that God’s promises are most certain and that his decree is immutable. How, then, does the Lord make a promise and then go back on it? The answer is that some of God’s promises are absolute without any condition, as was the promise of the Messiah. However, others of God’s promises are given to us conditionally, especially the temporal promises made to the Israelites. These conditional promises, such as the priesthood being promised to the family of Eli, depended on the condition of their obedience. So now, life everlasting is promised to those who have faith and believe. But will some say: Does God’s election, therefore, depend on our works or belief? Not in any way. For God, as he has promised the reward—so also, to those whom he purposes to make heirs of his promise—he has likewise ordained the means to give them faith (and all other graces) to apprehend and lay hold of the promises. God’s promises, then, are only effectual to those who, by a lively faith, apprehend them. The rest, which by their disobedience fall off from God’s promises, do not work any alteration in the purpose of God, who has foreseen both their disobedience and that his promises did not belong to them. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-384-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor1949"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1950"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1951"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1952"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1953"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1954"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1955"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1956"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1957"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1958"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1959"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1960"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1961"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1962"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1963"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1964"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1965"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1966"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1967"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1968"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1969"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1970"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1971"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1972"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1973"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1974"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1975"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1976"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1977"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1978"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1979"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1980"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1981"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1982"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1983"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1984"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1985"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1986"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1987"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1988"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1989"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1990"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1991"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1992"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1993"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1994"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1995"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1996"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1997"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1998"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor1999"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2000"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2001"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page20",
      "title": "20"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_37"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("3:1–4:1a")]), _vm._v(" SAMUEL’S CALLING")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now the boy Samuel was ministering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in the presence of Eli. And the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was rare in those days; there was no frequent vision.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("At that time Eli, whose eyesight had begun to grow dim so that he could not see, was lying down in his own place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("The lamp of God had not yet gone out, and Samuel was lying down in the temple of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", where the ark of God was.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("called Samuel, and he said, “Here I am!”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("and ran to Eli and said, “Here I am, for you called me.” But he said, “I did not call; lie down again.” So he went and lay down.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("called again, “Samuel!” and Samuel arose and went to Eli and said, “Here I am, for you called me.” But he said, “I did not call, my son; lie down again.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now Samuel did not yet know the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had not yet been revealed to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("called Samuel again the third time. And he arose and went to Eli and said, “Here I am, for you called me.” Then Eli perceived that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was calling the boy.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Therefore Eli said to Samuel, “Go, lie down, and if he calls you, you shall say, ‘Speak,")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for your servant hears.’” So Samuel went and lay down in his place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("came and stood, calling as at other times, “Samuel! Samuel!” And Samuel said, “Speak, for your servant hears.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “Behold, I am about to do a thing in Israel at which the two ears of everyone who hears it will tingle.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("On that day I will fulfill against Eli all that I have spoken concerning his house, from beginning to end.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And I declare to him that I am about to punish his house forever, for the iniquity that he knew, because his sons were blaspheming God,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("and he did not restrain them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Therefore I swear to the house of Eli that the iniquity of Eli’s house shall not be atoned for by sacrifice or offering forever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Samuel lay until morning; then he opened the doors of the house of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". And Samuel was afraid to tell the vision to Eli.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("But Eli called Samuel and said, “Samuel, my son.” And he said, “Here I am.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And Eli said, “What was it that he told you? Do not hide it from me. May God do so to you and more also if you hide anything from me of all that he told you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("So Samuel told him everything and hid nothing from him. And he said, “It is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". Let him do what seems good to him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And Samuel grew, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was with him and let none of his words fall to the ground.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And all Israel from Dan to Beersheba knew that Samuel was established as a prophet of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("appeared again at Shiloh, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("revealed himself to Samuel at Shiloh by the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("4")]), _vm._v(" "), _c('i', [_vm._v("And the word of Samuel came to all Israel."), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("blaspheming for themselves"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" There was a general sense among Reformation interpreters that in their day God was dismantling the church of old on account of its faithlessness and breathing new life into the church—not very different from the way God was ending Eli’s line and starting afresh with Samuel. Due to the godlessness on the part of Israelite leadership, God sends a spiritual famine in accordance with Scripture. As the last of the judges, Samuel is a true prophet of God, who begins to restore the Israelites to proper worship of God. Although Samuel does not initially understand God’s voice, God chooses him to lead God’s people into the truth. His first assignment is to deliver a divine word to his teacher Eli. The reformers commend Eli’s humility to Christian believers. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2002"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2003"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2005"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2012"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2015"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2017"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2021"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2022"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2024"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2030"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2031"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2032"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2033"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2034"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2035"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2036"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2037"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2038"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2040"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2043"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2045"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2046"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2048"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2053"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2069"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2070"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page21",
      "title": "21"
    }
  }), _vm._v("Like Eli, Christians must always affirm and patiently accept the word of the Lord, regardless of the immediate pain it causes us or the difficulty that ensues. For the commentators, the beauty of this passage is that God gives partial revelation to Samuel and partial revelation to Eli, reminding us of Paul’s analogy of the church as one body with many members.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Called by God Alone.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" This particular chapter recounts the direct calling of Samuel to prophetic service. Samuel was not called by people or through the agency of people but by God. And Samuel was called in this way so that he could be an expounder of the law and a witness of the Messiah, who would govern the political realm. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-383-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_38"
    }
  }, [_c('b', [_vm._v("3:1")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Scarcity of God’s Word in Those Days")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli Establishes Samuel as a Prophet.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Prophets and divine revelations were rare then. At that time the godlessness of the priests and the people was very great. As the Lord said in Amos: “I will send a famine on the land—not a famine of bread, nor a thirst for water, but for hearing the words of the Lord.” Because God’s people then deserved punishment, a prophet was raised up, namely Samuel. For when God punishes his people’s sins, he first sends someone to invite and call them to repentance, saying, “Come to your senses and escape punishment.” Already, therefore, Samuel is called to the office of prophet. . . . [He then replied to God’s call, saying]: “I am humbly ready to receive the word that you will tell me.” And so Eli, who was denied prophetic visions, nevertheless established Samuel in how he prepared him to hear the divine oracle. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-382-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Neglected Word.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" At this time there were not many preachers or pastors. It was as if sacred Scripture was covered in mold or dust. The study of Scripture was neglected when Samuel came along, who roused and illuminated the study of it again. And just as the supreme good of any church is the preservation of the true doctrine of God, so the worst thing that can happen to a church is to have a famine, not of bread, but of the Word of God. Whenever the Word is lost or obscured, a horrible darkness concerning the benefits of Christ, concerning true prayer and concerning faith must inevitably follow. Therefore we give thanks to God because his Word desires to dwell among us abundantly with all wisdom. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-381-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("There Was No Manifest Vision.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" God, for the sin of his people, brought a famine on them—“not a famine of bread, or a thirst for water”—just as he threatened by his prophet Amos: “They shall wander from sea to sea, and from north to east; they shall run to and fro, to seek the word of the Lord, but they shall not find it.” Although there might be some private and particular visions and revelations—as to Manoah in Judges 13—yet the public office of prophets was ceased and intermittent. For this is not to be understood of the written word—for they had the books of Moses—but of the word of prophecy. And if there were any such visions, they were dark, hidden and obscure. As the Septuagint reads, there was no “distinct vision,” that is, opened, unfolded and applied. Christ Jesus the Word of God, by whom the Lord spoke to Samuel in 1 Samuel 3:21 and to David in 2 Samuel 7:21, sparingly revealed and manifested himself to his servants the prophets. "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-380-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_39"
    }
  }, [_c('b', [_vm._v("3:2-18")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God’s Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Same Lord Empowering Everyone.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" God provided the revelation in this way so Eli could recognize that what was first "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2071"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2090"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2097"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2109"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2121"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2123"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2129"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2130"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2131"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2139"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page22",
      "title": "22"
    }
  }), _vm._v("revealed to Samuel through a dream was truly divine. Thus after Eli heard Samuel describe the revelation, he was convinced by his own testimony that this was no mere dream but a certain pronouncement from the Lord. In this way Eli might recognize and be frightened by his own true unworthiness before the Lord, and thereby be revived. This passage shows us the wonderful plan of God that one person is not given all gifts but rather that individuals are given individual gifts. To Samuel was given the gift of hearing the voice of God, though he was not given the gift of recognizing it as God’s voice without being taught to know it by Eli. To Eli it was given that he might recognize the voice of God through his intellect, though it was not given him to hear the Lord himself. As Paul says, “Now there are varieties of gifts, but the same Spirit; and there are varieties of service, but the same Lord; and there are varieties of activities, but it is the same God who empowers them all in everyone.” "), _c('i', [_vm._v("Sermons on Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-379-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Listening Like Samuel.")]), _vm._v(" "), _c('i', [_vm._v("Johann Arndt:")]), _vm._v(" The Lord says, “Hear my voice and open unto me.” In a house in which there is the noise of this world, no sweet music can be heard. In a like manner, God cannot be heard in a worldly heart, for it is not opened toward God and does not let him in. Therefore such an earthly heart cannot taste the heavenly manna. When the tumult of this world is still in the heart, God comes and knocks and allows himself to be heard. Then you can say with the prophet Samuel: “Speak, Lord, for your servant hears.” "), _c('i', [_vm._v("True Christianity.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-378-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How Samuel Did Not Know the Lord.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some read: “This is what Samuel did before he knew the Lord.” However, the passage is better interpreted as: “Samuel did not yet know the Lord,” as the Hebrew here signifies both "), _c('i', [_vm._v("not yet")]), _vm._v(" and "), _c('i', [_vm._v("before that")]), _vm._v(". At any rate, the first interpretation is more proper here, which makes the sense full without any other addition. But in the other reading something must be supplied. Now there is a twofold knowledge of God: ordinary and extraordinary. One is common to all servants of God, the other only to the prophets when the will of God is revealed concerning things to come: Samuel was not without the ordinary knowledge of God before, but the latter he had no experience of until now. As the next words shows, “The word of the Lord had not yet been revealed to him,” which the Jews interpret as prophecy. Therefore Eli gave him instruction and informed him that it was the Lord who spoke to him. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-377-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Preaches Repentance to Eli.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" We can see how merciful and long-suffering our heavenly father is when we consider that Eli the priest was told to repent by two prophets. For in the previous chapter Eli heard the most fervent advice of the unnamed prophet. Now he is invited to repentance by the ministry of the prophet Samuel. But then consider Samuel’s great sorrow upon seeing his master and teacher’s unhappy end. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-376-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("What Seems Good to God.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" We must bear quietly the punishment laid on us, for out of affliction the godly gather a matter of thanks for having all taken from them. . . . The godly praise God for the cup of affliction as well as for the cup of salvation, and are as thankful to God for the benefits the Lord bestows on them by means of affliction against their will as for those that come to them by their will and good liking. And this is the perfection we are to strive toward. But if we do not at all reckon them as benefits, nevertheless we must say with Eli, “It is the Lord; let him do what seems good to him.” "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-375-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli Confesses His Sins.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" When Eli responded, “It is the Lord. Let him do "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2146"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2200"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2203"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page23",
      "title": "23"
    }
  }), _vm._v("what seems good to him,” it was as if he were saying, “I recognize my sin and the righteous wrath of the Lord. And I understand that I and my posterity are no longer allowed to continue the sacrifices or serve as mediators as a punishment for our sins. I will bear this patiently, content in this one thing: that I know the Lord God seriously desires repentance and not that we are cast into eternal damnation.” Therefore, even if we are not able to escape from such physical punishment, we still should not doubt the mercy of God, which leads to eternal life. Instead, we should subject ourselves to the will of God with continual, humble and patient supplications. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-374-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Not Eternal Condemnation.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Jackson:")]), _vm._v(" Now when Samuel had delivered this fearful and reproving sentence to Eli, the latter replied no more than this: “It is the Lord. Let him do what seems him good to him.” Had this message been delivered by that “man of God” who brought the former prophecy of doom to this good old man, Eli—though he was a weak judge—he probably would have happily ignored it, for such did he do when the man of God spoke to him. At the least, he would have called the messenger’s prophecy into question. But because this latter and more terrible doom was delivered to him by a child—who was far removed from secular cunning and sophisms of corrupt priests or Levites, who could not even distinguish the voice of the Lord from the voice of his teacher until he was instructed by him and who depended on Eli completely as his foster father—his message was to Eli more authentic. In other words, Samuel’s message, both in its content and in its presentation, was freer from all suspicion of imposture.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Eli’s response is of the same alloy of Job’s reply to the sad news his servants brought to him. “The Lord,” says Job, “gave and has taken away; blessed be the name of the Lord.” Such is how he spoke after he had seen himself and his family utterly undone for worldly substance, deprived of all earthly contentment. Eli knew that this sentence against him was denounced as by oath. It was as certain and impossible to be reversed as if it had already happened. For this reason, I believe, the old man, Eli, did consider a more submissive answer to Samuel than he had vouchsafed to the man of God who was sent to him on the same errand. The humility and modesty of his answer persuades me that the fearful sentence denounced against him extended no further than to the irreversible deposition of him and his family from the legal or temporary priesthood to the poor and humble estate where his posterity after the disaster of his two sons were to live here on the earth. Nor have I any warrant from God’s Word to say, and Christian charity forbids me to think, that either Eli himself, his two lewd sons or his posterity were absolutely or irreversibly decreed from this time forward to everlasting damnation. "), _c('i', [_vm._v("A Treatise of the Son of God to His Everlasting Priesthood.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-373-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_40"
    }
  }, [_c('b', [_vm._v("3:19-4:1a")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel’s Calling to the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Word of God Reestablished Under Samuel.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This describes the Lord’s first revelation to the young Samuel. It came at a time when the Lord had ceased to appear in Shiloh, for the reasons clearly explained in chapter two. Here you see an example of this: “You have hidden these things from the wise and understanding and revealed them to little children.” So Samuel grew before God and the people, for he had the word of God and became known by all of Israel as a faithful prophet. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-372-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel’s Calling.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Three things are expressed whereby the excellence of Samuel’s gifts and the prerogative of his calling appear. First, the certainty of his predictions and prophecies all came to pass and none were spoken "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2221"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2233"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2246"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page24",
      "title": "24"
    }
  }), _vm._v("in vain. Samuel did not need any signs or miracles for the demonstrations of his calling, as the effect and accomplishment of his prophecies were a sufficient evidence. Second, Samuel was faithful, without any partiality or accepting of persons, in delivering the word of God to Israel—just as Moses is said to have been faithful in the Lord’s house. Finally, after the Lord had begun in this way to reveal himself to Samuel, God continued to do so, and he added further to reveal to Samuel his will and to appear to him. Samuel therefore was an honorable prophet, because in him the word of prophesying revived out of its previous decay. And therefore Scripture says, “No Passover like it had been kept in Israel since the days of Samuel the prophet,” since he restored the religion that had been greatly corrupted. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-371-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2257"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2262"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2263"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2267"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2277"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2286"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page25",
      "title": "25"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_41"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("4:1b–7:2")]), _vm._v(" THE ARK CAPTURED AND RETURNED")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now Israel went out to battle against the Philistines. They encamped at Ebenezer, and the Philistines encamped at Aphek.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("The Philistines drew up in line against Israel, and when the battle spread, Israel was defeated before the Philistines, who killed about four thousand men on the field of battle.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And when the people came to the camp, the elders of Israel said, “Why has the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("defeated us today before the Philistines? Let us bring the ark of the covenant of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("here from Shiloh, that it")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("may come among us and save us from the power of our enemies.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("So the people sent to Shiloh and brought from there the ark of the covenant of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts, who is enthroned on the cherubim. And the two sons of Eli, Hophni and Phinehas, were there with the ark of the covenant of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("As soon as the ark of the covenant of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("came into the camp, all Israel gave a mighty shout, so that the earth resounded.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And when the Philistines heard the noise of the shouting, they said, “What does this great shouting in the camp of the Hebrews mean?” And when they learned that the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had come to the camp,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("the Philistines were afraid, for they said, “A god has come into the camp.” And they said, “Woe to us! For nothing like this has happened before.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Woe to us! Who can deliver us from the power of these mighty gods? These are the gods who struck the Egyptians with every sort of plague in the wilderness.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Take courage, and be men, O Philistines, lest you become slaves to the Hebrews as they have been to you; be men and fight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("So the Philistines fought, and Israel was defeated, and they fled, every man to his home. And there was a very great slaughter, for thirty thousand foot soldiers of Israel fell.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the ark of God was captured, and the two sons of Eli, Hophni and Phinehas, died.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("A man of Benjamin ran from the battle line and came to Shiloh the same day, with his clothes torn and with dirt on his head.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("When he arrived, Eli was sitting on his seat by the road watching, for his heart trembled for the ark of God. And when the man came into the city and told the news, all the city cried out.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("When Eli heard the sound of the outcry, he said, “What is this uproar?” Then the man hurried and came and told Eli.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Now Eli was ninety-eight years old and his eyes were set so that he could not see.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And the man said to Eli, “I am he who has come from the battle; I fled from the battle today.” And he said, “How did it go, my son?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("He who brought the news answered and said, “Israel has fled before the Philistines, and there has also been a great defeat among the people. Your two sons also, Hophni and Phinehas, are dead, and the ark of God has been captured.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("As soon as he mentioned the ark of God, Eli fell over backward from his seat by the side of the gate, and his neck was broken and he died, for the man was old and heavy. He had judged Israel forty years.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now his daughter-in-law, the wife of Phinehas, was pregnant, about to give birth. And when she heard the news that the ark of God was captured, and that her father-in-law and her husband were dead, she bowed and gave birth, for her pains came upon her.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And about the time of her death the women attending her said to her, “Do not be afraid, for you have borne a son.” But she did not answer or pay attention.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And she named the child Ichabod, saying, “The glory has departed")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("from Israel!” because the ark of God had been captured and because of her father-in-law and her husband.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And she said, “The glory has departed from Israel, for the ark of God has been captured.”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("5")]), _vm._v(" "), _c('i', [_vm._v("When the Philistines captured the ark of God, they brought it from Ebenezer to Ashdod.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Then the Philistines took the ark of God and brought it into the house of Dagon and set it up beside Dagon.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And when the people of Ashdod rose early the next day, behold, Dagon had fallen face downward on the ground before the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". So they took Dagon and put him back in his place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("But when they rose early on the next morning, behold, Dagon had fallen face downward on the ground before the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2290"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2299"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2305"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2306"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2310"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2313"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2315"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page26",
      "title": "26"
    }
  }), _c('i', [_vm._v("ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and the head of Dagon and both his hands were lying cut off on the threshold. Only the trunk of Dagon was left to him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("This is why the priests of Dagon and all who enter the house of Dagon do not tread on the threshold of Dagon in Ashdod to this day.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("The hand of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was heavy against the people of Ashdod, and he terrified and afflicted them with tumors, both Ashdod and its territory.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And when the men of Ashdod saw how things were, they said, “The ark of the God of Israel must not remain with us, for his hand is hard against us and against Dagon our god.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("So they sent and gathered together all the lords of the Philistines and said, “What shall")]), _vm._v(" "), _c('i', [_vm._v("we do with the ark of the God of Israel?” They an­­­­swered,")]), _vm._v(" "), _c('i', [_vm._v("“Let the ark of the God of Israel be brought around to Gath.” So they brought the ark of the God of Israel there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("But after they had brought it around, the hand of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was against the city, causing a very great panic, and he afflicted the men of the city, both young and old, so that tumors broke out on them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("So they sent the ark of God to Ekron. But as soon as the ark of God came to Ekron, the people of Ekron cried out, “They have brought around to us the ark of the God of Israel to kill us and our people.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("They sent therefore and gathered together all the lords of the Philistines and said, “Send away the ark of the God of Israel, and let it return to its own place, that it may not kill us and our people.” For there was a deathly panic throughout the whole city. The hand of God was very heavy there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("The men who did not die were struck with tumors, and the cry of the city went up to heaven.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("6")]), _vm._v(" "), _c('i', [_vm._v("The ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was in the country of the Philistines seven months.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And the Philistines called for the priests and the diviners and said, “What shall we do with the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("? Tell us with what we shall send it to its place.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("They said, “If you send away the ark of the God of Israel, do not send it empty, but by all means return him a guilt offering. Then you will be healed, and it will be known to you why his hand does not turn away from you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And they said, “What is the guilt offering that we shall return to him?” They answered, “Five golden tumors and five golden mice, according to the number of the lords of the Philistines, for the same plague was on all of you and on your lords.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("So you must make images of your tumors and images of your mice that ravage the land, and give glory to the God of Israel. Perhaps he will lighten his hand from off you and your gods and your land.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Why should you harden your hearts as the Egyptians and Pharaoh hardened their hearts? After he had dealt severely with them, did they not send the people away, and they departed?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now then, take and prepare a new cart and two milk cows on which there has never come a yoke, and yoke the cows to the cart, but take their calves home, away from them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And take the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and place it on the cart and put in a box")]), _vm._v(" "), _c('i', [_vm._v("at its side the figures of gold, which you are returning")]), _vm._v(" "), _c('i', [_vm._v("to him as a guilt offering. Then send it off and let it go its way")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("and watch. If it goes up on the way to its own land, to Beth-shemesh, then it is he who has done us this great harm, but if not, then we shall know that it is not his hand that struck us; it happened to us by coincidence.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("The men did so, and took two milk cows and yoked them to the cart and shut up their calves at home.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And they put the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("on the cart and the box with the golden mice and the images of their tumors.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And the cows went straight in the direction of Beth-shemesh along one highway, lowing as they went. They turned neither to the right nor to the left, and the lords of the Philistines went after them as far as the border of Beth-shemesh.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Now the people of Beth-shemesh were reaping their wheat harvest in the valley. And when they lifted up their eyes and saw the ark, they rejoiced to see it.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("The cart came into the field of Joshua of Beth-shemesh and stopped there. A great stone was there. And they split up the wood of the cart and offered the cows as a burnt offering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And the Levites took down the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and the box that was beside it, in which were the golden figures, and set them upon the great stone. And the men of Beth-shemesh offered burnt offerings and sacrificed sacrifices on that day to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And when the five lords of the Philistines saw it, they returned that day to Ekron.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2320"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2342"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page27",
      "title": "27"
    }
  }), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("These are the golden tumors that the Philistines returned as a guilt offering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(": one for Ashdod, one for Gaza, one for Ashkelon, one for Gath, one for Ekron,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("and the golden mice, according to the number of all the cities of the Philistines belonging to the five lords, both fortified cities and unwalled villages. The great stone beside which they set down the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is a witness to this day in the field of Joshua of Beth-shemesh.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And he struck some of the men of Beth-shemesh, because they looked upon the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". He struck seventy men of them,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("and the people mourned because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had struck the people with a great blow.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then the men of Beth-shemesh said, “Who is able to stand before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", this holy God? And to whom shall he go up away from us?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("So they sent messengers to the inhabitants of Kiriath-jearim, saying, “The Philistines have returned the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". Come down and take it up to you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("7")]), _vm._v(" "), _c('i', [_vm._v("And the men of Kiriath-jearim came and took up the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and brought it to the house of Abinadab on the hill. And they consecrated his son Eleazar to have charge of the ark of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("From the day that the ark was lodged at Kiriath-jearim, a long time passed, some twenty years, and all the house of Israel lamented after the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("he")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Or "), _c('i', [_vm._v("gone into exile")]), _vm._v("; also verse 22 "), _c('b', [_vm._v("c")]), _vm._v(" Most Hebrew manuscripts "), _c('i', [_vm._v("struck of the people seventy men, fifty thousand men"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" According to the commentators, God uses the war between the Israelites and the Philistines to take the lives of Eli and his sons as punishment for their sins. The interpreters are also agreed that taking the ark of the covenant to the battlefield is a foolish act with dire consequences. Nevertheless, when the Philistines place the Israelite ark, which signifies the presence of Yahweh, alongside their god Dagon, the Lord God guards his sanctity despite the godlessness of the Israelites. In fact, God punishes the Philistines, who ironically display more reverence toward the ark than the Israelites had, sending it back to Bethshemesh with materials for guilt offerings and burnt offerings. Although the men of Bethshemesh should have known better, the interpreters explain, they violate the law of God by opening the ark and not handling it lawfully. God, therefore, rightly takes the lives of the guilty men. In this same passage, God takes the lives of Hophni, Phinehas, Eli and Phinehas’s wife. Although it is a harsh concept for many of us today, the commentators take to heart Hannah’s earlier song that “the Lord kills . . . ; he brings down to Sheol” (1 Sam 2:6). The interpreters do not distinguish here between God’s role in the taking of human life and the giving of it.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_42"
    }
  }, [_c('b', [_vm._v("4:1b-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Priests Accompany the Ark into Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Fighting Battles Without God’s Word.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Whoever goes to war without the word of God and trusts in his own strength will fall, because victory is the Lord’s. The self-appointed masters Hophni and Phinehas show that they did not have this word of God. You will not remain standing against “the Philistines,” whether that means people of God or enemies of the faith, unless the spiritual word guards your heart. For there are some among us who have the word of God (like the Israelites), who then produce great speeches of human knowledge, pointing to the Scriptures and arguing against adversaries, saying that it is good to destroy whomever and to strive to win on the holy day, as if conducting worship would be a lie and hypocrisy, as if the sacraments were just another kind of communion, as if they were not a righteous work to share with all and that Scripture says so. However that may be, they do not know that faith happens in the heart. They do not know that the gospel is not letter but spirit, not doctrine but life. And while they themselves trust that the sacraments show only an external salvation (however otherwise beautiful), they crumble in the face of "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2344"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2351"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2361"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2368"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page28",
      "title": "28"
    }
  }), _vm._v("th"), _c('a', {
    attrs: {
      "id": "_idTextAnchor2369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2370"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2374"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2375"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2380"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2390"
    }
  }), _vm._v("eir adversaries. This is what it means that the Israelites hoped for salvation from the ark, which was a sacrament according to the word of God. It had the propitiator who is Christ and the two cherubim, which are the two testaments of propitiation gazing on each other. But without the word of God, that is, without faith in their hearts, the ark was nothing but that death which they shamefully brought on themselves. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-370-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Blaming God for Defeat.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Just as Brutus exclaimed before meeting his end, “O Jupiter, the cause of all evils!” so the people of Israel disputed the reason for their loss in the battlefield. And just as Brutus was rightly punished for his monstrous scheming, first when he drove Caesar out of Cyprus and then when he killed him in the Senate out of ingratitude, so the people of Israel were rightly punished by God for their disobedience and ingratitude. Therefore, in our times of calamity, we ought to praise God’s righteousness and cry out with David, “Against you, you only, have I sinned and done what is evil in your sight.” And “You are righteous, O L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(", and your judgment is righteous.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-369-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_43"
    }
  }, [_c('b', [_vm._v("4:12-22")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Death and Life")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Eli’s Death.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The principal cause of Eli’s death was the justice of God in punishing, by this temporal judgment, Eli’s negligence in not correcting his sons. For, as he did not bow the necks of his sons to the yoke, so his neck, now bowed and broken, served as a just recompense. The subordinate cause of Eli’s death was the lamentable report of so many calamities, which all fell out together—Israel fleeing, his sons’ deaths and the ark’s capture, for which he grieved most of all. The messenger made no pause at all but uttered all his heavy news at once, as if it were on purpose to oppress and overload Eli with grief. However, if the messenger had taken time to tell the story by degrees, Eli’s grief might have been allayed. Finally, the instrumental cause of Eli’s death was his falling from his feet, which was not a low stool but a high throne, which was proper for a high priest and chief judge. So he fell high and, since he was also very old—almost one hundred years old—his body was fat and round, and he was not nimble enough to shift himself. What’s more, he was very dim-sighted and so could not see which way to help himself as he fell. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-368-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("An Eli in Every Age.")]), _vm._v(" "), _c('i', [_vm._v("John Robinson:")]), _vm._v(" It is dangerous in the course of religion and godliness to fall forward by errors, preposterous zeal or another misguidance; yet not so much so as to fall backward by an unfaithful heart. The former may break his face thereby and lose his comfort in a great measure both with God and with people. But the latter is in danger utterly to break the neck of his conscience, as old Eli broke his neck bodily by falling backward from his seat and died. Are there not many Eli’s in all ages? "), _c('i', [_vm._v("Essays.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-367-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Birth of Ichabod.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" The attending woman said to the wife of Phinehas, “Do not fear, get your soul back together, for you have borne a son. Recover your soul in hope, because when other mothers have given birth to their children they are often overwhelmed with great joy.” Truly, the new mother was by no means cheered up, because she did not respond to hearing the consolation of the child’s birth and she did not direct her mind to it, or in Hebrew, “she did not apply her heart to it.” That is, she did not sense any recovery. She named the newborn child Ichabod, saying, “Glory (that is, our glory, all glory, and the majesty of the people of Israel) has departed.” "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-366-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2391"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2393"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2397"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2400"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2402"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2413"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2414"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2417"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2421"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2422"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2430"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2432"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page29",
      "title": "29"
    }
  })]), _c('b', [_vm._v("The Death of Phinehas’s Wife.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Phinehas’s wife grieved more for the loss of the ark than in rejoicing that she had gained a son. She gave up the ghost based on her zeal and love of religion, which was absent in her husband. In fact, she did not even take into account the death of her husband and father-in-law, but was highly concerned about the capture of the ark and how its glory was lost. She therefore named her son Ichabod, which consists of two words: the first signifying “woe” or “where” . . . and the second, “glory.” The name Ichabod, then, means “Where is the glory?,” or “No glory.” Josephus thinks that she gave birth before her time, and that Ichabod was born at seven months. However, that is not likely, because the child lived. Nonetheless, here Samuel’s prophecy is fulfilled—that there would not be an old man left of Eli’s house. This translating of the glory of God to the Philistines prefigured the offering of grace to the Gentiles and the removing of the glory of religion from the Jews. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-365-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_44"
    }
  }, [_c('b', [_vm._v("5:1-12")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The L")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("ord Versus Dagon")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Trusting in False Gods.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Just as the Israelites impiously trusted in the ark, despising the truly sacramental word of God, so the Gentiles impiously betrayed God too. They presumed to rule over God, standing the ark next to their god Dagon. But they were the ones who were themselves undone by God’s Scriptures and sacraments. They were terribly ignorant of God, not having even a crumb of the Spirit, which a disciple of Christ shows by his or her fruits. For these others stand next to their god, that is, next to their trust in works, traditions and human inventions, which they want to establish in this way, as if they already had God’s testimony for their impieties and idolatries. But this is against the first commandment: “You shall have no other gods before me.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-364-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Power Roused Against Enemies and Idols.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" While the triumphing, blasphemous enemies rise against the church and yell taunts against the God of Israel, God was then thought to be asleep or buried in his cups. But then he was roused, so that the Philistines were brought together to confess the thing itself, the infinite separation between the true and living God and the false and fabricated god known as Dagon. And so God is announced in his glory even without our prayers, even though Samuel and other pious people in Israel were doubtlessly making vows like this one: “Therefore arise, O Lord God, and sanctify your name, which they desecrate. Strengthen in us your kingdom, which they would destroy. Let your will be done, which they would suppress. Grant that your name not be trampled on because of our sin by those who do not seek to punish our sin but who desire only to destroy in us the knowledge of thy holy Word, of your name and of your work, so that they might dethrone you and rob you of a people that proclaims and confesses you and trusts in you. Amen.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-363-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Is Not Mocked.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" The Philistines set the ark beside Dagon, evidently as if in triumph about taking captive the God of Israel, whose captured ark was taken into their idol’s temple like spoils of war. For it was the custom to be arrogant in such victories, especially when enemies conquered God’s people. Then the true God and his religion was mocked. But God did not let a day go by without avenging their insults against him. Then “Dagon had fallen face downward on the ground before the ark of the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(",” as if adoring the ark in veneration. For when an act of true religion is seen, then God begins to bring a great number people to himself. Quite sensibly, then, from this miracle the Philistines recognized the Israelite religion as truth and their idol Dagon "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2433"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2434"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2438"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2440"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2446"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2449"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2453"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2454"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2455"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page30",
      "title": "30"
    }
  }), _vm._v("as vanity. But with blinded minds, they did not totally comprehend it. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-362-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Philistine God Is Merely a Fish.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" Consider, prudent reader, that here for the second time Dagon fell on its face on the ground before the ark of the covenant, and that its head and hands were cut off on the threshold. And so understand that this text does not say that Dagon’s trunk remained in its place . . . but it says that nothing remained in the idol’s place except "), _c('i', [_vm._v("dāg")]), _vm._v(", that is, the form of a fish—for the Hebrews, Dagon sounds like “fish.” And they say that this idol was an image of a man mixed with a fish, so that its head and hands were human, but the rest of its body was of a fish. And this fits very well with the letter of the Hebrew, which clearly states: only Dagon remained left over. For with its human members severed off, only a fish remained, prostrate before the ark of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-361-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Unfit Companions.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" Just as the Lord’s ark and Dagon cannot dwell together under one roof, so the love of God and the love of the world can never subsist together. Therefore St. John advises us, “Do not love the world or the things in the world. If anyone loves the world, the love of the Father is not in him.” "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-360-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_45"
    }
  }, [_c('b', [_vm._v("6:1-12")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Philistines")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Peace of Conscience Without God.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Whenever humans and reason dominate, the word of God is removed from their midst and from any collective glory. Then the true priesthood falls and is extinguished, the cause of which is the wrath of God. But the victors never have peace in the consciences after this. For wherever the word of God is corrupted, pestilence and destruction are driven on consciences, just as the ark did to the Philistines. At length they had to confess their own shamefulness, that they had adulterated God’s word, the ark. So they got themselves together in order to return it unblemished. This is what the golden rings and mice signify: they are arcane signs for the pains of conscience, which are ultimately revealed through the word of God. As Paul says, “They will not get very far, for their folly will be plain to all.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-359-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Reverence of the Philistines.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The Philistines were punished for their gross rudeness in profaning the ark and for consecrating it as one of their chief spoils to their idol, thereby making the great God inferior to their abominable invention. This breach of the natural and moral law did not escape unpunished. However, as for the ceremonial law—which prohibited the Israelites from coming near the ark or gazing on it—it was given only to the Israelites and so the heathen were ignorant of it. In this we see that the Lord requires a stricter obedience at the hands of his own people than of uninformed foreigners. What’s more, the Lord accepts this kind of reverence, which the Philistines out of their simple knowledge yielded to the ark—not allowing it to go empty but bestowing on it jewels of gold. They also used choice cows that were never before hitched to the yoke in addition to providing a new cart, which befits the holiness of the ark. The Philistines thereby expressed their reverence for the ark in this regard, by actually following the prescript of Moses’ law. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-358-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Human Advice.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" This first part of the Philistines’ answer is naturally grounded on the ordinary means of appeasing God’s wrath by offerings. . . . It was likely consid"), _c('a', {
    attrs: {
      "id": "_idTextAnchor2456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2461"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2462"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2463"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2464"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2465"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2466"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2467"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2468"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2469"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2470"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2471"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2472"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2473"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2474"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2475"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2476"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2477"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2478"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2479"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2480"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2481"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2482"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2483"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2484"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2485"
    }
  }), _vm._v("ered a trespass-offering, for it was a kind of trespass—though committed through ignorance—by which it was believed that God would be appeased and that the people would know that his wrath had been the cause of the people’s evils. . . . At the same time, the specification of the offerings—which is really absurd and ridiculous to think the Deity wants, for instance, images of mice—seems to be suggested by the devil in contempt of God. Who would accept this as a memorial that he had overcome his enemies by such poor and contemptible means—unless even in those days it was customary to consecrate a resemblance of those parts of the body in which they were healed, or of the annoyances which they were freed from, to that Deity which they were devoted to or from which they acknowledged the said deliverance? But because God’s law decreed nothing of the sort, it was truly an idolatrous superstition. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-357-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_46"
    }
  }, [_c('b', [_vm._v("6:13-18")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Israelites")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Alone Brought the Ark Back to Israel.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" God restored the ark of Israel by sending illustrious miracles, so that he might show that his church is gathered and protected not by human decisions or strength but by divine power. Yet though they had not set this miracle in motion, the Israelites with their meager human counsels would still move away from the form of government that God had instituted, as it says in chapter eight below. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-356-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Continuance of the Ark.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Here we may see the miserable state of Israel at this time—that they were deprived of that visible sign of God’s presence among them, namely, the ark, where the two tables of commandments dwelled. During this time they seemed to be forlorn and forsaken of God. Indeed, such times may sometimes fall out in the church of God: For a time, the Lord may allow sinners to be deprived of the true use of God’s Word and the sacraments. The Philistines held the ark for awhile—thinking that in time plagues would lessen. Afterward they purposed to keep the ark in enslavement and captivity still. At this time the ark sojourned among the Philistines without any profit to them at all. In the same way, a long time passed among the unrighteous Gentiles before truth was revealed to them, as the apostle says, since the time had not yet come for the Jews to be utterly dispossessed of the ark. But now we see that the ark of the gospel has been transferred to the believing Gentiles, and it has continued among them for hundreds of years, working in them faith and obedience to the truth. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-355-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_47"
    }
  }, [_c('b', [_vm._v("6:19–7:2")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God’s Judgment for Looking at the Ark")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Unholy Curiosity.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" We have spoken above about looking at the ark out of curiosity. The law prohibits this under the penalty of death: no one should look at the ark, no one should come close to it and no one should look at it in the holy of holies. This is your death and you will be unable to avoid meeting it. You will be blinded by this inaccessible light, where you will have wanted to measure what is from God by your reason and wisdom. God reveals them to be small and foolish, whoever lets go of God in favor of their own works and judgment. For he hides this from the wise and the intelligent, as it says in Romans, “Oh, the depth of the riches and wisdom and knowledge of God!” and in Ecclesiasticus, “Seek not the things that are too high for you.” See this example of people’s conventional wisdom, how they push down the divine things that are seen as troublesome. They ask for kindness, but do not know even if they might be counted among the people of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-354-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2486"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2487"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2488"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2489"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2490"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2491"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2492"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2493"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2494"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2495"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2496"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2497"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2498"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2499"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2500"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2501"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2502"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2503"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2504"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2505"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2506"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2507"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2508"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2509"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page3132",
      "title": "3132"
    }
  })]), _c('b', [_vm._v("Causal but Not Casual.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" The sickness and mortality of people is causal and not casual. For nothing is more contrary to judgment than chance or fortune. Just as a sparrow cannot fall on the ground without God’s providence—such is God’s care for them. . . . It is a senseless thing to think that sickness can befall a person by chance. Therefore the Philistines, being plagued by God, would boldly test whether that disease came of God’s hand or by chance. . . . But the very name "), _c('i', [_vm._v("plague")]), _vm._v(" signifies “judgment,” which shows that it is no casual thing. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-353-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Smiting Bethshemesh.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The Bethshemites were offensive in several ways. First, they did not receive the ark with great reverence and devotion when they saw it coming. Instead, they entertained it, as apparently they thought best, with shouting and signs of joy, as was common during the time of harvest. Second, they sacrificed female cows, namely, the two cows that drew the cart. However, according to the law, only bulls were to be offered. (Some also think that the Bethshemites themselves offered sacrifice rather than consulting with priests or the prophet Samuel. But that is not likely. . . .) Finally, the main reason why the Lord killed the Bethshemites was because “they looked on the ark of the Lord,” which was contrary to Numbers 5:20. . . . Josephus thinks that they also handled it irreverently with their hands. However, the fact that they looked on the ark without being priests was sufficient reason to procure God’s judgment. It is, of course, possible that the priests may have offended God by not approaching and drawing near with sufficient reverence. Nonetheless, it seems that by the number of them that were killed, most of them were of the common sort rather than priests. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-352-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Unusual Circumstance.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" Kiriath-jearim was not a city that belonged to the priests as Bethshemesh was. As such, it was unlawful for anyone other than priests to touch the ark. It is therefore to be imagined that all this was done by the ministry of some priests who were sent for from some other place—unless there was some great toleration from God in such an extraordinary case as this was. "), _c('i', [_vm._v("Annotation on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-351-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2510"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2511"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2512"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2513"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2514"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2515"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2516"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2517"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2518"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2519"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2520"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2521"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2522"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2523"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2524"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2525"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2526"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2527"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2528"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2529"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2530"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2531"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2532"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2533"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2534"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2535"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page33",
      "title": "33"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_48"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("7:3–8:22")]), _vm._v(" SAMUEL JUDGES WHILE ISRAEL DEMANDS A KING")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And Samuel said to all the house of Israel, “If you are returning to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("with all your heart, then put away the foreign gods and the Ashtaroth from among you and direct your heart to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and serve him only, and he will deliver you out of the hand of the Philistines.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("So the people of Israel put away the Baals and the Ashtaroth, and they served the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("only.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Then Samuel said, “Gather all Israel at Mizpah, and I will pray to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("for you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("So they gathered at Mizpah and drew water and poured it out before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and fasted on that day and said there, “We have sinned against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".” And Samuel judged the people of Israel at Mizpah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now when the Philistines heard that the people of Israel had gathered at Mizpah, the lords of the Philistines went up against Israel. And when the people of Israel heard of it, they were afraid of the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And the people of Israel said to Samuel, “Do not cease to cry out to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("our God for us, that he may save us from the hand of the Philistines.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("So Samuel took a nursing lamb and offered it as a whole burnt offering to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". And Samuel cried out to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("for Israel, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("answered him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("As Samuel was offering up the burnt offering, the Philistines drew near to attack Israel. But the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("thundered with a mighty sound that day against the Philistines and threw them into confusion, and they were defeated before Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the men of Israel went out from Mizpah and pursued the Philistines and struck them, as far as below Beth-car.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Then Samuel took a stone and set it up between Mizpah and Shen")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("and called its name Ebenezer;")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("for he said, “Till now the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has helped us.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("So the Philistines were subdued and did not again enter the territory of Israel. And the hand of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was against the Philistines all the days of Samuel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("The cities that the Philistines had taken from Israel were restored to Israel, from Ekron to Gath, and Israel delivered their territory from the hand of the Philistines. There was peace also between Israel and the Amorites.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Samuel judged Israel all the days of his life.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And he went on a circuit year by year to Bethel, Gilgal, and Mizpah. And he judged Israel in all these places.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Then he would return to Ramah, for his home was there, and there also he judged Israel. And he built there an altar to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("8")]), _vm._v(" "), _c('i', [_vm._v("When Samuel became old, he made his sons judges over Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("The name of his firstborn son was Joel, and the name of his second, Abijah; they were judges in Beersheba.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Yet his sons did not walk in his ways but turned aside after gain. They took bribes and perverted justice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then all the elders of Israel gathered together and came to Samuel at Ramah")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("and said to him, “Behold, you are old and your sons do not walk in your ways.Now appoint for us a king to judge us like all the nations.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("But the thing displeased Samuel when they said, “Give us a king to judge us.” And Samuel prayed to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “Obey the voice of the people in all that they say to you, for they have not rejected you, but they have rejected me from being king over them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("According to all the deeds that they have done, from the day I brought them up out of Egypt even to this day, forsaking me and serving other gods, so they are also doing to you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Now then, obey their voice; only you shall solemnly warn them and show them the ways of the king who shall reign over them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("So Samuel told all the words of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("to the people who were asking for a king from him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("He said, “These will be the ways of the king who will reign over you: he will take your sons and appoint them to his chariots and to be his horsemen and to run before his chariots.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And he will appoint for himself commanders of thousands and commanders of fifties, and some to plow his ground and to reap his harvest, and to make his implements of war and the equipment of his chariots.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("He will take your daughters to be perfumers and cooks and bakers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("He will take the best of your "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2536"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2537"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2538"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2539"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2540"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2541"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2542"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2543"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2544"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2545"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2546"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2547"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2548"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2549"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2550"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2551"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2552"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2553"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2554"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2555"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2556"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2557"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2558"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2559"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2560"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page34",
      "title": "34"
    }
  }), _c('i', [_vm._v("fi"), _c('a', {
    attrs: {
      "id": "_idTextAnchor2561"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2562"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2563"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2564"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2565"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2566"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2567"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2568"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2569"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2570"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2571"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2572"
    }
  }), _vm._v("elds and vineyards and olive orchards and give them to his servants.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("He will take the tenth of your grain and of your vineyards and give it to his officers and to his servants.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("He will take your male servants and female servants and the best of your young men")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("and your donkeys, and put them to his work.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("He will take the tenth of your flocks, and you shall be his slaves.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And in that day you will cry out because of your king, whom you have chosen for yourselves, but the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will not answer you in that day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("But the people refused to obey the voice of Samuel. And they said, “No! But there shall be a king over us,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("that we also may be like all the nations, and that our king may judge us and go out before us and fight our battles.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And when Samuel had heard all the words of the people, he repeated them in the ears of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “Obey their voice and make them a king.” Samuel then said to the men of Israel, “Go every man to his city.”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew; Septuagint, Syriac "), _c('i', [_vm._v("Jeshanah")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("Ebenezer")]), _vm._v(" means "), _c('i', [_vm._v("stone of help")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Septuagint "), _c('i', [_vm._v("cattle"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" In these two chapters, we witness the transition from judgeship to kingship in Israel. The reformers regard Samuel as a true prophet of God who leads the Israelites toward repentance and restores them to proper worship of God. In particular, the Lutheran interpreters note the concept of conversion in the leadership of Samuel. Because of Samuel’s godly leadership, the Israelites defeat the Philistines since faith proves the best of all weapons. Despite this victory, the reformers recognize the impiety of the Israelites for wanting a king like the rest of the nations rather than trusting in God as their king. The commentators interpret this desire as undue trust in worldly things such as power and comfort, while also seeing God’s hand in providing an earthly king whose descendants will lead to the King of kings, Jesus Christ. Some of the commentators, astute readers of the Old Testament and of the interpretive tradition before them, draw a parallel between this passage, about the role of a king, and the duties of a king set out in Deuteronomy 17.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_49"
    }
  }, [_c('b', [_vm._v("7:3-17")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Victory by Humility")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Returning to God’s Word and to Faith.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Under Samuel, the people truly turn back to God, are liberated by God, receive peace and triumph over their enemies, because in Samuel they have the word of God. “Since we have been justified by faith, we have peace,” and we put the kingdom of Satan and antichrist under foot. “Therefore,” as Christ says, “pray earnestly to the Lord of the harvest to send out laborers into his harvest.” For the wrath of God comes with the removal of God’s word, as in Isaiah 3:8 and Amos 8:11. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-350-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Contrition, Faith and the New Obedience.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" This chapter shows extraordinary examples of true conversion to God, which is grasped through contrition, faith and the new obedience. The signs of contrition are true confession of sin, tears and fasting. The fruits of faith are prayers of invocation and the rejection of idols, for “how shall they call on him unless they believe?” After this conversion follows the clearest victory, which freed the people of Israel from a sad servitude. For no one can have strength of weapons without true repentance and invocation. How else can we be free from the many fighting Turks and other enemies of the church? Not by weapons alone, but also by crying out to God for conversion. That is our help in tribulation, for human salvation is vanity. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-349-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Meaningful Offerings.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" As Samuel not only prayed to God for the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2573"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2574"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2575"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2576"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2577"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2578"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2579"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2580"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2581"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2582"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2583"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2584"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2585"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2586"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2587"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2588"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2589"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2590"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2591"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2592"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2593"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2594"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2595"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page35",
      "title": "35"
    }
  }), _vm._v("people but also sacrificed a suckling lamb and offered it up to God for them . . . so Christ, our intercessor to God, not only prayed but also made an offering on our behalf. He made an offering in the morning when he was presented to God his Father to yield obedience to the law; and he made an offering in the evening when he died. Not only was Christ the ear and firstfruit of the corn, but he also became the vine in his death by shedding his blood. And he not only prayed but also gave meaning to our prayers. In this way, not only did he make an offering for us, but he also gives meaning to our offerings. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-348-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Erecting a Stone.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Samuel took a stone and called the name of the place Ebenezer, that is, a stone of help. This stone was erected as a sure testimony and memorial to divine goodness and power, which helped the people subdue their enemies. So Samuel said, “Till now the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" has helped us against the Philistines,” that is, let us preserve the memory of such great kindness with grateful souls and pass it on to those who come after us. We therefore truly erect such an image of God whenever we preach and sing the same glory, both privately and publicly. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-347-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Greatness of the Victory.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Three things set forth and commend the greatness of this victory. First, the people were unprepared and unarmed since they gathered together in common prayer and supplication, while their enemies came on them hastily and all of a sudden. Second, they used no carnal weapons or outward defense. Instead, Samuel only offered a sacrifice and prayed for them. Finally, God humbled the Philistines from heaven. The earth trembled under them, and they fell. The thunder astonished them and the lightning blasted them. This victory is like that which God gave to Barak and Deborah against Sisera (Judg 5) and that which God gave to Joshua when the Lord cast down stones on his enemies (Josh 10:10-11). "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-346-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_50"
    }
  }, [_c('b', [_vm._v("8:1-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Asking for a King")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The People’s Request.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Recognizing the occasion provided by the sins of Samuel’s sons, the people impiously asked for a king who might defend them according to the customs of the Gentiles. They did not look to God, who had thus far been a king to them and fought for them, as Moses had said, “The L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" will fight for you, and you have only to be silent.” God did this for them through the judges Moses, Aaron, Joshua, Eleazar and other successors described in the book of Judges. Through them the people were saved from their enemies until the time of Eli, when God served the people without regard to Eli’s impiety and the people’s idolatry. Then the rejected sons of Eli gave way to the greater Samuel. So it was already a great impiety to ask Samuel for a king while he was still living and not to expect that a judge would be given as usual to replace his impious sons, just as Samuel had been given to them instead of Eli’s sons. This is clearly a rejection of God and trusting in humans, in whom there is no salvation, as it says in the Psalms. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-345-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Distrust and Audacity.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Someone might ask how the people sinned in asking for a new form of government, when it seems wise to have deliberated on fixed leadership. Here is my simple reply. Two great sins are most severely punished, distrust and the audacity to set up new political forms according to human ideas rather than divine ones. For God wants to gather, protect and serve the church through the son, who is the head of the church. They do not need human protection, and God wants them to expect divine assistance, just "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2596"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2597"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2598"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2599"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2600"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2601"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2602"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2603"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2604"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2605"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2606"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2607"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2608"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2609"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2610"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2611"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2612"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2613"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page36",
      "title": "36"
    }
  }), _vm._v("as they expected deliverance from Egypt after more than eighty years. The elders rejected this faith, thinking of human assistance. The other trespass is the audacity to constitute a new political form without God’s establishment. For God does not want the teaching, worship or laws that have been handed down to change. God does not want to change the political forms, because such changes also shake the laws and doctrines and because legal restraints often make kings feel ill. Many also bend religion to serve their own desires, as when the kings of Samaria established new forms of worship during their reigns. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-344-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("New Mediator.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Now, there is great disagreement between God and humankind by reason of sin, which has made a separation. And therefore we are to inquire who shall be the mediator between the two. It is certain Samuel, while he lived, stood between God and the people as a mediator to appease God by sacrifice. But his role as mediator has come to an end. Therefore we must look for a more perfect Mediator—such a one as Samuel himself needed. Now, the Mediator who stands between God and us is not Samuel the priest—but Christ. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-343-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Did the People Cast Off the Lord’s Government?")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It is not quite true to say that the government under kings is a shaking off of the Lord’s yoke. For the Lord is with kings and he rules his people through them: They are the ordinance of God. Wisdom says, “By me kings reign.” Indeed, the Lord blessed the governments of David, Jehoshaphat, Hezekiah and Josiah. Yet the people . . . rejected the Lord’s government because they disliked the form of administration the Lord had set on them. They desired change and innovation without any direction from God. But it will be further questioned: Did God also reign together with bad kings? Yes. Even the authority of wicked kings is of God, which they abuse to tyranny. And for their evil and abuse of the government they shall give account to God. But although the people are evil who govern, yet the authority they possess is lawful and good. For even under tyrants there are many good things, such as the enacting of political laws, the administration of justice and the punishment of lawbreakers. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-342-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Obeying Authorities, Obeying God.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" Work and its reward are related. Therefore, equity demands that for whom the work is done, from him the reward should be expected. It will seem scarcely credible that those who discharged the basest offices among people here on earth should be said on that very account to serve Christ himself, who sits in the heavens most glorious and by no means needing human service. But the reason is manifest . . . , namely, that whatever duties are performed by people according to the direction and at the command of Christ, and on account of the appointment and for the glory of Christ, they are judged to be offered and rendered to Christ himself. For “he serves God who for the sake of God serves people,” as Jerome has rightly observed. . . . Christ himself shows this: “As you have done it to the least of these, you have done it to me; As you did not do it to one of the least of these, you did not do it to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Jesus speaks in this place about almsgiving, as far as they are done or denied to people. But it ought to be extended to all the works of obedience commanded by God. For when these are rendered to people they are rendered to God, who commanded them to be done; when denied to people, they are deemed as denied to God himself. And this is right. For if the one who is commanded by God to obey people refuses to yield to human authority, this person would—if he had the power—also shake off the divine government.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There are three corollaries to this. First, no service is dishonorable in which people conduct "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2614"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2615"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2616"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2617"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2618"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2619"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2620"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2621"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2622"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2623"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2624"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2625"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2626"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2627"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2628"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2629"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2630"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2631"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2632"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2633"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page37",
      "title": "37"
    }
  }), _vm._v("themselves well and faithfully: For such people and actions serve Christ himself, which is the height of dignity and honor. Second, no honor or authority screens a wicked person from dishonor and disgrace: For they who are of that character serve the devil, which is the abyss of infamy and misery. Third, those who, being placed under the rule of others, are unwilling to serve are rebels not only against people but also against God and Christ. Hence that reproof of God himself against the Israelites wishing to shake off the government of Samuel: “They have not rejected you, but they have rejected me.” "), _c('i', [_vm._v("Exposition of Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-341-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_51"
    }
  }, [_c('b', [_vm._v("8:10-22")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The King’s Duties")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Divine Sanction to Abuse Authority.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Because there are some God-fearing rulers, this doctrine about property is emphasized so they may remember that the goods of the subjects are not to be appropriated by the master unless the common necessity of the country requires this. But some will quote the passage from 1 Samuel 8:11, “These will be the ways of the king who will reign over you; he will take your sons, your best fields. . . .” These words do not empower the sovereign power to do anything more than to requisition things for the common protection of the land. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-340-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Rule of Kings.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" It is not that this legal system before God will necessarily be as Samuel describes, because the law says of a king, “His heart may not be lifted up above his brothers.” Rather, it will not be otherwise but that the people will want to have a king according to the customs of the Gentiles. When the Lord truly gives assent to a king, he gives assent to that which kingly majesty requires before the world, how the king’s heart shall be directed according to Deuteronomy 17. As long as they all give their assent to this good, then the monarchy will have turned back to God through Christ. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-339-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Kings, Taxes and Justice.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Here some say that this describes a tyrant, not a king, and that it does not speak of a condition of servitude sanctioned by God. But the text calls this the rule of kings and speaks of the tax burden caused by their establishment. It does not authorize the power to establish severe servitude against divine law, because Deuteronomy 17 commands that a king shall study the law and follow it in all governance. This differentiation between dominion according to the holy law punishes Ahab, who wanted to elevate himself when he stole away Naboth’s vineyard against his will. Therefore such a great threat from Samuel about taxes was perceptive; that is, kings will raise themselves up greatly by way of private means, with as much legitimate tax as is fitting. This is just, because the benefit of defending the community clearly pertains to the individual, even as individuals need to unite with others. Romans 13 teaches that it is right to pay taxes. Therefore return what is determined, as the Baptist says, “Do not extort money from anyone by threats or by false accusation, and be content with your wages.” Do not be endlessly greedy, or invoke taxes as a pretext for all kinds of plundering. This is the true and simple meaning of Samuel to the assembly. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-338-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2634"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2635"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2636"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2637"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2638"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page38",
      "title": "38"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_52"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("9:1–10:27")]), _vm._v(" SAUL CHOSEN AS KING")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("There was a man of Benjamin whose name was Kish, the son of Abiel, son of Zeror, son of Becorath, son of Aphiah, a Benjaminite, a man of wealth.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And he had a son whose name was Saul, a handsome young man. There was not a man among the people of Israel more handsome than he. From his shoulders upward he was taller than any of the people.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now the donkeys of Kish, Saul’s father, were lost. So Kish said to Saul his son, “Take one of the young men with you, and arise, go and look for the donkeys.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And he passed through the hill country of Ephraim and passed through the land of Shalishah, but they did not find them. And they passed through the land of Shaalim, but they were not there. Then they passed through the land of Benjamin, but did not find them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("When they came to the land of Zuph, Saul said to his servant")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("who was with him, “Come, let us go back, lest my father cease to care about the donkeys and become anxious about us.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("But he said to him, “Behold, there is a man of God in this city, and he is a man who is held in honor; all that he says comes true. So now let us go there. Perhaps he can tell us the way we should go.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Then Saul said to his servant, “But if we go, what can we bring the man? For the bread in our sacks is gone, and there is no present to bring to the man of God. What do we have?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("The servant answered Saul again, “Here, I have with me a quarter of a shekel")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("of silver, and I will give it to the man of God to tell us our way.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("(Formerly in Israel, when a man went to inquire of God, he said, “Come, let us go to the seer,” for today’s “prophet” was formerly called a seer.)")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And Saul said to his servant, “Well said; come, let us go.” So they went to the city where the man of God was.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("As they went up the hill to the city, they met young women coming out to draw water and said to them, “Is the seer here?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("They answered, “He is; behold, he is just ahead of you. Hurry. He has come just now to the city, because the people have a sacrifice today on the high place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("As soon as you enter the city you will find him, before he goes up to the high place to eat. For the people will not eat till he comes, since he must bless the sacrifice; afterward those who are invited will eat. Now go up, for you will meet him immediately.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("So they went up to the city. As they were entering the city, they saw Samuel coming out toward them on his way up to the high place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Now the day before Saul came, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had revealed to Samuel:")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("“Tomorrow about this time I will send to you a man from the land of Benjamin, and you shall anoint him to be prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("over my people Israel. He shall save my people from the hand of the Philistines. For I have seen")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("my people, because their cry has come to me.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("When Samuel saw Saul, the L")]), _c('span', {
    staticClass: "small-caps_i"
  }, [_vm._v("ord")]), _vm._v(" "), _c('i', [_vm._v("told him, “Here is the man of whom I spoke to you! He it is who shall restrain my people.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Then Saul approached Samuel in the gate and said, “Tell me where is the house of the seer?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Samuel answered Saul, “I am the seer. Go up before me to the high place, for today you shall eat with me, and in the morning I will let you go and will tell you all that is on your mind.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("As for your donkeys that were lost three days ago, do not set your mind on them, for they have been found. And for whom is all that is desirable in Israel? Is it not for you and for all your father’s house?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Saul answered, “Am I not a Benjaminite, from the least of the tribes of Israel? And is not my clan the humblest of all the clans of the tribe of Benjamin? Why then have you spoken to me in this way?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Then Samuel took Saul and his young man and brought them into the hall and gave them a place at the head of those who had been invited, who were about thirty persons.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And Samuel said to the cook, “Bring the portion I gave you, of which I said to you, ‘Put it aside.’”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("So the cook took up the leg and what was on it and set them before Saul. And Samuel said, “See, what was kept is set before you. Eat, because it was kept for you until the hour appointed, that you might eat with the guests.”")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("So Saul ate with Samuel that day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("And when they came down from the high place into the city, a bed was spread for Saul")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('i', [_vm._v("on the roof, and he lay down "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2639"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2640"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2641"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2642"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2643"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2644"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2645"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2646"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2647"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page39",
      "title": "39"
    }
  }), _c('i', [_vm._v("to sleep.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Then at the break of dawn")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("g")]), _vm._v(" "), _c('i', [_vm._v("Samuel called to Saul on the roof, “Up, that I may send you on your way.” So Saul arose, and both he and Samuel went out into the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("As they were going down to the outskirts of the city, Samuel said to Saul, “Tell the servant to pass on before us, and when he has passed on, stop here yourself for a while, that I may make known to you the word of God.”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("10")]), _vm._v(" "), _c('i', [_vm._v("Then Samuel took a flask of oil and poured it on his head and kissed him and said, “Has not the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("anointed you to be prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("h")]), _vm._v(" "), _c('i', [_vm._v("over his people Israel? And you shall reign over the people of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and you will save them from the hand of their surrounding enemies. And this shall be the sign to you that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has anointed you to be prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("i")]), _vm._v(" "), _c('i', [_vm._v("over his heritage.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("When you depart from me today, you will meet two men by Rachel’s tomb in the territory of Benjamin at Zelzah, and they will say to you, ‘The donkeys that you went to seek are found, and now your father has ceased to care about the donkeys and is anxious about you, saying, “What shall I do about my son?”’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Then you shall go on from there farther and come to the oak of Tabor. Three men going up to God at Bethel will meet you there, one carrying three young goats, another carrying three loaves of bread, and another carrying a skin of wine.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And they will greet you and give you two loaves of bread, which you shall accept from their hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("After that you shall come to Gibeath-elohim,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("j")]), _vm._v(" "), _c('i', [_vm._v("where there is a garrison of the Philistines. And there, as soon as you come to the city, you will meet a group of prophets coming down from the high place with harp, tambourine, flute, and lyre before them, prophesying.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Then the Spirit of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will rush upon you, and you will prophesy with them and be turned into another man.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now when these signs meet you, do what your hand finds to do,for God is with you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then go down before me to Gilgal. And behold, I am coming down to you to offer burnt offerings and to sacrifice peace offerings. Seven days you shall wait, until I come to you and show you what you shall do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("When he turned his back to leave Samuel, God gave him another heart. And all these signs came to pass that day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("When they came to Gibeah,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("k")]), _vm._v(" "), _c('i', [_vm._v("behold, a group of prophets met him, and the Spirit of God rushed upon him, and he prophesied among them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And when all who knew him previously saw how he prophesied with the prophets, the people said to one another, “What has come over the son of Kish? Is Saul also among the prophets?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And a man of the place answered, “And who is their father?” Therefore it became a proverb, “Is Saul also among the prophets?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("When he had finished prophesying, he came to the high place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Saul’s uncle said to him and to his servant, “Where did you go?” And he said, “To seek the donkeys. And when we saw they were not to be found, we went to Samuel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And Saul’s uncle said, “Please tell me what Samuel said to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Saul said to his uncle, “He told us plainly that the donkeys had been found.” But about the matter of the kingdom, of which Samuel had spoken, he did not tell him anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Now Samuel called the people together to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("at Mizpah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And he said to the people of Israel, “Thus says the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, ‘I brought up Israel out of Egypt, and I delivered you from the hand of the Egyptians and from the hand of all the kingdoms that were oppressing you.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("But today you have rejected your God, who saves you from all your calamities and your distresses, and you have said to him, ‘Set a king over us.’ Now therefore present yourselves before the L")]), _c('span', {
    staticClass: "small-caps_i"
  }, [_vm._v("ord")]), _vm._v(" "), _c('i', [_vm._v("by your tribes and by your thousands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Samuel brought all the tribes of Israel near, and the tribe of Benjamin was taken by lot.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("He brought the tribe of Benjamin near by its clans, and the clan of the Matrites was taken by lot;")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("l")]), _vm._v(" "), _c('i', [_vm._v("and Saul the son of Kish was taken by lot. But when they sought him, he could not be found.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("So they inquired again of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", “Is there a man still to come?” and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “Behold, he has hidden himself among the baggage.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("Then they ran and took him from there. And when he stood among the people, he was taller than any of the people from his shoulders upward.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And Samuel said to all the people, “Do you see him whom the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has chosen? There is none like him among all the people.” And all the people shouted, “Long live the king!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2648"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2649"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2650"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2651"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2652"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2653"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2654"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2655"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2656"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2657"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2658"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2659"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2660"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2661"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2662"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2663"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2664"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2665"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2666"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2667"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2668"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page40",
      "title": "40"
    }
  }), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Then Samuel told the people the rights and duties of the kingship, and he wrote them in a book and laid it up before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". Then Samuel sent all the people away, each one to his home.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Saul also went to his home at Gibeah, and with him went men of valor whose hearts God had touched.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("But some worthless fellows said, “How can this man save us?” And they despised him and brought him no present. But he held his peace.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew "), _c('i', [_vm._v("young man")]), _vm._v("; also verses 7, 8, 10, 27 "), _c('b', [_vm._v("b")]), _vm._v(" A "), _c('i', [_vm._v("shekel")]), _vm._v(" was about 2/5 ounce or 11 grams "), _c('b', [_vm._v("c")]), _vm._v(" Or "), _c('i', [_vm._v("leader")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint adds "), _c('i', [_vm._v("the affliction of")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Hebrew "), _c('i', [_vm._v("appointed, saying, ‘I have invited the people’")]), _vm._v(" "), _c('b', [_vm._v("f")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("and he spoke with Saul")]), _vm._v(" "), _c('b', [_vm._v("g")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("And they arose early and at the break of dawn")]), _vm._v(" "), _c('b', [_vm._v("h")]), _vm._v(" Or "), _c('i', [_vm._v("leader")]), _vm._v(" "), _c('b', [_vm._v("i")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("over his people Israel? And you shall…. to be prince")]), _vm._v(" "), _c('b', [_vm._v("j")]), _vm._v(" "), _c('i', [_vm._v("Gibeath-elohim")]), _vm._v(" means "), _c('i', [_vm._v("the hill of God")]), _vm._v(" "), _c('b', [_vm._v("k")]), _vm._v(" "), _c('i', [_vm._v("Gibeah")]), _vm._v(" means "), _c('i', [_vm._v("the hill")]), _vm._v(" "), _c('b', [_vm._v("l")]), _vm._v(" Septuagint adds "), _c('i', [_vm._v("finally he brought the family of the Matrites near, man by man"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" For the commentators here, both human and divine forces are at work in the choosing of Israel’s first king, Saul. God chooses the person he wants to rule the Israelites by orchestrating several seemingly unrelated events. Indeed, the reformers recognize God’s providence in Saul’s life in the very manner he is selected king through the circumstance of his father’s straying donkeys. At the same time, the reformers note Saul’s humble beginnings from the smallest tribe of Israel, Benjamin, and they cite his lack of confidence and leadership. Saul’s anointing by Samuel, however, temporarily invigorates him. As the commentators explain, anointings in the Old Testament impart supernatural gifts, and Saul becomes a new man who is regarded as a prophet on account of his changed behavior and new leadership gifts. Despite Saul’s reluctance to be Israel’s king, God’s plan cannot be thwarted.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_53"
    }
  }, [_c('b', [_vm._v("9:1-20")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God’s Providence in")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Life")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Benjamin’s Weakness and Saul’s Great Stature.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" This ninth chapter now tells how Saul will rise up and where he had his beginnings. His ancestor Aphiah was of the tribe of Benjamin. On the diminishment of that tribe at that time when the king of Israel was chosen from it, see Judges 21. For we are reminded that God chooses what is low and despised and lifts them up on high. But Saul’s father Kish was valiant and strong; he was a brave hero. His son was called Saul, excellent and good; that is, he was an extraordinary character, even commended with a gifted soul. No man in Israel was his better. That is, he had no equal or comparison in terms of his body and his majestic form, because “from his shoulders upward he was taller than any of the people.” For although the soul’s strength is preferable to physical form, nevertheless his extraordinary height was a gift of God and was accompanied by a certain honor from the people. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-337-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Promises Happen over Time.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The beginning recites Saul’s genealogy, so that the reader knows from which tribe the people of Israel’s first king was chosen. For although kingship had been promised to the tribe of Judah in Genesis 49 and Deuteronomy 33, yet God did not choose a king according to that first counsel from the tribe of Judah but from the tribe of Benjamin. Thus is grasped the rule of all promises to the flesh: they cannot be seized by our plans without divine calling, just as Abraham was promised land, even though he never possessed it. And the ancestors in Egypt knew they had been promised the land of Canaan, but they did not occupy it either; still they awaited the call. Even so, it was promised that David would be king, but he could not take it during Saul’s lifetime. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-336-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Done by Providence.")]), _vm._v(" "), _c('i', [_vm._v("Huldrych Zwingli:")]), _vm._v(" The straying donkeys, in search of which Saul had "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2669"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2670"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2671"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2672"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2673"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2674"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2675"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2676"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2677"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2678"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2679"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2680"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2681"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2682"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2683"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2684"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page41",
      "title": "41"
    }
  }), _vm._v("left his father’s house, show clearly enough that they went astray at the ordination of God, since the son sought donkeys and found a kingdom that he had not sought, and the father got not only the donkeys he was concerned about but also a king for a son, which he had never anticipated. . . . In this we see that everywhere the things we "), _c('i', [_vm._v("say")]), _vm._v(" occur by accident are done and regulated by providence. "), _c('i', [_vm._v("On the Providence of God.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-335-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Arranged by God.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" In this story you see that things like luck, prudence, industry and study are human causes. With God there is providence. For what great fortune could have seen that Saul would be anointed king when he was looking for donkeys and then rushing to consult a seer, so that through these things God would call and anoint him? Therefore all the spontaneous things we do like this or somehow feel compelled to do get put in motion or pushed along by God. Whether it is for God’s mercy or judgment, these things are not active in themselves as we want or determine them to be. In the end, they have been arranged by God in ways we have not known or could not have known. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-334-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_54"
    }
  }, [_c('b', [_vm._v("9:21-27")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Refusal and Samuel’s Teaching")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Teaches Saul Servant Leadership.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" In this conversation with Saul, Samuel undoubtedly greatly admonished the future king about the office of pious governance, which is no different from being a good parent. See how he exhorts him to follow the law of all government, as Deuteronomy 17 most gravely teaches. For kingly authorities have been established from heaven, so that they defend laws, peace, and discipline and well preserve responsible public human society. This is just as Paul says in Romans 13: The magistrate is “God’s servant for your good.” Daniel also gave this direction to the king of the Chaldeans: “Break off your sins by practicing righteousness, and your iniquities by showing mercy to the oppressed.” To this end, princes surely need to know and consider that dominion should not resemble piracy, as it finally does among all those who inflict harm on others. In short, Samuel encouraged the future king to think about how his kingship came directly from God for the benefit of all humankind. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-333-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Saul’s Refusal of the Kingdom.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Saul excuses himself by three arguments. First, his tribe was the smallest in Israel, since it had not yet recovered from the loss and slaughter it had received in the battle with Israel in Judges 20. Second, his father’s house was of small account in the tribe. And third, he himself was the least in his father’s house. In fact, some think Saul was stalling and that he was full of hypocrisy, attributes that later manifested themselves during his reign as king. But I rather agree with those who think that Saul modestly refused the kingdom at this time and that he really tried to excuse himself from the honor of being king. This is clear from Saul’s different responses to Samuel, such as, “Why . . . have you spoken to me in this way?” Although it is clear that Saul later played the hypocrite, yet here he had another heart and he spoke from simplicity and humility. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-332-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_55"
    }
  }, [_c('b', [_vm._v("10:1")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Anointing")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Royal Priesthood.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The godly anointing used among the people of Israel looked toward Christ’s anointing, the anointing of the Lord, as it says in Isaiah, “The Spirit of the Lord God is upon me, because the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" has anointed me.” And in the psalm, “You have loved righteousness and hated wickedness. Therefore God, your God, has anointed you with the oil of gladness beyond your companions.” For "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2685"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2686"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2687"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2688"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2689"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2690"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2691"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2692"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2693"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2694"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2695"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2696"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2697"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2698"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2699"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2700"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2701"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2702"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page42",
      "title": "42"
    }
  }), _vm._v("Christ is the priest and king who puts an end to priesthood and royal dignity in Israel, for he is the true and eternal reality of all those figures who had come before. And through this one, all Christians are Christ’s: that is, priests and kings just as Abraham, Isaac and Jacob had been, of whom the psalm speaks, “Touch not my anointed ones, do my prophets no harm!” In that way, God’s external institution is not a human invention but has signified a spiritual and internal anointing. For this reason, what the gospel has publicly proclaimed in the world is not the work God instituted for a time being. This does not permit us to act or speak in this way: “God instituted this and wanted it to signify thus; so therefore whatever similar things we have instituted deserve the same significance.” For ours is a time of ungodliness, and we make human and divine signs equal, without any word of God. But 1 John 2 speaks of Christian anointing, how they are those who have had the oil of righteousness, just like Abraham, Isaac and Jacob. The psalm says, “the oil of gladness,” which is the Holy Spirit in your heart. But this impious argument is made against us: “The thing you admire is not in the words themselves. Those whom God commanded to anoint priests or kings were themselves anointed to be priests or kings before God. Therefore those whom we anoint as priests or kings without God’s command are truly ordained priests or kings before God.” Who told this to you, that from your hearts you have decided that God will definitely accept your word on this, whether it is true or false? The Lord commanded this anointing and Samuel said, “The L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" has anointed you.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-331-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Grounded on the Holy Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" Ordinary ceremonies of anointing of the Old Testament were grounded on the communication of the gifts of the Holy Spirit and were figured by the oil. Now it is not said that it was anything other than the ordinary oil used by a priest, whereas it is likely that the horn of oil by which David was anointed was afterward kept in the tabernacle. Afterward other kings, when occasion served, were anointed with the same oil, as is the case in 1 Kings 1:39. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-330-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Gifts of the Holy Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" This anointing in the Old Testament signified the gifts of the Holy Spirit that were necessary for those who would rule. This was a type and figure of the spiritual anointing of the Messiah—to be our Priest, Prophet and King. However, this ceremony was not necessary to continue in the New Testament. The Jews think Saul was not anointed in the same way that David and Solomon were anointed. They believe that David’s and Solomon’s anointing oil came from the tabernacle, but that Saul’s did not. And they also believe that the oil poured over David and Solomon came from a horn, while the oil poured over Saul came from a vial—the same way Jehu was anointed. This type of anointing, coming as it did from a brittle vessel like a vial—regardless of whether it was made of glass or of earth—signified the unstableness and short continuance of Saul’s and Jehu’s two kingdoms. By contrast, the oil coming from a horn indicated the firm and durable state of the kingdoms of David and Solomon. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-329-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_56"
    }
  }, [_c('b', [_vm._v("10:2-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("A Sign, the Spirit and a Command")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Faith Before Works.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" Here Samuel does not set forth one single work, but he sends a man, changed by the Spirit, as into a forest of works. Because he has become another man, therefore, other works follow. Our opponents do not understand this theology, but turn it upside down. They prescribe and teach that people should do works until they are changed and become different. But a man or person must first be changed. . . . Afterward, everything will be made "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2703"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2704"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2705"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2706"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2707"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2708"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2709"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2710"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page43",
      "title": "43"
    }
  }), _vm._v("right. . . . Everything now pleases God because the person pleases God, not for their own sake but for the sake of the sacrifice of Christ and the mercy which faith grasps. "), _c('i', [_vm._v("Comments on Psalm 51.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-328-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Signs and Sacraments from God.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Samuel said, “And this shall be the sign to you.” This reality was new and hardly believable to Saul. Therefore it was confirmed by many foretold signs from God, so that he would believe the word of God. In the same way the external sacraments are confirmed to us. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-327-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How the Spirit of God Came On Saul.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The spirit of God is taken here as (1) the gift of prophesying, (2) the ability to achieve and prosper in an undertaking or (3) the gift of sanctification. Saul was endued with the spirit of God in the first two ways. First, he received a temporary gift of prophesying that confirmed him in his calling, just as the seventy elders prophesied temporarily in Numbers 11:25. Second, he was also furnished with gifts fit for that calling, as courage and generosity were necessary for the office of a king. However, as for the third sense, he was far off from true inward sanctification, as his latter actions demonstrated. He became another man in these two respects: first, because he should now show himself a prophet—singing divine songs and hymns among the prophets as though he had from his youth been trained up among them. And, second, that he should now put on a princely mind and meditate on matters belonging to the kingdom—whereas he was before but conversant only with his cattle. Yet this was but a civil kind of change in him. There was no inward renewal; nor did he become a regenerated man who was born of the Spirit. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-326-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Leaving Certainty for Uncertainty.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" [One of the many manifestations of] deceit is when we are occupied in thinking of some good thing to come to make us neglect our present duty. Here we should remember that saying of Samuel to Saul, “ . . . Do what your hand finds to do, for God is with you.” It is a folly to leave certainties for uncertainties. If you will lay hold of the present occasion, you may do so. But as for that which is to come, you are wholly uncertain. You do not know whether there will ever be any occasion of good for you to lay hold of or not. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-325-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_57"
    }
  }, [_c('b', [_vm._v("10:10-16")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Among the Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("“Is Saul Also Among the Prophets?”")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This proverb, that Saul is among the prophets, means that many can be made suitable, even those who do not seemingly belong: "), _c('i', [_vm._v("Nos poma natamus")]), _vm._v(". To condemn the gifts of God because of a person’s outward appearance is truly the foolishness of human wisdom. Christ addressed this when he said, “No prophet is acceptable in his hometown.” This point condemns anyone who makes the mistake of marveling about another person, just as they so greatly seized on the son of Kish when they said, “Who is their father?” as if he needed to be from the prophets. So it is shown that prophets are not made by parents or from the flesh but by the gift of God, who gives it to anyone he desires, including those not accustomed to titles great or small or respectable. This is not a work of the flesh but of the will of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-324-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Who Is Their Father?")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Many marveled at this sudden change in Saul, whom they had known to be a valiant and courageous man before—but no prophet. . . . Nevertheless, we should not marvel that Saul prophesies, even though he does not have a prophet for a father. For the gift of prophecy is not hereditary. True prophets are not "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2711"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2712"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2713"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2714"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2715"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2716"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2717"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2718"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2719"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2720"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2721"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2722"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2723"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2724"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page44",
      "title": "44"
    }
  }), _vm._v("such because their fathers were prophets. Rather, it is the Spirit of God who is their father. The Spirit of God is their instructor. Prophets are not so much taught by people as taught by the spirit of God, who works freely and who accepts no person’s worth. For the Spirit of God can raise up prophets even from among the most wretched and abject of people. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-323-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_58"
    }
  }, [_c('b', [_vm._v("10:17-24")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Selection and Hiding of Saul")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Casting Lots and Trusting God.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Proverbs says, “The lot is cast into the lap, but its every decision is from the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(".” It is not necessary to ask whether casting lots may be allowed. It is allowed if you will have faithfully and modestly gathered together to cast lots from God, committing prayers to God for safekeeping in all things, so that this sign shows you the important thing it wants to show. You read that the apostles did exactly this in Acts 1. This is not tempting God but seeking God’s own will in matters in which you do not know everything that should be done, especially what is right to do for the glory of God and the salvation of your neighbors. The fear of God does this for those who do not at all dare to trust human advice. It is rightly translated “casting lots” in Latin, because in Hebrew it shows an external sign by which God indicates whom he has chosen. But why did Samuel do this? I reply: He did not do this for himself but for the people, so that the people know who had been chosen to be king by God, so as to prevent what had been done earlier with Aaron and the priests in Numbers 16. Therefore among ministers of the Word it is most important to know that which should be taught in order to be an apostle of God; otherwise, how will you believe? "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-322-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hiding the Baggage Within.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" There are not so many, nor so cunning, devices for the hiding of natural infirmities of the body—such as the crookedness of the legs or back or the lack of a tooth or an eye—as there are for the unnatural deformities of the soul. But once their desires are granted, they show themselves. Then the waters, which were previously stopped and damned up, run over and rage furiously. . . . And this is surely like it was when Saul hid himself in the baggage when he was to be chosen king. In the same way, the wicked—when they look either by election or other means to get this or that—they very soon hide in themselves their filthy stuff and baggage within. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-321-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hiding Does Not Foil Providence.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Saul is appointed to the kingdom of Israel by God and anointed by the prophet Samuel; yet still he must be designated by lot. Was this to leave behind certainty and put it to chance? No, for of all the tribes in Israel, Benjamin is taken; of all the families of Benjamin, Matri is taken; of all the kindred of Matri, the house of Kish is taken; of all the house of Kish, Saul is chosen to be king. Saul had hidden himself, but he could not hope that his being hidden should foil the purpose of God. He who designed his name among the thousands of Israel (he might well think) could easily find Saul in a tent, and bring him forth to honor. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-320-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_59"
    }
  }, [_c('b', [_vm._v("10:25-27")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Good and the Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Only the Holy Spirit Works Faith.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The text speaks of “those whose hearts God had touched.” This is the nature of God’s word and activity, that it is not received or accepted unless God’s Spirit touches the heart. You see this in 1 Esdras 1, which speaks of the return from the Babylonian Captivity. . . . Those who had previously sinned by asking for a king now most grievously sin again by despising the one whom God had chosen with clear signs. They did not look to God’s will but to human "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2725"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2726"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2727"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2728"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2729"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2730"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2731"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2732"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2733"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2734"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2735"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2736"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2737"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2738"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2739"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page45",
      "title": "45"
    }
  }), _vm._v("appearances, just as the flesh always does. It has nothing to do with the spirit of faith but with trying to have all kinds of things without wisdom or righteousness. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-319-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Human Heart Is Not Able to Rest in God Alone.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Samuel finds fault with the ungrateful people, and he exposes their audacity and mistrust. For the God who so far had defended the church by the power of his hand, preserved and freed it was also repeatedly able to carry them without human assistance by his help and deliverance. But so great is the mistrust of the human heart that it is not able to rest in God alone. Therefore all people seek help from visible sources while they can. Then when these sources lead to ruin, they shatter many souls and do not permit any consolation. This shows the anguish of confiding only in visible things instead of God. It is permitted to use things ordained by God, as David used them for his army. But faith in things without faith in God scorns the divine voice, “Cursed is the man who trusts in man and makes flesh his strength, whose heart turns away from the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(".” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-318-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Victory by Leniency.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" These “worthless fellows” were men of Belial, that is, men without a yoke who refused to submit themselves to Saul’s government. They thought that because he was of low parentage and of no power, he was not a likely man to save the people. Therefore they did not come to show their respects to the king, nor bring him presents as others did. For by such gifts of acknowledgment, subjects express their loyal affection to the magistrate. But Saul held his peace and winked at this fault to avoid sedition and to win them by leniency. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-317-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2740"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2741"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2742"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2743"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2744"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2745"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2746"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page46",
      "title": "46"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_60"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("11:1-15")]), _vm._v(" BATTLE AGAINST THE AMMONITES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Then Nahash the Ammonite went up and besieged Jabesh-gilead, and all the men of Jabesh said to Nahash, “Make a treaty with us, and we will serve you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("But Nahash the Ammonite said to them, “On this condition I will make a treaty with you, that I gouge out all your right eyes, and thus bring disgrace on all Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("The elders of Jabesh said to him, “Give us seven days’ respite that we may send messengers through all the territory of Israel. Then, if there is no one to save us, we will give ourselves up to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("When the messengers came to Gibeah of Saul, they reported the matter in the ears of the people, and all the people wept aloud.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Now, behold, Saul was coming from the field behind the oxen. And Saul said, “What is wrong with the people, that they are weeping?” So they told him the news of the men of Jabesh.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And the Spirit of God rushed upon Saul when he heard these words, and his anger was greatly kindled.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("He took a yoke of oxen and cut them in pieces and sent them throughout all the territory of Israel by the hand of the messengers, saying, “Whoever does not come out after Saul and Samuel, so shall it be done to his oxen!” Then the dread of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("fell upon the people, and they came out as one man.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("When he mustered them at Bezek, the people of Israel were three hundred thousand, and the men of Judah thirty thousand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And they said to the messengers who had come, “Thus shall you say to the men of Jabesh-gilead: ‘Tomorrow, by the time the sun is hot, you shall have salvation.’” When the messengers came and told the men of Jabesh, they were glad.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Therefore the men of Jabesh said, “Tomorrow we will give ourselves up to you, and you may do to us whatever seems good to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the next day Saul put the people in three companies. And they came into the midst of the camp in the morning watch and struck down the Ammonites until the heat of the day. And those who survived were scattered, so that no two of them were left together.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Then the people said to Samuel, “Who is it that said, ‘Shall Saul reign over us?’ Bring the men, that we may put them to death.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("But Saul said, “Not a man shall be put to death this day, for today the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has worked salvation in Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Then Samuel said to the people, “Come, let us go to Gilgal and there renew the kingdom.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("So all the people went to Gilgal, and there they made Saul king before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in Gilgal. There they sacrificed peace offerings before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and there Saul and all the men of Israel rejoiced greatly."), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers recognize this passage as narrating Saul’s first assignment as king of Israel. Several commentators dwell on issues related to authority and governance. For example, Luther interprets this passage in light of the Peasants’ Revolt of 1524–1525, juxtaposing the divinely sanctioned leadership of Saul with that of renegade theologian Thomas Müntzer, who played an active role in the German revolt. Luther raises, but does not answer, a larger question related to authority: How do we determine legitimate leadership? Other commentators emphasize that the Holy Spirit empowers Saul to gain victory over the Ammonites, though they disagree on the personal and spiritual motives of Saul when it comes to his actions surrounding the battle. While some of the reformers comment positively on Saul’s refusal to kill those Israelites opposed to his leadership, others are tempted to interpret all of Saul’s actions in light of his overall failure as a godly king. As the story of Saul unfolds, however, the commentators become increasingly critical of his character and leadership, finding little to salvage from his reign as king of Israel.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_61"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2747"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2748"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2749"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2750"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2751"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2752"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2753"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2754"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2755"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2756"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2757"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2758"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2759"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2760"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page47",
      "title": "47"
    }
  }), _c('b', [_vm._v("11:1-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s New Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Honor of Agriculture.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Even though he had been chosen as king, still he was not ashamed to continue farming, just like the old Romans formerly were not ashamed of rural matters. Some of them were called from the plow to the office of dictator."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-316-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" Agriculture is an honest way of life—the least shameful way of life for a free person. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-315-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Reading the Bible Carefully.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" I have often warned that much good sense is needed when passing judgment on the works of the saints. When the Spirit had come on Saul, he cut oxen to pieces and threatened that the same thing would happen to the sheep of those who would not follow him and Samuel to war. Success followed the impulse, which was both heroic and from the Holy Spirit. After Thomas Müntzer had aroused the peasants to take up arms, he was also sure of victory in what seemed to him a just cause. But he perished, and rightly so; for his actions came from his own spirit, not from the Spirit of God. Nor could he get any support from the examples of the Old Testament saints, the examples on which he was nevertheless relying. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-314-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Beneficial Authority Is a Gift of God.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Authority should not be matched up to our efforts. It is rather an exceptional and singular gift of God, as when the young Alexander the Great was followed by a large army such that no other leader will be followed in the same way. Similarly, Julius Caesar was such an authority that he could make a fleeing army stand put. Thus in this place the Lord bedecks the new king with authority, inclining the souls of the people to him. For it is a mistake to make an unwilling hound go hunting. But having been put under a clear, guiding and auspicious sequence of events about their government, the people can endure great things. Therefore whoever wants to enter into matters of government should ask God for wisdom beyond what the eye sees and the ear hears, as Solomon did.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Three benefits accompanied the state of being a king. First, any kind of pious king delighted in doing good for the preservation of doctrine, just as David, Solomon, Jehoshaphat, Hezekiah and Josiah cherished the study of doctrine and true worship. Second, through the king’s victories God gave illustrious testimony of his presence among the people, making himself visible, giving witness to doctrine and the church, and sending prophets to the kings. The third benefit about the kingly station was that he did whatever was good for the strengthening of the state. These benefits were great and singular works of God to those who acknowledged them, just as Scripture says, “Unless the Lord watches over the city, the watchman stays awake in vain.” And so that these highest goods relate to our states, let us pray most ardently for this and—wherever it is given—acknowledge this to be the work of God, celebrate God as the gracious author and custodian of this and remain diligent for him. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-313-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("What Spirit of God Came to Saul?")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It is best to understand this passage as indicating that the spirit of fortitude came on Saul. This is similar to the way the spirit of God came on Sampson in Judges 14:5, when he tore apart the lion. It was, then, a heroic spirit that he received: the spirit of strength and courage. . . . It was not the spirit of sanctification or regeneration. By this it is evident that a person, even in civil actions, has need of the direction of God’s Spirit to bring him or her to a good end. This is as before: “Saul also went to his home at Gibeah, and with "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2761"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2762"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2763"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2764"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2765"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2766"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2767"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2768"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2769"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2770"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2771"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2772"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2773"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2774"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page48",
      "title": "48"
    }
  }), _vm._v("him went men of valor whose hearts God had touched.” People do not have any free will of themselves in moral actions to do that which is good and pleasing in the sight of God, unless such a person is drawn and guided by the Spirit of God. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-312-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Waiting for Public Installation.")]), _vm._v(" "), _c('i', [_vm._v("Dutch Annotations:")]), _vm._v(" Even though Saul was privately anointed king over Israel by Samuel and he accepted the greatest part of the position, he did not as yet begin to execute that office in public. Instead, he lived a retired life until he was publicly installed by all the people. . . . Then the Spirit of the Lord came on him; that is, then God immediately, by the power of his Spirit, gave Saul the gifts of strength and courage to oppose the Ammonites. . . . And he took a couple of oxen, and hewed them in pieces. . . . He did this so that the Israelites would see the pieces of the oxen and remember what damage would befall them if they refused to follow Saul in this expedition. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-311-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_62"
    }
  }, [_c('b', [_vm._v("11:12-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Appearance of Grandeur")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Forgiveness for the Sake of Public Tranquility.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" Saul’s dissimilation is praiseworthy, as he had not yet been confirmed as king. Rather, he is long and greatly honored for this moderation in victory, which he achieved as an unjustly forgotten person. Whoever thus conquers his soul at the height of its power over all things is comparable to one who finds the greatest way of life. It is like when David returned to Jerusalem after the war of sedition in 2 Samuel 19 and he swore that no one would be destroyed. These examples remind us that we should forgive anyone their most bitter wrongs and pardon private offenses for the sake of public tranquility. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-310-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Evil Deeds Beget Evil Deeds.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Saul was pious and began his reign with God, but the end of his reign was bloody. The further he went, the worse he was till even the night before he died, he consulted with a witch and ended his reign with the devil. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-309-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Superficially Infused.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Saul here shows his piety, humanity and wisdom. He shows the first by not seeking private revenge, and the second by bearing with the people’s scruples and doubtfulness, since they had not yet received him as their king. Saul demonstrates his wisdom by seeking to win them with leniency. Such qualities are also seen in David (2 Sam 19:25) in pardoning Shimei and granting him his life. Saul gives this reason: “For today the Lord has worked salvation in Israel.” Saul would not have the joy of that day obscured and polluted with the shedding of blood. For, as God had shown the people mercy in sending them such a joyful deliverance, so he thought it fit that a similar mercy should be showed to others. Rabbi Ben Gerson thinks that Saul did not pardon these men but only delayed their punishment. But that is not likely. For until now Saul had proved himself to be an innocent man and a good prince. But afterward Saul forgot his own rule when he tried to kill Jonathon for unknowingly breaking Saul’s rash vow. . . . This mutability in Saul and his changeable nature—in falling from clemency to cruelty, from piety to profanity, from being a good governor to becoming a tyrant—shows that these virtues were not thoroughly grounded in him but were only superficially infused. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-308-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2775"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2776"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2777"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2778"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2779"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2780"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2781"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2782"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2783"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2784"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2785"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page49",
      "title": "49"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_63"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("12:1-25")]), _vm._v(" SAMUEL GIVES A FAREWELL ADDRESS")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Samuel said to all Israel, “Behold, I have obeyed your voice in all that you have said to me and have made a king over you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And now, behold, the king walks before you, and I am old and gray; and behold, my sons are with you. I have walked before you from my youth until this day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Here I am; testify against me before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and before his anointed. Whose ox have I taken? Or whose donkey have I taken? Or whom have I defrauded? Whom have I oppressed? Or from whose hand have I taken a bribe to blind my eyes with it? Testify against me")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("and I will restore it to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("They said, “You have not defrauded us or oppressed us or taken anything from any man’s hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And he said to them, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is witness against you, and his anointed is witness this day, that you have not found anything in my hand.” And they said, “He is witness.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And Samuel said to the people, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is witness,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("who appointed Moses and Aaron and brought your fathers up out of the land of Egypt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now therefore stand still that I may plead with you before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("concerning all the righteous deeds of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("that he performed for you and for your fathers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("When Jacob went into Egypt, and the Egyptians oppressed them,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("then your fathers cried out to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent Moses and Aaron, who brought your fathers out of Egypt and made them dwell in this place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("But they forgot the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("their God. And he sold them into the hand of Sisera, commander of the army of Hazor,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("and into the hand of the Philistines, and into the hand of the king of Moab. And they fought against them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And they cried out to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and said, ‘We have sinned, because we have forsaken the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and have served the Baals and the Ashtaroth. But now deliver us out of the hand of our enemies, that we may serve you.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent Jerubbaal and Barak")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('i', [_vm._v("and Jephthah and Samuel and delivered you out of the hand of your enemies on every side, and you lived in safety.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And when you saw that Nahash the king of the Ammonites came against you, you said to me, ‘No, but a king shall reign over us,’ when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God was your king.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And now behold the king whom you have chosen, for whom you have asked; behold, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has set a king over you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("If you will fear the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and serve him and obey his voice and not rebel against the commandment of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and if both you and the king who reigns over you will follow the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God, it will be well.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("But if you will not obey the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", but rebel against the commandment of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", then the hand of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will be against you and your king.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("Now therefore stand still and see this great thing that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will do before your eyes.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Is it not wheat harvest today? I will call upon the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", that he may send thunder and rain. And you shall know and see that your wickedness is great, which you have done in the sight of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", in asking for yourselves a king.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("So Samuel called upon the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent thunder and rain that day, and all the people greatly feared the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and Samuel.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And all the people said to Samuel, “Pray for your servants to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God, that we may not die, for we have added to all our sins this evil, to ask for ourselves a king.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And Samuel said to the people, “Do not be afraid; you have done all this evil. Yet do not turn aside from following the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", but serve the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("with all your heart.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And do not turn aside after empty things that cannot profit or deliver, for they are empty.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("For the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will not forsake his people, for his great name’s sake, because it has pleased the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("to make you a people for himself.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("Moreover, as for me, far be it from me that I should sin against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("by ceasing to pray for you, and I will instruct you in the good and the right way.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Only fear the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and serve him faithfully with all your heart. For consider what great things he has done for you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("But if you still do wickedly, you shall be swept away, both you and your king.”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("Testify against me")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("is witness")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("and the Egyptians oppressed them")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint "), _c('i', [_vm._v("the army of Jabin king of Hazor")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Septuagint, Syriac; Hebrew "), _c('i', [_vm._v("Bedan")]), _vm._v(" "), _c('b', [_vm._v("f")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("fathers"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2786"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2787"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2788"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2789"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2790"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2791"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2792"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2793"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2794"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2795"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2796"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2797"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2798"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2799"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2800"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2801"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2802"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page50",
      "title": "50"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" The interpreters here recognize the godly leadership of Samuel over the people of Israel but see different themes within that larger unity. In terms of the speech Samuel gives, some regard it as a sermon that aims to bring about conversion, while other commentators focus on issues related to integrity or the duties of government officials. The reformers interpret the violent weather that accompanied Samuel’s speech as divine proof of God’s displeasure at the people’s request for a king. Like the biblical authors themselves, the reformers readily adduce God’s finger in physical occurrences such as weather. Samuel is not only a judge of the people but also their priest and mediator; the reformers emphasize the burden he carries as the people’s priest to pray for the people.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_64"
    }
  }, [_c('b', [_vm._v("12:1-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("One’s Clear Conscience and Good Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Conquers Hardened Hearts.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Because the people were often reminded by God’s Word that they had sinned by asking for a king and by not wanting to acknowledge sins, Samuel confronted their sins with this biting address about God’s clearly extensive works; he does by retelling the whole story in only a few words. . . . By telling this history, Samuel declares that God had ruled the people to this point and that the people had confidently lived under God. The prophets had already promised this grace to all who believe in Christ, so that they might have confidence in spirit. That means they might have an untroubled conscience before God and have the peace of God in their hearts through the one reigning there, as in Jeremiah 23 and Isaiah 32. . . . Samuel showed how for so long God had been a king and continuously raised up good leaders in those days. He did this so that the people would acknowledge what they had done. And by a clear miracle of God, Samuel conquered their hardened hearts. He led them to confess the sin, and they judged his wisdom to be real, useful, necessary and salutary. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-307-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Glorious Testimony of a Good Conscience.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The approval of a good conscience and the testimony of others to the honest fact of that judgment are truly glorious things. But much is meant by the true approval of our consciences. For when the conscience judges truly, it recognizes its infirmities, fears God and also faithfully obeys God’s call. It then carries the one who is called not by personal striving but by recognizing oneself as being supported by God. Samuel glories in this, that he has the true testimony of conscience. He knows that he did not steal leadership but obeyed the call. He did not mix up personal gain with the happy burden of having authority from God. This glory, that is, this good testimony of the conscience, is rightly desired, because God wants us to live with a good conscience. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-306-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel and Moses’ Example.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Aepinus:")]), _vm._v(" These two godly men, Moses and Samuel, teach us by their example that magistrates ought not to take or receive any manner of gifts from people who stand before them in judgment. Their example also teaches us that magistrates are bound to obey the precepts and commandments of God without any manner of denial or grudge. "), _c('i', [_vm._v("Exposition on Psalm 15.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-305-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Who Samuel Meant for His Anointed.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think that under the type of Saul the anointed king, Samuel understands the Messiah, the anointed of God, whom the Lord had appointed to be judge of the world and before whom we must give account of all our doings. But it is evident that Samuel means something different. Verse 5 states, “His anointed is witness this day.” Samuel’s use of “this day” refers to Saul, in whose hearing he made this statement. In the same sense, David later calls Saul the Lord’s anointed (1 Sam 24:10). Now Samuel makes special mention of Saul in two regards. First, in respect of himself, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2803"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2804"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2805"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2806"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2807"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2808"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2809"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2810"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2811"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2812"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2813"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2814"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2815"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page51",
      "title": "51"
    }
  }), _vm._v("he provides Saul a pattern on how to govern the people uprightly and justly without oppression. Second, in respect of the people, that they might see what difference there was (as they latter discovered) between the upright government that they had enjoyed under their judges, and the hard service they would feel under some of their kings—as Samuel had foretold them before. Finally, Samuel also means to preserve his own name, which is lawful to preserve, lest in time the people wrongly accuse him and speak ill of him after he is gone. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-304-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_65"
    }
  }, [_c('b', [_vm._v("12:16-18")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God and Thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Lord Sent Thunder and Rain.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" This thunder and rain is like the terrifying crashes that accompanied the giving of the law on Mount Sinai. Thus the gathering, where Samuel was exhorting the people to repent, was confirmed and sealed by a divine sign. For the gathering of repentant people in the church is not an empty sound, but a sound that strikes the heart with a sense of God’s wrath and prepares it to accept the seed of the gospel. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-303-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why Samuel Called for Thunder.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Here the Lord showed his power. And the people saw their foolishness in not being content with having such a mighty God for their protector who could fight for them with thunder and rain against their enemies, as he did for Israel against the host of Pharaoh and against the Philistines. And besides, it appeared that they had little reason to be wary of Samuel’s government, who by prayer could fetch down rain and thunder from heaven. In these two signs the Lord showed his mercy and judgment: The rain is, for the most part, a sign of his mercy, while the thunder and lightning are signs of his judgment. And as the rain mitigates the heat and the raging of the lightning . . . so the Lord’s judgments are tempered with mercy. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-302-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_66"
    }
  }, [_c('b', [_vm._v("12:19-25")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel as Priest and Intercessor")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Duties of a Priest.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" The duty of a priest is twofold: in the first place, to turn to God and pray for himself and for his people; in the second place, to turn from God to people by means of doctrine and the Word. Thus Samuel states in 1 Samuel 12:23: “Far be it from me not to pray for you and not to lead you to the good and the right way.” He acknowledges that this is essential to his office. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-301-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Gospel Follows Confession.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" “Do not be afraid.” The law was proclaimed up to this point. Here now the gospel follows the recognition of sin. Now the triumphant Samuel does not cease to pray or instruct those who are in the office of priest. This is for “his great name’s sake.” God does not bless us on account of our merits or demerits, but on account of two things Scripture insists upon: mercy and truth. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-300-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Praying for the Church.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The office of priest contains two main roles. The first is to teach. The second is to pray for the church. Samuel shows himself to have been most faithful in each of the two. In the same way, all pious people are priests, whether—according to their calling—they are teaching in the temple, in a school or in their homes. And they pray for the church, which is not only a place of speaking or Scriptures but a place where many great prayers are boldly offered. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-299-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Continual Prayer.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" Persistence in prayer is commanded in Scripture: “We ought always to pray and not to lose heart,” "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2816"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2817"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2818"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2819"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2820"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2821"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2822"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2823"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2824"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2825"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2826"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2827"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2828"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2829"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2830"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page52",
      "title": "52"
    }
  }), _vm._v("“pray without ceasing” and “The prayer of a righteous person has great power as it is working.” But it may be said: How is it possible that Paul should never cease from prayer, when the weakness of human nature will not sustain continual praying? Indeed, some who have feigned to be part of the church have made constant prayer the pretext of indolence and sluggishness, and are reckoned among heretics in Theodoret and Augustine. I answer: We are said not to cease from prayer or not to leave off praying for anything when we have a fixed desire of that thing in our heart. As Augustine says regarding Psalm 37: “Your desire is your prayer; if there is a continual desire, there is continual prayer.” Second, we are said not to faint, or not to cease from praying, when we exercise it in its proper time and place. For it is idleness in a person, and he ceases from his work when he does not perform what he can and ought to do. In either respect, therefore, Paul said truly, “We have not ceased to pray for you.” For there was both a perpetual desire in his mind (at least as to the habit) of promoting their good; and that also, as much as in him lay, he did promote by his prayers as often as opportunity of praying offered itself to him. Observe, then, not only is the duty of the pastor to teach his flock and to commend them to God in public prayers, but also in his private prayer he ought never to be unmindful of the people committed to his care. Thus Samuel was actuated toward the people of God, “Moreover, as for me, far be it from me that I should sin against the Lord by ceasing to pray for you.” "), _c('i', [_vm._v("Exposition of Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-298-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Praying Without Ceasing.")]), _vm._v(" "), _c('i', [_vm._v("John Dod:")]), _vm._v(" God commands us to pray one for another. Now if those who are not connected to us in any way are to be recommended to God in our prayers, how much more so those whom God has more specially united to us either by nature or by duty and service! Indeed, Christ Jesus directly commands us to pray for our enemies. And if that is a bound duty, how much more is it to pray for our friends, especially if they also are God’s friends? For by our prayers they may be helped a great deal and endangered without them. The prophet Samuel understood that this was a duty when he accounted the neglect of it to be a sin against God. . . . For when the people were frightened and humbled, both by the words of Samuel and by the miraculous work of God in sending extraordinary thunder and rain in the time of the wheat harvest, they came to Samuel saying: “Pray for your servants to the Lord your God, that we might not die.” And his answer was, “ . . . as for me, far be it from me that I should sin against the Lord by ceasing to pray for you.” "), _c('i', [_vm._v("The Fourth Sermon on the Lord’s Supper.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-297-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2831"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2832"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2833"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2834"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page53",
      "title": "53"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_67"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("13:1–14:52")]), _vm._v(" SAUL GOES TO BATTLE AGAINST THE PHILISTINES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Saul lived for one year and then became king, and when he had reigned for two years over Israel,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Saul chose three thousand men of Israel. Two thousand were with Saul in Michmash and the hill country of Bethel, and a thousand were with Jonathan in Gibeah of Benjamin. The rest of the people he sent home, every man to his tent.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Jonathan defeated the garrison of the Philistines that was at Geba, and the Philistines heard of it. And Saul blew the trumpet throughout all the land, saying, “Let the Hebrews hear.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And all Israel heard it said that Saul had defeated the garrison of the Philistines, and also that Israel had become a stench to the Philistines. And the people were called out to join Saul at Gilgal.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And the Philistines mustered to fight with Israel, thirty thousand chariots and six thousand horsemen and troops like the sand on the seashore in multitude. They came up and encamped in Michmash, to the east of Beth-aven.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("When the men of Israel saw that they were in trouble (for the people were hard pressed), the people hid themselves in caves and in holes and in rocks and in tombs and in cisterns,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("and some Hebrews crossed the fords of the Jordan to the land of Gad and Gilead. Saul was still at Gilgal, and all the people followed him trembling.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("He waited seven days, the time appointed by Samuel. But Samuel did not come to Gilgal, and the people were scattering from him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("So Saul said, “Bring the burnt offering here to me, and the peace offerings.” And he offered the burnt offering.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("As soon as he had finished offering the burnt offering, behold, Samuel came. And Saul went out to meet him and greet him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Samuel said, “What have you done?” And Saul said, “When I saw that the people were scattering from me, and that you did not come within the days appointed, and that the Philistines had mustered at Michmash,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("I said, ‘Now the Philistines will come down against me at Gilgal, and I have not sought the favor of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".’ So I forced myself, and offered the burnt offering.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And Samuel said to Saul, “You have done foolishly. You have not kept the command of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God, with which he commanded you. For then the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("would have established your kingdom over Israel forever.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("But now your kingdom shall not continue. The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has sought out a man after his own heart, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has commanded him to be prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("over his people, because you have not kept what the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("commanded you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And Samuel arose and went up from Gilgal. The rest of the people went up after Saul to meet the army; they went up from Gilgal")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("to Gibeah of Benjamin.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("And Saul numbered the people who were present with him, about six hundred men.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Saul and Jonathan his son and the people who were present with them stayed in Geba of Benjamin, but the Philistines encamped in Michmash.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And raiders came out of the camp of the Philistines in three companies. One company turned toward Ophrah, to the land of Shual;")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("another company turned toward Beth-horon; and another company turned toward the border that looks down on the Valley of Zeboim toward the wilderness.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now there was no blacksmith to be found throughout all the land of Israel, for the Philistines said, “Lest the Hebrews make themselves swords or spears.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("But every one of the Israelites went down to the Philistines to sharpen his plowshare, his mattock, his axe, or his sickle,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("and the charge was two-thirds of a shekel")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('i', [_vm._v("for the plowshares and for the mattocks, and a third of a shekel")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('i', [_vm._v("for sharpening the axes and for setting the goads.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("g")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("So on the day of the battle there was neither sword nor spear found in the hand of any of the people with Saul and Jonathan, but Saul and Jonathan his son had them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And the garrison of the Philistines went out to the pass of Michmash.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("14")]), _vm._v(" "), _c('i', [_vm._v("One day Jonathan the son of Saul said to the young man who carried his armor, “Come, let us go over to the Philistine garrison on the other side.” But he did not tell his father.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Saul was staying in the outskirts of Gibeah in the pomegranate cave")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("h")]), _vm._v(" "), _c('i', [_vm._v("at Migron. The people who were with him were about six "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2835"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2836"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2837"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page54",
      "title": "54"
    }
  }), _c('i', [_vm._v("hundred men,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("including Ahijah the son of Ahitub, Ichabod’s brother, son of Phinehas, son of Eli, the priest of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in Shiloh, wearing an ephod. And the people did not know that Jonathan had gone.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Within the passes, by which Jonathan sought to go over to the Philistine garrison, there was a rocky crag on the one side and a rocky crag on the other side. The name of the one was Bozez, and the name of the other Seneh.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("The one crag rose on the north in front of Michmash, and the other on the south in front of Geba.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Jonathan said to the young man who carried his armor, “Come, let us go over to the garrison of these uncircumcised. It may be that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will work for us, for nothing can hinder the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("from saving by many or by few.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And his armor-bearer said to him, “Do all that is in your heart. Do as you wish.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("i")]), _vm._v(" "), _c('i', [_vm._v("Behold, I am with you heart and soul.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then Jonathan said, “Behold, we will cross over to the men, and we will show ourselves to them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("If they say to us, ‘Wait until we come to you,’ then we will stand still in our place, and we will not go up to them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("But if they say, ‘Come up to us,’ then we will go up, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has given them into our hand. And this shall be the sign to us.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("So both of them showed themselves to the garrison of the Philistines. And the Philistines said, “Look, Hebrews are coming out of the holes where they have hidden themselves.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And the men of the garrison hailed Jonathan and his armor-bearer and said, “Come up to us, and we will show you a thing.” And Jonathan said to his armor-bearer, “Come up after me, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has given them into the hand of Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Then Jonathan climbed up on his hands and feet, and his armor-bearer after him. And they fell before Jonathan, and his armor-bearer killed them after him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And that first strike, which Jonathan and his armor-bearer made, killed about twenty men within as it were half a furrow’s length in an acre")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("j")]), _vm._v(" "), _c('i', [_vm._v("of land.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And there was a panic in the camp, in the field, and among all the people. The garrison and even the raiders trembled, the earth quaked, and it became a very great panic.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("k")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And the watchmen of Saul in Gibeah of Benjamin looked, and behold, the multitude was dispersing here and there.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("l")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Then Saul said to the people who were with him, “Count and see who has gone from us.” And when they had counted, behold, Jonathan and his armor-bearer were not there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("So Saul said to Ahijah, “Bring the ark of God here.” For the ark of God went at that time with the people")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("m")]), _vm._v(" "), _c('i', [_vm._v("of Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now while Saul was talking to the priest, the tumult in the camp of the Philistines increased more and more. So Saul said to the priest, “Withdraw your hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Saul and all the people who were with him rallied and went into the battle. And behold, every Philistine’s sword was against his fellow, and there was very great confusion.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Now the Hebrews who had been with the Philistines before that time and who had gone up with them into the camp, even they also turned to be with the Israelites who were with Saul and Jonathan.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Likewise, when all the men of Israel who had hidden themselves in the hill country of Ephraim heard that the Philistines were fleeing, they too followed hard after them in the battle.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("So the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("saved Israel that day. And the battle passed beyond Beth-aven.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And the men of Israel had been hard pressed that day, so Saul had laid an oath on the people, saying, “Cursed be the man who eats food until it is evening and I am avenged on my enemies.” So none of the people had tasted food.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Now when all the people")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("n")]), _vm._v(" "), _c('i', [_vm._v("came to the forest, behold, there was honey on the ground.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And when the people entered the forest, behold, the honey was dropping, but no one put his hand to his mouth, for the people feared the oath.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("But Jonathan had not heard his father charge the people with the oath,so he put out the tip of the staff that was in his hand and dipped it in the honeycomb and put his hand to his mouth, and his eyes became bright.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Then one of the people said, “Your father strictly charged the people with an oath, saying, ‘Cursed be the man who eats food this day.’” And the people were faint.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("Then Jonathan said, “My father has troubled the land. See how my eyes have become bright because I tasted a little of this honey.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("How much better if the people had eaten freely today of the spoil of their enemies that they found. For now the defeat among the Philistines has not been great.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("They struck down the Philistines that day from Michmash to Aijalon. And the people were very faint.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("The people pounced on the spoil and took sheep and oxen and calves and slaughtered them on the ground. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2838"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2839"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2840"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2841"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2842"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page55",
      "title": "55"
    }
  }), _c('i', [_vm._v("And the people ate them with the blood.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("Then they told Saul, “Behold, the people are sinning against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("by eating with the blood.” And he said, “You have dealt treacherously; roll a great stone to me here.”")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("o")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("And Saul said, “Disperse yourselves among the people and say to them, ‘Let every man bring his ox or his sheep and slaughter them here and eat, and do not sin against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("by eating with the blood.’” So every one of the people brought his ox with him that night and they slaughtered them there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("And Saul built an altar to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("; it was the first altar that he built to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("Then Saul said, “Let us go down after the Philistines by night and plunder them until the morning light; let us not leave a man of them.” And they said, “Do whatever seems good to you.” But the priest said, “Let us draw near to God here.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("37")]), _c('i', [_vm._v("And Saul inquired of God, “Shall I go down after the Philistines? Will you give them into the hand of Israel?” But he did not answer him that day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("38")]), _c('i', [_vm._v("And Saul said, “Come here, all you leaders of the people, and know and see how this sin has arisen today.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("39")]), _c('i', [_vm._v("For as the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives who saves Israel, though it be in Jonathan my son, he shall surely die.” But there was not a man among all the people who answered him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("40")]), _c('i', [_vm._v("Then he said to all Israel, “You shall be on one side, and I and Jonathan my son will be on the other side.” And the people said to Saul, “Do what seems good to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("41")]), _c('i', [_vm._v("Therefore Saul said, “O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("God of Israel, why have you not answered your servant this day? If this guilt is in me or in Jonathan my son, O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", God of Israel, give Urim. But if this guilt is in your people Israel, give Thummim.”")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("p")]), _vm._v(" "), _c('i', [_vm._v("And Jonathan and Saul were taken, but the people escaped.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("42")]), _c('i', [_vm._v("Then Saul said, “Cast the lot between me and my son Jonathan.” And Jonathan was taken.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("43")]), _c('i', [_vm._v("Then Saul said to Jonathan, “Tell me what you have done.” And Jonathan told him, “I tasted a little honey with the tip of the staff that was in my hand. Here I am; I will die.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("44")]), _c('i', [_vm._v("And Saul said, “God do so to me and more also; you shall surely die, Jonathan.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("45")]), _c('i', [_vm._v("Then the people said to Saul, “Shall Jonathan die, who has worked this great salvation in Israel? Far from it! As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, there shall not one hair of his head fall to the ground, for he has worked with God this day.” So the people ransomed Jonathan, so that he did not die.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("46")]), _c('i', [_vm._v("Then Saul went up from pursuing the Philistines, and the Philistines went to their own place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("47")]), _c('i', [_vm._v("When Saul had taken the kingship over Israel, he fought against all his enemies on every side, against Moab, against the Ammonites, against Edom, against the kings of Zobah, and against the Philistines. Wherever he turned he routed them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("48")]), _c('i', [_vm._v("And he did valiantly and struck the Amalekites and delivered Israel out of the hands of those who plundered them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("49")]), _c('i', [_vm._v("Now the sons of Saul were Jonathan, Ishvi, and Malchi-shua. And the names of his two daughters were these: the name of the firstborn was Merab, and the name of the younger Michal.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("50")]), _c('i', [_vm._v("And the name of Saul’s wife was Ahinoam the daughter of Ahimaaz. And the name of the commander of his army was Abner the son of Ner, Saul’s uncle.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("51")]), _c('i', [_vm._v("Kish was the father of Saul, and Ner the father of Abner was the son of Abiel.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("52")]), _c('i', [_vm._v("There was hard fighting against the Philistines all the days of Saul. And when Saul saw any strong man, or any valiant man, he attached him to himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew "), _c('i', [_vm._v("Saul was one year old when he became king, and he reigned two years over Israel")]), _vm._v(" (see 1 Samuel 10:6); some Greek manuscripts give Saul’s age when he began to reign as thirty years "), _c('b', [_vm._v("b")]), _vm._v(" Or "), _c('i', [_vm._v("leader")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("The rest of the people… from Gilgal")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("plowshare")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Hebrew "), _c('i', [_vm._v("was a pim")]), _vm._v(" "), _c('b', [_vm._v("f")]), _vm._v(" A "), _c('i', [_vm._v("shekel")]), _vm._v(" was about 2/5 ounce or 11 grams "), _c('b', [_vm._v("g")]), _vm._v(" The meaning of the Hebrew verse is uncertain "), _c('b', [_vm._v("h")]), _vm._v(" Or "), _c('i', [_vm._v("under the pomegranate")]), _vm._v(" [tree] "), _c('b', [_vm._v("i")]), _vm._v(" Septuagint "), _c('i', [_vm._v("Do all that your mind inclines to")]), _vm._v(" "), _c('b', [_vm._v("j")]), _vm._v(" Hebrew "), _c('i', [_vm._v("a yoke")]), _vm._v(" "), _c('b', [_vm._v("k")]), _vm._v(" Or "), _c('i', [_vm._v("became a panic from God")]), _vm._v(" "), _c('b', [_vm._v("l")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("they went here and there")]), _vm._v(" "), _c('b', [_vm._v("m")]), _vm._v(" Hebrew; Septuagint "), _c('i', [_vm._v("“Bring the ephod.” For at that time he wore the ephod before the people")]), _vm._v(" "), _c('b', [_vm._v("n")]), _vm._v(" Hebrew "), _c('i', [_vm._v("land")]), _vm._v(" "), _c('b', [_vm._v("o")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("this day")]), _vm._v(" "), _c('b', [_vm._v("p")]), _vm._v(" Vulgate and Septuagint; Hebrew "), _c('i', [_vm._v("Therefore Saul said to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, “Give Thummim.”"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers see the beginnings of Saul’s eventual downfall in this section of the biblical narrative. They do not agree, however, as to the exact cause, and they offer various reasons why Saul does not prove to be a godly king. While most commentators focus on Saul’s shortcomings, some "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2843"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2844"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2845"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2846"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2847"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2848"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2849"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2850"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2851"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2852"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page56",
      "title": "56"
    }
  }), _vm._v("also apply lessons from his life to our own, exhorting us to become people who are sincere and without hypocrisy. Jonathan, however, is the real hero in this section. The reformers recognize the juxtaposition the biblical authors make between Jonathan and Saul. Sensitive to the misuse of vows before and during their time period in the Catholic Church, the reformers interpret Jonathan’s breaking of Saul’s vow as more an example of a rash decision on Saul’s part than a faulty action on Jonathan’s.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_68"
    }
  }, [_c('b', [_vm._v("13:1-7")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Beginning of Saul’s Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Character Not the Chronology of Saul’s Reign.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" According to the Hebrew the words are: “Saul, a one-year-old son, in his reign.”"), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-296-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" That is, according to the image of a one-year-old son Saul ruled innocently. Accordingly it describes the character of his reign and says nothing about the beginning of his reign.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“And for two years he reigned over Israel.” Immediately the question concerning the truth of these words occurs. For it is evident that Saul waged so many wars, which are narrated below, thus witnessing to the fact that his reign included many more years. And the apostle Paul in Acts 13 clearly says that Saul reigned forty years. Although Josephus, at the end of book six of the "), _c('i', [_vm._v("Antiquities")]), _vm._v(", says that Saul reigned twenty years—eighteen while Samuel was alive and two after Samuel’s death. The solution is that in this passage the years of Saul’s reign are not calculated absolutely, but, as it was said before, the years are calculated by the character of his reign. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-295-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Is a Supreme Example of Self-Deception.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Thus far we have seen the gifts of God in Saul, and no one would have any reason to suspect any evil of him. But a person’s heart is deep and inscrutable, even to himself. Real and unavoidable afflictions reveal this. Therefore what follows reveals Saul’s hypocrisy and impiety. He looks after himself, not trusting in God and becoming a person of blood against his neighbors. All who do this are hypocrites, imposing human judgments under the form of holiness to suit the occasion. We can see this all the way to Saul’s death. He is someone who rules and administers without faith. He has gifts from God but misuses them, which is to say, he does not have faith in God and does not fear God. You will not find anything in Saul’s story that smacks of faith in God. One sees nothing but sheer mistrust, thoughtlessness, hypocrisy, and ambition, even though the king should be the best in all things. You will not easily find another example that uncovers the hypocrisy of the human heart. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-294-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Reign of Tyranny.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" What a humble man was Saul before he was king, and in the first beginning of the kingdom! But afterward, being confirmed in his kingdom, what a tyrant did he prove to be? Therefore, it is said that Saul reigned but two years, because after the two first years, though he held the government still in his hands, his deceitful heart was discovered, and he no longer reigned but tyrannized. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-293-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_69"
    }
  }, [_c('b', [_vm._v("13:8-23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Unlawful Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Temptation.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Saul’s temptation is described. The people were scattering, and Saul did not expect Samuel to arrive. Mistrust disguised as necessity compelled Saul to sacrifice, against the word of God. Hypocrisy does not believe the word of God but takes refuge in works and despairs. And then even the attempt to placate God is itself a way of dishonoring God, as you will see in chapter 15. Anyone who fears the seeming necessity of the moment more than they fear the Lord always acts foolishly. Such "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2853"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2854"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2855"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2856"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2857"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2858"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2859"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2860"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2861"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page57",
      "title": "57"
    }
  }), _vm._v("are all the works and even worship of those who do not receive the word of God, “for whatever does not proceed from faith is sin.” For this reason, God rejects Saul because Saul had rejected God. But Saul does not see this judgment in the world, for he reigned among the people for forty years, as Paul says. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-292-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Reign Serves as a Warning.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Saul, the first king of Israel, was very fortunate and victorious as long as he followed the word of God in all things. However, once he gave place to his own good intentions, being rejected by God, he heard Samuel essentially announce to him: “You have refused and rejected the word of the Lord; therefore, the Lord has also rejected you from being king over Israel.” I will not explain here the amount of evil he was involved in from that time. For, as he himself was horribly agitated by an evil spirit, so he did not cease to agitate and torment his kingdom until he had brought them all into great danger when he and his soldiers were crudely taken down by the pagan nations, leaving behind an eternal and shameful legacy. "), _c('i', [_vm._v("Decades 3.1.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-291-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Where Saul Offended.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think Saul’s sin at this time was distrust in God’s help and assistance, because the people fell away from him—as though the Lord could not save as well with few as with many. It is similar to the plight of Moses when he was not allowed to go into the land of Canaan because he doubted God’s power and did not believe him when he struck the rock. But there was another special sin with which Samuel charged Saul, namely, that he had broken the commandment of God. Or it may be thought that Saul had an evil opinion of Samuel—that Samuel failed in his promise and that he forgot the time he had appointed for Saul. . . . Some think Saul broke Samuel’s charge in that he did not stay for him a full seven days, but in the beginning of the seventh day he offered sacrifice. For as soon as he had made an end of sacrificing, Samuel came. But it seems that this was not the greatest matter: For whereas Saul exonerated himself by claiming that Samuel had not come at the day set, Samuel answered nothing and only charged him with the breach of God’s commandment. Therefore there were two parts of Samuel’s charges: first, that he should wait for Samuel for seven days; second, that he should attempt nothing before Samuel came: “Seven days you shall wait, until I come to you and show you what you shall do.” Saul offended more in the second than in the first. That is, he presumed of himself, without direction from the prophet Samuel, to command sacrifice to be offered—thinking that God would be pleased with the external act of sacrificing, which apparently was not made in faith or obedience. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-290-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Taking Before Punishing.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Just as when Saul had lost his spirit the kingdom did not last long without him, so if our talents are once taken away, we may perceive that God will lay a punishment on our persons. If we fall from our first love . . . and do not use our talents to God’s glory, we may justly fear our persons. But as God first commanded Lot to go out of Sodom before he destroyed the city itself, so God will first take away the talent so that it will not perish; and afterward the person will be punished. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-289-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Man of Sincerity.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" The special hatred and antipathy that is in God against deceitfulness should be a strong motive for us to show sincerity. There can be no union between God and the hypocrites in regard to the great dissimilitude of disposition. God is single; he is not double. We are to be as David, a person according to God’s heart. The hypocrite is crooked, and God is straight. And how will you connect these "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2862"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2863"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2864"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2865"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2866"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2867"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2868"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2869"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2870"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page58",
      "title": "58"
    }
  }), _vm._v("together, and make something straight and crooked? How can there be friendship between those who are every way of contrary dispositions? But where there is likeness of manners, there easily will be hearts that are glued and riveted together. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-288-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Cold Religion.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Saul took the priest with him when he went to battle. . . . Although there was an outward appearance of religion, it was very coldly and grudgingly performed. We must realize that it takes far more than making a formal profession and merely declaring that we are God’s people and want to serve him. When we hear what was pronounced by the Spirit of God, it should encourage us to seek him voluntarily, and not in such a cold manner. If someone had asked all the people in the time of Saul, “Do you not want to seek God?” each one would have replied, “Yes, this is my intention.” But so what? God disdained their talk, and declared that they were despising and rejecting him, and in fact denying him. Why? Because they had no zeal and no pure and true affection for him. Let us therefore be careful not to seek God halfway. On the contrary, let us earnestly seek his face, driving ourselves forward as we realize that he is the mainspring of our whole life, on whom we must concentrate all our thoughts and study in order to be pleasing to him. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-287-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Fickle Faith.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Seeing the Philistines routed, the rest of the Hebrews went to join up with the army. This is a sign of those people who come to the gospel while it is in full bloom but who leave under the cross. It is a sign of those who believe for a time but then fall away in the time of trial. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-286-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Glorious Victories.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" And just as the servant of Jonathan, who was Saul’s son, dispatched and killed those whom his master had cast down, in the same way we need only pursue the glorious victories of the son of the King of kings, or rather, we need only gather up the pleasant fruits of his conquests. For this prince of life that has overcome death for us offers to overcome it also in us with the weapons with which he arms us. In short, to speak properly, there can be no death for those who are incorporated in Jesus Christ by a true and lively faith. For the one who lives and believes in him shall never die; and the one who believes in him, though he were dead, yet he shall live. "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-285-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Jonathan’s Creeping up the Hill.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some believe that where it is said that Jonathan went up on his hands and feet, the meaning is that he went up with all his strength. However, this passage merely shows the manner of his climbing up: Because the place was steep, he was said to creep up it on all fours and to take hold with his hands and feet. He went up the hill with much patience rather than in haste. For he could not make great haste when going up so steep a rock. But it is further to be considered [that Jonathan and his armor-bearer climbed right up the Philistine garrison in plain sight]. This rare adventure and hard enterprise shows that God was with them and that he assisted them far beyond their own strength. Foreign histories highly commend Alexander’s taking of Aornos when he sent up his soldiers onto those steep rocks on their hands and feet. But more worthy is the memory of Jonathan who, with much less power than Alexander had, succeeded in a harder work and achieved a greater victory—since he had such confidence in his God, who intended nothing but victory from and praise for him. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-284-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_70"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2871"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2872"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2873"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2874"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2875"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2876"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2877"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page59",
      "title": "59"
    }
  }), _c('b', [_vm._v("14:1-52")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Offense")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Is Like Jephthah.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Here you see hypocrisy even among those who reign and judge and who otherwise are supposed to be near to God and seek nothing but God’s glory. As proof, you have this example of a rash vow or oath, which was just like that of Jephthah. I wonder what good this vow was supposed to do, not only in itself but also inasmuch as it endangered all the people? Jonathan, full of faith, wondered the same thing when he reproved his father’s actions, saying, “My father has troubled the land,” etc. Because of this rashness, God immediately reproved Saul for this vow to strike down even his own innocent and holy child, in order to show that it was just as impious and destructive as that of rash Jephthah, who did not know that he was so painfully obligating himself to the Lord to sacrifice his daughter. The people were right to identify as an injustice the king’s rash vow to condemn the innocent. The same is true of all of our rash vows made without faith and in hypocrisy, when we (if such a thing were possible) offer our own souls to the devil in the name of God’s glory. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-283-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Concerning Oaths.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Jonathan is not to be considered the special offender at whom God should here shoot, as God, on a similar occasion, brought Achan’s sin to light (Judg 7). So neither is he to be altogether excused: For although it is a sin to make a rash oath and vow to begin with, it is also a fault to break such a rash oath. Yet it is a greater sin to keep it with greater inconvenience and hurt. And ignorance, though it qualifies the offense, does not altogether justify it. Ignorance excuses from so great a fault, but not from the entire fault. As the Preacher says, “It is better that you should not vow than that you should vow and not pay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We must therefore consent that Jonathan was somewhat faulty in breaking the oath, though ignorantly, because the lots fell out justly. Yet Saul was faultier in making it in the first place. For the Lord does not by this lot show who was most at fault, but only who it was that had broken the oath—which was the thing Saul earnestly requested. But though Jonathan was somewhat touched in this action, as his own heart misgives him—which the disposing of the lots and his own confession reveal—yet it was not God’s principal intention to uncover the offense of Jonathan as it was to lay open Saul’s hypocrisy, which damaged his own son, troubled the soldiers and hindered the victory. Yet it was also by this means that God would humble Jonathan, lest he become too puffed up with the joy of his victory. Finally, it must be considered that, as God by lot brought Jonathan to light and so into this danger, yet God also provided a means whereby Jonathan should escape it, namely, by the mediation of the people. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-282-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Innocent and Faultless.")]), _vm._v(" "), _c('i', [_vm._v("The English Annotations:")]), _vm._v(" Jonathan really and truly was innocent and faultless, but not in Saul’s sense. But why is Jonathan taken by lot since he was innocent? First, some think that God acted in this way to show how severe he is in allowing any show of disobedience to princes. Second, to make children fear and avoid even the rash and causeless curses of parents, which out of God’s secret judgment are sometimes inflicted. Third, to punish Saul’s rash oath by bringing his dearest son into extreme danger. And finally, to discover Saul’s great hypocrisy, who scrupulously kept a rash and wicked oath but was not reluctant to kill his innocent son. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-281-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2878"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2879"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2880"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2881"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2882"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2883"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2884"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page60",
      "title": "60"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_71"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("15:1-35")]), _vm._v(" THE REJECTION OF SAUL BY THE LORD")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Samuel said to Saul, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent me to anoint you king over his people Israel; now therefore listen to the words of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Thus says the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts, ‘I have noted what Amalek did to Israel in opposing them on the way when they came up out of Egypt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now go and strike Amalek and devote to destruction")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("all that they have. Do not spare them, but kill both man and woman, child and infant, ox and sheep, camel and donkey.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("So Saul summoned the people and numbered them in Telaim, two hundred thousand men on foot, and ten thousand men of Judah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And Saul came to the city of Amalek and lay in wait in the valley.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Then Saul said to the Kenites, “Go, depart; go down from among the Amalekites, lest I destroy you with them. For you showed kindness to all the people of Israel when they came up out of Egypt.” So the Kenites departed from among the Amalekites.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And Saul defeated the Amalekites from Havilah as far as Shur, which is east of Egypt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And he took Agag the king of the Amalekites alive and devoted to destruction all the people with the edge of the sword.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("But Saul and the people spared Agag and the best of the sheep and of the oxen and of the fattened calves")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("and the lambs, and all that was good, and would not utterly destroy them. All that was despised and worthless they devoted to destruction.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("The word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("came to Samuel:")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("“I regret")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("that I have made Saul king, for he has turned back from following me and has not performed my commandments.” And Samuel was angry, and he cried to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("all night.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And Samuel rose early to meet Saul in the morning. And it was told Samuel, “Saul came to Carmel, and behold, he set up a monument for himself and turned and passed on and went down to Gilgal.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And Samuel came to Saul, and Saul said to him, “Blessed be you to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". I have performed the commandment of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And Samuel said, “What then is this bleating of the sheep in my ears and the lowing of the oxen that I hear?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Saul said, “They have brought them from the Amalekites, for the people spared the best of the sheep and of the oxen to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God, and the rest we have devoted to destruction.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("Then Samuel said to Saul, “Stop! I will tell you what the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to me this night.” And he said to him, “Speak.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And Samuel said, “Though you are little in your own eyes, are you not the head of the tribes of Israel? The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("anointed you king over Israel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent you on a mission and said, ‘Go, devote to destruction the sinners, the Amalekites, and fight against them until they are consumed.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Why then did you not obey the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("? Why did you pounce on the spoil and do what was evil in the sight of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And Saul said to Samuel, “I have obeyed the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". I have gone on the mission on which the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sent me. I have brought Agag the king of Amalek, and I have devoted the Amalekites to destruction.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("But the people took of the spoil, sheep and oxen, the best of the things devoted to destruction, to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God in Gilgal.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And Samuel said,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("“Has the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("as great delight in burnt offerings and sacrifices,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("as in obeying the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("Behold, to obey is better than sacrifice,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and to listen than the fat of rams.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")])]), _c('i', [_vm._v("For rebellion is as the sin of divination,")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("and presumption is as iniquity and idolatry.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("Because you have rejected the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "verseindent"
  }, [_c('i', [_vm._v("he has also rejected you from being king.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Saul said to Samuel, “I have sinned, for I have transgressed the commandment of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and your words, because I feared the people and obeyed their voice.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Now therefore, please pardon my sin and return with me that I may bow before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And Samuel said to Saul, “I will not return with you. For you have rejected the word of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has rejected you from being king over Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("As Samuel turned to go away, Saul seized the skirt of his robe, and it tore.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("And Samuel said to him, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has torn the kingdom of Israel from you "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2885"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2886"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2887"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2888"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2889"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2890"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page61",
      "title": "61"
    }
  }), _c('i', [_vm._v("this day and has given it to a neighbor of yours, who is better than you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("And also the Glory of Israel will not lie or have regret, for he is not a man, that he should have regret.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("Then he said, “I have sinned; yet honor me now before the elders of my people and before Israel, and return with me, that I may bow before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("So Samuel turned back after Saul, and Saul bowed before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("Then Samuel said, “Bring here to me Agag the king of the Amalekites.” And Agag came to him cheerfully.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("Agag said, “Surely the bitterness of death is past.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("And Samuel said, “As your sword has made women childless, so shall your mother be childless among women.” And Samuel hacked Agag to pieces before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("in Gilgal.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("Then Samuel went to Ramah, and Saul went up to his house in Gibeah of Saul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("And Samuel did not see Saul again until the day of his death, but Samuel grieved over Saul. And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("regretted that he had made Saul king over Israel.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" That is, set apart (devote) as an offering to the Lord (for destruction); also verses 8, 9, 15, 18, 20, 21 "), _c('b', [_vm._v("b")]), _vm._v(" The meaning of the Hebrew term is uncertain "), _c('b', [_vm._v("c")]), _vm._v(" See also verses 29, 35 "), _c('b', [_vm._v("d")]), _vm._v(" Or "), _c('i', [_vm._v("haltingly")]), _vm._v(" (compare Septuagint); the Hebrew is uncertain"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" Focusing on Samuel’s rebuke of Saul, the reformers remind us that human reason can easily deceive us. Even though Saul thought he was acting mercifully toward Agag, the interpreters understand his actions differently. Divine obedience, they assert, takes precedence over everything else. Drawing a point of application from Saul’s lack of obedience, some of the reformers warn readers about the dangerous consequences of not mortifying the flesh, that is, of not constantly pruning the evil that lies hidden within all of us. They also applaud the pastoral spirit of Samuel toward Saul despite the latter’s wickedness. Finally, the commentators take great pains to clarify what it means for God to repent or regret an action.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_72"
    }
  }, [_c('b', [_vm._v("15:1-8")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Feigned Obedience")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Would-Be Mercy.")]), _vm._v(" "), _c('i', [_vm._v("Menno Simons:")]), _vm._v(" How little the Word of the Lord is regarded which says, “You shall not do after that which is right in your own eyes, but observe whatsoever I command you.” Did not the Father testify from heaven and declare, “This is my beloved Son in whom I am well pleased; listen to him?” Does not the whole Scripture direct us to Christ? Are we not baptized in his name that we should hear his voice, and be obedient to his Word? Do you not boast to be the apostolic church? Why then do you go from Christ and antichrist and from the apostolic doctrine and practice to that of the learned ones? Observe how severely and frequently God has punished human inventions they considered holy transactions and religion! . . . Saul had mercy on Agag, the king of the Amalekites, and prompted by his invention he spared the best and fattest sheep and oxen to sacrifice to the Lord, contrary to the word of the prophet. That act of would-be mercy and illustrious zeal was punished as a sin of witchcraft and idolatry because he acted according to his own invention and not according to the word of the prophet. He was reproved by the prophet, smitten with pestilence, and his kingdom was taken from him and given to a more faithful man. "), _c('i', [_vm._v("Foundation of Christian Doctrine.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-280-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Rejecting Blind Reason and Good Intentions.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Saul’s otherwise most generous-looking actions reveal his impiety. It is nothing but blind human reason, which sees nothing here but piety and is therefore deceived by the appearance of holiness. According to God’s Word, Saul struck down the impious and led his people to victory through God, whom he appeared to serve as king among the people. If, as everyone knew, he was going to use the cattle piously for sacrifice and for worshiping God, then what can be condemned about this? Who would not commend "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2891"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2892"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2893"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2894"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2895"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2896"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2897"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page62",
      "title": "62"
    }
  }), _vm._v("him as a great king in the sight of the people and pious in the sight of God? But this has been written so that we learn not to follow blind reason but truly fear God’s judgment, so that we do not forsake God’s Word on account of our good intentions and our contrived worship of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-279-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("More Merciful Than God.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Saul committed his first transgression when God sent him to destroy the Amalekites. . . . He was not supposed to spare anything, yet he preserved the king in order to show him off. . . . He was not content merely with sparing the people but . . . also wanted the keep the cattle—either out of avarice or ambition, or for some other reason. He had been told that if he had disobeyed God’s command, evil would rebound on him, and that condemnation would fall on his head. . . . Then he was shown by the prophet Samuel that obedience is better than all the sacrifices in the world; and to obey God’s voice is far better than the fat of sheep. . . . Here, then, was Saul’s sin. He wished to be more merciful than God. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-278-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_73"
    }
  }, [_c('b', [_vm._v("15:9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Killing Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Turning Against All Sin.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" This, then, we must first and principally remember—to set ourselves against all sin. In confession, we are not to lie; in supplication, we are not to stop; in conversion, we are not to forget anyone. Never give up so long as any remains. . . . When people kill snakes or vipers, they do not stop striking them until certain they are dead. Sin, like the thief on the cross when it is fast nailed and kept from its old tyranny, will, as much as it can, revile and spit out venom on Christ. Therefore do not give in; break its legs; crucify it clean through till it is quite dead. None can pray or turn to God in truth or hope to be delivered from judgment in mercy so long as he holds fast any known sin. Can any person look to receive benefit by the blood of Christ who hugs the enemy that shed it? Is it not treason to knowingly harbor and entertain a traitor? Whoever loves and holds fast to sin lies to God in every prayer that he makes. This proves and humbles us for our hypocrisy and halving with God in our conversions from sin and confessions of it. We are willing to pray for the pardon of them all; we would have none hurt us. But when it comes to parting and taking all away, this we cannot get away. Some are fat and delicate golden sins. We must not spare these, as Saul did Agag. "), _c('i', [_vm._v("Seven Sermons on the Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-277-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Killing Secret Desires.")]), _vm._v(" "), _c('i', [_vm._v("Johann Arndt:")]), _vm._v(" Saul cast Agag . . . into prison, although according to God’s commandment he was to have killed him. In the same way, many people secretly conceal their desires that they should kill. It is not enough that you hide away your lusts; you must kill them or you will be cast out of the kingdom as Saul was, that is, out of eternal life.” "), _c('i', [_vm._v("True Christianity.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-276-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Destroying Our Flesh.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" Though your feelings, desires and motions are good, and do not always come from devilish illusion—but from the spirit of God—they are not sufficient. It is good and well that you have spiritually surpassed those who do not know what these kinds of feelings mean. It is good that you are not treading on thorny or stony ground but are nearer to the good ground. But so what? Because you have come thus far in the way, will you go no further? Do you therefore think yourself well enough? No, as our Savior said to the young man, so I say to you: “One thing you still lack”: There lies in you some leaven of hypocrisy that must be purged out; some root of bitterness that must be weeded up; some thorn of covetousness, pride and vainglory that must be cut down. . . . You have many wonderful graces, and they make you to shine as a wonderful and beautiful temple of the Holy Spirit. Only one thing is lacking: There is "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2898"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2899"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2900"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2901"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2902"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2903"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2904"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2905"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2906"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2907"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page63",
      "title": "63"
    }
  }), _vm._v("some error in the foundation. It is sandy, and you must dig a little deeper. You need to get a little more humility of spirit and truth and purity of heart; or else, when a storm comes, all your other labor about the building will be lost. I am the more earnest in this exhortation because of those fearful shipwrecks that many ships, richly laden with many precious jewels of grace, have suffered in all ages on this rock of an evil and unrenewed heart. Take heed of it, then, as the very bane and poison of all grace, and so the only cause of those many deceits of temporary believers. Enter, therefore, into those dark parts of your heart, take the light of the world in the one hand and the sword of the spirit in the other: and whatever Agagite or Amalekite that light discovers, kill, spare none, with Saul, make havoc of all a universal destruction. Save only one thing: yourself. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-275-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Level and Random Shots.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" The natural conscience shoots only by aim and level against some sins and spares the rest, as Saul in the slaughter of the Amalekites. But the spiritual conscience shoots by level against not only particular notorious sins but collectively as well, against the whole army of sin. And it is by this means that our lusts are wounded and weakened, which it did not distinctly observe in itself by complaining to God against the body of sin by watching over the course and frame of the heart by acquainting itself out of the Word with the armor and devices of Satan. The opposition, then, between the natural conscience and sin is like the opposition between fire and hardness in some subjects, while the conflict between the spiritual conscience and sin is like the opposition between fire and coldness. Put metal into the fire and the heat will dissolve and melt it: but put a brick into the fire and it will neither melt nor soften. . . . However, if you put either one or the other into the fire, the coldness of it will be removed. "), _c('i', [_vm._v("The Sinfulness of Sin.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-274-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_74"
    }
  }, [_c('b', [_vm._v("15:10-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Lord’s Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Not a Christian.")]), _vm._v(" "), _c('i', [_vm._v("John Knox:")]), _vm._v(" Where God says, “I regret that I have made Saul king,” he does not mean that Saul at any time was a member of Christ’s body; he means only that he was a temporal officer, promoted of God and yet most disobedient to his commandment. Therefore God would provide another to occupy his office. And where God says, “I regret,” we must understand him to speak after the manner of mortals, accommodating himself to our understanding. God did not repent, because his majesty knew the disobedience and rebellion of the wicked king beforehand. And so . . . God the Father cannot regret that he has engrafted us as members of Christ’s body. Otherwise God would regret the honor of his own Son and thereby his own good work in us. "), _c('i', [_vm._v("Letters.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-273-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How the Lord Is Said to Repent.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" God is properly not said to repent as a person repents (1 Sam 15:29). And although the passage says that God repented, this is a literary phrase spoken in a way that humans can understand. From our perspective, God is said to repent when anything goes contrary to his temporal election. That is, God is said to repent not in respect of his counsel—which is constant and immutable, even in things that are mutable—but in respect of the thing that is altered and changed, which God himself decreed should be changed. As Augustine says, “The repentance of God is an unchangeable course of changeable things.” This is the case here. God did not change in regard to Saul, for God had decreed that the kingdom should not continue in his posterity. Rather, it was Saul who changed in forgetting his duty and obedience toward God. So God’s decree concerning Saul was unchangeable: He foresaw that Saul would fall away and decreed the change of the kingdom. But though Saul was changeable—and the kingdom did change—God’s decree remained unchangeable. Here repentance is joined with grief. By this is signified the Lord’s grief, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2908"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2909"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2910"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2911"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page64",
      "title": "64"
    }
  }), _vm._v("as it were, for Saul, for Saul’s disobedience made himself unworthy of the kingdom. Indeed, human beings often change. For as they are mutable creatures, so they have changeable minds. What’s more, things occur otherwise than what people sometimes think. But God is of an immutable nature. His foreknowledge cannot be frustrated or deceived. Nor can anything occur other than what he has decreed. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-272-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Accommodation to Humankind.")]), _vm._v(" "), _c('i', [_vm._v("John Knox:")]), _vm._v(" The Spirit of God must accommodate and submit himself oftentimes to our weakness and speak to us who, by corruption, are made ignorant and vulgar, so that we may understand what he works by his incomprehensible wisdom and inscrutable providence. For instance, there is no such thing as our God having a mouth to speak vocal words as the first sense appears in David’s statement: “O Lord, rebuke me not in your anger.” Indeed, many other places of Scripture attribute to God not only such body parts as human beings possess but also such affections and unstable passions that nevertheless are not in God, who always in himself remains stable, constant, holy and just. And of that sort is that manner of speech, “I regret that I have made Saul king.” That is to say, “My justice is compelled to reject and throw down the rebellious king from that estate and dignity in which I have placed him; and so I shall "), _c('i', [_vm._v("appear")]), _vm._v(" to repent of my former work.” The Scripture attributes to God such conditions, qualities and affections as his majesty "), _c('i', [_vm._v("appears")]), _vm._v(" to show in his works on his creatures. As when he plagues the world, Scripture says, “God did it in his anger.” When he delivers those who have long suffered trouble, the Scripture states, “God stretched out his hand” or “God lifted up his eyes, his face or countenance.” Yet no such thing can be in the Godhead. And therefore . . . do not think that God is changeable and repents or regrets, although it appears thus; for the Scripture speaks this way to instruct our weakness. For before God appointed Saul to be king, his majesty knew his disobedience and how he was to be subjected. Nor did Saul please God in Jesus his Son, but Saul was always reprobate and never embraced the promise of remission of sins and reconciliation in such promises, although the Lord did promote him to worldly dignity. However, this is no sure sign of God’s everlasting love and favor, given that the ungodly are oftentimes placed alongside the godly. "), _c('i', [_vm._v("Letters.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-271-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_75"
    }
  }, [_c('b', [_vm._v("15:12-21")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Pride in Saving Part of the Spoil")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Love of Self.")]), _vm._v(" "), _c('i', [_vm._v("Johann Gerhard:")]), _vm._v(" Sacrifice was an acceptable work to God in the Old Testament. Nevertheless, God was not pleased that Saul set apart the spoils of the Amalekites to offer sacrifice to God. Why? Because this did not proceed from the love of God. For if Saul had truly loved God, he would not have held in contempt the commandment of God to burn the spoils. Rather than loving God, Saul loved himself and his own devotion. "), _c('i', [_vm._v("Sacred Meditations.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-270-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Saul’s Excuse and Defense.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Saul’s hypocrisy is discovered. He boasts that he had fulfilled God’s commandment, whereas he had really transgressed it. This is the manner of hypocrites: They say they have fulfilled the commandment of the Lord when in reality they have not. Saul excuses himself by laying the fault on the people and putting it away from himself. He cloaks and colors his covetousness with a pretense of zeal and religion, as though he had spared the best things for sacrifice. He afterward justifies his sin, as though he had for all this done well and obeyed the voice of God. Ultimately he does make a semblance of sorrow and repentance, but it was far from true submission. Saul does this on a vain ostentation, only desiring that Samuel would honor him before the people. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-269-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_76"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2912"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2913"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2914"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2915"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2916"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2917"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2918"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page65",
      "title": "65"
    }
  }), _c('b', [_vm._v("15:22")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God Desires Obedience")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Nothing Without God’s Word.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" Do nothing without God’s word. And to his word add nothing, nor pull anything from it. . . . Serve God in the Spirit, and serve your neighbor with all outward service. Serve God as he has appointed you, and not with your good intent and good zeal. Remember that Saul was cast away of God forever for his good intent. God requires obedience to his word, and he abhors all good intents and good zeal that are without God’s word, for they are nothing else than plain idolatry and the worshiping of false gods. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-268-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Don’t Ask Why.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" Therefore let no one add this detestable and fatal little word "), _c('i', [_vm._v("why")]), _vm._v(" to God’s commands. But when the command is certain, let us obey at once without any argument, and let us conclude that God is wiser than we are. He who argues about why God gives a particular command actually doubts that God is wise, just and good. What sin can be more hideous and more intolerable to God? Therefore we must believe—this is part of our duty—and not argue, for these matters are too lofty for us to be able to argue about them. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-267-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_77"
    }
  }, [_c('b', [_vm._v("15:23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Idolatry Is Divination")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On True Obedience.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" At this point there arises an opportunity to discuss obedience, which is extolled to such an extent in the monasteries that no monk has been too unlearned not to leave some writing about it. And in his decretals the pope puts greater stress on obedience to his laws than on anything else. As a result, the statement of Samuel has been heard from every pulpit: “To obey is better than sacrifice. Rebellion is as a sin of divination.” To this true statement they appended the inference: “Hence no kind of life is better than that of the monks.” Surely a fine conclusion, which, as used to be said in the schools, has the force of the argument from the staff to the corner. . . . True obedience is not to do what you yourself choose or what you impose on yourself, but what the Lord has commanded you through his Word. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-266-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Sin of Divination.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" Idolatry is a sin against God’s majesty. It’s not the case that all sins are equal or alike. The meaning of the passage is that idolatry is a sin against God, which is also repugnant and contrary to his will, to the truth and to the glory of his nature and essence. In fact, magic arts and idolatry are alike, and therefore deserve the same punishment that is due to all sin: namely, death. At the same time there are degrees of severity to God’s justice. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-265-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Rebellion Is the Sin of Witchcraft.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" In order to amplify Saul’s sin, Samuel compares it with two great transgressions: soothsaying and divining by magical predictions and committing idolatry. Samuel touches on two kinds of idolatry: the first one being inward in the superstition of the mind, which signifies a lie or a falsehood. The Septuagint refers to this as injustice or unrighteousness, but it is properly applied to false worship. The other kind of idolatry is the outward adoration of idols, here called "), _c('i', [_vm._v("teraphim")]), _vm._v(". Some think a comparison is made here not of the sins but of the punishment: that rebellion deserves capital punishment as much as either idolatry or soothsaying. But the prophet speaks directly of the sin itself, as before of the virtue of obedience: “to obey is better than sacrifice.” Samuel must be understood not to speak of transgressions—either of ignorance or infirmity—but of the sin of obstinacy, contumacy and rebellion. Such are the sins of those who know the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2919"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2920"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2921"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2922"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2923"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2924"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2925"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2926"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2927"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2928"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2929"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page66",
      "title": "66"
    }
  }), _vm._v("will of God but willfully resist it. For this proceeds from the same cause, namely, infidelity—which is the corollary sin of witchcraft and idolatry. The one who does not fear to break God’s commandments does not acknowledge the Lord to be God. Further, such people actually make themselves wiser than God, as though they could discover a better way than the Lord had prescribed. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-264-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_78"
    }
  }, [_c('b', [_vm._v("15:24-26")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Difference Between Saul and David’s Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Same Words but Different Hearts.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" David’s word to Nathan (2 Sam 12:13), “I have sinned,” must be understood altogether differently from the word of Saul, who likewise said to Samuel: “I have sinned.” It is indeed the same word, the same voice and face of compunction or repentance, but the hearts are very different. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-263-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Smelling of Pride.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" To cover and conceal sin is a double sin; and not to confess it plainly is partly pride and presumption, or else servile fear and despair. The sinners fear, lest they should have to confess all to God. This assumes that God has no goodness or mercy, and that it is not enough to forgive them. Or else these sinners conceal their sins out of pride, presuming that God cannot see and find out that which they do and hide from the eyes of people. . . . In short, pride makes people ashamed to confess their sins, or else so to confess that one may see a plain difference between the confession of a proud sinner and a poor, humble sinner; the difference between the confession of the good and faithful, and confession of evil and unfaithful. This is the difference between Saul’s and David’s confessions. Saul’s confession smells of pride. . . . “I have sinned,” he says, “yet honor me.” That is, he would so confess his sin that he might keep his credit and have his reputation, and not to lose one jot of either. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-262-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Failure to Acknowledge Sin.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" There was great difference between Saul’s repentance here and David’s, who forthwith confesses: “I have sinned.” David, as soon as his sin was shown to him, confessed it. But Saul is hardly brought to acknowledge his sin. Indeed, he is an example of slow and late repentance. He does not make a simple and plain confession, but minces and extenuates his sin, because he feared the people, and so at their instigation did as he did. It is very hard for hypocrites to be brought to make a true confession of their sin. Instead, they prefer to lay the fault on others. Saul only confesses his sin out of the fear of losing the kingdom rather than for the grief that he had offended God: For till such time as Samuel had said that the Lord had rejected and cast him off, Saul would not confess himself as guilty. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-261-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_79"
    }
  }, [_c('b', [_vm._v("15:27-29")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Kingdom Torn")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Doubt About God’s Constancy.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" We should have said enough concerning God’s providence to achieve the perfect instruction and comfort of believers (for nothing whatsoever can be sufficient to satisfy the curiosity of vain people, nor ought we want to satisfy it) if certain passages did not stand in the way. These seem to suggest, contrary to the above exposition, that the plan of God does not stand firm and sure, but is subject to change in response to the disposition of things below. . . . Hence many contend that God has not determined the affairs of humans by an eternal decree, but that, according to each person’s deserts or according as he deems fair and just, he decreed this or that each year, each day and each hour. Concerning repentance, we ought so to hold that it is no more chargeable against God than is ignorance, or error, or powerlessness. For if no one "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2930"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2931"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2932"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2933"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2934"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2935"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2936"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2937"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page67",
      "title": "67"
    }
  }), _vm._v("willingly and wittingly puts themselves under the necessity of repentance, we shall not attribute repentance to God without saying that he is ignorant of what is going to happen, or cannot escape it, or hastily and rashly rushes into a decision of which he immediately has to repent. But this is far removed from the intention of the Holy Spirit, who in the very reference to repentance says that God is not moved by compunction because he is not a man so that he can repent. And we must note that in the same chapter both are so joined together that the comparison well harmonizes the apparent disagreement. When God repents of having made Saul king, the change of mind is to be taken figuratively. A little later it is added: “The strength of Israel will not lie, nor be turned aside by repentance; for he is not a man, that he may repent.” By these words openly and unfiguratively God’s unchangeableness is declared. Therefore it is certain that God’s ordinance in the managing of human affairs is both everlasting and above all repentance. And lest there be doubt as to his constancy, even his adversaries are compelled to render testimony to this. "), _c('i', [_vm._v("Institutes 1.17.12.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-260-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How the Kingdom Is Torn from Saul.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" By this present occasion of tearing the piece of Samuel’s garment, Samuel confirms God’s former sentence in the rejection of Saul. It’s not that he was immediately deposed, for he continued being king until his dying day. Rather, he was deprived of the right of the kingdom, which was given to David. Accordingly, although the kingdom was not immediately taken from his own person, it was taken from his posterity and succession. And this is how we can insinuate the violent death of Saul, who should by force be pulled from the kingdom and taken from it. And whereas David is said to be better than Saul, it is not understood of any difference in their nature—for we are all by nature the children of wrath. Nor is their difference so much in respect of outward works, which—in some of them—David offended more than Saul. But this difference is to be taken, first, in respect of God, of whom David was better accepted and more favored and his sins pardoned; and, second, in respect of David, who had a more obedient heart wrought in him by grace to do the will of God and to seek and set forth God’s glory. However, Saul’s heart was not like this, but was rather averse and estranged from God. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-259-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Not Using God’s Things.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" When God threatened . . . Saul, he did not intend for there to be no more kings or turn back the kingdom to the former state of judges: no, only the kingdom would lose Saul, but Israel would not lose the kingdom. It is a clear testimony in nature that things dedicated to God should not be used by people. "), _c('i', [_vm._v("The Temple.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-258-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_80"
    }
  }, [_c('b', [_vm._v("15:30-33")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Seeks Honor Before the People")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Panting After Air.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" Mark it when you will: There is no animal so ambitious, no chameleon that so pants after air, as does the hypocrite after popular praise. For it he fasts, and so hungry and thirsty is he after it that you shall even hear him beg for it. “Honor me now before the elders of my people,” says one of them—it is Saul. "), _c('i', [_vm._v("On Repentance and Fasting")]), _c('i', [_c('b', [_vm._v(":")])]), _vm._v(" "), _c('i', [_vm._v("Sermon 6.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-257-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why Samuel Returned with Saul.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Initially Samuel refused to return with Saul, lest he give the appearance of approving Saul’s sins. Accordingly, Samuel did not simply deny Saul but said, in effect, that he would not go with him yet or at that time. As Christ said, “You go up to the feast. I am not going up to this feast, for my time has not yet fully come”; and yet afterward, Jesus went. Some think that because Saul only required Samuel to honor him in a civil "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2938"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2939"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2940"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2941"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2942"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2943"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page68",
      "title": "68"
    }
  }), _vm._v("ceremony in the presence of the people, Samuel did not refuse. But seeing that Saul worshiped God—with Samuel being present—it is probable that Samuel also worshiped God with Saul, as Josephus well observes. But though Samuel vouchsafed his presence to Saul in prayer, he did not pray for the restoring of the kingdom to Saul or for the reversing of God’s sentence. Had Samuel done so, he would have prayed against the will of God. However, Samuel only assisted Saul in his prophetic office according to the will of God. One reason also of Samuel’s returning might be to see just execution done on Agag the king of Amalek, whom Samuel hewed in pieces before the Lord. This reverent and respective behavior of Samuel toward Saul demonstrates that ministers of God should yield outward honor even to evil magistrates. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-256-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_81"
    }
  }, [_c('b', [_vm._v("15:34-35")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel Mourns over Saul")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Mourning for a Time.")]), _vm._v(" "), _c('i', [_vm._v("Dutch Annotations:")]), _vm._v(" Samuel saw Saul no more. Or, alternatively interpreted, Samuel visited Saul no more to instruct him concerning the government of the kingdom or to ask counsel of God for him. At the same time, Samuel did see Saul unawares at Naioth in Rama . . . and in other places until the day of his death. But these later encounters are not reckoned as proper seeing, thus implying that Samuel never visited Saul again after this time. Nevertheless, Samuel did mourn for Saul. Samuel did so not for the rest of his life but so long until he was forbidden by God to mourn. Thereafter he was commanded by God to anoint David king over Israel. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-255-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Ministering Affectionately.")]), _vm._v(" "), _c('i', [_vm._v("Henry Airay:")]), _vm._v(" Great and godly affection . . . ought to be in the pastor toward his people. In fact the pastor’s affection ought to be so great that it should grieve him and even cause him to shed tears to see the enemies of the truth trouble his people or to see his people drawn into any sin or error by anyone or anything. For this is how we testify to our affection for the church of God—if we are grieved to see Satan assault God’s people or attempt to prevail against them. For so we see how Samuel mourned for Saul when he had provoked the Lord to anger by means of his disobedience against him. "), _c('i', [_vm._v("Lectures on Philippians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-254-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why Samuel Mourned for Saul.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Though he mourned, Samuel did not so much mourn for Saul as he did for the fact that Saul had been rejected and deposed from the kingdom. For Samuel knew that the sentence of God was irrevocable, and that it was not good to be discontented with the Lord’s will. Yet Samuel lamented the hardness of Saul’s impenitent heart, seeing that Saul continued in his sin without any remorse—as was evident in the persecution of David. What’s more, Samuel also foresaw the misery in which Saul was likely to fall—relative to the loss not only of the kingdom but of his life as well. Indeed, though Samuel knew that God’s rejection of Saul from the kingdom could not be reversed, yet he grieved and tried to entreat the Lord for the forgiveness of Saul’s sin. Here Samuel shows his tender and loving affection, in addition his complete lack of envy: he felt sorry for the misery of Saul, even though Saul had succeeded him in the government. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-253-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor2944"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2945"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page69",
      "title": "69"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_82"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("16:1-23")]), _vm._v(" DAVID IS ANOINTED AND ENTERS SAUL’S SERVICE")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “How long will you grieve over Saul, since I have rejected him from being king over Israel? Fill your horn with oil, and go. I will send you to Jesse the Bethlehemite, for I have provided for myself a king among his sons.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And Samuel said, “How can I go? If Saul hears it, he will kill me.” And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “Take a heifer with you and say, ‘I have come to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And invite Jesse to the sacrifice, and I will show you what you shall do. And you shall anoint for me him whom I declare to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Samuel did what the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("commanded and came to Bethlehem. The elders of the city came to meet him trembling and said, “Do you come peaceably?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And he said, “Peaceably; I have come to sacrifice to the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". Consecrate yourselves, and come with me to the sacrifice.” And he consecrated Jesse and his sons and invited them to the sacrifice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("When they came, he looked on Eliab and thought, “Surely the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed is before him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("But the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to Samuel, “Do not look on his appearance or on the height of his stature, because I have rejected him. For the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("sees not as man sees: man looks on the outward appearance, but the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("looks on the heart.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then Jesse called Abinadab and made him pass before Samuel. And he said, “Neither has the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("chosen this one.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Then Jesse made Shammah pass by. And he said, “Neither has the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("chosen this one.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And Jesse made seven of his sons pass before Samuel. And Samuel said to Jesse, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has not chosen these.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then Samuel said to Jesse, “Are all your sons here?” And he said, “There remains yet the youngest,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("but behold, he is keeping the sheep.” And Samuel said to Jesse, “Send and get him, for we will not sit down till he comes here.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And he sent and brought him in. Now he was ruddy and had beautiful eyes and was handsome. And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “Arise, anoint him, for this is he.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Then Samuel took the horn of oil and anointed him in the midst of his brothers. And the Spirit of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("rushed upon David from that day forward. And Samuel rose up and went to Ramah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Now the Spirit of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("departed from Saul, and a harmful spirit from the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("tormented him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And Saul’s servants said to him, “Behold now, a harmful spirit from God is tormenting you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("Let our lord now command your servants who are before you to seek out a man who is skillful in playing the lyre, and when the harmful spirit from God is upon you, he will play it, and you will be well.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("So Saul said to his servants, “Provide for me a man who can play well and bring him to me.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("One of the young men answered, “Behold, I have seen a son of Jesse the Bethlehemite, who is skillful in playing, a man of valor, a man of war, prudent in speech, and a man of good presence, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is with him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Therefore Saul sent messengers to Jesse and said, “Send me David your son, who is with the sheep.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And Jesse took a donkey laden with bread and a skin of wine and a young goat and sent them by David his son to Saul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And David came to Saul and entered his service. And Saul loved him greatly, and he became his armor-bearer.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And Saul sent to Jesse, saying, “Let David remain in my service, for he has found favor in my sight.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And whenever the harmful spirit from God was upon Saul, David took the lyre and played it with his hand. So Saul was refreshed and was well, and the harmful spirit departed from him.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("smallest"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" God cannot lie. So when God commands Samuel to conceal a truth, the reformers clarify how to interpret this passage. They also humanize the prophet Samuel—they do not confuse saintliness with sinlessness. The interpreters use the occasion of Samuel’s confusion about "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2946"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2947"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2948"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2949"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2950"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2951"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2952"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2953"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2954"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2955"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2956"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page70",
      "title": "70"
    }
  }), _vm._v("which of Jesse’s sons to anoint to reflect on the differences between the outward and the inward, the ungodly and the godly. Indeed, they ponder the well-known passage that “the Lord sees not as man sees.” This truth is not always convenient for God’s people—for example, despite his royal anointing, David endures years of persecution before undisputedly claiming the throne of Israel. The reformers also dwell on the spirit that tormented Saul, struggling to understand the relationship between the devil and God when it comes to working in the life of unbelievers, and how David’s delightful music was able to expel the evil spirit inflicting Saul.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_83"
    }
  }, [_c('b', [_vm._v("16:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Samuel Questions God")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel Was a Sinner Like Us.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Samuel said, “How can I go? If Saul hears it, he will kill me.” You see that Samuel was a sinner the same as us. It is impossible to have this kind of fear without sin, without letting go of what God commands. So this fear is a great impurity when it comes near you. Faith swallows this sin so that it is not imputed to us. I freely offer this example from the holy ones. Otherwise what consolation could I have from their miracles? "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-252-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Whether Samuel Lied.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Three things excuse, or rather, justify Samuel’s act here. First, he is excused because the author of this command was God, who does not command sin to be performed. Nor is God the author of any evil. Samuel, therefore, being bid to say what he did by the Lord, would not even have sinned had he killed someone—given that it was the Lord who commanded him to do so. Second, it is the "), _c('i', [_vm._v("end")]), _vm._v(" that always has to be considered. It is unlawful to lie or evade, for instance, if it is done in malice or in order hurt someone. But this evasion here by Samuel brought no such inconvenience with it. None received any hurt by it. Finally, the "), _c('i', [_vm._v("manner")]), _vm._v(" of this action makes Samuel’s excuse lawful: For he told no untruth, but only concealed part of the truth. Although he sacrificed, that was not the chief or only purpose of his coming. In this way, to conceal a great or weighty affair, and to reveal nothing at all, is providence—not hypocrisy. In the same way, the prophet Jeremiah—upon being asked by the princes what communication he had with King Zedekiah—only told them that he had entreated him to not return to Jonathan’s house to die there. But concerning the rest of the conversation, he did not utter anything. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-251-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_84"
    }
  }, [_c('b', [_vm._v("16:6-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Appearances Can Deceive")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Lord Looks on the Heart.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Samuel looked on Eliab. In this example to us, the Lord commands Samuel not to judge Eliab by appearances, since indeed they were all already falling because of Saul. If they have to follow their eyes, they will be deceived, whether they are hypocrites or even good kinds of saints. I know this from 1 John regarding the “desires of the eyes.” But in the psalm, the Lord promises us his eyes: “I will instruct you and teach you in the way you should go; I will counsel you with my eye upon you.” The boy is given the kingdom, which neither his father or brothers or Samuel himself recognize. The kingdom of God is not seen by observation. The Lord knows who belongs to him, and all of Isaiah 53 shows that Christ is not known by people because of the form of the cross. But hypocrites follow Eliab because of his stature, speaking hatefully about David, “Why have you come down?” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-250-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Prefiguring of Jesus’ Baptism by John.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Jackson:")]), _vm._v(" Although John the Baptist no more knew our Savior by face from other men than Samuel did the sons of Jesse—one of which he was appointed to anoint as king in Saul’s place "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2957"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2958"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2959"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2960"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2961"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2962"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2963"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2964"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2965"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page71",
      "title": "71"
    }
  }), _vm._v("over Israel—yet when our Savior came to be baptized, he knew him to be the Messiah by some divine instinct or revelation as Samuel knew David (whose face he had never seen before) to be the man whom God had appointed him to anoint. . . . For it is evident . . . that although Samuel knew none of Jesse’s sons by face, yet he had received a distinct revelation from God. . . . “Do not look on his appearance or on the height of his stature, because I have rejected him.” But when David was brought before him, the Lord said, “Arise, anoint him, for this is he.” Samuel had no visible sign given from God by which to know the man whom he was to anoint from among his brothers; rather, he was merely to rely on the revelation or instruction that God had promised to give him in the very act or situation. God said, “invite Jesse to the sacrifice, and I will show you what you shall do. And you shall anoint for me him whom I declare to you.” "), _c('i', [_vm._v("Christ’s Answer to John’s Question.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-249-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Samuel’s Error.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Samuel, in saying that the Lord’s anointed was before him, meant he believed that Eliab was chosen and approved of God to be anointed king. It is as if a person casts his eye on that which he loves and turns his eyes away from that which he hates. But here Samuel speaks unadvisedly of himself, without God’s warrant, as Nathan did to David when he encouraged him to build God a house (2 Sam 7:3). Samuel looked to the outward stature, lineaments and proportion of Eliab’s body, which indeed are attractive qualities in magistrates and governors, but the inward parts and gifts of the mind are more to be respected. These are the things on which the Lord looks. God does not look to the outward person. What’s more, Samuel already had experience of a king in the outward comeliness and stature of the body who exceeded all others. Indeed, none in Israel compared with Saul. Yet God was not pleased with Saul, nor were the inwards parts of his mind answerable to the outward ones any more than were Eliab’s—as may appear by his unkind and discourteous conversation toward David. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-248-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Inside Versus Outside.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Jesse could find nothing in David worthy of honor in relation to his brothers, but God found something in him that honored David before them all. David’s father thought him fit to keep sheep, and his brothers fit to rule over people. God thought David fit to rule, and for his brothers to serve. . . . Here was all the difference. . . . Jesse saw things based on the outside, God by the inside: Jesse saw the composition of the body, God saw the disposition of the mind. "), _c('i', [_vm._v("The Holy Choice.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-247-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_85"
    }
  }, [_c('b', [_vm._v("16:10")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Jesse’s Other Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Kindness.")]), _vm._v(" "), _c('i', [_vm._v("John Fisher:")]), _vm._v(" Jesse, the father of David, had seven sons. David was the youngest of them all, the least in appearance, the least established, and he kept his father’s sheep. Nevertheless, the goodness of Almighty God not only elected and chose him, but all his brothers were rejected and set aside. Then God commanded Samuel, the bishop and prophet, to anoint him king of Israel. Was not this a great kindness that Almighty God showed to such a, so to speak, vile person who was used to the habit of keeping beasts? God, out of his goodness, called David from so vile an office and set him by his commandment as king and head of all his people. "), _c('i', [_vm._v("Commentary on the Seven Penitential Psalms.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-246-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of the Number of Jesse’s Sons.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Josephus thinks Jesse only had seven sons—six in addition to David—and that David was the seventh. Josephus names all seven sons according to the names set down in 1 Chronicles 2:13-15, which are these: Eliab, also called Elihu, Abinadab . . . , Shimea, also called Shammah, Nethanel, Raddai, whom Josephus calls Rael, and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2966"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2967"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2968"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2969"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2970"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2971"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2972"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2973"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2974"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2975"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2976"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page72",
      "title": "72"
    }
  }), _vm._v("Ozem. . . . These six are said to be Jesse’s sons, and David the seventh. However, in this present passage six sons were brought before Samuel before David came. And it is stated explicitly that Jesse had eight sons. To reconcile this discrepancy, we may conjecture that the “eighth son” was one of the elder brother’s sons. Most likely it was Jonadab, son of Shimea, about whom mention is made in 2 Samuel 13:3, for in the Hebrew the word “nephew” is also translated as “son.” "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-245-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Undivided Heart.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" Samuel said to Jesse “Are all your children here? If any remain, we will not sit down till he comes here.” We must be the same way in our confessions and renunciation of sin. Christ asks us, “Are any still here? If any are remaining, I will not take possession till they are cast out.” . . . God’s law, as well as humankind’s, disallows inmates in the same house; he will not endure a divided heart; he is heir of all things; there lies no writ of partition in his inheritance; his title is so good that he will never yield to a composition; he will have all the heart or none. "), _c('i', [_vm._v("Seven Sermons on the Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-244-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_86"
    }
  }, [_c('b', [_vm._v("16:11-13")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Anointing")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Whether David Was Anointed.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think David was not anointed. Accordingly, when it is said in the text that Samuel “anointed him in the midst of his brothers,” these commentators interpret this passage in this way: Samuel merely anointed one of the brothers, in this case, the youngest of all the brothers. . . . It is also to be gathered out of this passage that all the brothers sat down together at the feast. As Samuel said after Jesse informed the prophet that David was not yet present at the meal: “Send and get him, for we will not sit down till he comes here.” Josephus thinks Samuel, having placed David next to him at the table, whispered in his ear that God had appointed him to be king, and only then poured the anointed oil on him. However, seeing that he was anointed “in the midst of his brothers,” so that David’s brothers perceived what the prophet intended, to what end should Samuel have concealed the words? And I should also mention that the people of Israel, when they later anointed David king, repeated the words Samuel had used at David’s first anointing: “You shall be shepherd of my people Israel, and you shall be prince over Israel.” It is likely that these words were not whispered in David’s ear, for how then should they come to the notice of all Israel? Therefore some think it more probable that Samuel both spoke to David in the audience of his brothers and anointed him in their sight. Yet David’s brothers did not greatly regard David’s anointing, nor think the prophet did it seriously. On the contrary, they condemned it, as appears from Eliab’s unkind reception of David in the camp after this (1 Sam 17:28). This mirrors Joseph’s brothers disregard of his dreams—only Jacob taking them to heart—and the Pharisee’s and Jewish leaders’ refusal to acknowledge Christ—of whom David was a type—as their Messiah and King.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Now, then, whereas some think David was not anointed in front of his brothers before they sat down and some think he was anointed in their presence but they did not realize the significance, I take a middle position. Though his brothers saw him being anointed in their presence, they understood nothing concerning the kingdom. For if they had understood this, then Eliab would not have spoken to David so insolently afterward. However, when they heard David sing prophetic psalms, they might have thought he was anointed to be a prophet. Yet there is no evidence that David was unaware of the significance of his anointing in relation to the kingdom, for the word of promise was annexed to the outward sign of his anointing. Those words Samuel spoke to David were afterward published by Samuel or David himself. And if all David’s brothers had been acquainted with this secret, it could not have been kept from Saul, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2977"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2978"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2979"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2980"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2981"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2982"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2983"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2984"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2985"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2986"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2987"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2988"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2989"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2990"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page73",
      "title": "73"
    }
  }), _vm._v("who just like his brother Eliab was envious of David. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-243-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Anointed but Not Enthroned.")]), _vm._v(" "), _c('i', [_vm._v("Geneva Bible:")]), _vm._v(" Though David was now anointed king by the prophet, God would exercise him in many ways before he had the command of his kingdom. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-242-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Suffering Before Glory.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" David, after being anointed to be king, lives in exile for ten years, is a servant of servants and is king only in name and in accordance with the empty words he heard from Samuel. Yet he holds out, and he perseveres in faith and expectation, until the outcome corresponds in richest abundance to the promise. This is the constant course of the church at all times, namely, that promises are made and that then those who believe the promises are treated in such a way that they are compelled to wait for things that are invisible, to believe what they do not see and to hope for what does not appear. He who does not do this is not a Christian. For Christ himself entered into his glory only by first descending into hell. When he is about to reign, he is crucified. When he is to be glorified, he is spit on. For he must suffer first and then at length be glorified. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-241-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("An Allegory on the Two Kings.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The people of God are described by two kingdoms, that of Saul and that of David. One is a kingdom of hypocrisy; the other, a kingdom of the elect. The one group blossoms and is judged to be wise, powerful and righteous until the cross comes. But the other group is led through the cross and death into glory and life. In the meantime, however, you see nothing in them other than contempt, folly, sin and condemnation. They see nothing good in themselves whatsoever either, just as you see in many psalms. This is the hidden way of God in the flesh, which has been revealed to little children. It is said of Saul’s reign in the last chapter of Isaiah, “Before she was in labor, she gave birth.” That is not of God. But David’s reign is of God, which is from eternity in Christ. At first, David truly represents Christ, our head. Ever after, he represents all who are in Christ. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-240-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of the Spirit of God That Came on David.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" By the spirit we understand the excellent graces and gifts of the spirit with which David was now endued and made fit for the kingdom—Saul being deprived, since he was rejected from the kingdom. An example of the gift of the Spirit was fortitude and magnanimity, through which David did not fear to fight with a lion and a bear. David was also given a gift of prophecy, through which he began to craft and sing divine psalms and hymns to the praise of God. The blessing of God was with David, and his spirit assisted him through which he did all things happily, providentially and prosperously. . . . Besides, the spirit of God came in a further degree on David than it had on Saul, for it framed David’s heart to obedience to the will of God and it wrought in him true sanctification, which Saul did not have since he only received the Spirit for a certain time to perform temporary heroic acts. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-239-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_87"
    }
  }, [_c('b', [_vm._v("16:14a")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("God’s Spirit Departs from Saul")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Temporary Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" It says that “the Spirit departed from Saul.” I ask: what is this? Has not enough of Saul’s impiety been described above? Why is this the first time that it is written that the Spirit of the Lord departed from him? I answer: Thus is the Spirit of the Lord to sinners who have fallen away from God. It argues against the unbelief of their conscience, just as Christ says: the Spirit “will "), _c('a', {
    attrs: {
      "id": "_idTextAnchor2991"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2992"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2993"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2994"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2995"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2996"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2997"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2998"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor2999"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3000"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3001"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3002"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page74",
      "title": "74"
    }
  }), _vm._v("convict the world concerning sin and righteousness and judgment: concerning sin, because they do not believe in him.” But it withdraws at that time when those who are despairing surrender to a depraved mind, when a chiding spirit can no longer strengthen them. They are despisers, and they rush into wicked deeds. This is what the Lord said in Genesis: “My Spirit shall not abide in humans forever.” Therefore, before this time Saul could be conscious of his sins; after this, he despises everything and wants to establish himself as king, even when he sees the kingdom going to David, as you will see below. You can be sure that this is the highest impiety, to want to fight openly against God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-238-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Can Revoke His Gifts.")]), _vm._v(" "), _c('i', [_vm._v("Hans Denck:")]), _vm._v(" Now, since God does not will sin but still knows that it happens, we should not in this case trouble ourselves about him. God will not become desperate in himself, as we do. His foreknowledge, which is unknown to us, will surely accord with his will (of which even the perverse know something) apart from our inquisitiveness. But thus the clever must become fools who yearn to know God’s mysteriousness and to despise the acknowledged intention of his commandments.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("You say: We do not need foreknowledge, as you say, except for a consolation to all the elect that they may know that all their help and salvation lie in the hand of God and that no power is so mighty that it will or could wrest it from him. Response: This consolation you can give no one and also none can take from you, for he who has committed himself to the chastisement of the Father and who has tasted partially the sweetness of the bitter cross, to him the Father reveals himself through his Spirit in defiance before all his enemies, but, nonetheless, he must fear God and despise no one. For those whom God has received in faith he can and will reject again if he does not remain in faith, since he did not even spare the angels because they were so secure that they thereby developed satisfaction in themselves and forgot God. Therefore also Paul, the elect instrument of God, says now in vain: Let him who stands take heed lest he fall! If God gave his Spirit to Saul the king and took it again, and if it is nevertheless true that he never regrets his gifts, what should be wrong if he were to take from us the talent he gave us so that we have nothing—that is, would the one for whom grace means nothing nevertheless remain true and just? Speak out, whoever will, is it not a misuse of foreknowledge to want to be certain of the Lord’s reward (God help us!) regardless of how well we serve him? "), _c('i', [_vm._v("Whether God Is the Cause of Evil.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-237-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_88"
    }
  }, [_c('b', [_vm._v("16:14b-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("A Harmful Spirit")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Sent from the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("All God’s Doing.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" I confess indeed that it is often by means of Satan’s intervention that God acts in the wicked, but in such a way that Satan performs his part by God’s impulsion and advances as far as he is allowed. An evil spirit troubles Saul; but it is said to have come from God, that we may know that Saul’s madness proceeds from God’s just vengeance. . . . To sum up, since God’s will is said to be the cause of all things, I have made his providence the determinative principle for all human plans and works, not only in order to display its force in the elect, who are ruled by the Holy Spirit, but also to compel the reprobate to obedience. "), _c('i', [_vm._v("Institutes 1.18.2.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-236-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Evil Spirits Sent by God Alone.")]), _vm._v(" "), _c('i', [_vm._v("George Gifford:")]), _vm._v(" I hold it no small folly for any person to think that the Lord does not now scourge his children, at least some of them, for their good, by the devil. There is no doubt that the devil has power given him to afflict, uses all the craft he can and will seem to be sent by a witch. The devil will make it appear that he is not sent from God but from the anger of a poor woman. And now, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3003"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3005"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3012"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page75",
      "title": "75"
    }
  }), _vm._v("touching the wicked, who provoke God by their wicked sins and unbelief, may we not read in the Scriptures that an evil spirit was sent from God to King Saul, which haunted and vexed him? Was this spirit sent by a witch? . . . As I said before, here is the deep craft of Satan: that he will appear to be sent by witches whereas, in truth, God sent him, seeing none can send him but God. "), _c('i', [_vm._v("A Dialogue Concerning Witches and Witchcraft.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-235-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Working by Emission and Permission.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Satan’s service and ministry is not absolutely accepted and pleasing to God. Further, there is a double work to be considered in the evil ministering spirits. For either they are ministers of outward punishments only—as in vexing and afflicting the body—in which case they work by "), _c('i', [_vm._v("emission")]), _vm._v(", that is, sending from God; or they also urge on and tempt to evil, in which case they work only by the "), _c('i', [_vm._v("permission")]), _vm._v(" or sufferance of God. Satan assaulted Saul in both of these ways, for both his body was vexed and his mind was tempted. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-234-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_89"
    }
  }, [_c('b', [_vm._v("16:16-23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Music Soothes Saul’s Bad Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Restraining Saul’s Evil Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" David . . . often banished the evil spirit of Saul or restrained and subdued it with his lyre. . . . For the evil spirit is ill at ease wherever God’s Word is sung or preached in true faith. He is a spirit of gloom and cannot abide where he finds a spiritually happy heart, that is, where the heart rejoices in God and in his Word. "), _c('i', [_vm._v("Treatise on the Last Words of David.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-233-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Godly Are Like David’s Harp.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" One good person can do much good for many. They not only act as chains to the hands of God by holding them back from judgment, but they are also a happy prevention of sin. They keep God from being angry; and when God is angry, they calm God. Godly people are like David’s harp; they chase away evil spirits from people’s company. . . . For in his presence . . . insolence grows ashamed, course jokes appear foolish, drunkards become sober, blasphemers have their lips sealed up and the mouth of all wickedness is stopped. This good comes by the good. "), _c('i', [_vm._v("The Spiritual Navigator.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-232-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Music, the Joy on the Earth.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_vm._v("Of all the joys upon this earth")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("None has for men a greater worth")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Than what I give with my ringing")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("And with voices sweetly singing.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("There cannot be an evil mood")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Where there are singing fellows good,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("There is no envy, hate nor ire,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Gone are through me all sorrows dire;")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Greed, care and lonely heaviness")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("No more do they the heart oppress.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Each man can in his mirth be free")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Since such a joy no sin can be.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("But God in me more pleasure finds")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Than in all joys of earthly minds.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Through my bright power the devil shirks")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("His sinful, murderous, evil works.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Of this King David’s deeds do tell")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Who pacified King Saul so well")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("By sweetly playing on the lyre")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("And thus escaped his murderous ire.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("A Preface for All Good Hymnals.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-231-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Remedy of David’s Harp.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" Take pleasure to meditate often on God’s wonderful works and sing forth his praises. The spiritual songs inspired by the Holy Spirit commonly appease all the evil motions of our mind and they also produce in us a holy joy and celestial peace. Just like when Saul was tormented with a "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3015"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page76",
      "title": "76"
    }
  }), _vm._v("wicked spirit, David was appointed with his harp to play before him and by that means quieted his troubled mind. Likewise, when hatred, anger, revenge, covetousness, ambition, lust or any other of the unruly passions—which are like evil spirits—disturb and torture our souls within us, we must seek a remedy from David’s harp and sing to the Lord in spiritual songs and hymns. "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-230-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Good Music Drives Out Bad Habits.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" A gambler will hold so long as his money lasts, an adulterer so long as his loins last, but a drunkard so long as his lungs and life last. A philosopher, once finding himself in the company of drunkards where a musician ruled the disorderly gathering, charged the musician to change his music into a better tune. By doing so he brought the drunkards to sobriety; and casting away their drinks, they were ashamed of all they had done. But our drunkards have not the patience to hear such music. Saul was vexed with an evil spirit, but David’s harp expelled him. O that we knew that instrument or lesson, which could work such a reformation! We would double and triple that note, which might bring about such a cure. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-229-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Playing Music with David.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The art of instrumental music back then was delightful in itself, just as it is now. But unlike we who rejoice in dirty songs, they only sang to God about praise and mercy, composing psalms and hymns that the devil could not bear and in which faith was played and sung. This was no doubt true of David’s songs too. Therefore, as often as you sing from a spirit of instruction to the Lord, you understand how to play the harp with David, especially when those songs restore the senses from the snare of the devil through God’s Word. But, as in David’s case, it is also important that the Lord is sought. Otherwise, “We played the flute for you, and you did not dance; we sang a dirge, and you did not weep.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-228-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Music and Madness.")]), _vm._v(" "), _c('i', [_vm._v("Giovanni Diodati:")]), _vm._v(" The musician was only sought for when Saul had fits of rage or melancholy, for he had some respites and spaces between these fits. . . . It’s not that musical sounds or any other corporal and sensible means have any power over the devil, who is only let loose, it should be noted, by God’s permission. The situation was this: With the supernatural madness or rage, there was a bodily defect in the mind and an exasperation of the spirits, which are the organs of diabolical operation in such cases. And music, by reducing the spirits of human beings for a time to some sweet concordance and harmony, makes the corporal or bodily instrument less subject to the devil’s operation. That is, unless this sound was accompanied with some divine word or subject whose power and respect repressed and quelled the devil’s action for the present. It’s also possible that some motion of God’s Spirit was awakened in Saul at times by prophetic music, as when he later prophesied. . . . Or finally, it’s possible that God of his free will determined to cooperate with David’s playing of music to lead Saul to need David to remain in the king’s court. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-227-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3017"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page77",
      "title": "77"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_90"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("17:1-58")]), _vm._v(" DAVID AND GOLIATH")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now the Philistines gathered their armies for battle. And they were gathered at Socoh, which belongs to Judah, and encamped between Socoh and Azekah, in Ephes-dammim.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And Saul and the men of Israel were gathered, and encamped in the Valley of Elah, and drew up in line of battle against the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And the Philistines stood on the mountain on the one side, and Israel stood on the mountain on the other side, with a valley between them.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And there came out from the camp of the Philistines a champion named Goliath of Gath, whose height was six")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("cubits")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("and a span.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("He had a helmet of bronze on his head, and he was armed with a coat of mail, and the weight of the coat was five thousand shekels")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("of bronze.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And he had bronze armor on his legs, and a javelin of bronze slung between his shoulders.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("The shaft of his spear was like a weaver’s beam, and his spear’s head weighed six hundred shekels of iron. And his shield-bearer went before him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("He stood and shouted to the ranks of Israel, “Why have you come out to draw up for battle? Am I not a Philistine, and are you not servants of Saul? Choose a man for yourselves, and let him come down to me.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("If he is able to fight with me and kill me, then we will be your servants. But if I prevail against him and kill him, then you shall be our servants and serve us.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And the Philistine said, “I defy the ranks of Israel this day. Give me a man, that we may fight together.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("When Saul and all Israel heard these words of the Philistine, they were dismayed and greatly afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Now David was the son of an Ephrathite of Bethlehem in Judah, named Jesse, who had eight sons. In the days of Saul the man was already old and advanced in years.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("The three oldest sons of Jesse had followed Saul to the battle. And the names of his three sons who went to the battle were Eliab the firstborn, and next to him Abinadab, and the third Shammah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("David was the youngest. The three eldest followed Saul,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("but David went back and forth from Saul to feed his father’s sheep at Bethlehem.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("For forty days the Philistine came forward and took his stand, morning and evening.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And Jesse said to David his son, “Take for your brothers an ephah")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('i', [_vm._v("of this parched grain, and these ten loaves, and carry them quickly to the camp to your brothers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Also take these ten cheeses to the commander of their thousand. See if your brothers are well, and bring some token from them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now Saul and they and all the men of Israel were in the Valley of Elah, fighting with the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And David rose early in the morning and left the sheep with a keeper and took the provisions and went, as Jesse had commanded him. And he came to the encampment as the host was going out to the battle line, shouting the war cry.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And Israel and the Philistines drew up for battle, army against army.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And David left the things in charge of the keeper of the baggage and ran to the ranks and went and greeted his brothers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("As he talked with them, behold, the champion, the Philistine of Gath, Goliath by name, came up out of the ranks of the Philistines and spoke the same words as before. And David heard him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("All the men of Israel, when they saw the man, fled from him and were much afraid.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("And the men of Israel said, “Have you seen this man who has come up? Surely he has come up to defy Israel. And the king will enrich the man who kills him with great riches and will give him his daughter and make his father’s house free in Israel.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And David said to the men who stood by him, “What shall be done for the man who kills this Philistine and takes away the reproach from Israel? For who is this uncircumcised Philistine, that he should defy the armies of the living God?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("And the people answered him in the same way, “So shall it be done to the man who kills him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Now Eliab his eldest brother heard when he spoke to the men. And Eliab’s anger was kindled against David, and he said, “Why have you come down? And with whom have you left those few sheep in the wilderness? I know your presumption and the evil of your heart, for you have come down to see the battle.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("And David said, “What have I done now? Was it not but a word?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("And he turned away from "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3021"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3022"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page78",
      "title": "78"
    }
  }), _c('i', [_vm._v("him toward another, and spoke in the same way, and the people answered him again as before.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("When the words that David spoke were heard, they repeated them before Saul, and he sent for him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("And David said to Saul, “Let no man’s heart fail because of him. Your servant will go and fight with this Philistine.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("And Saul said to David, “You are not able to go against this Philistine to fight with him, for you are but a youth, and he has been a man of war from his youth.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("But David said to Saul, “Your servant used to keep sheep for his father. And when there came a lion, or a bear, and took a lamb from the flock,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("I went after him and struck him and delivered it out of his mouth. And if he arose against me, I caught him by his beard and struck him and killed him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("Your servant has struck down both lions and bears, and this uncircumcised Philistine shall be like one of them, for he has defied the armies of the living God.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("37")]), _c('i', [_vm._v("And David said, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("who delivered me from the paw of the lion and from the paw of the bear will deliver me from the hand of this Philistine.” And Saul said to David, “Go, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("be with you!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("38")]), _c('i', [_vm._v("Then Saul clothed David with his armor. He put a helmet of bronze on his head and clothed him with a coat of mail,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("39")]), _c('i', [_vm._v("and David strapped his sword over his armor. And he tried in vain to go, for he had not tested them. Then David said to Saul, “I cannot go with these, for I have not tested them.” So David put them off.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("40")]), _c('i', [_vm._v("Then he took his staff in his hand and chose five smooth stones from the brook and put them in his shepherd’s pouch. His sling was in his hand, and he approached the Philistine.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("41")]), _c('i', [_vm._v("And the Philistine moved forward and came near to David, with his shield-bearer in front of him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("42")]), _c('i', [_vm._v("And when the Philistine looked and saw David, he disdained him, for he was but a youth, ruddy and handsome in appearance.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("43")]), _c('i', [_vm._v("And the Philistine said to David, “Am I a dog, that you come to me with sticks?” And the Philistine cursed David by his gods.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("44")]), _c('i', [_vm._v("The Philistine said to David, “Come to me, and I will give your flesh to the birds of the air and to the beasts of the field.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("45")]), _c('i', [_vm._v("Then David said to the Philistine, “You come to me with a sword and with a spear and with a javelin, but I come to you in the name of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("of hosts, the God of the armies of Israel, whom you have defied.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("46")]), _c('i', [_vm._v("This day the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will deliver you into my hand, and I will strike you down and cut off your head. And I will give the dead bodies of the host of the Philistines this day to the birds of the air and to the wild beasts of the earth, that all the earth may know that there is a God in Israel,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("47")]), _c('i', [_vm._v("and that all this assembly may know that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("saves not with sword and spear. For the battle is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s, and he will give you into our hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("48")]), _c('i', [_vm._v("When the Philistine arose and came and drew near to meet David, David ran quickly toward the battle line to meet the Philistine.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("49")]), _c('i', [_vm._v("And David put his hand in his bag and took out a stone and slung it and struck the Philistine on his forehead. The stone sank into his forehead, and he fell on his face to the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("50")]), _c('i', [_vm._v("So David prevailed over the Philistine with a sling and with a stone, and struck the Philistine and killed him. There was no sword in the hand of David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("51")]), _c('i', [_vm._v("Then David ran and stood over the Philistine and took his sword and drew it out of its sheath and killed him and cut off his head with it. When the Philistines saw that their champion was dead, they fled.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("52")]), _c('i', [_vm._v("And the men of Israel and Judah rose with a shout and pursued the Philistines as far as Gath")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('i', [_vm._v("and the gates of Ekron, so that the wounded Philistines fell on the way from Shaaraim as far as Gath and Ekron.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("53")]), _c('i', [_vm._v("And the people of Israel came back from chasing the Philistines, and they plundered their camp.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("54")]), _c('i', [_vm._v("And David took the head of the Philistine and brought it to Jerusalem, but he put his armor in his tent.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("55")]), _c('i', [_vm._v("As soon as Saul saw David go out against the Philistine, he said to Abner, the commander of the army, “Abner, whose son is this youth?” And Abner said, “As your soul lives, O king, I do not know.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("56")]), _c('i', [_vm._v("And the king said, “Inquire whose son the boy is.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("57")]), _c('i', [_vm._v("And as soon as David returned from the striking down of the Philistine, Abner took him, and brought him before Saul with the head of the Philistine in his hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("58")]), _c('i', [_vm._v("And Saul said to him, “Whose son are you, young man?” And David answered, “I am the son of your servant Jesse the Bethlehemite.”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Hebrew; Septuagint, Dead Sea Scroll and Josephus "), _c('i', [_vm._v("four")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" A "), _c('i', [_vm._v("cubit")]), _vm._v(" was about 18 inches or 45 centimeters "), _c('b', [_vm._v("c")]), _vm._v(" A "), _c('i', [_vm._v("shekel")]), _vm._v(" was about 2/5 ounce or 11 grams "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint, Syriac; Hebrew "), _c('i', [_vm._v("advanced among men")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" An "), _c('i', [_vm._v("ephah")]), _vm._v(" was about 3/5 bushel or 22 liters "), _c('b', [_vm._v("f")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("Gai"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3024"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3030"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3031"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3032"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3033"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3034"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3035"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page79",
      "title": "79"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" For some of the reformers, the famous battle between David and Goliath serves as an allegory, which symbolizes the battle of Christ against Satan and that of belief against disbelief. Due to his strong faith in God, David, often regarded by the reformers as a type of Christ, proves victorious over a visibly more terrifying foe. Unarmed but for a few stones, David overpowers the giant Goliath by God’s providence. Fighting in the name of the Lord against the giant, David cannot lose the battle, inciting these interpreters to apply the battle between the humble David and the arrogant Goliath to our spiritual lives.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("An Allegory on David and Goliath.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Goliath, lord of the Philistines, is the ruler of the world. Saul is a shepherd without faith. David is Christ and anyone who has a firm spirit in Christ. The Israelites are the common people, as yet unsure about the gospel, which goes forth from Christ and the good shepherd, that is, the inspired preacher of the gospel who stands above all enemies. Saul is in the habit of delaying, which makes all Israel fear the one Philistine. For this is what the kingdom of hypocrisy is like against Satan. God’s righteousness cannot endure this, for this is not the spirit of victory. But David alone (that is, Christ) saves the people. For this reason, it is among the most esteemed stories you will ever read in human history. Here you see David’s marvelous faith and zeal for his people against the blasphemy of their enemies, as he blazed—carried by the Spirit—for the glory of God. These are Christ’s benefits, presented to us so that from the beginning of his anointing David might show through God what the kingdom itself will produce through Christ, David’s son. This is also the result of all faith fighting against Satan’s cunning and against worldly wisdom and power. These are not the weapons of the flesh but the armor of God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-226-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Perennial Duel.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" The story of the duel between David and Goliath provides an eminent and wonderful example of faith. For David, full of faith and hope, requests and awaits the help of God. David undertakes this dangerous task, which God guides for the fortune and advantage of the church. This story reminds us of the victory of Christ and the church. This story admonishes us [to keep in mind] the victory of Christ and the church. For Christ repels the devil, opposing him with the word and prayer, just as the church, through the Word of God and through prayer, repels the same enemy and his heretical and tyrannical instruments. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-225-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_91"
    }
  }, [_c('b', [_vm._v("17:1-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Giant Goliath Frightens the Israelites")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Diabolical Goliath.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" Goliath’s tremendous size suggests that he might have come from the huge race of the giants, or Anakim, of whom some remained in the city of Gath (around Gaza and Ashdod) as recorded in Joshua 11. . . . From the weight of his armor, we can imagine what a monster of a man this Goliath was. This Goliath signifies the devil, who is terrifying and powerful and whose strength surpasses that of humans. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-224-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Protection from the Vile and Powerful Creature.")]), _vm._v(" "), _c('i', [_vm._v("Viktorin Strigel:")]), _vm._v(" This splendid description of Goliath and his armor illustrates the faith of David. Even though he was an unadorned and unarmed novice, David nevertheless dared to go against an experienced and noble enemy in hand-to-hand combat. Meanwhile, the stature and weaponry of this dreaded and monstrous giant brought fear on Saul and the whole of Israel. Now, Goliath is a picture of the devil, whose power is described in the following words from Job 41: “He counts iron as straw, and bronze as rotten wood. On earth he has no equal, a creature without fear.” "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3036"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3037"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3038"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3040"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3043"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3045"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page80",
      "title": "80"
    }
  }), _vm._v("To which defense should we seek refuge so that we are protected from this very powerful spirit? God strengthens us and is our refuge and defense! "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-223-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Parallel Fear and Faith.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" The more Goliath’s ferocity grew, the more the timidity and cowardice of the Israelites increased. The more abject the Israelites’ fear became, the more Goliath’s fearsome majesty increased, until the people’s souls fell to their feet and they became the most shameful sort of deserters. Those who notice this relationship between Goliath’s increasing ferocity and the Israelites increasing fearfulness will notice the parallel way in which the Lord gloriously restored David, who had been despised and turned away by the people. For we should learn that in the same way as God would exalt the one person David by his grace, so would God allow Saul and all his people who first scorned David to fall into a disgraceful ruin. "), _c('i', [_vm._v("Sermons on Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-222-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_92"
    }
  }, [_c('b', [_vm._v("17:12-30")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Cares for God’s Flock")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Over the Course of Forty Days.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" God ordained that forty days should be spent this way, thereby serving as the occasion through which David was sent to the camp to visit his brothers. This is the means by which the Lord appointed the conquest of Goliath. Likewise, the more the Israelites were in fear and the greater their perplexity, the more famous their victory and deliverance was, which they did not expect. This further evidences the great change and alteration that took place in Saul, namely, how the Spirit of God had forsaken him. From a valiant and courageous man with a heroic spirit, he grew to be a despicable coward. Whereas before in one day he had killed almost forty thousand of the Philistines, now, over the course of forty days, he was afraid to fight just one man. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-221-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Obeying His Father.")]), _vm._v(" "), _c('i', [_vm._v("Lucas Osiander:")]), _vm._v(" David had been anointed king by Samuel in the previous chapter. Even so, he was not carrying himself around as if he were king. Instead, he was humbly obeying his father and providing for his absent brothers. For though Christ (the true David) was in the form of God, he emptied himself for our sake, taking the form of a servant and obeying the Father, even to death on a cross. And though he was sent first to his brothers (the Jewish people), it became known that he had in fact come to free all of humankind from Satan’s tyranny. Therefore children ought to imitate David’s obedience and remember that he rose to glory and dignity through obedience. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-220-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Makes an Example of David.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" When Goliath insulted the armies of Israel, there were many pious men in the army. However, they did not sin by not engaging Goliath in single combat because God had inspired for them to do so by means of a spiritual gift. Only David received this gift because God wanted to make him illustrious. "), _c('i', [_vm._v("Commentary on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-219-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of the Rewards.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It is fit and proper that, as in the case with David, rewards should be given to those who offer their service in the defense of the commonwealth. For although we do not deserve an everlasting reward from the hands of God, yet a temporary reward may be deserved from the hands of people. And such rewards may be respected and aimed for, though chiefly the glory of God and the good of his church ought to move everyone to perform his duty. Now the rewards that Saul gave to David were three: (1) to join him in affinity in making him his son-in-law; (2) in endowing him with riches and enlarging his house—as in setting it free from taxes and other impositions—and (3) in advancing David to the state of nobility. But here Saul’s inconstancy "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3046"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3048"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page81",
      "title": "81"
    }
  }), _vm._v("and fickleness appeared: he was liberal in promising but slow in performing, which was evident in his unkind attitude toward David afterward. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-218-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Whether David Was Overly Ambitious.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David was not incited or stirred up by the hope of any kind of reward. . . . Rather, David was incited by the honor of God and the love of the people of God. Therefore, when David says: “What shall be done for the man who kills this Philistine and takes away the reproach from Israel?” he says in effect: “Who cares about receiving a promise? The indignity of the insult to the people of God, and the reproach they bear at the hand of this Philistine, is sufficient to provoke any man to action.” David offers two reasons for his decision. The first was taken from the person of the Philistine, who was an uncircumcised foreigner. The other was taken from one of the Israelites, who served the living God. In short, the Philistine’s insult was not to be endured. In this way, it was the honor of God and the reproach of the people of God that moved David to act. It was not the consideration of the reward. No, David was not won with these promises. In fact, when David appeared before Saul, he made no mention of any reward nor did he require any provision or promise from the king. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-217-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("When the Shepherd Is Away, the Wolves Will Slay.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The care and charge David had of his flock (being morally applied) shows what duty is required of the spiritual pastor toward his people. It also shows what causes of absence are allowable and when the shepherd ought not to be absent. Pastors ought not to be absent from their charges for long. And when their necessary occasions of being absent are completed, they are bound in conscience to return to their places. That these reasons are grounded on the Word of God and agreeable to the continual practice of the church of Christ we may demonstrate as follows.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("First, there is a great danger that accrues and grows to the pastors themselves if any of those souls that are committed to their charge perish in their absence through their negligence. As the prophet Ezekiel says, “If I say to the wicked, ‘O wicked one, you shall surely die,’ and you do not speak to warn the wicked to turn from his way, that wicked person shall die in his iniquity, but his blood I will require at your hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I do wonder how negligent pastors, when they read this passage, can pass it over without trembling—seeing what danger they incur in omitting to admonish the people committed to them. As Jerome well says, “The loss of the flock is the shame of the shepherd.” In fact, such loss even leads to the shepherd’s everlasting shame and confusion—without God’s great mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Second, the absence and negligence of the pastor proceeds from lack of love toward the flock. The one who does not love the flock does not love the one who owns the flock. Therefore our Savior says to Peter after he asked if he loved him, “Feed my sheep.” Therefore Pope Damasus I warns that anyone who is negligent in feeding the Lord’s flock, despite clear commendation, is found not to love the chief shepherd. And how can the one who does not love Christ be assured of Christ’s love toward him?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Third, let the inconveniences be considered that grow when pastors are absent. To begin with, the people will soon fall away from zeal to coldness and from virtue to vice. Where good seed is not sown, thistles and weeds will spring up instead. The apostle found this to be true by experience in the church of the Galatians when he was absent from them. As he says, “It is always good to be made much of for a good purpose, and not only when I am present with you, my little children, for whom I am again in the anguish of childbirth until Christ is formed in you! I wish I could be present with you now and change my tone, for I am perplexed about you.” It seems that while the apostle was present, the Galatians were very enthusiastic and zealous, but in his absence their "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3053"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3062"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page82",
      "title": "82"
    }
  }), _vm._v("zeal and first love abated. Therefore the apostle Paul wished he was among them, so that he might change and apply his voice to admonition or exhortation, as each person’s case required. This is the same thing Ambrose feared. Being on some necessary occasion absent from his church, he wrote: “I was mindful of you, fearing, lest in my absence any might fall through negligence and succumb to the ways of Satan.” And Augustine complains that while he was absent from Hippo, the citizens lost a certain godly custom among them of clothing and coating the poor. Therefore it is evident that good things will soon be discontinued and grow out of use where the pastor is not present to call on the people.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Fourth, the more diligent the spiritual adversary is to harm the flock, the more vigilant the pastor should be to watch over it. Now the devil, as Saint Peter says, “prowls around like a roaring lion, seeking someone to devour.” And the wolf is most likely to invade the flock when the pastor is not near at hand to defend them. Therefore Saint Paul says, “I know that after my departure fierce wolves will come in among you, not sparing the flock.” So Ambrose says well that the wolves watch for the pastor’s absence, because while the pastors are present they cannot invade the sheep of Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Fifth, how necessary the presence and residence of pastors and ministers in their churches is appears by the excellence and price of that object where their cure and charge lies. For indeed, they are watchmen not of people’s bodies, but of their souls; and they must give account for them. If a steward, a dispenser of temporal things, must be faithful, as Jacob watched his flock by day and night and whatever perished he made it good (Gen 31:39), how much more careful, circumspect and vigilant ought the dispenser of spiritual things be? The imperial laws have provided that advocates should stay out of the cities and places where they practiced. They should not busy themselves with other people’s affairs but attend to their own calling and charge. If those who merely fight for people’s bodies and their goods give such diligent attendance, how much more so is the same requisite for those who are charged with people’s souls? But nowadays it is counted so ordinary and easy a thing to be the pastor of souls that a person will require more diligence at his servant’s hands about his cattle than many will perform in the feeding of souls! God, in his good time, opens the eyes of some so they may see the great danger in which they, by their negligence and carelessness, cast themselves. God also makes them aware, so they may feel the heavy weight of the burden of souls.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Finally, not to heap up more arguments in so evident a matter, but pastors give great offense when they are absent unnecessarily. It is as if they were seeking to feed on their church rather than feeding their church. As the prophet Ezekiel complains of such idle shepherds, “You eat the fat, you clothe yourselves with the wool, you slaughter the fat ones, but you do not feed the sheep.” Saint Paul says to the Corinthians, “I seek not what is yours but you.” But those who do not care for Christ’s flock evidently proclaim that they do not seek them, but theirs. Of this kind of scandal and offense Augustine had experience in his people of Hippo. Of his flock he writes, “The people of Hippo, whose servant the Lord has made me, are so altogether weak that a little trouble is able to make them very sick: I found them at my return dangerously scandalized with my absence.” If the people took offense at Augustine’s necessary absence—for we know that such a holy man would not be absent without just cause—how much more grievous is the offense given by a pastor’s unnecessary absence? "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-216-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Eldest Brother.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think Eliab was speaking sternly to David out of the love and protection of an older brother for a younger one. Yet by means of the rough words he used and the untrue surmises he made, it is evident that Eliab spoke out of envy. Indeed, he spoke with great indignation. And this might be "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3069"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3070"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page83",
      "title": "83"
    }
  }), _vm._v("the reason why Eliab envied David, namely, because David was advanced to the king’s service and court, while Eliab, the firstborn brother, was neglected. It was for this reason that Eliab blamed David when he should have commended him—for by leaving his flock, David was merely obeying his father’s command to visit his brothers. In fact, Eliab took it on himself to judge David’s heart and affection, reckoning David’s goodness to pride and malice, whereas such virtues actually came forth from the Spirit of God in him. In this way David was envied by his brothers to serve as a type of Christ, who was rejected by his brothers the Jews. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-215-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_93"
    }
  }, [_c('b', [_vm._v("17:31-37")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Prepares for Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Serving Under a Prince.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" Nothing makes a person more fearful of wars than the dangers and hazards that accompany them. But if a person can serve under such a prince whose employments are not only honorable but also safe; if he, who is able and faithful to make good his promise to us that none of the strategies or forces of the enemy will hurt us, but that they shall fly before us while we resist them; who would not volunteer in such services as are not liable to the casualties and vicissitudes, which usually attend other wars, where he might fight with safety, and come off with honor? David had experience of God’s power in delivering him from the lion and the bear. He was well assured that God, who was careful of sheep, would be more caring to his people Israel. This gave him greater willingness to encounter Goliath, whose assurance was only in himself and not in God. "), _c('i', [_vm._v("The Sinfulness of Sin.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-214-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Circumcision of the Heart.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" As David holds the Philistine to be without defense—since he is uncircumcised—so he encourages himself because he was circumcised and so within God’s covenant. But David does not look to mere circumcision. Instead, he looks at it in relation to the covenant. Otherwise there were many who were bodily circumcised who did not belong to the covenant and many bodily uncircumcised who were the servants of God. (This appears, for instance, in the book of Job.) As circumcision, then, was a mark and outward recognition of God’s people, so baptism is now. As David’s circumcision defended him from Goliath, so baptism now shields us from Satan—but not merely the washing of the flesh, but as it is a seal of the covenant of grace in Christ. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-213-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Fear.")]), _vm._v(" "), _c('i', [_vm._v("Henry Airay:")]), _vm._v(" We read that David—after having experienced God’s help in his deliverance out of the paw of the lion and out of the paw of the bear—did not fear to encounter Goliath, but assured himself that “the Lord who delivered him out of the paw of the lion and the paw of the bear will deliver him from the hand of this Philistine.” In the same way, the children of God—after having felt the love of God in Christ Jesus in their souls and the testimony of the Spirit witnessing to their spirits that they are the sons of God—should not fear to encounter sin or Satan, but should assure themselves that nothing is able to separate them from the love of God in Christ Jesus. "), _c('i', [_vm._v("Lectures on Philippians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-212-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_94"
    }
  }, [_c('b', [_vm._v("17:38-40")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Outfits David but David Finds His Own Weapon")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Why David Put Off Saul’s Armor.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David would have used the armor if it had been helpful for him. But perceiving that they would rather be an impediment to him than a help, he laid them aside. This also brought about God’s providence, in the sense that God would not have David use any external defense, so that the glory of the victory might only be given to God. Furthermore, as there was a difference between the spirits of David and of Saul in the way in which they were "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3071"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3079"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page84",
      "title": "84"
    }
  }), _vm._v("led, so also their armor was different. Saul trusted in his helmet and breastplate, but David put his confidence in God. In this way David was a figure of Christ, who conquered Satan not by outward pomp and worldly power but by spiritual weapons. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-211-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of David’s Weapons.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David takes only his sling and certain smooth stones, for by such means the Lord brings to pass mighty things. Indeed, so that the glory and power of God might more fully be made manifest in the blessing of so simple a means—just as Moses brought waters out of the rock with his rod, Elisha healed the waters with salt and Christ cured the blind with spittle—David used this simple weapons because Israelites were formerly forbidden by the Philistines to use any iron weapons. David takes more than one stone—five all together—so that if at the first throw he fails, he might cast the others as needed. The typical application of these five stones to the five books of Moses, in which Satan is vanquished, is somewhat far-fetched, and therefore I will not stand on it. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-210-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Leaving Room for the Captain.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" When David went forth against Goliath, he did not grapple with him by his own strength, but with his sling and his stone overthrew him at a distance. It is not good to let Satan come too close to the soul, to let in his temptation, or to enter into any private and intimate combat with him. This was only for our captain to do who, we know, entered into the field with him as being certain of his own strength. But our only way to prevail against him is to take faith as a sling and Christ as a stone. "), _c('i', [_vm._v("The Sinfulness of Sin.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-209-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Walking in God’s Ways.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" David approached Goliath, walking in the calling of God. Therefore God established his portion against Goliath. Why, if you wished, God would establish your portion "), _c('i', [_vm._v("if")]), _vm._v(" you walked by faith. "), _c('i', [_vm._v("Commentary on Romans.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-208-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_95"
    }
  }, [_c('b', [_vm._v("17:41-58")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Fighting in the Name of the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overcoming Death.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" When David showed himself with a purpose to fight with Goliath, he spoke to this dreadful Philistine in this manner: “I come to you in the name of the Lord of hosts, the God of the armies of Israel.” But you, Christian souls, when you are encountering death, you may say to it, “Not only do I come to you in the name of he who commands legions of angels and all the armies of immortal spirits, but I also come to you clothed with his armor, strengthened by his Holy Spirit and assisted by him in person.” For Jesus Christ, who has overcome death "), _c('i', [_vm._v("for us")]), _vm._v(", intends to overcome death "), _c('i', [_vm._v("by us")]), _vm._v(". We are the living stones that he has chosen of his wonderful grace and mercy to bring down that proud insulting enemy, who causes all creatures to tremble and cover their faces with shame and confusion. "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-207-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Gospel of David’s Victory.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" When David had killed Goliath the giant, glad tidings came to the Israelites that their fearful and cruel enemy was dead and that they were delivered out of all danger. For this gladness, they sang, danced and were joyful. In like manner, the good news or “gospel” of God is joyful tidings; and, as some say, it is a good hearing proclaimed by the apostles throughout all the world of Christ as the real heir of David. It is good news of how he has fought with sin, death and the devil and overcome them. The result of this is that all people who were in bondage to sin, wounded with death and overcome of the devil are— without their own merits or deserving—freed, justified, restored to life and saved. They are brought to liberty and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3081"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page85",
      "title": "85"
    }
  }), _vm._v("reconciled to the favor of God and set at one with him again. These are tidings to as many as believe, laud, praise and thank God; and who are glad, sing and dance for joy. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-206-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("All Christians Are Strong.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" For though David was insignificant in person and weak compared with others, he nevertheless became a greater hero than Goliath and slew him. Therefore, because Christians all have the same Christ and his Spirit, every one of them, when they are most insignificant and weak, can do as much as the very strongest. For they shall, all of them, conquer sin, death and the world. They all gain the same victory, however different they may be. For there is one Spirit and one Christ in all of them, who protects them and helps them. To the world they may therefore appear to be nothing but falling and all be heroes and victors in that world. "), _c('i', [_vm._v("Lectures on Zechariah.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-205-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Little Person, Big Results.")]), _vm._v(" "), _c('i', [_vm._v("John Fisher:")]), _vm._v(" No man among all the great multitude of Israelites had the audacity or boldness to make battle with this monstrous creature, this Philistine, save only this little person David. It was Almighty God who gave him so great a boldness, although he was but little in appearance and stature. Nevertheless, he in no way feared to fight and make battle with this great and mighty giant. "), _c('i', [_vm._v("Commentary on the Seven Penitential Psalms.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-204-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Love of God.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" Our very actions are wrought in us and carried to their end by the power of Christ, who has enough mercy, wisdom and strength to rescue us from the power of hell and death and from the danger of our own sick and proud hearts. To see a person—half a mile from his enemy—draw a sword to encounter him or take up a stone to hit him would be a ridiculous spectacle. For what could he do with such weapons by his own strength at such a distance? But if he mounted a cannon and pointed his target against the enemy, we would not wonder at this even though the distance would be great between them because the effect of it proceeds from the force of the materials and instruments he uses, namely, the powder, the bullet, the fire and the cannon. It seemed absurd in the eyes of the enemy for little David—with a shepherd’s bag and a sling—to go against an armed giant like Goliath. This produced in the giant’s proud heart much disdain and offense. But when we hear David mention the name of God, in the strength and confidence where he came against so proud an enemy, this makes us conclude that weak David was strong enough to battle against great Goliath. It was not our own strength but the love of God that is the foundation of our triumph over all enemies. "), _c('i', [_vm._v("Seven Sermons on Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-203-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page86",
      "title": "86"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_96"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("18:1-30")]), _vm._v(" DAVID CONTINUES TO PREVAIL")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("As soon as he had finished speaking to Saul, the soul of Jonathan was knit to the soul of David, and Jonathan loved him as his own soul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And Saul took him that day and would not let him return to his father’s house.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Then Jonathan made a covenant with David, because he loved him as his own soul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And Jonathan stripped himself of the robe that was on him and gave it to David, and his armor, and even his sword and his bow and his belt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And David went out and was successful wherever Saul sent him, so that Saul set him over the men of war. And this was good in the sight of all the people and also in the sight of Saul’s servants.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("As they were coming home, when David returned from striking down the Philistine, the women came out of all the cities of Israel, singing and dancing, to meet King Saul, with tambourines, with songs of joy, and with musical instruments.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And the women sang to one another as they celebrated,")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("“Saul has struck down his thousands,")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("and David his ten thousands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And Saul was very angry, and this saying displeased him. He said, “They have ascribed to David ten thousands, and to me they have ascribed thousands, and what more can he have but the kingdom?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And Saul eyed David from that day on.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("The next day a harmful spirit from God rushed upon Saul, and he raved within his house while David was playing the lyre, as he did day by day. Saul had his spear in his hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And Saul hurled the spear, for he thought, “I will pin David to the wall.” But David evaded him twice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Saul was afraid of David because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was with him but had departed from Saul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("So Saul removed him from his presence and made him a commander of a thousand. And he went out and came in before the people.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And David had success in all his undertakings, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was with him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And when Saul saw that he had great success, he stood in fearful awe of him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("But all Israel and Judah loved David, for he went out and came in before them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Then Saul said to David, “Here is my elder daughter Merab. I will give her to you for a wife. Only be valiant for me and fight the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s battles.” For Saul thought, “Let not my hand be against him, but let the hand of the Philistines be against him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And David said to Saul, “Who am I, and who are my relatives, my father’s clan in Israel, that I should be son-in-law to the king?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("But at the time when Merab, Saul’s daughter, should have been given to David, she was given to Adriel the Meholathite for a wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Now Saul’s daughter Michal loved David. And they told Saul, and the thing pleased him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Saul thought, “Let me give her to him, that she may be a snare for him and that the hand of the Philistines may be against him.” Therefore Saul said to David a second time,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("“You shall now be my son-in-law.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And Saul commanded his servants, “Speak to David in private and say, ‘Behold, the king has delight in you, and all his servants love you. Now then become the king’s son-in-law.’”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And Saul’s servants spoke those words in the ears of David. And David said, “Does it seem to you a little thing to become the king’s son-in-law, since I am a poor man and have no reputation?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And the servants of Saul told him, “Thus and so did David speak.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Then Saul said, “Thus shall you say to David, ‘The king desires no bride-price except a hundred foreskins of the Philistines, that he may be avenged of the king’s enemies.’ ” Now Saul thought to make David fall by the hand of the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("And when his servants told David these words, it pleased David well to be the king’s son-in-law. Before the time had expired,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("David arose and went, along with his men, and killed two hundred of the Philistines. And David brought their foreskins, which were given in full number to the king, that he might become the king’s son-in-law. And Saul gave him his daughter Michal for a wife.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("But when Saul saw and knew that the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("was with David, and that Michal, Saul’s daughter, loved him,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("Saul was even more afraid of David. So Saul was David’s enemy continually.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3090"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page87",
      "title": "87"
    }
  }), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("Then the commanders of the Philistines came out to battle, and as often as they came out David had more success than all the servants of Saul, so that his name was highly esteemed.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("triangles")]), _vm._v(", or "), _c('i', [_vm._v("three-stringed instruments")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Hebrew "), _c('i', [_vm._v("by two"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers consistently view David as a messianic figure whose righteousness incites criticism and attacks from the unrighteous. In this case, Saul serves as the instrument of attack on account of his jealous and ungodly motives. Saul’s behavior toward David is malicious and, according to some of the commentators, demonic. Saul slyly offers his daughter to David, according to the interpreters, as a snare (and later marries her to another man). David’s friendship with Jonathan, by contrast, is the paradigm of godly and virtuous friendship, the likes of which set the ideal for relationships on earth.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_97"
    }
  }, [_c('b', [_vm._v("18:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David and Jonathan’s Friendship")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Difference Between Jonathan and Saul.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" We see the faith of David, which is necessary when following the cross and when faith gets tested. His victory over Goliath is itself the occasion of persecutions, for Saul could not bear someone else to be liked more. We see from this that the saints bear punishment just as sinners do, but not on account of sins but on account of righteousness. For what honor would not have been worthy of David for such a holy deed? But it happens just as Christ says in the psalm, “In return for my love they accuse me, but I give myself to prayer. So they reward me evil for good, and hatred for my love.” Scripture truly describes the difference between Jonathan and Saul with respect to David. Jonathan’s character was shown earlier in his love of virtue and piety, according to these words, “Those who fear you will see me and rejoice, because I have hoped in your word.” But it is impossible for the ungodly to do anything but hate and persecute the godly. But Jonathan is not afraid of losing glory and majesty, even though his father’s kingdom would have belonged to him, because he does not look on his own concerns but those of God. But it would be with him like it is with us when some look kindly on us, while others despise or hate us. The one group is more hidden and appears weaker before the world than the majority and the powerful who are able to be secure. Still, God cares for us, so that we see God’s work in every desperate situation, believing in God’s mercy and protecting hand even in the midst of death and hell, and not (as Paul says in 2 Cor 1) trusting in ourselves. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-202-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("True Friendship.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" The ground and foundation of true Christian friendship is the admiration of virtue or of some special gift of God that resides in another—the praise or use of which respects either God himself or a person. This moved Jonathan to knit himself in most firm friendship with David, whom for his valiant heart and noble courage in vanquishing proud Goliath he highly esteemed, honored and entirely loved. Such persons—as either some singular gift of true godliness or some special praise of some moral virtue (whether justice, fortitude, liberality, etc.)—excel others, and are therefore worthily invested with the title of deserved commendation, whom we thoroughly love, entirely reverence and heartily favor. And this latter is the secret or the next cause that we commonly use to respect and to regard. But the former of the two is that which is occasioned, bred and brought forth by a secret instinct of the Spirit from God: namely, the mutual knitting together of minds and a like inclination and conformity of wills. For all true and holy friendship has its ground from God, in whom it is firmly established "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3097"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page88",
      "title": "88"
    }
  }), _vm._v("and by whom alone it continues sure, steadfast and permanent. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-201-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Religion and Friendship.")]), _vm._v(" "), _c('i', [_vm._v("Henry Airay:")]), _vm._v(" Sincerity in religion and true fear of the Lord are the best bands of Christian friendship. We read in secular stories of some individuals who were renowned for their rare friendships. But what are these but shadows in respect to the Christian body? What friendship of theirs came ever near that of Jonathan and David? . . . Indeed, generally where religion and fear of the Lord knits the knot, there the friendship is most sure and the duties thereof are best performed. If, therefore, you will have such a friend . . . when need requires it . . . join yourself to someone who is religious and who fears the Lord; and let your love be in the Lord and for the Lord. For what is the cause that friendship is so rare, and why is there such slackness in all sorts of people to help one another and to comfort one another in any time of need? Surely this is the reason: because our love is only a cold love, grounded on this or that worldly respect, instead of our love for one another being in the Lord and for the Lord. "), _c('i', [_vm._v("Lectures on Philippians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-200-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Keeping One’s Promise.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" It is written of Jonathan that he gave to David as a pledge, bond or pawn of their newly begotten friendship not only the solemn citing of the name of God but also other visible gifts and outward testimonies—namely, his robe, girdle, sword, bow and such other garments and furniture he had at that time. For such hearty courtesies make people not only the more mindful but also the more religious in the keeping and observing of their promises and covenants. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-199-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Disarming Death.")]), _vm._v(" "), _c('i', [_vm._v("Charles Drelincourt:")]), _vm._v(" Just as our Savior has once overcome death for us, he continues to subdue it in and by us. He does us not let us encounter our enemies alone, nor leave us in our agonies. In a day of battle a wise and provident general has an eye to every place and encourages his soldiers by his action and with his voice when he perceives they are at blows with the enemy: some he loads with praises, others with promises. By that means he encourages those who act bravely and rescue the weak and feeble, and those who are overwhelmed he furnishes with fresh supplies. This is the same way our Lord and Savior Jesus Christ, the great Lord of hosts, who sits above in the heavens in triumph and beholds all our combats and encounters, deals with us. When he perceives that we are too weak, in order that we might not be overcome by our dreadful enemies he furnishes us with his Holy Spirit, and his own armor, as Jonathan did David, when he delivered to him his cloak, his bow, his belt and his sword. Besides, this merciful Savior disarms death of its most hurtful weapons and takes away all its arrows and darts. "), _c('i', [_vm._v("Christian Defense Against the Fears of Death.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-198-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_98"
    }
  }, [_c('b', [_vm._v("18:6-16")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Jealousy of David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Rules for Dancing.")]), _vm._v(" "), _c('i', [_vm._v("Martin Bucer:")]), _vm._v(" Because human nature has that feebleness by which it cannot always concentrate on grave and serious things but demands other rest besides sleep, there must also be provision made for certain rest from work and useful studies and a certain recreation of the strength of the spirit and of the body in play and games. This is especially the case when grave and serious things have been satisfied in wise moderation and prudence, insomuch that the kind of game is prescribed and exhibited for adults and youth in such a way that they do not have to fear any lessening of morals or delight in wicked idleness, and in a way that there can also be gained a certain strengthening of health as well as some addition in the cultivation of the mind. . . . These "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3109"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page89",
      "title": "89"
    }
  }), _vm._v("games should come from musical and gymnastic art. From this music should come poems and songs that present nothing futile, nothing inappropriate to the Christian profession and nothing obscene and wicked, but only sounds that set forth the praises of God and of his servants from all his works and judgments as these are set forth in holy Scripture. . . . To these may be added dances, but the dances of godly girls should be separate from the dances of young men, which may be danced to pure, wholesome and holy songs, with chaste and modest motion that befits those who profess godliness. . . . Such was the dance of holy girls who celebrated a song of victory for David and Saul when they returned from the killing of the Philistines. "), _c('i', [_vm._v("Reign of Christ.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-197-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Sin Against the Holy Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" As you know, we do not carelessly regard the words of Scripture to be the simple legends they seem to be. For this chapter clearly shows us Saul’s envy, which is the sin against the Holy Spirit. Scripture insists more than once that Saul knew the Lord had departed from him to be with David, along with all the counsel and favor that went with him, so that Saul has fallen. He is clearly fighting against knowledge of the truth, and therefore against God, as you see shortly. This is not a mistake or ignorance; rather it is pure folly and desperate ungodliness. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-196-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Vindictiveness Is a Great Anger.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Vindictiveness is a great anger, stemming from pride, one’s own wantonness to overwhelm or to blot out others without the orderly office of authority; such pride is often great, even though the perpetrator has no reason, as Cain, for imagining that God honors only the other and wishes to do nothing for him. This is very common, and all rational beings can understand that this vice is repugnant to many divine commandments. Pride, through which anger is kindled like a fire in the heart, is against the first commandment. Saul wishes to drive David out of the way in order that he alone may have authority. This unrighteous anger, this jealousy and hate and thirst for blood are against the commandment, “You shall not kill.” "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-195-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Advantages of Adversity.")]), _vm._v(" "), _c('i', [_vm._v("Roger Hutchinson:")]), _vm._v(" Our nature is such that prosperity depraves us. Prosperity brings many people to destruction and fills them with pride and covetousness; it makes them negligent, dissolute, forgetful and unthankful. . . . Therefore the wise person admonishes . . . “When you have refreshed yourself and are full of food and drink and other things, then take heed to yourself; you stand on a slippery ground.” Adversity, on the other hand, makes us lowly, gentle, diligent, circumspect and pitied. It garnishes us with all flowers of virtue and expels all sin. David, as long as he was in trouble and vexation under Saul, was in favor with God and famous among the people; but after he reigned and governed Israel prosperously, did he not fall into sin? . . . The devil is crafty. Those he cannot supplant by adversity he overthrows with prosperity. "), _c('i', [_vm._v("Two Sermons of Oppression, Affliction and Patience.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-194-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Triumph.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" Saul knew that David would succeed him as king. And so, considering himself to be in great danger, he planned to kill David. But all of his spirited attempts were in vain. And another event eventually showed this. For Joseph became the leader of his older brothers at the right time. And David became king, not as a normal family member of Saul’s. For Saul sinned to such an extent that not even David could preserve his family since it would all soon fall. But to David’s credit, the line of Saul was not damned. For although God removed a gift from someone and conferred it on another, he did "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3121"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3123"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page90",
      "title": "90"
    }
  }), _vm._v("not do it here for this reason, so that it would affect him inconveniently, but he would take counsel to his advantage by removal. "), _c('i', [_vm._v("Commentary on Romans.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-193-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Leering Eye.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" There are two ways to convey sin to us: by the ear and by the eye. And there are two ways to discover sin: by the mouth and by the eye. This is because the eye is a way both in the conveyance and discovery of the sin. . . . When Saul saw how David was esteemed, it is there said that he “eyed David from that day on,” as if he looked asquint, in that he looked on David with a leering eye. This is because he envied and hated David. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-192-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Lack of True Obedience.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" Note that constancy accompanies true obedience. For instance, the Scripture says that when we walk in the commandments of the Lord, we walk in peace. Conversely, the wicked are said to be involved in covetousness in that they constantly follow it as the thief does his trade. However, the “temporary” wicked person does not walk in these ways as does the honest traveler in the broad highway. . . . His obedience is like the true Christian’s disobedience, which is not settled and constant but is only for a time. The good Christian quickly remembers himself and returns to his course of godliness when, through a temporary lapse, he has begun to stray. In the same way, the “temporary” Christian quickly returns to his intermittent wickedness even though he occasionally stumbles on piety. His obedience is a moody and passionate obedience; it is soon forgotten. It is like Saul’s affection for David. When the evil spirit came on Saul, the piety about which he before seemed to make much of departed along with the spear in his hand. He did not, nor could he, cleave to the Lord with a full purpose of heart as the true believer can. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-191-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_99"
    }
  }, [_c('b', [_vm._v("18:17-30")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Offers Michal to David as a Wife at a Price")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On Hypocrisy.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" King Saul did not like David and would have liked to kill him; but since he wanted to be holy, he decided not to kill him himself, but to send him among the Philistines to be killed there, so that his hand would remain innocent. Look at this beautiful Pharisaic holiness! It can purify itself and stay pious as long as it does not kill with its own hand, though its heart may be crammed full of anger, hate and envy, of hidden and evil schemes of murder, and though its tongue may be loaded with curses and blasphemies. "), _c('i', [_vm._v("The Sermon on the Mount.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-190-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Deceitful Plan.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Saul said to David, “Behold, my daughter.” This is an example of the greatest men being seen as hypocrites. They see themselves as good men. They handle themselves in such a way as to excuse their sins. They say to us, “It is not lawful for us to put anyone to death” and they did not enter Pilate’s quarters so that they would not be defiled and could eat the Passover. Scripture calls them men of blood, of deceit, of lies and of works of iniquity, as in Psalms 5, 58, 140 and Isaiah 59, etc. This reveals Saul’s hypocrisy, which continues to the end of the chapter. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-189-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Three-Knot Chain.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" With people it oftentimes happens that saying is without doing. That is, too often people promise and say much, but do nothing; and many times we see a person’s doing to be without completing. . . . Saul said he would give Michal to David, but he did not do it. However, it is not so with God; for he is not “yes” in saying, and “no” in doing and performing. Rather, as certain as he says a thing, so surely it is done—for his word is truth, and his deeds declare it. . . . If God begins a good work, he will surely finish it thoroughly. . . . If he is the beginner "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3129"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page91",
      "title": "91"
    }
  }), _vm._v("and author of anything, he will also perfect it. . . . This is the first consideration when it comes to God: that these three things—saying, doing and perfecting—are inseparable in him, joined and linked together as a chain, where all proceed after the other and all follow the first. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-188-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hidden Agenda.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" David had grown so gracious with the people that the king could not harm him. Therefore he lured him into the jaws of death by no less a price than his eldest daughter. What could be spoken more honorably, more graciously? A king could not offer a more noble gift than his own daughter nor desire a more gracious reward than to fight the Lord’s battles. What a saint, what a friend was Saul! Yet he never meant so much mischief to David and so much unfaithfulness to God as in this offer! A good man is never safe from the false-hearted: For when they make the fairest weather, that’s when the greatest danger is. Whatever the appearance was, Saul meant nothing to David but death. Yet this falsehood did discover itself, for Merab was not given to David but to Adriel. Seeing that all these dangers could not bring about what Saul desired, he himself would not bring about what he promised. Yet still he would be a friend and he had another daughter for David; even though she was younger, she was the more affectionate one. She was as sick in love as her father was of hate toward David. Saul was glad of this, as his daughter could never live to do him better service. If she could betray David, David would have his goodwill to marry her. Thus this false-hearted king sacrificed his own child to his envy, hoping that her honest and sincere love would betray her worthy and innocent husband. There is a story of an emperor in Turkey who married his own daughter to a man on the one day and then after a night’s pleasure sent for his head the next morning. Are there none who care not to cast away a daughter on their friend for their own ends? Such is the rage of desperate malice; rather than not ruin those they hate, they will do it through the means of their own children. “Faithful are the wounds of a friend, but the kisses of an enemy are deceitful.” . . . We pray, from the hands of all our enemies, and (of all our enemies) from the hands of our deceitful friends, good Lord deliver us. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-187-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Giftless Gift.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" The devil sometimes gives the truth. In fact, he sometimes sets a snare to catch the truth. He does so as Saul, a good student in Satan’s school, did for David in giving him Michal as a wife. “I will give him her,” Saul reasons, “so that she may be a snare to him and so that the hand of the Philistines may be upon him.” What a splendid show of favor and goodwill! Yet David was so ravished by the offer, thinking about his lowness of birth, that he was honored with the prospect of so great a marriage. But it is but bait—a phony poison is covering up the hook. . . . It is just as the proverb says: Saul’s gift to David was a “giftless gift.” It was bread in one hand and a stone in the other. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-186-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Benefit of an Enemy.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" We may not deny but that a person may have gain by an enemy, as poison to some creatures affords nourishment. . . . They say the sweetest roses are the ones that grow near garlic. In the same way, the nearness of an enemy makes a good person even better. . . . When Saul, David’s enemy, eyed and persecuted him, this made him walk more circumspectly, pray more and trust in God more: He thought, “I will guard my ways, that I may not sin with my tongue; I will guard my mouth with a muzzle, so long as the wicked are in my presence.” . . . A malicious enemy that watches for our halting will make us look the better to our ways. "), _c('i', [_vm._v("Seven Sermons on the Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-185-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page92",
      "title": "92"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_100"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("19:1–20:42")]), _vm._v(" SAUL MAKES AN ATTEMPT ON DAVID’S LIFE")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Saul spoke to Jonathan his son and to all his servants, that they should kill David. But Jonathan, Saul’s son, delighted much in David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And Jonathan told David, “Saul my father seeks to kill you. Therefore be on your guard in the morning. Stay in a secret place and hide yourself.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And I will go out and stand beside my father in the field where you are, and I will speak to my father about you. And if I learn anything I will tell you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And Jonathan spoke well of David to Saul his father and said to him, “Let not the king sin against his servant David, because he has not sinned against you, and because his deeds have brought good to you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("For he took his life in his hand and he struck down the Philistine, and the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("worked a great salvation for all Israel. You saw it, and rejoiced. Why then will you sin against innocent blood by killing David without cause?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And Saul listened to the voice of Jonathan. Saul swore, “As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, he shall not be put to death.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And Jonathan called David, and Jonathan reported to him all these things. And Jonathan brought David to Saul, and he was in his presence as before.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And there was war again. And David went out and fought with the Philistines and struck them with a great blow, so that they fled before him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Then a harmful spirit from the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("came upon Saul, as he sat in his house with his spear in his hand. And David was playing the lyre.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And Saul sought to pin David to the wall with the spear, but he eluded Saul, so that he struck the spear into the wall. And David fled and escaped that night.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Saul sent messengers to David’s house to watch him, that he might kill him in the morning. But Michal, David’s wife, told him, “If you do not escape with your life tonight, tomorrow you will be killed.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("So Michal let David down through the window, and he fled away and escaped.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Michal took an image")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("and laid it on the bed and put a pillow of goats’ hair at its head and covered it with the clothes.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And when Saul sent messengers to take David, she said, “He is sick.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Then Saul sent the messengers to see David, saying, “Bring him up to me in the bed, that I may kill him.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And when the messengers came in, behold, the image was in the bed, with the pillow of goats’ hair at its head.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Saul said to Michal, “Why have you deceived me thus and let my enemy go, so that he has escaped?” And Michal answered Saul, “He said to me, ‘Let me go. Why should I kill you?’”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Now David fled and escaped, and he came to Samuel at Ramah and told him all that Saul had done to him. And he and Samuel went and lived at Naioth.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And it was told Saul, “Behold, David is at Naioth in Ramah.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Saul sent messengers to take David, and when they saw the company of the prophets prophesying, and Samuel standing as head over them, the Spirit of God came upon the messengers of Saul, and they also prophesied.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("When it was told Saul, he sent other messengers, and they also prophesied. And Saul sent messengers again the third time, and they also prophesied.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Then he himself went to Ramah and came to the great well that is in Secu. And he asked, “Where are Samuel and David?” And one said, “Behold, they are at Naioth in Ramah.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And he went there to Naioth in Ramah. And the Spirit of God came upon him also, and as he went he prophesied until he came to Naioth in Ramah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And he too stripped off his clothes, and he too prophesied before Samuel and lay naked all that day and all that night. Thus it is said, “Is Saul also among the prophets?”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("20")]), _vm._v(" "), _c('i', [_vm._v("Then David fled from Naioth in Ramah and came and said before Jonathan, “What have I done? What is my guilt? And what is my sin before your father, that he seeks my life?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And he said to him, “Far from it! You shall not die. Behold, my father does nothing either great or small without disclosing it to me. And why should my father hide this from me? It is not so.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("But David vowed again, saying, “Your father knows well that I have found favor in your eyes, and he thinks, ‘Do not let Jonathan know this, lest he be grieved.’ But truly, as "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3130"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page93",
      "title": "93"
    }
  }), _c('i', [_vm._v("the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives and as your soul lives, there is but a step between me and death.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then Jonathan said to David, “Whatever you say, I will do for you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("David said to Jonathan, “Behold, tomorrow is the new moon, and I should not fail to sit at table with the king. But let me go, that I may hide myself in the field till the third day at evening.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("If your father misses me at all, then say, ‘David earnestly asked leave of me to run to Bethlehem his city, for there is a yearly sacrifice there for all the clan.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("If he says, ‘Good!’ it will be well with your servant, but if he is angry, then know that harm is determined by him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Therefore deal kindly with your servant, for you have brought your servant into a covenant of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("with you. But if there is guilt in me, kill me yourself, for why should you bring me to your father?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And Jonathan said, “Far be it from you! If I knew that it was determined by my father that harm should come to you, would I not tell you?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Then David said to Jonathan, “Who will tell me if your father answers you roughly?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And Jonathan said to David, “Come, let us go out into the field.” So they both went out into the field.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And Jonathan said to David, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, be witness!")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("When I have sounded out my father, about this time tomorrow, or the third day, behold, if he is well disposed toward David, shall I not then send and disclose it to you?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("But should it please my father to do you harm, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("do so to Jonathan and more also if I do not disclose it to you and send you away, that you may go in safety. May the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("be with you, as he has been with my father.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("If I am still alive, show me the steadfast love of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", that I may not die;")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("and do not cut off")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("your steadfast love from my house forever, when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("cuts off every one of the enemies of David from the face of the earth.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Jonathan made a covenant with the house of David, saying, “May")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("take vengeance on David’s enemies.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And Jonathan made David swear again by his love for him, for he loved him as he loved his own soul.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Then Jonathan said to him, “Tomorrow is the new moon, and you will be missed, because your seat will be empty.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("On the third day go down quickly to the place where you hid yourself when the matter was in hand, and remain beside the stone heap.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And I will shoot three arrows to the side of it, as though I shot at a mark.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And behold, I will send the boy, saying, ‘Go, find the arrows.’ If I say to the boy, ‘Look, the arrows are on this side of you, take them,’ then you are to come, for, as the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, it is safe for you and there is no danger.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("But if I say to the youth, ‘Look, the arrows are beyond you,’ then go, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has sent you away.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("And as for the matter of which you and I have spoken, behold, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("is between you and me forever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("So David hid himself in the field. And when the new moon came, the king sat down to eat food.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("The king sat on his seat, as at other times, on the seat by the wall. Jonathan sat opposite,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("f")]), _vm._v(" "), _c('i', [_vm._v("and Abner sat by Saul’s side, but David’s place was empty.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Yet Saul did not say anything that day, for he thought, “Something has happened to him. He is not clean; surely he is not clean.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("But on the second day, the day after the new moon, David’s place was empty. And Saul said to Jonathan his son, “Why has not the son of Jesse come to the meal, either yesterday or today?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Jonathan answered Saul, “David earnestly asked leave of me to go to Bethlehem.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("He said, ‘Let me go, for our clan holds a sacrifice in the city, and my brother has commanded me to be there. So now, if I have found favor in your eyes, let me get away and see my brothers.’ For this reason he has not come to the king’s table.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("Then Saul’s anger was kindled against Jonathan, and he said to him, “You son of a perverse, rebellious woman, do I not know that you have chosen the son of Jesse to your own shame, and to the shame of your mother’s nakedness?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("For as long as the son of Jesse lives on the earth, neither you nor your kingdom shall be established. Therefore send and bring him to me, for he shall surely die.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("Then Jonathan answered Saul his father, “Why should he be put to death? What has he done?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("But Saul hurled his spear at him to strike him. So Jonathan knew that his father was determined to put David to death.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("And Jonathan rose from the table in fierce anger and ate no food the second day of the month, for he was grieved for David, because his father had disgraced him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("In the morning Jonathan went out into the field to the appointment with David, and with him a little boy.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("And he said to his boy, “Run and find the arrows that I shoot.” As the boy ran, he shot an arrow beyond him. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3131"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3138"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page94",
      "title": "94"
    }
  }), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("37")]), _c('i', [_vm._v("And when the boy came to the place of the arrow that Jonathan had shot, Jonathan called after the boy and said, “Is not the arrow beyond you?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("38")]), _c('i', [_vm._v("And Jonathan called after the boy, “Hurry! Be quick! Do not stay!” So Jonathan’s boy gathered up the arrows and came to his master.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("39")]), _c('i', [_vm._v("But the boy knew nothing. Only Jonathan and David knew the matter.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("40")]), _c('i', [_vm._v("And Jonathan gave his weapons to his boy and said to him, “Go and carry them to the city.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("41")]), _c('i', [_vm._v("And as soon as the boy had gone, David rose from beside the stone heap")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("g")]), _vm._v(" "), _c('i', [_vm._v("and fell on his face to the ground and bowed three times. And they kissed one another and wept with one another, David weeping the most.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("42")]), _c('i', [_vm._v("Then Jonathan said to David, “Go in peace, because we have sworn both of us in the name of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", saying, ‘The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("shall be between me and you, and between my offspring and your offspring, forever.’” And he rose and departed, and Jonathan went into the city.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("h")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("a household god")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Hebrew lacks "), _c('i', [_vm._v("be witness")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Or "), _c('i', [_vm._v("but if I die, do not cut off")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint "), _c('i', [_vm._v("earth,")]), _vm._v(" "), _c('i', [_vm._v("16")]), _c('i', [_vm._v("let not the name of Jonathan be cut off from the house of David. And may")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("the stone Ezel")]), _vm._v(" "), _c('b', [_vm._v("f")]), _vm._v(" Compare Septuagint; Hebrew "), _c('i', [_vm._v("stood up")]), _vm._v(" "), _c('b', [_vm._v("g")]), _vm._v(" Septuagint; Hebrew "), _c('i', [_vm._v("from beside the south")]), _vm._v(" "), _c('b', [_vm._v("h")]), _vm._v(" This sentence is 21:1 in Hebrew"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The interpreters here find comfort in David’s protection from Saul. For example, Knox deduces that God protects the godly from evil snares. Some regard Jonathan as driven by God’s Spirit and Saul as driven by an evil spirit. The reformers weigh Michal’s actions—did she lie to her father Saul? Luther uses this instance to cite Augustine’s threefold definition of lies. The combined actions of Saul’s children Michal and Jonathan, both of whom come to the aid and support of David over against Saul, are indications of God’s providence and goodness.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Is Driven by a Hidden Hatred.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" These chapters set before our eyes the fact that the Spirit of God drove Jonathan and an evil spirit drove Saul. The one loves and defends the innocent and godly; the other hates and persecutes it. This hatred fills him with such rage that his son Jonathan is not spared from it. No wonder, when he rages and is indignant against the divine judgment that God begins to prefer David, as we clearly saw in chapter 18. This state of being lives most horribly in the hearts of the ungodly, so that they are not able to see it hidden in themselves. But immediately and clearly through the revealed Spirit, the godly sense to come to pray, acknowledging that they do not follow God’s will in all things and saying, “your will be done.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-184-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_101"
    }
  }, [_c('b', [_vm._v("19:1-7")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul Announces His Plan to Kill David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s False Words.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" By speaking the truth, Jonathan convinces Saul, who then swears falsely to God that he will not kill David, even though he cannot bear his hatred for him. By this you see how a person does not have free will. Some people are driven by evil spirits like Saul; others are led by the Spirit of God, like the godly in Romans 8. And this Spirit, even at those times when we cannot see, is given occasions to reveal itself. For the blessed one is like a good tree that yields fruit in its season, as Psalm 1 says. Similarly, the ungodly receive occasions to yield the fruits of their unbelief. You have this example in Saul, who—despite having made his oath—seeks to kill David, after David had fought bravely and saved the people’s life. Thus blindness and impiety lead to hatred. This sign is a figure for those who persecute the gospel, that is, the kingdom of Christ the true David. . . . Saul hoped that the Philistines would do away with David, just as Satan once led Christ to the cross. But this only made David’s glory increase, as he is cleansed wherever he goes, being driven by God, who delivers him even in death and leads him to the kingdom through the cross, against the will of Satan. You see this in those hypocrites who say with Saul, “I will not lay my hand on him.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-183-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3146"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page95",
      "title": "95"
    }
  })]), _c('b', [_vm._v("God’s Deliverance.")]), _vm._v(" "), _c('i', [_vm._v("John Knox:")]), _vm._v(" The notion that God delivers his chosen from their enemies is not written for David only, but for all those who shall suffer tribulation, until the end of the world. For I, John Knox—let this be said to the acclaim and praise of God alone—in anguish of mind and vehement tribulation and affliction, called on the Lord when not only the ungodly but even my faithful brothers (even my own self, that is, my natural understanding) judged my case to be irremediable. And yet, in my greatest calamity, and when my pains were most cruel, God’s eternal wisdom willed that my hands should be a writer, far contrary to the judgment of carnal reason, which his mercy has proved true, blessed be his holy name. And therefore I dare to be bold in the truth of God’s Word to promise that—notwithstanding the vehemence of trouble, the long continuance of it, the despair of all people and the fearfulness, danger, pain and anguish of our own hearts—yet if we call constantly to God, even beyond all human expectation, he shall deliver. "), _c('i', [_vm._v("Treatise on Prayer.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-182-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Forgiving and Forgetting.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Becon:")]), _vm._v(" King David was unjustly persecuted by Saul, and his life very narrowly sought. Yet the Spirit of God was so strong in David that he did not only not seek to avenge himself but also forgave his enemy Saul and never did or sought out any evil against him. Even when Saul was in his clutches he not only did not kill him but also did not even touch him. "), _c('i', [_vm._v("A New Catechism.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-181-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_102"
    }
  }, [_c('b', [_vm._v("19:8-17")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Michal’s Ruse")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On Lying.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" Augustine says there are three kinds of lies. It is a harmful lie when a falsehood is spoken out of a desire to deceive one’s neighbor for the purpose of injuring them, their property, their reputation or their very life. And this is worst when lies and false doctrines are spread under the name of God. God forbids this in the eighth commandment when he says: “You shall not bear false witness.” The second kind is the obliging lie, that is, a lie of love or compassion, as when the government happened to be searching for a thief to punish him and I knew where he was yet said that I did not know. In that case I am lying, not to harm, but to help my neighbor. Or if I saw that someone had designs on the chastity of a virgin or matron, and I pretended not to know her, then I would be lying to help, and out of respect for, the girl. Thus Michal is lying to her father when she says that David went way away, but she is doing this to help David. Accordingly, where it can be done without harm to the government or to parents, one may protect and defend those whom they are seeking or are asking about. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-180-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Righteous Deceptions.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Whether through Jonathan or through Michal, God’s providence keeps David unharmed wherever he goes. You ask: Is it allowed to deceive enemies in word or deed, both of which you see here? I reply: the law allows interest to be taken from Gentiles. Snares may be set for enemies to fall on, as they are even set by God sometimes. You see this in history, that it is allowed for the godly to do this against enemies but not allowed for others. You see many examples in the Scriptures, where the saints deceive the ungodly for the well-being of themselves and others. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-179-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Two Bodies Cannot Be in the Same Place Simultaneously.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" Do you not remember . . . what Michal, David’s wife, did and what device she practiced when she concealed the sight of her husband from her father Saul and his servants, who sought to slay him? Have you not read that which is written in this section, how she by craft and colorable means placed an image in place of David’s body—but not by any devilish art nor after the manner of sorcerers? She laid pillows "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3155"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page96",
      "title": "96"
    }
  }), _vm._v("under his head, trimming him with garments so finely and cunningly that Saul’s servants clearly thought David was there, as they beheld David’s counterfeit so lively set forth before their eyes. So likewise Satan, to the intent he may keep from us the absence of his adherents, in place of their true body—which is away—places there a false body when we chance to inquire. Whereby it comes to pass that many supposed that sorcerers are not bodily present at their secret assemblies, which they themselves contend that they were at, and because they perceive and find false and counterfeit bodies—instead of their own bodies—laid in their rooms and beds by Satan. But surely those who judge so are very much confused. "), _c('i', [_vm._v("Dialogue of Witches.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-178-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On God’s Providence.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" The prophet and king David said clearly: “But I trust in you, O Lord; I say, ‘You are my God.’ My times are in your hands.” Nevertheless, even he, who was one who totally joined himself to divine providence, carefully considered how he could diligently and industriously elude the deception of his father-in-law Saul. Nor did he despise the help and machinations of his beloved wife Michal. He did not reply to her: “All has occurred through the providence of God; therefore, there will be no need for scheming. God, who is all powerful, is able to rescue me from the hands of our father’s soldiers or to save me in another miraculous way. Let us be in peace and allow God to do something for us.” Rather, David understood that providence proceeds in a certain order through means of other things, so that it was his task to apply himself, in the fear of the Lord, to his own protection. "), _c('i', [_vm._v("Decades 4.4.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-177-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Persistent Idolatry.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" The statue Michal placed in the bed in place of David, I think, was an image that had been preserved somewhere from among the relics of superstition and idolatry. Among us, too, many statues are left that are preserved in one place in memory of the old idolatry, in another place as exhibits and objects of amusement for children, not worship. In David’s time such idols lay hidden away in the corners of buildings. Now when Michal had nothing else at hand, she quickly pulled out the statue and put it in David’s place. Undoubtedly there remained even at that time many vestiges of superstitions and idolatries from the kingdom and religion of the Jebusites as well as shouts of protest that could not be completely dispelled. Of this the worried complaints of many of the psalms testify, in which David with great grief prays and fights against idolatry. "), _c('i', [_vm._v("Lectures on Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-176-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Christological Undertones.")]), _vm._v(" "), _c('i', [_vm._v("Nikolaus Selnecker:")]), _vm._v(" Such histories about David’s crossbearing, suffering and deliverance are figures and images that signify the Lord Christ and his church—how, as several scribes point out excellently, Michal therefore placed an image in David’s place in bed and a goatskin at the head of the bed, so that the true David signifies Christ and the true sacrifice. "), _c('i', [_vm._v("The Whole Psalter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-175-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_103"
    }
  }, [_c('b', [_vm._v("19:18-24")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Spirit of God Co-opts Saul and His Attendants")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On Prophecy: What It Is and Who Does It.")]), _vm._v(" "), _c('i', [_vm._v("Hieronymus Weller von Molsdorf:")]), _vm._v(" In this passage the word “to prophesy” means . . . to hear, interpret and discuss the Word of God. But because the passage seems to prompt a discussion, let us speak about prophecy. Prophecy is threefold. First, there is what we otherwise call “the gift of interpretation,” when we interpret the prophetic and apostolic writings, and rightly instruct, strengthen and exhort consciences in the Word of God. This prophecy holds the highest rank, for it preserves the ministry of the gospel (1 Cor 12). Second is the prediction of things to come. When Joseph in Egypt interpreted Pharaoh’s dream—that was this kind of prophecy. Also, when Daniel "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3169"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page97",
      "title": "97"
    }
  }), _vm._v("expounded Nebuchadnezzar’s dream as well as the image in his other dream. Also, when the prophets foretold the fall of kingdoms, the destruction of cities and the defeat of nations. These two particular kinds of prophecy are confirmed in Scripture. The third kind of prophecy is astrology, when either from the observation and orbit of the stars or by the inspiration of some particular angel they foretell wars, seditions, plagues and similar calamities. However, these divinations that happen from the observation of the stars are ambiguous and uncertain. Those that happen by the inspiration of angels are certain, and the events correspond to them.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“The Spirit of God also came upon them.” That is, they too began to hear, cherish and meditate on the Word of God. For the same thing happened to them that happened to the servants of the Pharisees who were sent to arrest Christ (John 7). For in the same way that by hearing Christ’s preaching, those servants changed their minds and converted, so also the attendants of Saul as soon as they began to hear Samuel’s preaching, they immediately changed their mind about dragging David off for punishment, and instead they reverently cherished and contemplated the Word of God. For to prophesy in Scripture not only means to interpret the Word but also to hear and contemplate it, to glorify the name of God and give thanks to God. For “the Spirit of the Lord came upon them,” that is, the Holy Spirit touched their hearts by hearing the Word. This idea stands firm in Isaiah 55: “My Word does not return to me void, but effects whatever I will, and it will succeed in the matter for which I sent it.” We should gather this here from their example, who, even though they did not want to learn, because of the holy preaching they heard they were nevertheless converted.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“And again Saul sent a third group of messengers.” Saul was not at all moved by this miracle: that the previous attendants whom he sent to seize David had been converted by hearing Samuel’s preaching. Instead he proceeds to send a third group. Thus hardened enemies of the gospel are not moved by any miracles, so that they come to their senses. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“The Spirit of God came over him also, and as he walked, he prophesied until he came to Naioth in Ramah.” That is, the Holy Spirit stirred Saul up too, so that he prophesied. This agrees with Matthew 7, as well as the examples of Balaam, Caiaphas and Judas the traitor—sometimes even the impious are given the gift of prophecy from God. For there is absolutely no doubt that Judas, just like the other apostles, was able to prophesy; that is, he was able to teach the gospel and to perform miracles. But this is the difference between people like Judas and true prophets: true prophets teach the pure and unadulterated Word of God, and they reflect the true and genuine meaning of the Scripture. Accordingly those like Judas persevere in sound doctrine, but “they do not walk in step with the truth of the gospel.” However, they eventually introduce distortions to the Word of God—even as they teach the Word of God, pure and unadulterated, against their own will, or as they seem to be true teachers. Nevertheless, afterward they abandon sound doctrine and conspire with the enemies of true doctrine. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-174-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_104"
    }
  }, [_c('b', [_vm._v("20:1-23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("A Covenant Between Jonathan and David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Saints’ Examples, Good and Bad, Are for Our Consolation and Instruction.")]), _vm._v(" "), _c('i', [_vm._v("Justus Menius:")]), _vm._v(" It cannot happen, whenever the human mind begins to waver concerning the truth of God’s promises, that it could entrust itself to any other protection no matter how great, firm and safe it may be. Accordingly, David begins to doubt even most faithful Jonathan’s friendship, loyalty and help. Truly nothing is safe enough, no indeed, nothing is not suspect for a conscience hesitating in faith. Now these words reveal David’s mistrustful mind, when he says, “If there is any iniquity in me, kill me yourself, and bring me to your father.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3181"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page98",
      "title": "98"
    }
  }), _vm._v("There are two reasons why Scripture records the saints’ weakness and sin. Indeed the first is for our consolation, certainly, so that it might rouse our faith, lest we despair at the sight of our sin or some other weakness. Imagining that in the flesh the saints lived without sin, full of faith, full of the Spirit and full of righteousness, as if in complete and constant perfection, we focus on how plainly hopeless such perfection is; we will never be able to achieve it. Second, lest we slip into self-assured security and, unwisely abandoning all fear of God, we impiously place trust in our self-righteousness and hypocrisy, and we judge ourselves to be perfect, even in what we have not yet begun rightly. For who will dare to boast of their perfection when they see David’s weak faith and elsewhere that he falls into such stupid and shameful deeds? And not only when we regard this one man but also so great a host of God’s saints? So then, let us consider the saints’ weakness and sin, so that, firm in faith, even when we fall through our weakness, we would always fear, trust and pray to God; so that when we stand firm, God would guard us through his grace, not desert us, and when we fall, through his mercy he would lift us up and sustain us. "), _c('i', [_vm._v("Commentary on 1 Samuel 20.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-173-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Friend over Father.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" When a person is faithfully professed in a league of sincere and true friendship, he prefers and more esteems his friend than he does any other person. He bears toward him a far greater affection and zeal than to all other people, for Jonathan did seem to prefer his dear friend David before his own natural father. This type of friendship is not displeasing to God, nor does it willfully transgress his holy will and commandment. For Jonathan revealed and opened his father’s secret counsel to David and discovered by devices what his father’s purpose, sayings and meanings were toward him. Indeed, Jonathan was not at all afraid to reveal and disclose to David the shameful thoughts of his father, King Saul. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-172-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_105"
    }
  }, [_c('b', [_vm._v("20:24-31")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Jonathan’s Excuse and Saul’s Response")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Lying for a Friend.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" It is not lawful to lie for the sake of a friend, thereby to help his cause or to bring him out of a difficult situation. However, sometimes and in some cases it is not forbidden us to cause to evade a matter for a friend, or to give an impression and countenance some things as though they were true, which in deed are not so. I am referring to such things whereby God is neither dishonored nor our neighbor damned. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-171-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of Jonathan’s Excuse.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Because Jonathan charitably intended to do good to David and to do no harm to anyone in excusing David in this manner, he is freed from any great imputation of untruth. And besides, the sum and substance of the excuse—that there was a yearly feast at Bethlehem for David’s family—was likely true. It is also likely that David really asked leave to go there. Yet it seems that Jonathan added other details, namely, that David’s brother had commanded him to go there. However, David did not make mention of his brother sending for him; nor did he ask Jonathan to say so. On the contrary, David merely asked permission to go to Bethlehem. Josephus mentions that Jonathan’s addition to David’s words show duplicity to some degree. However, Jonathan was not accustomed to making such excuses, and he therefore speaks somewhat uncertainly and timorously. "), _c('i', [_vm._v("Harmony on 1 Samuel")]), _vm._v("."), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-170-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Exasperating One’s Children.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" Children are provoked if parents endeavor to load them with impious and unjust commands. It was impious of Saul when he commanded Jonathan to seize and bring David his friend, guiltless of any crime, that he might be put "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3188"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3189"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page99",
      "title": "99"
    }
  }), _vm._v("to death. Hence we read that Jonathan was inflamed with grief and anger. . . . It pertains to this provocation as well, when parents being seized with anger rashly revile and wound their children when they do not deserve it, with contemptuous and unbecoming language. For such scorn has a certain sting, which it is very difficult for even prudent persons to endure. Saul also provoked his son Jonathan with this kind of injury where he breaks forth in these words, “You son of a perverse and rebellious woman! Don’t I know that you have sided with the son of Jesse to your own shame and to the shame of the mother who bore you?” What could be said to be more bitter to provoke a son than that in order to reproach him he even reviles his own wife as a common prostitute? "), _c('i', [_vm._v("Exposition of Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-169-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_106"
    }
  }, [_c('b', [_vm._v("20:32-42")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Jonathan’s Goodness Versus His Father’s Evil")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Madness over David.")]), _vm._v(" "), _c('i', [_vm._v("Menno Simons:")]), _vm._v(" Saul regarded neither the piety nor the kindness, the fidelity nor the good deeds of David toward him and all Israel, nor the grace, the works and the will of God. He became so insane and drunken in his wrath and envy that the enemies and betrayers of David . . . were highly regarded and honored by him. But the peacemakers and those who advised for good, such as his own son Jonathan, were hated by him and considered suspect. In short, David had to take to his heels . . . until Saul was vanquished on Mount Gilboa by the Philistines, and there through utter despair and gloom he plunged the sword, which he had drawn against the righteous and the innocent, into his own heart, taking his own life. "), _c('i', [_vm._v("Cross of the Saints.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-168-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Jonathan as a Good Son.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Jonathan the son of Saul is a very godly and pious example for us. His father’s fury against David as well as his father’s injuries against himself caused him great pain and anguish. Nevertheless he prudently tolerated and concealed it until he could speak of it to him at the appropriate time and place. He never helped his father in his wicked ways. Instead he always clung to righteous and good things, he deplored his father’s stubbornness, and he did not resist him in boldness when he was dealt with violently but simply fled. Through all this, nevertheless, he loved his father and prayed for his health, in all ways showing himself to be a son who shows great respect. This is truly the duty of a godly son. "), _c('i', [_vm._v("Decades 2.5.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-167-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Jonathan’s Humility.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Jonathan is humble; he knows that he is too weak for the kingdom; he knows that blissful rule is God’s work alone, and he has fear of God in the knowledge of his sins and unworthiness. He remains in his calling; he does not wish to make himself king; he does not wish to push David aside; he relies on God, who helps and gives him success in his station. Later he is obedient to God, even though God removes him entirely away. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-166-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Love as the Foundation.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" The love of the church is the foundation of all our prayers and endeavors for the prosperity of the church. A person will not very hastily seek the good of those whom he does not love. Therefore when Christ requires that we should love our enemies, he adds as a fruit of it that we should pray for them. Love made Jonathan intercede with his father for David even when he knew his displeasure against him. How much more will it move us to intercede with God for his beloved people, the spouse of his own Son? "), _c('i', [_vm._v("Seven Sermons on Fourteenth Chapter of Hosea.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-165-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Is Driven by a Hidden Hatred.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Again this chapter sets "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3192"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page100",
      "title": "100"
    }
  }), _vm._v("before our eyes the fact that the Spirit of God drove Jonathan and an evil spirit drove Saul. The one loves and defends the innocent and godly; the other hates and persecutes it. This hatred fills him with such rage that his son Jonathan is not spared from it. No wonder, when he rages and is indignant against the divine judgment that God begins to prefer David, as we clearly saw in chapter 18. This state of being lives most horribly in the hearts of the ungodly, so that they are not able to see it hidden in themselves. But immediately and clearly through the revealed spirit, the godly sense to come to pray, acknowledging that they do not follow God’s will in all things and saying, “your will be done.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-164-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Increasing Friendship.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" Friendship requires the company, the sight and the familiar conversation of friends together among themselves. Therefore it is only among those who are either daily conversant with another or have previously spent much time together. For familiar conversation and frequent keeping in company increases (as the proverb says) this friendship, and sews people together in this indissoluble agreement of minds. No friendship has so much love and affection that there cannot possibly be any greater increase, or to which nothing can be either added or put into it. It requires therefore a mutual meeting and familiar conversation, because it is by this that our goodwill, liking and affection is increased, strengthened and made greater. It was this sort of friendship David and Jonathan shared, not only at the first occasion of their friendship . . . when they spoke in Saul’s house, but also as it continued to increase and grow. For . . . this frequent meeting and being together feeds (as it were) this new-kindled fire or flame or ardent affection, which burns alike in the breasts of either party. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-163-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3193"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page101",
      "title": "101"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_107"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("21:1–22:23")]), _vm._v(" DAVID FLEES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1 a")]), _vm._v(" "), _c('i', [_vm._v("Then David came to Nob to Ahimelech the priest. And Ahimelech came to meet David trembling and said to him, “Why are you alone, and no one with you?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And David said to Ahimelech the priest, “The king has charged me with a matter and said to me, ‘Let no one know anything of the matter about which I send you, and with which I have charged you.’ I have made an appointment with the young men for such and such a place.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now then, what do you have on hand? Give me five loaves of bread, or whatever is here.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And the priest answered David, “I have no common bread on hand, but there is holy bread—if the young men have kept themselves from women.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And David answered the priest, “Truly women have been kept from us as always when I go on an expedition. The vessels of the young men are holy even when it is an ordinary journey. How much more today will their vessels be holy?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("So the priest gave him the holy bread, for there was no bread there but the bread of the Presence, which is removed from before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", to be replaced by hot bread on the day it is taken away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now a certain man of the servants of Saul was there that day, detained before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". His name was Doeg the Edomite, the chief of Saul’s herdsmen.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then David said to Ahimelech, “Then have you not here a spear or a sword at hand? For I have brought neither my sword nor my weapons with me, because the king’s business required haste.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And the priest said, “The sword of Goliath the Philistine, whom you struck down in the Valley of Elah, behold, it is here wrapped in a cloth behind the ephod. If you will take that, take it, for there is none but that here.” And David said, “There is none like that; give it to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And David rose and fled that day from Saul and went to Achish the king of Gath.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And the servants of Achish said to him, “Is not this David the king of the land? Did they not sing to one another of him in dances,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("‘Saul has struck down his thousands,")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("and David his ten thousands’?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And David took these words to heart and was much afraid of Achish the king of Gath.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("So he changed his behavior before them and pretended to be insane in their hands and made marks on the doors of the gate and let his spittle run down his beard.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Then Achish said to his servants, “Behold, you see the man is mad. Why then have you brought him to me?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Do I lack madmen, that you have brought this fellow to behave as a madman in my presence? Shall this fellow come into my house?”")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("22")]), _vm._v(" "), _c('i', [_vm._v("David departed from there and escaped to the cave of Adullam. And when his brothers and all his father’s house heard it, they went down there to him.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And everyone who was in distress, and everyone who was in debt, and everyone who was bitter in soul,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("gathered to him. And he became commander over them. And there were with him about four hundred men.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And David went from there to Mizpeh of Moab. And he said to the king of Moab, “Please let my father and my mother stay")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("with you, till I know what God will do for me.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And he left them with the king of Moab, and they stayed with him all the time that David was in the stronghold.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Then the prophet Gad said to David, “Do not remain in the stronghold; depart, and go into the land of Judah.” So David departed and went into the forest of Hereth.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Now Saul heard that David was discovered, and the men who were with him. Saul was sitting at Gibeah under the tamarisk tree on the height with his spear in his hand, and all his servants were standing about him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And Saul said to his servants who stood about him, “Hear now, people of Benjamin; will the son of Jesse give every one of you fields and vineyards, will he make you all commanders of thousands and commanders of hundreds,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("that all of you have conspired against me? No one discloses to me when my son makes a covenant with the son of Jesse. None of you is sorry for me or discloses to me that my son has stirred up my servant against me, to lie in wait, as at this day.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("Then answered Doeg the Edomite, who stood by the servants of Saul, “I saw the son of Jesse coming to Nob, to "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3200"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page102",
      "title": "102"
    }
  }), _c('i', [_vm._v("Ahimelech the son of Ahitub,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("and he inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("for him and gave him provisions and gave him the sword of Goliath the Philistine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then the king sent to summon Ahimelech the priest, the son of Ahitub, and all his father’s house, the priests who were at Nob, and all of them came to the king.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And Saul said, “Hear now, son of Ahitub.” And he answered, “Here I am, my lord.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And Saul said to him, “Why have you conspired against me, you and the son of Jesse, in that you have given him bread and a sword and have inquired of God for him, so that he has risen against me, to lie in wait, as at this day?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("Then Ahimelech answered the king, “And who among all your servants is so faithful as David, who is the king’s son-in-law, and captain over")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("your bodyguard, and honored in your house?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Is today the first time that I have inquired of God for him? No! Let not the king impute anything to his servant or to all the house of my father, for your servant has known nothing of all this, much or little.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And the king said, “You shall surely die, Ahimelech, you and all your father’s house.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And the king said to the guard who stood about him, “Turn and kill the priests of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", because their hand also is with David, and they knew that he fled and did not disclose it to me.” But the servants of the king would not put out their hand to strike the priests of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Then the king said to Doeg, “You turn and strike the priests.” And Doeg the Edomite turned and struck down the priests, and he killed on that day eighty-five persons who wore the linen ephod.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And Nob, the city of the priests, he put to the sword; both man and woman, child and infant, ox, donkey and sheep, he put to the sword.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("But one of the sons of Ahimelech the son of Ahitub, named Abiathar, escaped and fled after David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And Abiathar told David that Saul had killed the priests of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And David said to Abiathar, “I knew on that day, when Doeg the Edomite was there, that he would surely tell Saul. I have occasioned the death of all the persons of your father’s house.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("Stay with me; do not be afraid, for he who seeks my life seeks your life. With me you shall be in safekeeping.”")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Ch 21:2 in Hebrew "), _c('b', [_vm._v("b")]), _vm._v(" Or "), _c('i', [_vm._v("discontented")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" Syriac, Vulgate; Hebrew "), _c('i', [_vm._v("go out")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Septuagint, Targum; Hebrew "), _c('i', [_vm._v("and has turned aside to"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers concentrate on the story about David’s army eating the holy bread, which was reserved only for priests. Does this signify that David was destined to be a great priestly king? Do the holy loaves foreshadow the holy Eucharist representing Christ’s body? The reformers interpret the passage within the context of Jesus’ larger message of love taking precedence over stringent interpretations of the law (Mt 12:1-8; Mk 2:23-28; Lk 6:1-5). Some cite this incident as an example of David’s freedom through faith, a concept that would only gradually be revealed during the time of Christ. David’s hardships and persecutions allowed these commentators to continue to interpret David’s life messianically. They also suggest that perhaps God used Saul to tame David and make him fit for kingship. At the same time, Saul’s scandalous treatment of the priests and inhabitants of Nob leads these commentators to consider him not only unfit for ruling but also irreversibly evil.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_108"
    }
  }, [_c('b', [_vm._v("21:1-6")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Common People Eating What Is Holy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Holy Vessels.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Here you elegantly read about matters that pertained to the sanctification of the outward person, which were not in conflict with godly desires. The Lord imposes a similar law about not going near a woman in Exodus 19. And Paul judges it good to abstain from marital relations for a time in order to grow in prayer, but only with mutual consent. Therefore it was a practice to keep the bodies of servants holy and clean by keeping away from women. Yes, truly, we say nothing against any uncleanness, whether nocturnal emissions or other unclean contact according to the law, but on the same day it will have been passed over, for the law "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3207"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3219"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3221"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page103",
      "title": "103"
    }
  }), _vm._v("speaks of common or regular daily impurities, which will be gone by evening. There is no danger here if there is no other hindrance than external impurity. Paul spoke of this use of vessels, “For this is the will of God, your sanctification: that you abstain from sexual immorality; that each one of you know how to control his own body in holiness and honor.” For in the Hebrew tradition, a vessel stands for all kinds of instruments, as in Ezekiel: “. . . each with his destroying weapon in his hand.” Our bodies are our instruments, with which we act. And the saints are said to be God’s instruments, through whom God’s Spirit itself is working, just as Christ called Paul “a chosen instrument of mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This is a sign, as Christ interpreted it in Matthew 12 and Mark 2, as Moses wanted to be heard in Deuteronomy 18. Christ sees David and this priest and lets it happen under the umbrella of legal cleanliness: “To the pure, all things are pure,” and “everything created by God is good,” and “all things are yours, whether Paul or Apollos or Cephas or the world or life or death or the present or the future—all are yours, and you are Christ’s, and Christ is God’s.” As Psalm 8 says, “You have given him dominion over all the works of your hands. . . . O L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(", our Lord, how majestic is your name in all the earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("If, therefore, David was allowed to use this freedom through faith, not yet revealed by the light of the gospel and at a time when this was still prohibited by God’s law, then how much more are we turned away from the decrees and elements of this world? For it has been revealed that the kingdom of God is not of this world. Necessity and love oversee the divine law, just as Christ interpreted. We most stupidly mangle this use when we set up and bind ourselves to human laws and the doctrines of demons. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-162-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Of the Holy Bread.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The law here is set down in Leviticus 24:5-9, concerning the matter of how the bread should be made, of the type of flour used, how much should be in every loaf, how many loaves should be baked in all, where they should be placed, how long they should continue from sabbath to sabbath and in what manner they should be presented, namely, with incense. The Jews used four kinds of breads. The first was common bread; the second was the bread the people used in the sacred feasts; the third was the kind of bread the priests ate with their families; and the fourth was the most holy bread, which was lawful only for the priests to eat within the tabernacle. The holy bread was called the “showbread” because it was always in the presence of God, which was a type of the true bread Christ Jesus who came down from heaven. The holy bread also shadowed forth the Eucharist of the New Testament, which is celebrated with bread. And there was the same signification of their sacraments with ours, except that ours are clearer and more manifest as a memorial of Christ already exhibited, whereas theirs foreshadowed him as the one who was to come. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-161-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Love Is the Only Excuse.")]), _vm._v(" "), _c('i', [_vm._v("Hieronymus Weller von Molsdorf:")]), _vm._v(" Even though it was not lawful for anyone to eat the sacred bread, which we usually call the bread of the Presence, nevertheless David demands it be given to him, and Ahimelech does not hesitate to submit to David’s demand. And Christ in Matthew 12 defends this event and shows that the entirety of the ceremonial law should yield to love. Now what was said concerning the ceremonial law should also be said about ecclesiastical rites, namely, that in matters of need or demand we faithfully and righteously act in love, if by disregard of ecclesiastical ceremonies or rites we take care of our neighbors in need or look out for them. Outside of this case it is not lawful for the pious to disregard ecclesiastical ceremonies. So then, how much more lawful is it to disregard those ceremonies and rites that draw consciences into a trap, or that produce scandals or cause rebellions and strengthen the raging of our opponents—that "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3233"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page104",
      "title": "104"
    }
  }), _vm._v("is, those which seem to be instituted to please enemies of the gospel, so that their wrath is placated. "), _c('i', [_vm._v("Annotations on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-160-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Love Trumps Customs.")]), _vm._v(" "), _c('i', [_vm._v("Hans Denck:")]), _vm._v(" Baptism, which is the sign of the covenant, should be given and not denied to any of those who by God’s power have been invited to it through knowledge of genuine love and who desire this love and agree to be its followers. However, they are not to be compelled to stay in this love by any other person within the covenant unless love itself compels them. This is as it is written in the Psalter: “Your people will be there willingly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("However, disregarding the customs of the law is a freedom permitted by love; it is not a commandment. For although it occasionally happened that even the holy patriarchs had to break these commands but without harm to themselves, no one can say therefore that anything other than love excused them. For this reason Jesus, who is genuine love, was silent and did not command or forbid any of these, as if he wanted to demonstrate that someone may come to this love without any of these customs. . . . Thus love permits her friends to be exempt from customs. "), _c('i', [_vm._v("Concerning True Love.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-159-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_109"
    }
  }, [_c('b', [_vm._v("21:7-9")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Retakes Goliath’s Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Whether David Sinned in Taking Goliath’s Sword.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think David sinned by taking Goliath’s old sword, which had been consecrated to God as a monument of great victory against the Philistine, and then converting it back to profane use. This action also brought the priest into danger. Now, it is acknowledged that it was David’s oversight, in the presence of Doeg, whom he suspected of evil, to ask for and receive these things from the priest. . . . And beside, it might have placed David in danger among the Philistines, when they saw Goliath’s sword. Yet, simply in using the sword—no other sword was available—David is excused by his necessity, like before in taking the showbread. For just as the Jews gave the Babylonians vessels of silver and gold to redeem their peace and were not reproved by the prophets, so David is excused for using the vessel of the sword for profane use. And who doubts but that the church may and ought, where there is no other remedy, sell the church vessels in order to help the poor. Besides, David took this sword to remind him of God’s former deliverance, so that he might by the sight of it be stirred up to wait on him still. And further, it is not unlikely that David later restored this monument again after he became king. By this example of David it is gathered . . . that it is lawful for the servants of God, where their cause is good, to wear armor and use weapons. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _vm._v(" "), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-158-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Remembering Experiences.")]), _vm._v(" "), _c('i', [_vm._v("John Arrowsmith:")]), _vm._v(" Reflect on former experiences and let them be encouragements from time to time. The psalmist did so when he said, “I consider the days of old, the years long ago.” “Then I said, ‘I will appeal to this: to the years of the right hand of the Most High. I will remember the deeds of the Lord; yes, I will remember your wonders of old.” Some inquire why David—when he asked for a sword and Ahimelech told him there was none at hand but that of Goliath—called for it, and said, “There is none like that.” It is probable that David might have found swords of better metal or just as good; perhaps he even found some more fit for his strength. Yet he prefers this above all because of his experience, for God had formerly blessed him in the use of that sword. "), _c('i', [_vm._v("Chain of Principles.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-157-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_110"
    }
  }, [_c('b', [_vm._v("21:10-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Fools for the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Foolishness: An Allegory on the Cross.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Christ and Christians appear to be insane before the powers of earth and the wisdom of the flesh. As Isaiah 53 says, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3246"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page105",
      "title": "105"
    }
  }), _vm._v("they are worthy who have been despised and rejected. For nothing is seen except the cross and foolishness. And it shall be that the faithful themselves see nothing but their sins and how Christ bore them for us. Truly, in the meantime, Satan’s blindness and the world’s foolishness do not recognize the wisdom of his victory. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-156-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God Provides Counsel in Times of Need.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Jonathan loved David, all Israel loved David, and so he lost favor with Saul and thought it better to flee to his enemies than to stay among friends. For who could hate David more than the people of Gath, from whom Goliath had come? You see from this that David acted from necessity. There is nothing easy described in David’s persecutions. As the following story will show, things are more clearly seen among enemy Gentiles than among the Israelites, whom the Lord often saved by intervening himself. We have spoken of such complications above. It is truly foolish when we dispute such things as whether or not the saints have sinned. The saints have sinned when they acted according to their own counsel, not seeking or requiring us to imitate them. We do not need to make their actions into a law. This applies to David, and something else applies to you through God. So therefore one course of action may appear to him, and maybe something else might arise if you had occasion today to evade prison and be delivered from your enemies without detriment to your salvation or without causing scandal to the gospel, which often comes during persecution. David’s liberation certainly did not come from his trickery but from God, who gave the counsel about trickery to the one whom he wanted to liberate. This is abundantly declared in the Hebrew heading of Psalm 34, where it shows that this story clearly teaches to trust God in all needs of body and mind. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-155-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Mercies.")]), _vm._v(" "), _c('i', [_vm._v("David Dickson:")]), _vm._v(" Sometimes people in fear for their lives fly from one danger and fall into one that is worse, as David did when he fled into an unhallowed place among God’s enemies. For fear of Saul, he falls into the hands of Achish. However, God pities the infirmity of his children, and sometimes gives success to weak and unwise decisions. This is seen here, as David “pretended to be insane” to escape. God can and does dispose of people’s hearts as he has a mind to work by them: For he moved the heart of Achish to take no notice of David other than to regard him as an unstable man. "), _c('i', [_vm._v("Explication of the First Fifty Psalms.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-154-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_111"
    }
  }, [_c('b', [_vm._v("22:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David at the Cave of Adullam")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Made to Serve.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" God promised David a kingdom, but immediately stirred up King Saul against him to persecute him, to hunt him as hunters do hares with greyhounds and to ferret him out of every hole. And God did this for the space of many years to tame David, to make him meek, to kill his lusts, to make him feel other people’s infirmities, to make him merciful and to make him understand that he was made king to minister and serve his brothers. In short, he was persecuted so that he should not think his subjects were made to minister to his lusts, or that it was lawful for him to take away from them life and goods at his pleasure. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-153-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Good Brings Good out of Bad.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" David loved God and had God as his friend. Therefore, when he was forced to flee from Saul he ascended in his exile almost by degree to the majesty of king. . . . Christ, the son of God, loved God, and had him as his friend. Therefore, when he was afflicted at the crucifixion and died, he attained great glory through the cross and his death. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3257"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page106",
      "title": "106"
    }
  }), _vm._v("“But,” you say, “I am neither Jacob nor Joseph nor David nor Christ. Therefore, none of these examples apply to me.” We rightly admit that we are not Christ ourselves; but we know that Christ came in our place so that all adverse things that come our way, even by way of our enemies, are used by God for our good. "), _c('i', [_vm._v("Commentary on")]), _vm._v(" "), _c('i', [_vm._v("Genesis.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-152-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul and the House of Eli.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Look with astonishment at the plans of God. The Lord had spoken against the house of Eli in the second chapter, which Saul fulfilled here through his most grave and manifest sin. For he not only sought the death of the Lord’s anointed king but also—because of David—did not spare the priesthood, which had been ordained and instituted by God. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-151-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_112"
    }
  }, [_c('b', [_vm._v("22:6-17")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Murderous Rage Against the Priests at Nob")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("We Must Disobey Unjust Rulers.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" Here an unalterable rule applies: “We should obey God rather than men.” For this reason, if an authority commands us to act against God, we should not obey, but should act like the three men in Babylon who refused to worship the idols or countenance idolatry, even though King Nebuchadnezzar had proclaimed a frightful command regarding it. As the worthy soldiers connected with the tyranny of Saul would not murder the innocent priest Ahimelech, the other priests, and their pious wives and children, even though Saul had commanded them to do it, so are we to act now. If the great lords command us to keep untrue doctrine and idolatry, we should not obey such commands. We should not assist in the murdering of the innocent or of Christians on account of their confession of the gospel, as many of the learned do by remaining silent because of fear. Such murder, along with such hypocrisy, will receive the terrible punishment of which Christ speaks in Matthew 23:35, “That on you may come all the righteous bloodshed on earth, from the blood of innocent Abel on . . . ,” for the Son of God will judge, and will hurl all the godless into eternal punishment. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-150-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Do Not Defend a Tyrant.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This chapter shows all of David’s descendants not to defend the kingdom of Saul for David’s sake, because of his striking down of the priests of the Lord. Who could fully describe this tyrant’s insanity? Neither God nor humans owe respect when a soul gets enslaved by a godless malady that is visible to all who look for it. For the best men do not act to suit an occasion; instead, they are known by their demeanor. At the same time, all who want to stand forever go to ruin. And yet wherever these atrocities are judged, some have tried to defend the good aspects of King Saul, especially those that are shown by his speech. For he was pursuing David, whom everyone favored, which made everyone guilty of conspiracy against the king. “Thus iniquity has betrayed itself.” And so a just and righteous confessor bears not only persecutions and hatred, but everyone wishes the persecutor well, according to the verse, “If you were of the world, the world would love you as its own.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-149-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul as Antichrist.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Saul’s speech to his servants is full of dissimulation and hypocrisy. Here he shows, first, his cruelty by charging his servants with negligence and unfaithfulness toward him because they were not more eager to pursue David, even though they were more removed from David and closer to Saul. Thus the wicked dislike all those who do not run together with them step by step, as Saint Peter says: “The sinful Gentiles are surprised when you "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3262"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page107",
      "title": "107"
    }
  }), _vm._v("do not join them in the same flood of debauchery, and they malign you.” "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-148-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_113"
    }
  }, [_c('b', [_vm._v("22:18-23")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Doeg Murders for Saul")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Ungodly Edomite.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" This ungodly Edomite, looking for honor and seeking the favor of his lord, betrays innocent people. He is a figure of all who only think about their own advancement and opportunity; they thereby help to trample on God’s truth and those who profess it. The heading of Psalm 52 shows this, where the impious ones—like Saul—are scolded, because they love and hope in their own ideas and things. But the righteous ones are like David, saying, “But I am like a green olive tree in the house of God. I trust in the steadfast love of God forever and ever.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-147-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The People Pleaser.")]), _vm._v(" "), _c('i', [_vm._v("Robert Sanderson:")]), _vm._v(" Sometimes we apply ourselves to the wills of others with an eye to our own benefit or satisfaction in some other carnal or worldly respect. This is our fleshliness, and the fault is in the heart. This sin is one of the worst kinds, and therefore in the first place to be avoided. It is the worst and most unconscionable people who often transgress this way. They do this for a variety of reasons: for fear of a frown or worse displeasure; to curry favor with those they may have use of in hope either of raising themselves to some advancement or of raising to themselves some advantage; or for some other like respects. As they do this, they become officious instruments to others for the accomplishing of their lusts in such services as are evidently, even to their own apprehensions, sinful and wicked. So Doeg did King Saul service in shedding the blood of eighty-five innocent priests. "), _c('i', [_vm._v("To the People.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-146-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3263"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page108",
      "title": "108"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_114"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("23:1–24:22")]), _vm._v(" DAVID SAVES KEILAH AND SPARES SAUL")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now they told David, “Behold, the Philistines are fighting against Keilah and are robbing the threshing floors.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Therefore David inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", “Shall I go and attack these Philistines?” And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to David, “Go and attack the Philistines and save Keilah.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("But David’s men said to him, “Behold, we are afraid here in Judah; how much more then if we go to Keilah against the armies of the Philistines?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then David inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("again. And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("answered him, “Arise, go down to Keilah, for I will give the Philistines into your hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And David and his men went to Keilah and fought with the Philistines and brought away their livestock and struck them with a great blow. So David saved the inhabitants of Keilah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("When Abiathar the son of Ahimelech had fled to David to Keilah, he had come down with an ephod in his hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Now it was told Saul that David had come to Keilah. And Saul said, “God has given him into my hand, for he has shut himself in by entering a town that has gates and bars.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And Saul summoned all the people to war, to go down to Keilah, to besiege David and his men.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("David knew that Saul was plotting harm against him. And he said to Abiathar the priest, “Bring the ephod here.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Then David said, “O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, your servant has surely heard that Saul seeks to come to Keilah, to destroy the city on my account.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Will the men of Keilah surrender me into his hand? Will Saul come down, as your servant has heard? O")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, please tell your servant.” And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “He will come down.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("Then David said, “Will the men of Keilah surrender me and my men into the hand of Saul?” And the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said, “They will surrender you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Then David and his men, who were about six hundred, arose and departed from Keilah, and they went wherever they could go. When Saul was told that David had escaped from Keilah, he gave up the expedition.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And David remained in the strongholds in the wilderness, in the hill country of the wilderness of Ziph. And Saul sought him every day, but God did not give him into his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("David saw that Saul had come out to seek his life. David was in the wilderness of Ziph at Horesh.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Jonathan, Saul’s son, rose and went to David at Horesh, and strengthened his hand in God.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And he said to him, “Do not fear, for the hand of Saul my father shall not find you. You shall be king over Israel, and I shall be next to you. Saul my father also knows this.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And the two of them made a covenant before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(". David remained at Horesh, and Jonathan went home.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Then the Ziphites went up to Saul at Gibeah, saying, “Is not David hiding among us in the strongholds at Horesh, on the hill of Hachilah, which is south of Jeshimon?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Now come down, O king, according to all your heart’s desire to come down, and our part shall be to surrender him into the king’s hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And Saul said, “May you be blessed by the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for you have had compassion on me.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Go, make yet more sure. Know and see the place where his foot is, and who has seen him there, for it is told me that he is very cunning.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("See therefore and take note of all the lurking places where he hides, and come back to me with sure information. Then I will go with you. And if he is in the land, I will search him out among all the thousands of Judah.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("And they arose and went to Ziph ahead of Saul.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("Now David and his men were in the wilderness of Maon, in the Arabah to the south of Jeshimon.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("And Saul and his men went to seek him. And David was told, so he went down to the rock and lived in the wilderness of Maon. And when Saul heard that, he pursued after David in the wilderness of Maon.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Saul went on one side of the mountain, and David and his men on the other side of the mountain. And David was hurrying to get away from Saul. As Saul and his men were closing in on David and his men to capture them,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("a messenger came to Saul, saying, “Hurry and come, for the Philistines have made a raid against the land.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("So Saul returned from pursuing after David and went against the Philistines. Therefore that place was called the Rock of Escape.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a 29b")]), _c('i', [_vm._v("And David went up from there and lived in the strongholds of Engedi.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3267"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page109",
      "title": "109"
    }
  }), _c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("24")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("When Saul returned from following the Philistines, he was told, “Behold, David is in the wilderness of Engedi.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("Then Saul took three thousand chosen men out of all Israel and went to seek David and his men in front of the Wildgoats’ Rocks.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And he came to the sheepfolds by the way, where there was a cave, and Saul went in to relieve himself.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("Now David and his men were sitting in the innermost parts of the cave.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And the men of David said to him, “Here is the day of which the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("said to you, ‘Behold, I will give your enemy into your hand, and you shall do to him as it shall seem good to you.’” Then David arose and stealthily cut off a corner of Saul’s robe.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And afterward David’s heart struck him, because he had cut off a corner of Saul’s robe.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("He said to his men, “The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("forbid that I should do this thing to my lord, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed, to put out my hand against him, seeing he is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("So David persuaded his men with these words and did not permit them to attack Saul. And Saul rose up and left the cave and went on his way.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Afterward David also arose and went out of the cave, and called after Saul, “My lord the king!” And when Saul looked behind him, David bowed with his face to the earth and paid homage.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And David said to Saul, “Why do you listen to the words of men who say, ‘Behold, David seeks your harm’?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Behold, this day your eyes have seen how the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("gave you today into my hand in the cave. And some told me to kill you, but I spared you.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("e")]), _vm._v(" "), _c('i', [_vm._v("I said, ‘I will not put out my hand against my lord, for he is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("See, my father, see the corner of your robe in my hand. For by the fact that I cut off the corner of your robe and did not kill you, you may know and see that there is no wrong or treason in my hands. I have not sinned against you, though you hunt my life to take it.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("May the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("judge between me and you, may the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("avenge me against you, but my hand shall not be against you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("As the proverb of the ancients says, ‘Out of the wicked comes wickedness.’ But my hand shall not be against you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("After whom has the king of Israel come out? After whom do you pursue? After a dead dog! After a flea!")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("May the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("therefore be judge and give sentence between me and you, and see to it and plead my cause and deliver me from your hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("As soon as David had finished speaking these words to Saul, Saul said, “Is this your voice, my son David?” And Saul lifted up his voice and wept.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("He said to David, “You are more righteous than I, for you have repaid me good, whereas I have repaid you evil.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And you have declared this day how you have dealt well with me, in that you did not kill me when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("put me into your hands.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("For if a man finds his enemy, will he let him go away safe? So may the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("reward you with good for what you have done to me this day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And now, behold, I know that you shall surely be king, and that the kingdom of Israel shall be established in your hand.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Swear to me therefore by the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("that you will not cut off my offspring after me, and that you will not destroy my name out of my father’s house.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And David swore this to Saul. Then Saul went home, but David and his men went up to the stronghold.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Or "), _c('i', [_vm._v("Rock of Divisions")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Ch 24:1 in Hebrew "), _c('b', [_vm._v("c")]), _vm._v(" Ch 24:2 in Hebrew "), _c('b', [_vm._v("d")]), _vm._v(" Hebrew "), _c('i', [_vm._v("cover his feet")]), _vm._v(" "), _c('b', [_vm._v("e")]), _vm._v(" Septuagint, Syriac, Targum; Hebrew "), _c('i', [_vm._v("it")]), _vm._v(" [my eye] "), _c('i', [_vm._v("spared you"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The Lord’s favor rests with David, as he proves victorious in battle, prudent in character and respectful of the king’s authority. Bugenhagen, committed to interpreting the Bible through the lens of law and gospel, cites this story as another example of God humbling David through the law so that he could receive God’s grace. The interpreters also reflect on David’s deference to King Saul. Although Saul is eager to kill David in the face of all the good he has done for him, David refuses to lay even a finger on Saul out of respect for his position as king. The reformers believe David would have sinned had he made an attempt on Saul’s life. Saul’s momentary remorse, however, does not trick the reformers into changing their negative assessment of the king.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_115"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3277"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page110",
      "title": "110"
    }
  }), _c('b', [_vm._v("23:1-14")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Keilah and")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Possible Contingencies")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("God’s Knowledge.")]), _vm._v(" "), _c('i', [_vm._v("Jacobus Arminius:")]), _vm._v(" I am thoroughly persuaded that God’s knowledge is eternal, immutable and infinite, and that it extends to all things . . . which he himself does with or without mediation, and which he permits to be done by others. But the mode in which he knows future contingencies, and especially those that appertain to the free will of creatures, and which he has decreed to permit, but not to do of himself—this I do not comprehend, not even in that measure in which I think it is understood by others of greater skill than myself. I know there are some who say that all things are present to God from eternity; and that the mode in which God knows future contingencies certainly and infallibly is this: that those contingencies coexist with God in the Now of eternity, and so are in him indivisible and in the infinite Now of eternity, which embraces all time. If that is so, it is not difficult to know in what way God knows future contingencies certainly and infallibly. For contingencies are not opposed to the certainty of knowledge, except as they are future, but not as they are present. But that reasoning does not exhaust all the difficulties that may arise in the consideration of these matters. For God knows, also, those things that may happen, but never do happen, and consequently do not coexist with God in the Now of eternity, which would happen unless they be stopped. "), _c('i', [_vm._v("Friendly Discussion Concerning Predestination.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-145-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Lonely Escape.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Who does not see that this revelation from God about David’s being surrendered to Saul should be understood with the clear condition: “unless you flee.” It is like Jonah’s “Yet forty days, and Nineveh shall be overthrown!” that is, implicitly, “unless you repent.” Here you see that David was not troubled about those people whom he had protected, just as we learn from Jeremiah 17:5 not to trust in humans. God did not want David to have that kind of trust. For now you have a well-fortified city, the citizens are indebted to you, all of Israel is favorably disposed to you because you have repelled the Philistines, and the king will not be able or permitted to hurt you. But God wanted David to despair of everyone and everything, being forsaken and exposed by his own forces, so that he would hope in God alone. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-144-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Deceitfulness of the Heart.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" One form of deceit is when in temptation our hearts betray us like Judas’s did into the devil’s hands. If a person is very close to you so that we trust him, should we not consider him a deceitful person if—when walking about and we are accosted by an enemy or a criminal—he runs away from you? How much more so if this friend should conspire with the enemy and take part in the violence against you? . . . But this is exactly how the half-hearted men of Keilah would have done with David. As David mistrusted them, so we should our deceitful hearts. We do not need to ask the question, as David did of the men of Keilah, “Will they deliver us?” We must assure ourselves that they certainly will. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-143-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_116"
    }
  }, [_c('b', [_vm._v("23:15-29")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Jonathan Renews His Covenant with David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Jonathan Renews His Vow for the Sake of the Truth.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Now Jonathan keeps and renews his faithful vow with David, so that—touched by the Spirit of God—he prophesied and comforted David. For all that, he did not come in order to be the second greatest himself, because the vow pertains not only to Jonathan and David but also to their descendants, as chapter 20 says. Then he most gravely condemns his father before God when he says, “Saul my father also knows this.” For he could not hide anymore from Saul now that the Lord had anointed David "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3286"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3290"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page111",
      "title": "111"
    }
  }), _vm._v("in Bethlehem through the prophet Samuel and now that Saul came to know the Lord had departed from him to be with David. On this point Scripture cannot keep silence, for it shows this hypocrisy fighting against conscience in order to fight against God, for it wants to be seen before people as fighting against the one who lies in wait for the king and disturbs the kingdom. In the same way, those who now want to suppress the gospel give the pretext that all things are being disturbed. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-142-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("True Friendship Lasts.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" Friendship does not cease or utterly perish even when absent because it grows on just and reasonable causes. As we may see in David and Jonathan, the whole friendship continued and lasted despite the one being absent from the other, for such deep-rooted goodwill and such ardent affection cannot be easily quenched. Therefore friendship—being strongly and surely grounded between persons present—continues still between them when they are absent. And the further they are separated, the greater is the longing desire of one for the other and the more vehemently their inflamed hearts increase. "), _c('i', [_vm._v("True and Christian Friendship.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-141-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_117"
    }
  }, [_c('b', [_vm._v("24:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Spares Saul’s Life")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Conscience.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" When David’s heart sunk, it shows the working of his conscience. Scripture writes this in order to show the fear of God in David, who—even though he was able to—did not want to act against Saul, one who was duly installed by God, just as it says in Romans 13 about submitting to God by submitting to authorities. At the same time, however, David perceives that God has departed from Saul, who will perish when God wants it. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-140-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Heart of the Matter.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Saul would kill David but could not. David could kill Saul but would not. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-139-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David Overcomes His Flesh.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Brenz:")]), _vm._v(" David was a truly pious man and did not take advantage of Saul, who was the greatest of his enemies, even when he was offered up to him in the cave. Naturally, David’s flesh suggested: “Take him, David. You now have your enemy in your hands. Kill him and you will have not only the king but also the kingdom!” But David not only crucified his fleshly thoughts but also mastered his earthly desires. "), _c('i', [_vm._v("Commentary on Galatians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-138-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_118"
    }
  }, [_c('b', [_vm._v("24:6-15")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Honoring the Lord’s Anointed One")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Unlawful.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" Why did David not kill Saul given that he was so wicked, not only in persecuting David but also in disobeying God’s commandments? And not only that, but he had also murdered eighty-five of God’s priests wrongfully? Truly, because it was not lawful. For if David would have done it, he would have sinned against God. This is because God makes the king in every realm judge over all, and over him there is no judge. The one who judges the king judges God; and the one who lays hands on the king lays hands on God. And the one who resists the king resists God and damns God’s laws and ordinances. If the subject sins, he or she must be brought to the king’s judgment. But if the king sins, he must be reserved to the judgment, wrath and vengeance of God. And as it is to resist the king, so is it to resist his officer, who is set or sent to execute the king’s commandment. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-137-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David Extends Grace.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" When we become indignant against someone, we very "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3299"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page112",
      "title": "112"
    }
  }), _vm._v("often fail to take account of all the favors God has given to the one whom we hate, as though those favors were beneath contempt. Even when we must hate and detest a person’s evil side, we must not be so carried away with the violence of our feelings that we are utterly unable to accept the good, for then we have lost our perception and discernment. On the contrary, we must honor the Lord for everything that comes from him. This is what we are to remember from David. David certainly knew that Saul was a desperate man. Nonetheless, God had chosen him to reign over his people, and had anointed him for that purpose. What is more, David knew that he would offend the Lord, and would commit a sacrilege if he ignored this grace God had put in Saul. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-136-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Inviolable Majesty.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" We owe this attitude of reverence and therefore piety toward all our rulers in the highest degree, whatever they may be like. I therefore the more often repeat this: that we should learn not to examine the men themselves, but take it as enough that they bear, by the Lord’s will, a character on which he has imprinted and engraved an inviolable majesty. But (you will say) rulers owe responsibilities in turn to their subjects. This I have already admitted. But if you conclude from this that service ought to be rendered only to just governors, you are reasoning foolishly. "), _c('i', [_vm._v("Institutes 4.20.29.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-135-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Respect for God’s Messiah.")]), _vm._v(" "), _c('i', [_vm._v("Jeremias Bastingius:")]), _vm._v(" In the Old Testament prophets, priests and kings were anointed by the commandment and ordinance of God. . . . Such ceremonies served as a seal of their calling that God would teach and govern his people by them, whereupon they were called “the Christ” or “the Anointed” of the Lord; as in the psalm: “Do not touch my anointed ones; do my prophets no harm.” So David calls Saul “the Lord’s anointed,” and for this reason would not hurt him even though he could. "), _c('i', [_vm._v("An Exposition on the Catechism of the Low Countries.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-134-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Conquering by Forbearance.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" The one who forbears conquers the very malice of his enemy. For when two competitors are in contention and conflict, the one who draws the other into similarity with itself conquers; and the one who is drawn and changed by the other is conquered. Therefore, as we say water is overcome by fire when it becomes warm; and on the contrary to have overcome it if, retaining its own cold, it can subdue the fire. So we say a Christian is overcome by a wicked person as often as he, by the provocation of attack, is drawn into similar fury; on the contrary, we may pronounce him to have conquered when he retains his own disposition and, by bearing with the violence of the other, changes and mollifies his ferocity. We see a beautiful example of this here where David, by forbearing and refraining from revenge, so mollifies and changes Saul from breathing blood and slaughter that he melts into tears and entreaties, confesses his fault and is compelled to acknowledge and extol David’s innocence and meekness. Who does not here see the malice of Saul overcome, and the patience of David triumphant? "), _c('i', [_vm._v("Exposition of Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-133-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_119"
    }
  }, [_c('b', [_vm._v("24:16-22")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Determining Whether Saul Was Sincere")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hearts as Crafty as a Fox.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" If a person had a reputation of being a common deceiver, we would never take his word for anything. However, if we had to deal with him for business, we would be sure to have everything done according to the law and with proper documentation. Indeed, we are to be wise and wary in matters of this life. Yet our hearts are far more cunning and deceitful than the craftiest fox. Do not be so simple as to believe every sigh, every wish and word, every motion and every inclination of your heart. Yet we "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3305"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page113",
      "title": "113"
    }
  }), _vm._v("too often allow our hearts to have sway over our lives. We think that when we feel some inordinate affection for something, we believe that we will prove victorious and that sin will never prevail against us. Saul, though seemingly moved by David’s apology, acknowledged both David’s innocence and his own injustice. In fact, it was in tears and kind words that he said, “Is this your voice, my son David?” He added, “I will no more do you harm.” Yet for all Saul said, David did not trust Saul at all. For what heed is to be taken to a false and fickle-hearted man’s words like Saul’s? Because our hearts are as fickle and unstable in their affections toward the Lord as Saul’s were toward David, we must not slavishly trust our hearts. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-132-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Brief Moment of Repentance.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Now Saul wastes no time, being certain that he will capture David, but is handed over by God into David’s hands instead. Then he is reluctantly summoned. He tearfully acknowledges the hand of God, David’s innocence and his own iniquity against both of them. That is because he is used to judging David’s faith falsely, even though David had often protected him, as you see again in chapter 26. For a sudden brief stupor comes over him when he hears that he was in the hands of David, whom he knows will reign after him. He weeps, he confesses, he makes a vow. But the word he proclaims is the repentance of a hypocrite, as we have often said before. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-131-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Acknowledging David’s Righteousness.")]), _vm._v(" "), _c('i', [_vm._v("Edward Reynolds:")]), _vm._v(" When Saul, out of the force of natural ingenuity, saw the evidence of David’s integrity—who refused to kill Saul even when the Lord had delivered him into his hands—he relented for the time and wept. He acknowledged David’s righteousness above his own and spoke in all earnestness. "), _c('i', [_vm._v("The Sinfulness of Sin.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-130-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Tears of Remorse.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think these tears of Saul and this kind of confession of his fault were done in hypocrisy, which Saul counterfeited out of deference to others, who would have thought Saul to be too hardhearted if he would not have be mollified by David’s submission. It was also hoped that because of this David would be persuaded to return to the court. . . . But it seems by Saul’s accusation of himself, his acknowledgment that David should be king and his instance in making David swear to him that Saul was truly touched. For, although the wicked have no true feeling of their sins, they may sometimes be moved in conscience even if it does not continue long. Indeed, Pharaoh confessed to Moses that he had sinned, and Judas also knew that he had sinned by betraying the innocent blood: for by the instinct of nature, the conscience in some degree both excuses and accuses, as the apostle shows in Romans 2:14-15. As David’s music had before diverse times allayed Saul’s malady, so now his divine voice worked some remorse in Saul. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-129-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3306"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page114",
      "title": "114"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_120"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("25:1-44")]), _vm._v(" NABAL, ABIGAIL AND DAVID")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now Samuel died. And all Israel assembled and mourned for him, and they buried him in his house at Ramah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("Then David rose and went down to the wilderness of Paran.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And there was a man in Maon whose business was in Carmel. The man was very rich; he had three thousand sheep and a thousand goats. He was shearing his sheep in Carmel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now the name of the man was Nabal, and the name of his wife Abigail. The woman was discerning and beautiful, but the man was harsh and badly behaved; he was a Calebite.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("David heard in the wilderness that Nabal was shearing his sheep.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("So David sent ten young men. And David said to the young men, “Go up to Carmel, and go to Nabal and greet him in my name.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And thus you shall greet him: ‘Peace be to you, and peace be to your house, and peace be to all that you have.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _vm._v(" "), _c('i', [_vm._v("I hear that you have shearers. Now your shepherds have been with us, and we did them no harm, and they missed nothing all the time they were in Carmel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Ask your young men, and they will tell you. Therefore let my young men find favor in your eyes, for we come on a feast day. Please give whatever you have at hand to your servants and to your son David.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("When David’s young men came, they said all this to Nabal in the name of David, and then they waited.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And Nabal answered David’s servants, “Who is David? Who is the son of Jesse? There are many servants these days who are breaking away from their masters.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Shall I take my bread and my water and my meat that I have killed for my shearers and give it to men who come from I do not know where?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("So David’s young men turned away and came back and told him all this.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And David said to his men, “Every man strap on his sword!” And every man of them strapped on his sword. David also strapped on his sword. And about four hundred men went up after David, while two hundred remained with the baggage.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("But one of the young men told Abigail, Nabal’s wife, “Behold, David sent messengers out of the wilderness to greet our master, and he railed at them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Yet the men were very good to us, and we suffered no harm, and we did not miss anything when we were in the fields, as long as we went with them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("They were a wall to us both by night and by day, all the while we were with them keeping the sheep.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Now therefore know this and consider what you should do, for harm is determined against our master and against all his house, and he is such a worthless man that one cannot speak to him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Then Abigail made haste and took two hundred loaves and two skins of wine and five sheep already prepared and five seahs")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("of parched grain and a hundred clusters of raisins and two hundred cakes of figs, and laid them on donkeys.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("And she said to her young men, “Go on before me; behold, I come after you.” But she did not tell her husband Nabal.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("And as she rode on the donkey and came down under cover of the mountain, behold, David and his men came down toward her, and she met them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Now David had said, “Surely in vain have I guarded all that this fellow has in the wilderness, so that nothing was missed of all that belonged to him, and he has returned me evil for good.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("God do so to the enemies of David")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("and more also, if by morning I leave so much as one male of all who belong to him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("When Abigail saw David, she hurried and got down from the donkey and fell before David on her face and bowed to the ground.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("She fell at his feet and said, “On me alone, my lord, be the guilt. Please let your servant speak in your ears, and hear the words of your servant.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Let not my lord regard this worthless fellow, Nabal, for as his name is, so is he. Nabal")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("is his name, and folly is with him. But I your servant did not see the young men of my lord, whom you sent.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("Now then, my lord, as the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, and as your soul lives, because the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has restrained you from bloodguilt and from saving with your own hand, now then let your enemies and those who seek to do evil to my lord be as Nabal.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("And now let this present that your servant has brought to my lord be given to the young men who follow my lord.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("Please forgive the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3310"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page115",
      "title": "115"
    }
  }), _c('i', [_vm._v("trespass of your servant. For the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will certainly make my lord a sure house, because my lord is fighting the battles of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and evil shall not be found in you so long as you live.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("If men rise up to pursue you and to seek your life, the life of my lord shall be bound in the bundle of the living in the care of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("your God. And the lives of your enemies he shall sling out as from the hollow of a sling.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("And when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has done to my lord according to all the good that he has spoken concerning you and has appointed you prince")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("d")]), _vm._v(" "), _c('i', [_vm._v("over Israel,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("my lord shall have no cause of grief or pangs of conscience for having shed blood without cause or for my lord working salvation himself. And when the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has dealt well with my lord, then remember your servant.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("32")]), _c('i', [_vm._v("And David said to Abigail, “Blessed be the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, who sent you this day to meet me!")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("33")]), _c('i', [_vm._v("Blessed be your discretion, and blessed be you, who have kept me this day from bloodguilt and from working salvation with my own hand!")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("34")]), _c('i', [_vm._v("For as surely as the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the God of Israel, lives, who has restrained me from hurting you, unless you had hurried and come to meet me, truly by morning there had not been left to Nabal so much as one male.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("35")]), _c('i', [_vm._v("Then David received from her hand what she had brought him. And he said to her, “Go up in peace to your house. See, I have obeyed your voice, and I have granted your petition.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("36")]), _c('i', [_vm._v("And Abigail came to Nabal, and behold, he was holding a feast in his house, like the feast of a king. And Nabal’s heart was merry within him, for he was very drunk. So she told him nothing at all until the morning light.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("37")]), _c('i', [_vm._v("In the morning, when the wine had gone out of Nabal, his wife told him these things, and his heart died within him, and he became as a stone.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("38")]), _c('i', [_vm._v("And about ten days later the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("struck Nabal, and he died.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("39")]), _c('i', [_vm._v("When David heard that Nabal was dead, he said, “Blessed be the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("who has avenged the insult I received at the hand of Nabal, and has kept back his servant from wrongdoing. The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has returned the evil of Nabal on his own head.” Then David sent and spoke to Abigail, to take her as his wife.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("40")]), _c('i', [_vm._v("When the servants of David came to Abigail at Carmel, they said to her, “David has sent us to you to take you to him as his wife.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("41")]), _c('i', [_vm._v("And she rose and bowed with her face to the ground and said, “Behold, your handmaid is a servant to wash the feet of the servants of my lord.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("42")]), _c('i', [_vm._v("And Abigail hurried and rose and mounted a donkey, and her five young women attended her. She followed the messengers of David and became his wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("43")]), _c('i', [_vm._v("David also took Ahinoam of Jezreel, and both of them became his wives.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("44")]), _c('i', [_vm._v("Saul had given Michal his daughter, David’s wife, to Palti the son of Laish, who was of Gallim.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" A "), _c('i', [_vm._v("seah")]), _vm._v(" was about 7 quarts or 7.3 liters "), _c('b', [_vm._v("b")]), _vm._v(" Septuagint "), _c('i', [_vm._v("to David")]), _vm._v(" "), _c('b', [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("Nabal")]), _vm._v(" means "), _c('i', [_vm._v("fool")]), _vm._v(" "), _c('b', [_vm._v("d")]), _vm._v(" Or "), _c('i', [_vm._v("leader"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The reformers remark that on account of his godly leadership, Samuel, Israel’s last judge, is buried properly in Ramah. The story of foolish Nabal leads these interpreters to apply the lessons from Nabal’s dealings with David to our own lives: we should prefer others over ourselves, show thankfulness and not waste our time casting pearls before swine. But the story about Nabal also warns us of the excesses of anger. Despite the patience David bears when wronged by others, these interpreters believe that David acts too rashly when he vows to harm Nabal for being rude and refusing to acknowledge social norms.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David Avoids Shedding Blood.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" In this story of David against Nabal, let us first say that David could have used the law of the sword to fight impiety and blasphemy because he was a king ordained by God over Nabal, who was a big man in and around Judah and a descendant of the excellent man Caleb. But while we thus excuse David’s situation, we fall into danger of speaking against Scripture, which says that David sought protection from human zeal. In this matter, he could have had a good conscience, for this impious man deserved to die and be slain; he could have made a vow against "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3313"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3315"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3320"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page116",
      "title": "116"
    }
  }), _vm._v("Nabal through the God of Israel. But see the words of Abigail. See David’s words of thanksgiving that he had been kept from shedding blood. Accordingly, you also will see this to be as clear as day. David sought relief from the unlawfulness being introduced to him, which Scripture prohibits. And, as a person, it would certainly be a sin to fall on him without consulting the Lord (as he usually did) instead of deciding about the righteousness of the matter based on what the Lord wants. For God establishes nothing more than this desire even in the saints, that we unite God’s word and will to our good intentions (as they call them). For indeed, it appears as if David’s cause is just, so that even his vow in verse 22 looks to him as something about to be accomplished, striking down the impious and blasphemous one, as if it were not against God’s law but in accordance with law and right. His conscience was certainly good. But while conscience is at its highest, it is impiously not being guided by the Word of God. This is indeed just as Paul says, he who was converted to a good conscience before God as his ancestors were (2 Tim 1), from having been a blasphemer and persecutor of the church (1 Tim 1). Therefore David gives thanks to God, who turned him away from his plans through Abigail. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-128-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Abigail as Allegory of the Church.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Nabal is described by his place of dwelling in Maon, though he kept his cattle in Carmel, where his business lay. According to Joshua 15:55, Maon, Ziph and Carmel were not far from each other. Carmel generally signifies any place tilled or planted. It was the proper name of two places, one in Issachar, where Baal’s priests were killed, and another in Judah, where this story takes place. Moreover, Nabal is set forth by his name, which means “fool.” By his riches and qualities, he was churlish and evil-conditioned. Indeed, riches, where God’s grace is not bestowed, make people proud and insolent. By his kindred, Nabal was of the posterity of Caleb. However, good men do not always have good issue. Parents may leave to their children riches and possessions, but they cannot bequeath them wisdom, understanding and piety; for these attributes only proceed from God. And if there might be a certain descent of these spiritual graces, as of temporal ones, they would be thought to be natural. As for Abigail, whose name is interpreted as “the joy of the father,” she was a virtuous woman who was unequally matched with a wicked husband. Ambrose makes this allegory concerning her: Abigail signifies the church, which first served under a foolish and unwise husband, the philosophers and other vain men among the heathen. But afterward she was joined in marriage to Christ, just as Abigail became David’s wife. But this figure does not hold water on every point. For Abigail was a beautiful and wise woman before she was married to David, while the church of God was deformed and without any spiritual attractiveness or beauty until she was espoused to Christ. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-127-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_121"
    }
  }, [_c('b', [_vm._v("25:1")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Death of Samuel")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Israel’s Last Judge.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" You might wonder that Saul did not manifestly threaten Samuel with evil, for Samuel himself said, “If Saul hears it, he will kill me.” But it is clear that he was afraid of the people, with whom this admirable prophet had lived from his youth until he was a holy judge in Israel, so that even the king was afraid of Samuel, as the story above in chapter 15 declared. The same is true in chapter 28 below, where in anguish Saul wanted to raise him up from death himself, which he wanted not out of any sense of sorrow but because of his own failure. . . . Here dies the last judge of Israel, the one who established the kingdom. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-126-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Burial with Reverence.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" The people had great cause to mourn for Samuel, the Lord’s prophet. He was an upright man. In "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3326"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page117",
      "title": "117"
    }
  }), _vm._v("fact, at this time two calamities happened together: first, the death of Samuel, so great a prophet, and the exile of David. And second, not long after Samuel’s death, the Philistines prevailed against Saul after he and his three sons died in battle. It is not likely that Saul publicly mourned for Samuel as Samuel had done for Saul. And he did not wait long after Samuel’s death before pursuing David. Therefore David took this opportunity to escape to the utmost parts of the land, while others were busy with the burial of Samuel. There was a very great assembly of all Israel to honor Samuel’s funeral, for the bodies of the saints are to be interred in a dignified way. They are to be brought to the ground with honorable solemnity according to their defects while they lived. . . . Indeed, the bodies of Christians should not be neglected and cast away as unclean. This is how the heathens act, who have no regard for the immortality of the soul. Accordingly, they make a small account of the dead. In fact, the pagan emperors of Rome let the bodies of Christians lie unburied. However, the bodies of Christians, in hope of the resurrection and as temples of the Holy Spirit, should be commended and committed to Christian burial with reverence. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-125-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_122"
    }
  }, [_c('b', [_vm._v("25:2-12")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Foolish Nabal")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Riches and Blessings Are Wasted on Fools.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Proverbs says, “What good does it do a fool to have riches when he cannot buy wisdom?” Here you have an example. It is all for the worst whenever power and riches fall on foolish people, that is, among those ignorant of God’s Word. How much do you really value the cross carried by this wise, God-fearing woman Abigail? What impious company, which congregates in any and every place where you read of a good woman in Scripture! But God later makes her the queen and holiest wife of David, for God often leads the elect through hell and back again, and the impious are preserved until the day of evil. Moreover, hypocrites say yes presumptively to God’s love as long as the better gifts of God are visible: power, riches, eloquence, worldly wisdom, expertise in the law, righteousness of the flesh, a robust body and appearance, and so on. We use these examples to oppose the notion that Nabal was great or wealthy or that he deserved to be given the greatest wife, for there is nothing greater in this life than that. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-124-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Tending to Christ’s Sheep.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" Nabal thinks only of his sheep and does not have any concern for David. If the truth were known, there are many Nabals today who love their own sheep better than Christ’s sheep. "), _c('i', [_vm._v("The White Devil.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-123-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Being Thankful Unlike Nabal.")]), _vm._v(" "), _c('i', [_vm._v("John Davenant:")]), _vm._v(" We ought to be thankful to God because without gratitude there can be no spiritual blessings within us. For since every spiritual blessing depends on a certain perpetual influx of divine grace, ingratitude is that infernal bar that interrupts the flow and the course of divine goodness. Therefore we ought to be thankful, lest we should be deprived of all our gifts.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But gratitude toward people is also required so that peace may be kept inviolate, because troubles and enmities sometimes arise from kindnesses not duly repaid or from injuries inflicted. We perceive this in the example of Nabal, who by his ingratitude so exasperated the mind of David that unless the prudence and humanity of Abigail had relieved him, that ungrateful man and his whole family would have been ruined.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There are two instructions we may gather from this: First, if we would have God remain kind to us, we ought to show ourselves thankful to him and grateful for the benefits conferred on us. Second, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3338"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page118",
      "title": "118"
    }
  }), _vm._v("the best proof we can give of our gratitude is that we obey the divine will. . . . Those benefited by kindnesses are bound by the divine command (if occasion offers) to return thanks to their benefactors not in mere words, but in reality. "), _c('i', [_vm._v("Exposition on Colossians.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-122-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_123"
    }
  }, [_c('b', [_vm._v("25:13-35")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Rashness")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("By God’s Permission.")]), _vm._v(" "), _c('i', [_vm._v("Jacobus Arminius:")]), _vm._v(" God permitted David to resolve in his mind to destroy with the sword Nabal and all his domestics, and to go instantly to him; but he did not permit him to shed innocent blood, and to save himself by his own hand. "), _c('i', [_vm._v("Disputation 10: On the Righteousness and Efficacy of God’s Providence Concerning Evil")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-121-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Hasty and Sudden Rage.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It may seem strange that David, who patiently bore both the wrongs Saul perpetrated against him as well as the ravings of Shimei later on when he was king, could not at this time hold himself back from Nabal’s insult. On the contrary, he quickly armed himself to take revenge. His first reason for doing so was due to the ingratitude of Nabal, who returned to him “evil for good,” as David says in verse 21. The other reason was due to the indignity and contempt with which Nabal spoke to David’s servants. Here it is clear that people can endure greater violence offered to their bodies than contempt and reproaches to their good name. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-120-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On David’s Lie.")]), _vm._v(" "), _c('i', [_vm._v("Benedict Aretius:")]), _vm._v(" David swore he would kill Nabal, but afterward he did not do so. We respond: He rashly swore, but he later more wisely changed his mind. In the thought was sin but in his change of heart is praise. Therefore, there is no profit for the one who lies. "), _c('i', [_vm._v("Common Places of the Christian Religion.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-119-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_124"
    }
  }, [_c('b', [_vm._v("25:36-38")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Not Reasoning with a Drunken Person")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Taking the Wise Course.")]), _vm._v(" "), _c('i', [_vm._v("Lancelot Andrewes:")]), _vm._v(" That course Abigail took . . . is the course God uses, that is, in the spirit of discretion to deal with people when the fit of rage of sin is past and when their blood is cold. For there is no meddling with a person in their drunken fit or in their fury of heat and rage, because their judgment and senses are then taken away. "), _c('i', [_vm._v("Collection of Lectures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-118-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Waiting till the Wine’s Gone Out.")]), _vm._v(" "), _c('i', [_vm._v("John Arrowsmith:")]), _vm._v(" You may see a drunk person reeling to and fro, today entertaining this odd conceit, tomorrow that . . . and unstable in all his ways. In fact, the drunk may be vomiting and casting out scornful reproaches on all who are of a contrary judgment. . . . You may perceive them full of slander, as drunkards commonly used to be, prating and venting their own apprehensions everywhere. . . . “One drunkard,” our proverb says, “is forty men strong.” Whoever attempts to reason with them will easily find them as incapable of conviction as Nabal was of Abigail’s narration till his wine was gone out of him. "), _c('i', [_vm._v("Chain of Principles.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-117-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_125"
    }
  }, [_c('b', [_vm._v("25:39-44")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Polygamy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Example for Admonishing, Not Imitating.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Piscator:")]), _vm._v(" This admission of polygamy in the holy figure of David is not given as an example to follow. Rather, it’s given as a way to admonish the weaknesses of the saints. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-116-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Polygamy Among Cave Wandering.")]), _vm._v(" "), _c('i', [_vm._v("Cardinal Cajetan:")]), _vm._v(" See how great the Jewish inclination toward procreation was! The zeal of the Jews was so great for producing children that they "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3344"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page119",
      "title": "119"
    }
  }), _vm._v("managed to multiply wives while also wandering through caves. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-115-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Multiple Wives and Singular Faith.")]), _vm._v(" "), _c('i', [_vm._v("Konrad Pellikan:")]), _vm._v(" David was allowed to have multiple wives, just as other saints similarly were welcomed amid great sins. Nevertheless, he knew that such temptations of the flesh were quite unbearable. We are not allowed to take many wives, as the saints were before us, without it causing trouble. Solomon did not handle having many wives well, nor did David, as we have seen. The Lord had advised them well, yet did not count their actions as a grave sin, as it would have been among others. On the contrary, Saul had few wives and yet displeased God; David had many and pleased the Lord. Wives did not cause this, rather faith. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-114-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Many Wives Are Permissible.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Because the law is given in Deuteronomy 17:17 that the king shall not multiply many wives lest his heart turn away, there is great doubt whether David did not offend against that law. That’s because this passage explicitly mentions that David had three wives (and many more afterward). Some answer that as in the same place the king is forbidden to have many horses, yet Solomon—before his fall, while his wisdom remained with him—had forty thousand stalls of horses, meaning that as it was lawful for the king to have a number of horses for the maintenance of the state, as long as they were necessary and not excessive. They were not to be kept only for ostentation and pleasure. According to such an interpretation, therefore, the king would be permitted to have two, three or more wives, so long as they were not multiplied out of measure. Such was Solomon’s sin and not David’s. But some do not find this interpretation satisfying. For although Solomon had hundreds more wives than David, David still had more than one wife; in fact, he had six. Nor does the comparison hold between the number of horses and wives: For one wife may suffice, where many thousands of horses are not sufficient for the state and service of a king. Some therefore think that the issue is not about having many wives but about not multiplying them such as would turn the king’s heart away from God. Again, in such a circumstance, Solomon’s wives did turn his heart away from God while David’s wives did not. But this answer is not sufficient either. That’s because this law is meant for all the kings of Israel, just as much as it is for all others. For anyone who has multiple wives will be put in peril, though some by God’s grace are kept from that danger.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Therefore the occasion of the danger is to be shunned completely, for no one knows their own strength. The same law is prescribed, namely, that they should not take the daughters of the foreign nations to their sons lest they make them “whore after their gods.” Yet was it simply forbidden to marry them even though no idolatry ensued? For example, although the people confessed that they had trespassed against God by taking foreign wives of the people of the land in Ezra 10:2, no mention is made that by them they fell into idolatry. Accordingly, some think the king was forbidden to violently take away other men’s wives, as they did before the flood. Such would have been David’s great offense by taking Uriah’s wife. If this was the meaning, however, then Solomon would not have transgressed against this law by taking many wives, for it does not appear that any of his queens and concubines were another’s wife. Nor yet can it be thought that such a holy man as David would transgress such a manifest law. Therefore, though it was a general infirmity in those days not only in kings but also in their people to have many wives . . . yet the meaning of this law does not appear to simply forbid many wives. This is apparent by the verse which indicates that the Lord gave power and liberty to David to take his master’s wives: “And I gave you your master’s house and your master’s wives into your arms and gave you the house of Israel and of Judah. And if this were too little, I would add to you as much more.” The Lord would "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3346"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page120",
      "title": "120"
    }
  }), _vm._v("not have gone against his own law. Therefore, in this passage, it is not the "), _c('i', [_vm._v("thing")]), _vm._v(" that is forbidden, but the "), _c('i', [_vm._v("manner")]), _vm._v(". In other words, the king was not to take many wives to give himself to lust and pleasure, and so neglect the office and duty of the kingdom. And just as the king was forbidden to multiply horses, gold and silver, so he was restrained from multiplying wives. But it was lawful in and of itself for the king to have many horses, silver and gold, as Solomon had. However, he was not to trust in them. To conclude, it was permitted in those times to have many wives. Yet the kings were not to use their wives for lust and concupiscence, but for procreation. The kings were not to be addicted to them. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-113-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page121",
      "title": "121"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_126"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("26:1–27:12")]), _vm._v(" DAVID SPARES SAUL AGAIN AND THEN FLEES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Then the Ziphites came to Saul at Gibeah, saying, “Is not David hiding himself on the hill of Hachilah, which is on the east of Jeshimon?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("So Saul arose and went down to the wilderness of Ziph with three thousand chosen men of Israel to seek David in the wilderness of Ziph.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And Saul encamped on the hill of Hachilah, which is beside the road on the east of Jeshimon. But David remained in the wilderness. When he saw that Saul came after him into the wilderness,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("David sent out spies and learned that Saul had indeed come.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Then David rose and came to the place where Saul had encamped. And David saw the place where Saul lay, with Abner the son of Ner, the commander of his army. Saul was lying within the encampment, while the army was encamped around him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Then David said to Ahimelech the Hittite, and to Joab’s brother Abishai the son of Zeruiah, “Who will go down with me into the camp to Saul?” And Abishai said, “I will go down with you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("So David and Abishai went to the army by night. And there lay Saul sleeping within the encampment, with his spear stuck in the ground at his head, and Abner and the army lay around him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Then Abishai said to David, “God has given your enemy into your hand this day. Now please let me pin him to the earth with one stroke of the spear, and I will not strike him twice.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("But David said to Abishai, “Do not destroy him, for who can put out his hand against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed and be guiltless?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("And David said, “As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will strike him, or his day will come to die, or he will go down into battle and perish.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("forbid that I should put out my hand against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed. But take now the spear that is at his head and the jar of water, and let us go.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("So David took the spear and the jar of water from Saul’s head, and they went away. No man saw it or knew it, nor did any awake, for they were all asleep, because a deep sleep from the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("had fallen upon them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("Then David went over to the other side and stood far off on the top of the hill, with a great space between them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("And David called to the army, and to Abner the son of Ner, saying, “Will you not answer, Abner?” Then Abner answered, “Who are you who calls to the king?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And David said to Abner, “Are you not a man? Who is like you in Israel? Why then have you not kept watch over your lord the king? For one of the people came in to destroy the king your lord.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("This thing that you have done is not good. As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, you deserve to die, because you have not kept watch over your lord, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed. And now see where the king’s spear is and the jar of water that was at his head.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("Saul recognized David’s voice and said, “Is this your voice, my son David?” And David said, “It is my voice, my lord, O king.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("And he said, “Why does my lord pursue after his servant? For what have I done? What evil is on my hands?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Now therefore let my lord the king hear the words of his servant. If it is the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("who has stirred you up against me, may he accept an offering, but if it is men, may they be cursed before the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for they have driven me out this day that I should have no share in the heritage of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", saying, ‘Go, serve other gods.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Now therefore, let not my blood fall to the earth away from the presence of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", for the king of Israel has come out to seek a single flea like one who hunts a partridge in the mountains.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Then Saul said, “I have sinned. Return, my son David, for I will no more do you harm, because my life was precious in your eyes this day. Behold, I have acted foolishly, and have made a great mistake.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("And David answered and said, “Here is the spear, O king! Let one of the young men come over and take it.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("rewards every man for his righteousness and his faithfulness, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("gave you into my hand today, and I would not put out my hand against the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v("’s anointed.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Behold, as your life was precious this day in my sight, so may my life be precious in the sight of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", and may he deliver me out of all tribulation.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("Then Saul said to David, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3347"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3351"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page122",
      "title": "122"
    }
  }), _c('i', [_vm._v("“Blessed be you, my son David! You will do many things and will succeed in them.” So David went his way, and Saul returned to his place.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("27")]), _vm._v(" "), _c('i', [_vm._v("Then David said in his heart, “Now I shall perish one day by the hand of Saul. There is nothing better for me than that I should escape to the land of the Philistines. Then Saul will despair of seeking me any longer within the borders of Israel, and I shall escape out of his hand.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("So David arose and went over, he and the six hundred men who were with him, to Achish the son of Maoch, king of Gath.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And David lived with Achish at Gath, he and his men, every man with his household, and David with his two wives, Ahinoam of Jezreel, and Abigail of Carmel, Nabal’s widow.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("And when it was told Saul that David had fled to Gath, he no longer sought him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Then David said to Achish, “If I have found favor in your eyes, let a place be given me in one of the country towns, that I may dwell there. For why should your servant dwell in the royal city with you?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("So that day Achish gave him Ziklag. Therefore Ziklag has belonged to the kings of Judah to this day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And the number of the days that David lived in the country of the Philistines was a year and four months.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("Now David and his men went up and made raids against the Geshurites, the Girzites, and the Amalekites, for these were the inhabitants of the land from of old, as far as Shur, to the land of Egypt.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And David would strike the land and would leave neither man nor woman alive, but would take away the sheep, the oxen, the donkeys, the camels, and the garments, and come back to Achish.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("When Achish asked, “Where have you made a raid today?” David would say, “Against the Negeb of Judah,” or, “Against the Negeb of the Jerahmeelites,” or, “Against the Negeb of the Kenites.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("And David would leave neither man nor woman alive to bring news to Gath, thinking, “lest they should tell about us and say, ‘So David has done.’” Such was his custom all the while he lived in the country of the Philistines.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("And Achish trusted David, thinking, “He has made himself an utter stench to his people Israel; therefore he shall always be my servant.”"), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Overview:")]), _vm._v(" The theme of David as a messianic figure and Saul as an evil oppressor continues in these two chapters. One of the Anabaptist commentators, likely drawing on his own experience as a persecuted minority, draws direct connections between David and Christ’s persecutions. In addition, David’s deception of Achish, though used to protect the Judeans, is not to be an example for believers—the works and words of God, not human beings, are.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_127"
    }
  }, [_c('b', [_vm._v("26:1-5")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Hunt Continues")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Persecuted Then Enthroned Heir.")]), _vm._v(" "), _c('i', [_vm._v("Dirk Philips:")]), _vm._v(" Christ also was persecuted by unbelieving and godless people and often had to escape from Judea and hide himself in the wilderness. But after this he received his kingdom and was established and inaugurated by God his Father as the mighty king on Mount Zion. God gave him the throne of David to rule in the house of Jacob for eternity, a kingdom without end. "), _c('i', [_vm._v("Enchiridion: Concerning Spiritual Restitution.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-112-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("No Rest for the Wicked.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" The wicked cannot sleep until they have done mischief. Saul would not give over the chase of David, but hunts him savagely through every wilderness. The very desert is held too good a refuge for innocence; the hills and rocks are searched in an angry jealousy. The very wild goats of the mountains were not allowed to be companions for the one who had no other fault but his virtue. Still David’s success is Saul’s vexation. Where will that person rest who seeks rest in sin? They cannot find rest in this life, for they walk in circles, grind in the devil’s mill. Will they rest hereafter? No, then they will eat of their own grist, and labor in torment. Only there is some difference in the manner of their working, and of the time; here with pleasure, there with horror: for a while here, there forever. Still "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3361"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page123",
      "title": "123"
    }
  }), _vm._v("these obstinate seducers who are obsessed with mischief go on, from strength in sin, to strength of sinning, till every one appears before their master in hell. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-111-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("How the Lord Stirs Up.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" God stirs no one up nor tempts the person to evil, just as he himself is not tempted of any evil. Yet the Lord may be said here to stir Saul up to the action of pursuing of David in three kinds of ways. First, God acts instrumentally. He justly uses here the ministry of the evil spirits, which were the instruments and ministers of God in stirring up Saul. God justly sent them on Saul to do his will. Second, God, acting efficiently, may be said to stir up the magistrate to act justly. But here Saul acted unjustly. Finally, the Lord occasionally stirs up when the wicked take occasion by God’s mercies on others to fret and show their malice. Such is how Pharaoh hated the people of God because he saw that they increased plentifully. And so Saul was David’s enemy because the Lord had caused him to be anointed as king. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-110-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_128"
    }
  }, [_c('b', [_vm._v("26:6-25")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David’s Great Restraint")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Wickedness by Another.")]), _vm._v(" "), _c('i', [_vm._v("William Tyndale:")]), _vm._v(" If any person might have avenged himself on his superior, it would have justifiably been David’s actions done on King Saul, who so wrongfully persecuted David. And he did this for no other cause than that God had anointed David king and promised him the kingdom. Yet when God had delivered Saul into the hands of David, he could not do what he may have wanted to do with him. . . . As the old proverb says, “Out of the wicked shall wickedness proceed, but my hand will not be on you,” meaning that God always punishes one who is wicked by another. "), _c('i', [_vm._v("Doctrinal Treatises and Introductions to Other Portions of Holy Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-109-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On Being a Good Subject.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" We learn partly through the example of David and partly through the teachings of Jeremiah and the apostles in what way subjects are to be influenced by their hard and cruel princes or tyrants. David was not ignorant of the type of person Saul was—an ungodly and cruel bandit; as such, he fled from him. But when the occasion arose for him once or twice to take him down, David did not kill Saul but spared the tyrant and honored him as if he were his own father. "), _c('i', [_vm._v("Decades 2.6.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-108-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Practice in Afflictions.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" As always, here goes Saul, except now with even more impiety since David overlooked his sins and false oaths above in chapter 24. Indeed, David does not turn away from his innocence this time either, as he still does not want to strike down the king until the Lord strikes him down. He trusts God’s vindication, perhaps having learned in the previous chapter that it might be harmful to follow our whims. And it clearly happens again as it did in chapter 4 that David has been well versed to this point in having a strong faith in his soul, so that by his own will he and his companions go down into Saul’s camp. For he has been protected so often that he knows himself to be in God’s care and that he cannot perish in Saul’s impiety. Only practice in afflictions can produce such faith in us. For God exalts through faith for faith, so that we might grow to full maturity. Moreover, this story has it that the wisdom of the flesh is mocked and the Spirit cares for the one to whom it has been given. A deep sleep from the Lord had come over David’s enemies. In this miracle, we see how much God cared for David, who entrusted himself to God with the highest faithfulness. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-107-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3364"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3365"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3366"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3367"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3368"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3369"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3370"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page124",
      "title": "124"
    }
  })]), _c('b', [_vm._v("Confident Prayer While Being Hunted.")]), _vm._v(" "), _c('i', [_vm._v("John Knox:")]), _vm._v(" What is necessary to be followed in prayer is a sure hope to obtain what we ask for. For nothing more offends God than when we ask doubtfully whether he will grant our petitions. For in so doing we doubt if God is true and if he is mighty and good. Such, says James, obtain nothing, and therefore Jesus Christ commands that we firmly believe in order to obtain whatever we ask for. For all things are possible to the one who believes. And therefore, in our prayers, desperation is always to be expelled. I do not mean that any person in extremity of trouble can be without present pain and without a greater fear of trouble to follow. Rather, trouble and fear are the very spurs to prayer. For when a person, encircled with vehement calamities and vexed with continual anxiety—having, by human help, no hope of deliverance, with an oppressed and punished heart, fearing also greater punishment to follow from the deep pit of tribulation—calls to God for comfort and support, such prayer ascends to God’s presence, and does not return in vain.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This is seen, for instance, in Saul’s vehement persecution of David, as the latter was hunted and chased from every hole, fearing that one day or other he should fall into the hands of his persecutors. After that he complained that no place of rest was left to him, vehemently praying, “O Lord my God, in you do I take refuge; save me from all my pursuers and deliver me, lest like a lion they tear my soul apart, rending it in pieces, with none to deliver. O Lord my God, if I have done this, if there is wrong in my hands, if I have repaid my friend with evil or plundered my enemy without cause, let the enemy pursue my soul and overtake it, and let him trample my life to the ground and lay my glory in the dust.” In the midst of these anguishes, the goodness of God sustained David, so that the present tribulation was tolerable. And the infallible promises of God so assured him of deliverance that fear was partly mitigated and gone, as plainly appears to those who diligently observe the process of his prayer. "), _c('i', [_vm._v("Treatise on Prayer.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-106-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Good Example.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Becon:")]), _vm._v(" It is good to follow the example of David, who showed such honor and reverence to King Saul, both a wicked ruler and his mortal enemy, that he would not once hurt him, nor yet suffer any other to do it, although he had sufficient opportunity . . . and occasion at diverse times to have slain him, if he had been minded. "), _c('i', [_vm._v("A New Catechism.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-105-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Innocence Before God.")]), _vm._v(" "), _c('i', [_vm._v("David Dickson:")]), _vm._v(" Though innocence cannot exempt a person from being unjustly slandered, yet it will furnish him with a good conscience and much boldness in the specific things before God. . . . The more a person renders good for evil, the more confidence he will have when he comes to God. For innocence served David for this good use, namely, that he delivered Saul—who was his enemy for no good reason. . . . The one who is conscious of doing or intending injury to his neighbor will have his own conscience against him, and in that case will be forced to justify God’s righteousness against himself. "), _c('i', [_vm._v("Explication of the First Fifty Psalms.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-104-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_129"
    }
  }, [_c('b', [_vm._v("27:1-12")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Flees to the Philistines")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Enemy of Your Enemy.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Here David in his anguish is driven away, deciding he will be better off among enemies than among his own people. And he flees to the one he was with before, Achish in Gath of the Philistines, the enemy of Israel. David receives the city of Ziklag from him to live in as a prince. But why does he flee to the one before whom he was so afraid that he pretended to be out of his mind? I reply: By this time it had become known that the life of this prince who had dispatched Goliath was being sought by the king of Israel. For this reason, the king of the Philistines was not afraid of any traps but warmly accepted this great man as a Philistine, of whom it might be expected that he would do great evil against Saul. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-103-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3371"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3372"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3373"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3374"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3375"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page125",
      "title": "125"
    }
  })]), _c('b', [_vm._v("David’s Unbelief and Belief.")]), _vm._v(" "), _c('i', [_vm._v("Justus Menius:")]), _vm._v(" Here David’s weakened faith is described. He feared that he would eventually fall into Saul’s hands; therefore he departed from the borders of Israel into the land of the Philistines. Now, as by this David’s faith had been weakened in part, so that he fled Saul; so also, again, in a different way his faith was strengthened in part, so that he dared to entrust himself to a most hostile people. For if you would consider what a wicked reputation he had earned for himself among the Philistines—because he killed Goliath and, in addition, he cut down two hundred of them and cut off their foreskin—you would easily recognize that there was nothing more dangerous than to dwell in this race’s country. Yes, although David was in the midst of an impious people, nevertheless he did not at the same time abandon faith, no indeed, he did nothing apart from faith. "), _c('i', [_vm._v("Commentary on 1 Samuel 27.")]), _c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-102-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Answers to King Achish.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" The king asked, “Where have you made a raid today?” David’s words were true, but through them he nevertheless deceived the king, who thought that David was bringing evil to the Judeans as an enemy. For the king greatly desired that David might sacrifice himself against the nations, and so he did not condemn those things, even though he did not know what was being plundered. Thus David deceived the king without being condemned by the king in order to defend himself and protect his own, which God was allowing to him to do. We spoke of this fraud earlier, that one may not make a rule of deception based on this. For it is the well-practiced hypocritical wisdom of the flesh that makes a law out of the works of the saints, as if the saints were not able to sin. We should follow the Word of God, not the works of the saints, unless we even want to imitate David in committing adultery and murder. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-101-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page126",
      "title": "126"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_130"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("28:1-25")]), _vm._v(" SAUL AND THE MEDIUM AT EN-DOR")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("In those days the Philistines gathered their forces for war, to fight against Israel. And Achish said to David, “Understand that you and your men are to go out with me in the army.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("David said to Achish, “Very well, you shall know what your servant can do.” And Achish said to David, “Very well, I will make you my bodyguard for life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("Now Samuel had died, and all Israel had mourned for him and buried him in Ramah, his own city. And Saul had put the mediums and the necromancers out of the land.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("The Philistines assembled and came and encamped at Shunem. And Saul gathered all Israel, and they encamped at Gilboa.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("When Saul saw the army of the Philistines, he was afraid, and his heart trembled greatly.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And when Saul inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("did not answer him, either by dreams, or by Urim, or by prophets.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("Then Saul said to his servants, “Seek out for me a woman who is a medium, that I may go to her and inquire of her.” And his servants said to him, “Behold, there is a medium at En-dor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("So Saul disguised himself and put on other garments and went, he and two men with him. And they came to the woman by night. And he said, “Divine for me by a spirit and bring up for me whomever I shall name to you.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("The woman said to him, “Surely you know what Saul has done, how he has cut off the mediums and the necromancers from the land. Why then are you laying a trap for my life to bring about my death?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("But Saul swore to her by the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", “As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, no punishment shall come upon you for this thing.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("Then the woman said, “Whom shall I bring up for you?” He said, “Bring up Samuel for me.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("When the woman saw Samuel, she cried out with a loud voice. And the woman said to Saul, “Why have you deceived me? You are Saul.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("The king said to her, “Do not be afraid. What do you see?” And the woman said to Saul, “I see a god coming up out of the earth.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("He said to her, “What is his appearance?” And she said, “An old man is coming up, and he is wrapped in a robe.” And Saul knew that it was Samuel, and he bowed with his face to the ground and paid homage.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("Then Samuel said to Saul, “Why have you disturbed me by bringing me up?” Saul answered, “I am in great distress, for the Philistines are warring against me, and God has turned away from me and answers me no more, either by prophets or by dreams. Therefore I have summoned you to tell me what I shall do.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And Samuel said, “Why then do you ask me, since the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has turned from you and become your enemy?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has done to you as he spoke by me, for the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has torn the kingdom out of your hand and given it to your neighbor, David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("Because you did not obey the voice of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("and did not carry out his fierce wrath against Amalek, therefore the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has done this thing to you this day.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Moreover, the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will give Israel also with you into the hand of the Philistines, and tomorrow you and your sons shall be with me. The")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("will give the army of Israel also into the hand of the Philistines.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("Then Saul fell at once full length on the ground, filled with fear because of the words of Samuel. And there was no strength in him, for he had eaten nothing all day and all night.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("And the woman came to Saul, and when she saw that he was terrified, she said to him, “Behold, your servant has obeyed you. I have taken my life in my hand and have listened to what you have said to me.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Now therefore, you also obey your servant. Let me set a morsel of bread before you; and eat, that you may have strength when you go on your way.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("He refused and said, “I will not eat.” But his servants, together with the woman, urged him, and he listened to their words. So he arose from the earth and sat on the bed.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Now the woman had a fattened calf in the house, and she quickly killed it, and she took flour and kneaded it and baked unleavened bread of it,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("and she put it before Saul and his servants, and they ate. Then they rose and went away that night."), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3376"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3377"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3378"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3379"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3380"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3381"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3382"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3383"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3384"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3385"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3386"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3387"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3388"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3389"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3390"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3391"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3392"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3393"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page127",
      "title": "127"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" The scene between Saul and the witch at En-dor elicits more commentary from the interpreters than perhaps any other passage in First or Second Samuel. Indeed, this passage provides a rich diversity of interpretation from all the major confessions of the Reformation era. All agree that seeking out a witch is a desperate and depraved act. There are three principal interpretive options when it comes to identifying the spirit the witch calls forth: it is Samuel in person, an illusion or a demon (perhaps even Satan himself). The reformers carefully examine the words of the spirit—that Saul and his sons would die tomorrow on the battlefield. That this prophecy came to pass complicates the issue of identifying exactly what or who the spirit is.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("In Distress and Temptation, Saul Turns to Idolatry.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" First, Samuel’s death was described in chapter 25, so that you know what follows about his rising to be a demonic illusion. Next, it is shown what kind of righteous and pious king this desperate hypocrite pretended to be after Samuel’s death, sweeping away the magicians—soothsayers and mediums—as if following the law of Leviticus 20, Deuteronomy 18 and Isaiah 8. For hypocrites insist upon forcing the works of the law upon the people, while neglecting and despising faith in God. Therefore it is written of Saul in 1 Chronicles, “Saul died for his breach of faith. He broke faith with the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" in that he did not keep the command of the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(", and also consulted a medium, seeking guidance. He did not seek guidance from the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(". Therefore the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" put him to death and turned the kingdom over to David the son of Jesse.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("What good did it do Saul to have a name among men that soothsayers would not be suffered, as he had heard from Samuel earlier: “Rebellion is as the sin of divination, and presumption is as iniquity and idolatry.” All the righteous ones are idolaters when they cast off the Word of God, etc. Further, this story reveals Saul’s hypocrisy, for he sought in distress that which he had publicly condemned. Hypocrisy boasts of being beyond temptation through the works of the law and of being seen in worship of God, but then it despairs in times of real temptation, because it never had true faith in God. Thus it says, “When Saul saw the army of the Philistines, he was afraid, and his heart trembled greatly.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-100-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_131"
    }
  }, [_c('b', [_vm._v("28:1-10")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul’s Desperate Act")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Wicked Act.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Saul was to the very end a rebel against God; he despised him like someone who is incorrigible. Not only did he persecute the innocent, but wishing to reverse the decree of God, he committed a most wicked act. He went like a wretched magician or enchanter to ask counsel of a witch. . . . That was the most desperate act of all. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-099-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Impatience Leads to Sin.")]), _vm._v(" "), _c('i', [_vm._v("Philipp Melanchthon:")]), _vm._v(" All those who allow the devil to embitter them with impatience, who give way to the flesh and who mumble and become angry against God allow faith and obedience to God to depart (which is frightful). Impatient, angry, embittered hearts think that God does not pay attention to them, that there is no point in praying, or in waiting and expecting comfort and help. In truly great temptations the heart will impatiently grasp at blasphemy, despondency and human comfort and assistance, against God’s commandment, just as King Saul sought out the witch. Such frightfully heavy sins against the first table of the Decalogue come from impatience. A little patience, however, often produces much good. "), _c('i', [_vm._v("Theological Commonplaces (1555).")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-098-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Appealing to God Too Late.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" The more hold a person takes of the world, the more they lose hold of the Lord. Covetous people cleave to the world so long as they can; but when that staff breaks, then they turn to the Lord. Extremity of distress will send the most profane to "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3394"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3395"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3396"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3397"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3398"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3399"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3400"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3401"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3402"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page128",
      "title": "128"
    }
  }), _vm._v("God: as the drowning person stretches out their hand to that lifejacket, which they condemned while safe on shore. So Saul retired himself to “inquire of the Lord, but the Lord did not answer him.” It is an unreasonable inequality to hope to find God at our command, when we would not be at his: to look that he should regard our voice in trouble, when we would not regard his voice in peace. Let your conversation be without covetousness. Why? Because God has said, “I will never leave you nor forsake you.” We credit the promise of a wealthy and trusty friend: yet a person may lie, a person may die and a person may be unable to help themselves. God is too constant to be changed, too powerful to be crossed, too wise to be deceived. “I will never leave you”: not in a year, not in age, not in sickness, not in death. Those who believe this cannot be covetous. The wealth you keep is not your own, but God’s. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-097-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Devil in God’s Place.")]), _vm._v(" "), _c('i', [_vm._v("George Gifford:")]), _vm._v(" No doubt many refuse to hear the voice of God and be instructed by him. They despise his word, and therefore they are given up to listen to devils. All those who have sought out the work of the devil and have now come to see their offense ought to show repentance for this, but not as for a light sin. It is no small abomination to go for help to the devil. It is to set him in God’s place and to honor him as God. It rises from infidelity to and distrust of help from God. We may see this in the example of King Saul who, finding neither answer nor comfort from God, whom he had so wickedly disobeyed, went to a witch. The heathen man said, “If I cannot entreat the gods, I will drown among the devils.” "), _c('i', [_vm._v("A Dialogue Concerning Witches and Witchcraft.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-096-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Truth Ministered by the Devil.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Jackson:")]), _vm._v(" Saul, who had followed the customs of other nations and not the prescripts of God’s Word, “asked of the L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(", but the Lord did not answer him, either by dreams, or by Urim, or by prophets.” His sins had made a separation between him and the God of Israel, who for this cause would not allow his presence to his priests or prophets—who came as mediators between God and Saul—to be manifested. Much less would vouchsafe his Spirit to priests and prophets who were carnally minded themselves. . . . Yet it cannot be denied that the pagans were oftentimes, by God’s permission, truly spoken to through the means of dreams and oracles—though ultimately ministered by the devil—of events that should come to pass. But such resolutions were rarely for their good. For example, when Saul inquired after a witch . . . when God had cast him off, she did in fact procure Saul a true prediction of his fearful end. "), _c('i', [_vm._v("The Eternal Truth of Scriptures.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-095-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_132"
    }
  }, [_c('b', [_vm._v("28:11-14")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Is It Samuel, an Overactive Imagination, a Demon or the Devil?")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("From Saul’s Perspective.")]), _vm._v(" "), _c('i', [_vm._v("Martin Luther:")]), _vm._v(" The Scriptures do not expressly state whether it was really Samuel; they only call him Samuel. This proves that the Scriptures put the matter as it was in the heart of Saul, who did not know but that it was Samuel; and the spirit skillfully spoke all the words of Samuel and added more to them. The Holy Spirit, however, intends that we should be warned and armed by this commandment . . . so that we might know that whatever happens contrary to it does not proceed from a good spirit or from the children of a good spirit. "), _c('i', [_vm._v("The Misuse of the Mass.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-094-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("On How People Live and Die Once.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Some people oppose Samuel’s appearance taken here from holy Scripture, which they contend to prove that souls return again after death and teach people about speculative matters. We answer briefly that this figure who seemed to be the prophet was called Samuel by a "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3403"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3404"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3405"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3406"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3407"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3408"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3409"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3410"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3411"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3412"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3413"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3414"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page129",
      "title": "129"
    }
  }), _vm._v("trope, but in fact it was not Samuel. In truth, it was a ghost—a delusion and illusion of Satan—for magic is strictly prohibited in the law of the Lord. Therefore blessed spirits do not submit to such prohibited things and unspeakable arts, which when they were still united with their flesh fought against and abhorred all of their ways. As for damned spirits, they do involve themselves in this. Now, who would believe their oracles? But Samuel predicts that which, they say, happened the next day. And then what? This was not difficult for the demon, given that the true and living Samuel had predicted many things a little while before. . . . Tertullian says in his book "), _c('i', [_vm._v("On the Soul")]), _vm._v(": “God forbid that we should believe that any soul, much less that of a prophet, could be called forth by a demon, since we are taught that ‘Satan disguises himself as an angel of light’—much less into a man of light—even asserting himself as God and presenting wonderful signs to overthrow, if possible, even the elect.” St. Augustine is of the same opinion about this appearance in his book "), _c('i', [_vm._v("To Simplician")]), _vm._v(" 2.3 and others. By these passages I hope that it is abundantly proved that souls of people separated from bodies do not wander or appear in these regions after death. For they remain until judgment in the destination appointed for them by the declaration of God. They are neither sent by the Lord nor are they able to enter into people; neither can they give warning of either present or future things. From this it follows that the appearances of souls, revelations and oracles are mere delusions of Satan, instituted contrary to the sincerity and purity of true religion. "), _c('i', [_vm._v("Decades 4.10.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-093-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Deceived by a Demon.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" I wonder how could it have been possible to have this damnable power over death unless Satan had taken the appearance of Samuel? Since the law reveals that the ungodly consult the dead, as in Deuteronomy 18 and Isaiah 8, who does not see that this was a diabolical illusion? Scripture does not write that this was truly Samuel but that Saul and the woman believed it was him. In its simplicity here, Scripture does not withdraw the prohibition not to seek truth by means of the dead. Such images are truly not the dead but demons who are wrongly believed to have been raised up among the living. Moreover, it is no wonder that the devil reports and predicts accurately. For he sees what is already everywhere: for no one hid the fact that David would soon reign or that Saul would soon perish. For against the Philistine forces, Saul himself saw no defense, neither from people, nor from God, whom Saul was already fighting through his adversaries, nor from David, who alone God might use to save, because David was not there. Therefore the devil could easily make certain conjectures as prophecy, especially because he is eager to cause and inspire failure. God allowed all these things to be spoken truly by Satan, so that all those who have refused to love the truth might be more fully confirmed in their errors, as it says in 2 Thessalonians 2. And in Deuteronomy 13 the law prohibits believing those who come forth to prophesy, offering signs so that we defect to a foreign god, for it says that “the Lord your God is testing you, to know whether you love the Lord your God with all your heart and with all your soul.” "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-092-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Samuel’s Body but the Devil’s Spirit.")]), _vm._v(" "), _c('i', [_vm._v("Heinrich Bullinger:")]), _vm._v(" Devils are spiritual substances. But no one, I think, is able to say exactly in what way they assume bodies or how they appear to human beings. Indeed, the story of Samuel being brought up by a witch shows clearly that devils put on bodies and shapes that are different from their own. It was not Samuel who was brought up from the dead; rather, the chief architect of lies—the devil—deceived King Saul by pretending to be Samuel. For Paul testifies that “Satan disguises himself as an angel of light.” Other stories testify that the devil is an extraordinary "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3415"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3416"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3417"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3418"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3419"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3420"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3421"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3422"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page130",
      "title": "130"
    }
  }), _vm._v("deceiver who assumes various forms and shapes. "), _c('i', [_vm._v("Decades 4.9.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-091-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Counterfeit Samuel.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" It seems by Saul’s question to the soothsayer that he did not at first see the apparition. In fact, the rabbis think Saul only heard the voice, and that only the woman both saw and heard. But Saul’s servants neither heard nor saw. Now, the woman was in another room, since witches back then did not like to be seen when they worked their magic. And it is likely that afterward Saul was admitted to see the apparition. This is indicated by both the reverence he showed to it, in bowing himself, and by the communication he had with the apparition of Samuel. It may be gathered also by the text that the woman did not hear the communication. For it is said that she entered or “came to Saul,” implying that she had gone forth beforehand. Presumably, after raising the spirit she left Saul alone in the bedchamber, as it expressed in verse 23. Now, where the woman said, “I saw a god coming up out of the earth,” some believe she indicated an excellent person who was ascending. But it is likely that these gods were certain attractive, satanic apparitions (as Satan can transform himself into an angel of light). Thus Samuel appears wrapped about with a mantle, which was the custom of magistrates and prophets to wear to distinguish them from the common sort. Josephus thinks it was a priestly garment. But Samuel was no priest, though he was of the tribe of Levi. The witch recognized him as Samuel, having so learned of the devil who told her who it was. And this counterfeit Samuel yielded to Saul. "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-090-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Devil Appears.")]), _vm._v(" "), _c('i', [_vm._v("Lambert Daneau:")]), _vm._v(" First, I agree with you that Satan can appear to people in the shape of a person. In fact, if we should say this cannot be done, then we must deny the meeting and talking together of Christ with the devil, about which the Scripture makes mention in Matthew 4, where it is written how Satan appeared visibly and in the shape of a man to Christ. Second, I will easily grant you that sorcerers can learn no good thing of Satan, but only such counsels and precepts as proceed from a vile and mischievous disposition, such as to revenge himself, to deceive strangers, to slay people at unawares and to do all these things secretly, none knowing about it or witnessing it. "), _c('i', [_vm._v("Dialogue of Witches.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-089-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_133"
    }
  }, [_c('b', [_vm._v("28:15-25")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Concerning the Accuracy of “Samuel’s” Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Judgment Left for God Alone.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some interpret this phrase—“tomorrow you and your sons shall be with me”—as though the devil, counterfeiting Samuel’s person, said that Saul would be with Samuel, that is, in the state of grace and in the favor of God, but that Satan here lied to him. However, as the rest of these words to Saul fell out to be true—that Saul would be delivered into the hands of the Philistines—so it is likely that the rest also should be true. Indeed, the event happened just as it was spoken. Both Saul and his sons were killed the next day. David Kimchi, along with other rabbis, thinks this is to be understood of the happy estate, where Saul should be. And that here nothing was uttered but truth. For these rabbis hold that Saul, dying for his country and not giving over the defense of Israel to pagans, died in the favor of God. Indeed, Josephus commends Saul as a worthy man who died for his country. But this resolution in Saul to die for his country was only a civil virtue. It was far from piety. Rather, it was like the fortitude of the heathen among the Romans who died for their country. And it was more a matter of God’s justice that forced him into this battle rather than his own will and resolution to defend his country. Besides, seeing that Saul killed himself and so died without repentance and ending his days in despair, how could he die in the favor and grace of God? But we will not hastily pronounce a verdict on his everlast"), _c('a', {
    attrs: {
      "id": "_idTextAnchor3423"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3424"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3425"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3426"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3427"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3428"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3429"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3430"
    }
  }), _vm._v("ing reprobation, though he was rejected from the kingdom. For that, we leave him to the judgment of the Lord. "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-088-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Hiding Behind Words.")]), _vm._v(" "), _c('i', [_vm._v("Francois Perrault:")]), _vm._v(" We read here that the devil, speaking to King Saul under the figure of Samuel, makes himself into an ambiguous form, saying to him, “and tomorrow you and your sons shall be with me,” which is to say, you all will die, but he speaks confidently and deceptively, using this word "), _c('i', [_vm._v("tomorrow")]), _vm._v(", which signifies not only the day immediately following but also the time to come indefinitely and at large, as in that passage speaking of the Eternal One: “When your sons will inquire of you tomorrow, saying, ‘What is this here?’” This word "), _c('i', [_vm._v("tomorrow")]), _vm._v(" means hereafter and of the time to come. In this same sense must be understood that which our Lord Jesus Christ says in Saint Matthew, “Do not be anxious about tomorrow.” And in order to make it evident that Saul would not die the next day, or the day following the conference that he had with the devil under the figure of Samuel, but only a year or so afterward, it is necessary to diligently examine the story. But the devil will consider that it certainly appeared by the state and disposition of events that that which he was saying must happen, and nevertheless not being assured he limits nothing certainly, thus hiding in the ambiguity of this word "), _c('i', [_vm._v("tomorrow")]), _vm._v(", wanting to always preserve an avenue door behind for escape. It is thus that he has nearly always deceived the pagans by the ambiguity of his oracles, and not only has he spoken strongly among the pagans, but also he has deceived many Christians by this means, as we have an infinity of examples in the histories. "), _c('i', [_vm._v("Demonology.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-087-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Even the Devil Can Speak Truly.")]), _vm._v(" "), _c('i', [_vm._v("Thomas Adams:")]), _vm._v(" It is pleasing to the wisdom of God to express himself even by the tongues of faulty instruments. In fact, Satan himself sometimes receives notice from God of his future actions that otherwise that evil Spirit could neither foretell nor foresee. Such, in all likelihood, was his information concerning the end of Saul: “. . . tomorrow you and your sons shall be with me.” How could Satan tell this? Did the devil become a prophet? No. But as he was once a good angel, so he can still act what he was. Even lewd men may be good preachers when Satan himself plays the prophet. What prophet could speak better words than this foul spirit in Samuel’s mantle? “Why do you consult me, now that the Lord has turned away from you and become your enemy?” Samuel himself while he was alive could not have spoken more gravely, more severely, more divinely, than this hellish counterfeit. Good words are no rule to distinguish a prophet from a devil. This kind of knowledge is both rare and common: rare, in that it is seldom given to any; common, in that it is indifferently given to the good and bad. Prophecy does not always presuppose sanctification. Many have had visions from God who will never enjoy the vision of God. "), _c('i', [_vm._v("Commentary on 2 Peter.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-086-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Devil at Play.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" The devil played with Saul by taking it on himself to foretell future events in the hands of God: “tomorrow you and your sons shall be with me,” that is, they shall die. Now how did the devil come to reveal God’s counsel? How is he able to determine with certainty the end of any person’s days given that they are numbered by God alone? However, if you look carefully, you will notice that the devil does not define Saul’s death in certain terms, but speaks darkly and deceitfully. For “tomorrow” does not only signify the day immediately following, but it also signifies the time to come indefinitely and at large. For instance, our Savior said, “Therefore do not be anxious about tomorrow”; that is, Jesus refers to the hereafter in the time to come. Moreover, the poet Horace said, “Do not seek what shall be tomorrow, for I care about only what is today. For who knows tomorrow?” In fact, Saul did not die the next day after this appearance—as the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3431"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3432"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3433"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page131132",
      "title": "131132"
    }
  }), _vm._v("more diligent reader of the whole context of that history will detect. It was only that Satan discerned the likelihood of it, and ventured so to speak as if the next day Saul should have died. However, because he was not sure of it, the devil tempered his speech with the ambiguity of the word "), _c('i', [_vm._v("tomorrow")]), _vm._v(", so that his reputation might be preserved. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-085-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "PER_Top-extra-space"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page133",
      "title": "133"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "PER_ScriptureCenter",
    attrs: {
      "id": "sigil_toc_id_134"
    }
  }, [_c('span', {
    staticClass: "RH-marker"
  }, [_vm._v("29:1–31:13")]), _vm._v(" THE PHILISTINES REJECT DAVID AND SAUL DIES")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("1")]), _c('i', [_vm._v("Now the Philistines had gathered all their forces at Aphek. And the Israelites were encamped by the spring that is in Jezreel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("As the lords of the Philistines were passing on by hundreds and by thousands, and David and his men were passing on in the rear with Achish,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("the commanders of the Philistines said, “What are these Hebrews doing here?” And Achish said to the commanders of the Philistines, “Is this not David, the servant of Saul, king of Israel, who has been with me now for days and years, and since he deserted to me I have found no fault in him to this day.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("But the commanders of the Philistines were angry with him. And the commanders of the Philistines said to him, “Send the man back, that he may return to the place to which you have assigned him. He shall not go down with us to battle, lest in the battle he become an adversary to us. For how could this fellow reconcile himself to his lord? Would it not be with the heads of the men here?")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("Is not this David, of whom they sing to one another in dances,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("‘Saul has struck down his thousands,")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('i', [_vm._v("and David his ten thousands’?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Then Achish called David and said to him, “As the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("lives, you have been honest, and to me it seems right that you should march out and in with me in the campaign. For I have found nothing wrong in you from the day of your coming to me to this day. Nevertheless, the lords do not approve of you.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("So go back now; and go peaceably, that you may not displease the lords of the Philistines.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And David said to Achish, “But what have I done? What have you found in your servant from the day I entered your service until now, that I may not go and fight against the enemies of my lord the king?”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("And Achish answered David and said, “I know that you are as blameless in my sight as an angel of God. Nevertheless, the commanders of the Philistines have said, ‘He shall not go up with us to the battle.’")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("Now then rise early in the morning with the servants of your lord who came with you, and start early in the morning, and depart as soon as you have light.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("So David set out with his men early in the morning to return to the land of the Philistines. But the Philistines went up to Jezreel.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("30")]), _vm._v(" "), _c('i', [_vm._v("Now when David and his men came to Ziklag on the third day, the Amalekites had made a raid against the Negeb and against Ziklag. They had overcome Ziklag and burned it with fire")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("and taken captive the women and all")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', [_vm._v("who were in it, both small and great. They killed no one, but carried them off and went their way.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("And when David and his men came to the city, they found it burned with fire, and their wives and sons and daughters taken captive.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then David and the people who were with him raised their voices and wept until they had no more strength to weep.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("David’s two wives also had been taken captive, Ahinoam of Jezreel and Abigail the widow of Nabal of Carmel.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("And David was greatly distressed, for the people spoke of stoning him, because all the people were bitter in soul,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("b")]), _vm._v(" "), _c('i', [_vm._v("each for his sons and daughters. But David strengthened himself in the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("his God.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And David said to Abiathar the priest, the son of Ahimelech, “Bring me the ephod.” So Abiathar brought the ephod to David.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("And David inquired of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(", “Shall I pursue after this band? Shall I overtake them?” He answered him, “Pursue, for you shall surely overtake and shall surely rescue.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("So David set out, and the six hundred men who were with him, and they came to the brook Besor, where those who were left behind stayed.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("But David pursued, he and four hundred men. Two hundred stayed behind, who were too exhausted to cross the brook Besor.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("They found an Egyptian in the open country and brought him to David. And they gave him bread and he ate. They gave him water to drink,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("and they gave him a piece of a cake of figs and two clusters of raisins. And when he had eaten, his spirit revived, for he had not eaten bread or drunk water for three days and three nights.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And David said to him, “To whom do you belong? And where are you from?” He said, “I am a")]), _vm._v(" "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page134",
      "title": "134"
    }
  }), _c('i', [_vm._v("young man of Egypt, servant to an Amalekite, and my master left me behind because I fell sick three days ago.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("14")]), _c('i', [_vm._v("We had made a raid against the Negeb of the Cherethites and against that which belongs to Judah and against the Negeb of Caleb, and we burned Ziklag with fire.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("15")]), _c('i', [_vm._v("And David said to him, “Will you take me down to this band?” And he said, “Swear to me by God that you will not kill me or deliver me into the hands of my master, and I will take you down to this band.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("16")]), _c('i', [_vm._v("And when he had taken him down, behold, they were spread abroad over all the land, eating and drinking and dancing, because of all the great spoil they had taken from the land of the Philistines and from the land of Judah.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("17")]), _c('i', [_vm._v("And David struck them down from twilight until the evening of the next day, and not a man of them escaped, except four hundred young men, who mounted camels and fled.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("18")]), _c('i', [_vm._v("David recovered all that the Amalekites had taken, and David rescued his two wives.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("19")]), _c('i', [_vm._v("Nothing was missing, whether small or great, sons or daughters, spoil or anything that had been taken. David brought back all.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("20")]), _c('i', [_vm._v("David also captured all the flocks and herds, and the people drove the livestock before him,")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("c")]), _vm._v(" "), _c('i', [_vm._v("and said, “This is David’s spoil.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("21")]), _c('i', [_vm._v("Then David came to the two hundred men who had been too exhausted to follow David, and who had been left at the brook Besor. And they went out to meet David and to meet the people who were with him. And when David came near to the people he greeted them.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("22")]), _c('i', [_vm._v("Then all the wicked and worthless fellows among the men who had gone with David said, “Because they did not go with us, we will not give them any of the spoil that we have recovered, except that each man may lead away his wife and children, and depart.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("23")]), _c('i', [_vm._v("But David said, “You shall not do so, my brothers, with what the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _vm._v(" "), _c('i', [_vm._v("has given us. He has preserved us and given into our hand the band that came against us.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("24")]), _c('i', [_vm._v("Who would listen to you in this matter? For as his share is who goes down into the battle, so shall his share be who stays by the baggage. They shall share alike.”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("25")]), _c('i', [_vm._v("And he made it a statute and a rule for Israel from that day forward to this day.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("26")]), _c('i', [_vm._v("When David came to Ziklag, he sent part of the spoil to his friends, the elders of Judah, saying, “Here is a present for you from the spoil of the enemies of the")]), _vm._v(" "), _c('i', [_vm._v("L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")])]), _c('i', [_vm._v(".”")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("27")]), _c('i', [_vm._v("It was for those in Bethel, in Ramoth of the Negeb, in Jattir,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("28")]), _c('i', [_vm._v("in Aroer, in Siphmoth, in Eshtemoa,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("29")]), _c('i', [_vm._v("in Racal, in the cities of the Jerahmeelites, in the cities of the Kenites,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("30")]), _c('i', [_vm._v("in Hormah, in Bor-ashan, in Athach,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("31")]), _c('i', [_vm._v("in Hebron, for all the places where David and his men had roamed.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("31")]), _vm._v(" "), _c('i', [_vm._v("Now the Philistines were fighting against Israel, and the men of Israel fled before the Philistines and fell slain on Mount Gilboa.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("2")]), _c('i', [_vm._v("And the Philistines overtook Saul and his sons, and the Philistines struck down Jonathan and Abinadab and Malchi-shua, the sons of Saul.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("3")]), _c('i', [_vm._v("The battle pressed hard against Saul, and the archers found him, and he was badly wounded by the archers.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("4")]), _c('i', [_vm._v("Then Saul said to his armor-bearer, “Draw your sword, and thrust me through with it, lest these uncircumcised come and thrust me through, and mistreat me.” But his armor-bearer would not, for he feared greatly. Therefore Saul took his own sword and fell upon it.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("5")]), _c('i', [_vm._v("And when his armor-bearer saw that Saul was dead, he also fell upon his sword and died with him.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("6")]), _c('i', [_vm._v("Thus Saul died, and his three sons, and his armor-bearer, and all his men, on the same day together.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("7")]), _c('i', [_vm._v("And when the men of Israel who were on the other side of the valley and those beyond the Jordan saw that the men of Israel had fled and that Saul and his sons were dead, they abandoned their cities and fled. And the Philistines came and lived in them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "perSS"
  }, [_vm._v("8")]), _c('i', [_vm._v("The next day, when the Philistines came to strip the slain, they found Saul and his three sons fallen on Mount Gilboa.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("9")]), _c('i', [_vm._v("So they cut off his head and stripped off his armor and sent messengers throughout the land of the Philistines, to carry the good news to the house of their idols and to the people.")]), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("10")]), _c('i', [_vm._v("They put his armor in the temple of Ashtaroth, and they fastened his body to the wall of Beth-shan.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("11")]), _c('i', [_vm._v("But when the inhabitants of Jabesh-gilead heard what the Philistines had done to Saul,")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("12")]), _c('i', [_vm._v("all the valiant men arose and went all night and took the body of Saul and the bodies of his sons from the wall of Beth-shan, and they came to Jabesh and burned them there.")]), _vm._v(" "), _c('span', {
    staticClass: "perSS"
  }, [_vm._v("13")]), _c('i', [_vm._v("And they took their bones and buried them under the tamarisk tree in Jabesh and fasted seven days.")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('b', [_vm._v("a")]), _vm._v(" Septuagint; Hebrew lacks "), _c('i', [_vm._v("and all")]), _vm._v(" "), _c('b', [_vm._v("b")]), _vm._v(" Compare 22:2 "), _c('b', [_vm._v("c")]), _vm._v(" The meaning of the Hebrew clause is uncertain"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3434"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3435"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3436"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3437"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3438"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page135",
      "title": "135"
    }
  }), _c('b', [_vm._v("Overview:")]), _vm._v(" David’s predicament about whether he should (or would be allowed to) fight with the Philistines against his fellow Israelites causes these interpreters to wonder about his motives. Was David waiting for the Lord to act? Would he have fought against Israel? Or would he have turned deceptively against the Philistines? At the same time, the reformers praise David’s shrewd leadership after Ziklag is captured and burned. Saul, by contrast, meets a lonely death on account of his poor leadership decisions.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_135"
    }
  }, [_c('b', [_vm._v("29:1-11")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Rejection of David")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Living by God’s Word in Troubled Times.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" David is seen to have had some doubts. It is as if he were thinking, “The children of Israel are my people, yet I have sworn faithfulness to the king of the Philistines. At the same time, God wants to punish the impious children of Israel. God does not want to give his faithful servant over to God’s enemies, but I should also not make my faith into more than the will of God (just as they now do with their monastic vows). I understand neither the one option nor the other. But I know this: I can follow neither side with a good conscience. Therefore I wait for the will of God in whatever I am called to do, for God will not push me away in this time of need, nor will God cause me to do what is against his will. Either way the people will have passed judgment over me.” Faith in humans comes to nothing when faith in God requires something else. God presents the second table of the law so that we should excel in keeping faith, promises, oaths and the like with each other, but not at the expense of the first table. In fact, no oaths or vows are superior to the first table of the law, unless you want to stand before the devil rather than God. For your own thoughtlessness does not need to be so great that you do injury to divine truth. God is truth, you are given to lying, and you ought to be humble before God, who will cause you to fall by the vows and oaths on which it is impossible to stand without going against God’s Word. Therefore God liberates David here and gathers the advice of the Philistines about sending him back. For in this case, if you let God work, then God will give counsel, so that you will be liberated without a bad conscience. In the same way, God liberates those who had been devoted to human traditions, so that they can conscientiously violate those vows through the Word of God, which has been taught from God. This is like the time when David did not have anything against his conscience in chapter 25 above, but rather gave thanks to God that he did not proceed with his oath. On this subject, however, there are those today who without the Word of God (and therefore in bad conscience) heedlessly attack everything, doing so in the name of gospel freedom. This is the freedom of the flesh and a great scandal to the gospel. This is not, I say, the same thing I have just been describing. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-084-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Fencing in the Heart.")]), _vm._v(" "), _c('i', [_vm._v("Daniel Dyke:")]), _vm._v(" When the Philistines were going out to war against the Israelites, they dared not allow David to go with them. They were jealous of him because of the love he bore to his own country. Therefore they put him out of the military. How happy would our spiritual war with Satan be if we could as easily rid ourselves of our deceitful hearts as they did themselves of David! Without doubt we have far greater cause to suspect our hearts than they did of David. The acquaintance of the flesh with Satan—and Satan’s interest in the flesh—is greater than the Israelites’ acquaintance of David. Besides that, the Philistines never had any experience of David’s deceitfulness and unfaithfulness as we have had of our flesh. Therefore I wish we could rid ourselves entirely of this treacherous and perfidious flesh! But since it sticks so close to us, and we cannot possibly remove it from ourselves, we must always have an eye over it just as we would over an untrustworthy and pilfering servant who—if not closely observed—would steal from us. For certainly such is the deceitfulness of our hearts that if we took our eyes off of them they would throw off the yoke of the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3439"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3440"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3441"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3442"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3443"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3444"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3445"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3446"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page136",
      "title": "136"
    }
  }), _vm._v("Lord and make a run for it! Therefore we must keep our hearts as closely monitored as the jailor does his prisoner. "), _c('i', [_vm._v("The Mystery of Self-Deceiving.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-083-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Did David Lie?")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Some think David had no intention at all to fight against Israel. Rather, he would have only defended the king’s person, who said he would make David keeper of his head for ever. But this does not agree with David’s own words. David seemed to be discontented because he was sent back and not allowed to fight against the enemies of the king. It seems therefore that he was fully in support of the Philistine king and that he was willing to go and fight against Israel. Others think that the Philistines’ war against Saul at this time was just, because this was the way the Lord intended to punish Saul’s wickedness. And besides, the kingdom rightly belonged to David, and therefore he was merely seeking what was his own. But neither of these makes the war just. For regardless of how God intended to judge Saul here, the Philistines went to battle against the people of God in a malicious way. And though David was the anointed king, that is, the apparent heir of the kingdom, he had no such commandment to invade the kingdom of Israel. Instead, he was to wait his time. Some are of the opinion that David would have turned his force against Achish in the battle had he been allowed to fight. Yet in such a case David, rather than supporting the Philistine king, would have disrespected Achish, with whom he had found such kind hospitality. Therefore the best solution to this question is that David very astutely neither directly promised his help, as Josephus believed, nor directly affirmed it. Instead he waited on God for his direction. He prayed to God fervently in his heart that some impediment might occur so that he would not be forced to fight against the Israelites, and especially against his dear and beloved friend Jonathan. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-082-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Faith Among the Gentiles.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" Because the Gentile king Achish swears by God and later invokes God’s angels, it is clear to see that an awareness of the true God had remained in the land from the time of the patriarchs, even though the false worship of God reigned there. Canaan—the son of Ham the son of Noah—first possessed the land, as you see illustrated later in the journeys of Abraham, Isaac and Jacob in Genesis. Many of them surely preached and taught the fear of God, as when Abraham, for instance, found Melchizedek that priest of God Most High in the land of Salem, among others. In Genesis 20 you also see how Abimelech, the king of the Palestinians in Gerar, had a holy conscience. But even though ideas about God survived to posterity, nothing remained of godliness except false worship where the preaching of God’s Word had ceased. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-081-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_136"
    }
  }, [_c('b', [_vm._v("30:1-20")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("David Overcomes Adversity")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Always Expecting Trials.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" We must learn from the example given to us here. David had recovered his wives. After that, he won a great quantity of spoil from his enemies, and everyone who was in his company made themselves rich in one day. Well, two days had been spent in this business. But the third day brought them news of the defeat of the people of Israel (2 Sam 1:2). Thus when God has given us cause to rejoice—whether for a day or a month—let us learn to accept any trial with which he chooses to test us. . . . For we need to be continually tried, because our senses are too attached to this world; and we wish to make our own paradise on earth as though there were no blessedness greater than that! That is why God subjects us to so many changes, and causes us to be cast from one side to the other. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-080-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor3447"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3448"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3449"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3450"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3451"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3452"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3453"
    }
  })])]), _c('b', [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page137",
      "title": "137"
    }
  })]), _c('b', [_vm._v("Persecuted and Weeping.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David was a figure of our Savior Christ, who was hated by his own people. Moses, that faithful servant of God, was also a figure of Christ. Thus it pleased the Lord to test David’s patience; and now, being as it were plunged in the depth of sorrow, it was a sign to him that his deliverance was near at hand. David excessively wept together with the rest of the men for their present loss, since their wives and children had been carried away. But David further wept because he knew the Lord was chastising him for his sin. David’s grievous weeping and lamenting serves as an example to us and, as such, confutes the opinion of the Stoics that a wise person is one who shows no passion, affection or ever changes his countenance. "), _c('i', [_vm._v("Harmony of 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-079-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_137"
    }
  }, [_c('b', [_vm._v("30:21-31")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("The Men’s Selfishness and David’s Generosity")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Equal Sharing of Goods.")]), _vm._v(" "), _c('i', [_vm._v("Peter Walpot:")]), _vm._v(" Humanity will hold a great sabbath. Yes, they will have a continual sabbath and will lead a most holy life on earth, when they rid their nature of two words—“mine” and “yours.” These words have been and are today the cause of many wars. From where comes war and bloodshed, quarreling and fighting, envy and hatred, disunity and disruption, if not from private possessions and greed? For whoever deals in mine and yours, that is, with possessions, becomes a friend of avarice. . . . When the evil men of Belial said that the one hundred who remained behind during the raid on Ziklag should not share in the booty won there, David said, “Do not be like that, brothers, with what God has given us. Who will agree with you on this? The share of those who went shall be the share of those who remained behind. It should be divided equally.” And since that time to this day that has been the custom and law in Israel. . . . How much more should this be the custom and law among the children of the New Testament? What God has given us should be divided equally. "), _c('i', [_vm._v("True Yieldedness.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-078-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("David’s Shrewd Generosity.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" David had found hospitality among some in his tribe, where he was able to hide himself while Saul pursued him. Therefore David showed his thankfulness by sending them presents. Besides, these people were his kindred and brothers, and it was therefore reasonable for David to first show his kindness to them. Moreover, these cities of Judah also had been robbed and spoiled by the Amalekites, as the Egyptian told David in verse 14. And because the Amalekites had robbed on the coast of Judah, David thought it reasonable that some restitution should be made to them for their losses. Additionally, it is by this means that David prepared their hearts and ingratiated himself into their affections, who afterward faithfully took part with David against the house of Saul. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-077-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "sigil_toc_id_138"
    }
  }, [_c('b', [_vm._v("31:1-13")]), _vm._v(" "), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Saul and His Sons Die")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul Dies in His Unbelief.")]), _vm._v(" "), _c('i', [_vm._v("Johannes Bugenhagen:")]), _vm._v(" It is written in the Psalms: “Precious in the sight of the Lord is the death of his saints.” This is no less true for the righteous Jonathan, who died fighting for the Lord’s inheritance. For “the righteous, though they die early, will be at rest,” as you read of the deaths of the righteous whom the world has judged to be contemptible and evil. But against others, it says in the psalm, “The death of the wicked is very evil.” You read that here as it applies to Saul, who did not hope in the God of Israel and instead consulted the soothsayer, as it says in 1 Chronicles. Therefore, when pressed on by enemies while desperately leading in battle, Saul perished like the apostle Judas, who also perished as one who had earlier been greatly blessed by God. In the end, Saul was a blasphemer of the God of Israel among both the Gentiles and those who exalt God in the holy places. This is how "), _c('a', {
    attrs: {
      "id": "_idTextAnchor3454"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3455"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3456"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3457"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3458"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3459"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3460"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor3461"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page138",
      "title": "138"
    }
  }), _vm._v("hypocrites meet their end, as it says in all of Job: “Do you not know this from of old, since humans were placed on earth, that the exulting of the wicked is short, and the joy of the godless but for a moment?” They reign gloriously and appear to be wise, righteous and the saviors of others, but their end reveals them to be in disgrace and blasphemy of God. This point relates to what Christ says of salt that has lost its flavor and what Paul wrote to the Romans: “The name of God is blasphemed among the Gentiles because of you.” Then and now, God unmasks our hypocrites, who are covered in the most Christian skins before God begins to judge them by his word and expel them from the kingdom, as he turned the kingdom to David, that is, to Christ the son of David through faith in the holy gospel. "), _c('i', [_vm._v("Commentary on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-076-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("The Death of Saul’s Sons.")]), _vm._v(" "), _c('i', [_vm._v("Andrew Willet:")]), _vm._v(" Here only three of Saul’s sons are mentioned to have died in this battle. Ish-bosheth was not present, either because he was not a warrior or because he was left at home to be overseer of the families. All three of these sons died together with their father. None of them bore his father’s punishment or suffered for his sin. They had sins of their own. Indeed, God’s judgments worked in such a way that they coincided with the punishment of their father. This was so that evil parents might be warned that their wickedness may bring God’s judgment on themselves and their posterity. But concerning Jonathan, because he was a good man his lamentable end deserves more compassion. It must be considered this way: Because Jonathan was a good man, regardless of how he ended his days he could not die in evil. God no doubt turned this temporal death of Jonathan to his everlasting glory. In fact God might have foreseen that if Jonathan had remained alive, his heart may have changed toward David. Therefore the Lord took him away. In this way God’s judgments, though secret and hidden to us, are most just. "), _c('i', [_vm._v("Harmony on 1 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-075-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', [_vm._v("Saul’s Multiple Deaths.")]), _vm._v(" "), _c('i', [_vm._v("John Calvin:")]), _vm._v(" Saul had to beg someone who was his enemy to kill him, since he was unable to do so himself (2 Sam 1:9). Saul, in desperation, had thrown himself on his sword in order to kill himself, but then he was not able to achieve it by himself and, as I have said, he had to beg his enemies to help him to do so. Since he had wickedly persecuted David, who was chosen and elected by God to succeed him, there was a very good reason why he should not simply die one death, but that he should actually die two or three times, as it were. "), _c('i', [_vm._v("Sermons on 2 Samuel.")]), _c('i', [_c('span', [_c('span', {
    staticClass: "notesbodyref",
    attrs: {
      "id": "footnote-074-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/Text/notes#footnote-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample from InterVarsity Press.  ")]), _vm._v(" "), _c('p', [_vm._v("Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780830899784',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(157)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(159);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 159 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.c4284d766d75fa622d29.js